// src/utils/deepFreeze.ts
function deepFreeze(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && !Object.isFrozen(obj[prop])) {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
}

// src/config/offices.ts
import { EStudentImportAttributeFieldNames } from "types";

// src/importStudentFields/index.ts
import { ImportFieldTypes, EStudentImportAttributeFieldNames as Field } from "types";
var importStudentFields = deepFreeze({
  // GENERAL FIELDS
  [Field.ADDRESS_LINE_1]: {
    summaryField: null,
    name: "addressLine1",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.ADDRESS_LINE_2]: {
    summaryField: null,
    name: "addressLine2",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.ADDRESS_LINE_3]: {
    summaryField: null,
    name: "addressLine3",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_COMPANY]: {
    summaryField: null,
    name: "agentCompany",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_COMPANY_EMAIL]: {
    summaryField: null,
    name: "agentCompanyEmail",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_EMAIL]: {
    summaryField: null,
    name: "agentEmail",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_NAME]: {
    summaryField: "agentName",
    summaryFieldType: "string",
    name: "agentName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Agent Name"
  },
  [Field.AGENT_OFFICE]: {
    summaryField: null,
    name: "agentOffice",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.APPLICATION_DATE]: {
    summaryField: null,
    name: "applicationDate",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.APPLICATION_ID]: {
    summaryField: null,
    name: "applicationId",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.BRANCH_OFFICE]: {
    summaryField: null,
    name: "branchOffice",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Office"
  },
  [Field.CITY]: {
    summaryField: "city",
    summaryFieldType: "string",
    name: "city",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "City"
  },
  [Field.CONFIRMED]: {
    summaryField: null,
    name: "confirmed",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.COUNSELLOR_EMAIL]: {
    summaryField: null,
    name: "counsellorEmail",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Counsellor Email"
  },
  [Field.COUNSELLOR_NAME]: {
    summaryField: null,
    name: "counsellorName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Counsellor Name"
  },
  [Field.COUNTRY]: {
    summaryField: "country",
    summaryFieldType: "string",
    name: "country",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Country"
  },
  [Field.COUNTRY_OF_BIRTH]: {
    summaryField: null,
    name: "countryOfBirth",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.CRIMINAL_CONVICTIONS]: {
    summaryField: "criminalConvictions",
    summaryFieldType: "boolean",
    name: "criminalConvictions",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Criminal Convictions"
  },
  [Field.DOB]: {
    summaryField: "dob",
    summaryFieldType: "string",
    name: "dob",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Date of Birth"
  },
  [Field.EMAIL]: {
    summaryField: "email",
    summaryFieldType: "string",
    name: "email",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Email"
  },
  [Field.ENGLISH_LEVEL_ATTAINED]: {
    summaryField: null,
    name: "englishLevelAttained",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.ENGLISH_TEST_PROVIDER]: {
    summaryField: null,
    name: "englishTestProvider",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.FAMILY_NAME]: {
    summaryField: "surname",
    summaryFieldType: "string",
    name: "familyName",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Family Name"
  },
  [Field.GENDER]: {
    summaryField: null,
    name: "gender",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.GIVEN_NAME]: {
    summaryField: "givenName",
    summaryFieldType: "string",
    name: "givenName",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Given Name"
  },
  [Field.NATIONALITY]: {
    summaryField: "nationality",
    summaryFieldType: "string",
    name: "nationality",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Nationality"
  },
  [Field.OTHER_NAME]: {
    summaryField: null,
    name: "otherName",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PASSPORT_EXPIRY]: {
    summaryField: null,
    name: "passportExpiry",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PASSPORT_NUMBER]: {
    summaryField: null,
    name: "passportNumber",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PHONE]: {
    summaryField: "phone",
    summaryFieldType: "string",
    name: "phone",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Phone"
  },
  [Field.PLACE_OF_BIRTH]: {
    summaryField: null,
    name: "placeOfBirth",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.POSTCODE]: {
    summaryField: "postcode",
    summaryFieldType: "string",
    name: "postcode",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Postcode"
  },
  [Field.PREVIOUS_COURSE_COMPLETION]: {
    summaryField: null,
    name: "previousCourseCompletion",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PREV_UK_STUDY]: {
    summaryField: null,
    name: "prevUKStudy",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_LISTENING]: {
    summaryField: null,
    name: "seltListening",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_READING]: {
    summaryField: null,
    name: "seltReading",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_SPEAKING]: {
    summaryField: null,
    name: "seltSpeaking",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_WRITING]: {
    summaryField: null,
    name: "seltWriting",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.STUDENT_NO]: {
    summaryField: "studentNo",
    summaryFieldType: "string",
    name: "studentNo",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Student Number"
  },
  [Field.UCAS_ID]: {
    summaryField: "ucasId",
    summaryFieldType: "string",
    name: "ucasId",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "UCAS ID"
  },
  [Field.WITH_AGENT]: {
    summaryField: "withAgent",
    summaryFieldType: "boolean",
    name: "withAgent",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "With Agent"
  },
  [Field.ADMISSIONS_OFFICE]: {
    summaryField: "admissionsOffice",
    summaryFieldType: "string",
    name: "admissionsOffice",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Uni Office"
  },
  [Field.SERVICES_ASSIGNED]: {
    summaryField: "partners",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Services"
  },
  [Field.TAGS_ASSIGNED]: {
    summaryField: "tags",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Tags"
  },
  [Field.STAGE]: {
    summaryField: "cas_status",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Stage"
  },
  [Field.AGE]: {
    summaryField: "age",
    summaryFieldType: "number",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Age"
  },
  [Field.VISA_APPLICATION_COUNTRY]: {
    summaryField: "countryOfVisaApplication",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Country of Visa Application"
  },
  [Field.RISK_REGION]: {
    summaryField: "regionConfigId",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Risk Region"
  },
  // OFFER FIELDS
  [Field.COURSE_FEE_PAID_TO_DATE]: {
    summaryField: "courseFeePaidToDate",
    summaryFieldType: "number",
    name: "courseFeePaidToDate",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.ACCOM_FEE_PAID_TO_DATE]: {
    summaryField: null,
    name: "accomFeePaidToDate",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.IS_SELT_REQD]: {
    summaryField: null,
    name: "isSELTReqd",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.REASON_SELT_NOT_REQD]: {
    summaryField: null,
    name: "reasonSELTNotReqd",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.PREVIOUS_COURSE_LEVEL]: {
    summaryField: null,
    name: "previousCourseLevel",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.COURSE_PROGRESSION]: {
    summaryField: null,
    name: "courseProgression",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.PROGRESSION_TEXT]: {
    summaryField: null,
    name: "progressionText",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.DOCS_USED_TO_OBTAIN_OFFER]: {
    summaryField: null,
    name: "docsUsedToObtainOffer",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  // COURSE FIELDS
  [Field.IS_ACCOM_PROVIDED]: {
    summaryField: null,
    name: "isAccomProvided",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.IS_ACCOM_INCLUDED_COURSE_FEE]: {
    summaryField: null,
    name: "isAccomIncludedCourseFee",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.IS_WORK_PLACEMENT]: {
    summaryField: null,
    name: "isWorkPlacement",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_PERC]: {
    summaryField: null,
    name: "workPlacementPerc",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_TEXT]: {
    summaryField: null,
    name: "workPlacementText",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_1]: {
    summaryField: null,
    name: "workPlacementAddressLine1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_2]: {
    summaryField: null,
    name: "workPlacementAddressLine2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_3]: {
    summaryField: null,
    name: "workPlacementAddressLine3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_ID]: {
    summaryField: "id",
    summaryFieldType: "string",
    name: "id",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: "Course ID"
  },
  [Field.OFFERS_PRESESSIONAL_TITLE]: {
    summaryField: "title",
    summaryFieldType: "string",
    name: "title",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: "PSE Course Title"
  },
  [Field.OFFERS_COURSES_TITLE]: {
    summaryField: "title",
    summaryFieldType: "string",
    name: "title",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: "Course Title"
  },
  [Field.OFFERS_COURSES_CONDITIONAL]: {
    summaryField: null,
    name: "conditional",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_DECLINED]: {
    summaryField: null,
    name: "isDeclined",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CAH3]: {
    summaryField: null,
    name: "cah3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_LEVEL]: {
    summaryField: "level",
    summaryFieldType: "string",
    name: "level",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: "Course Level"
  },
  [Field.OFFERS_COURSES_SECONDARY_LEVEL]: {
    summaryField: null,
    name: "secondaryLevel",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_PRESESSIONAL_START_DATE]: {
    summaryField: "startDate",
    summaryFieldType: "string",
    name: "startDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: "PSE Course Start Date"
  },
  [Field.OFFERS_COURSES_START_DATE]: {
    summaryField: "startDate",
    summaryFieldType: "string",
    name: "startDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: "Course Start Date"
  },
  [Field.OFFERS_PRESESSIONAL_END_DATE]: {
    summaryField: null,
    name: "endDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: ""
  },
  [Field.OFFERS_COURSES_END_DATE]: {
    summaryField: null,
    name: "endDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: ""
  },
  [Field.OFFERS_PRESESSIONAL_FEE]: {
    summaryField: null,
    name: "courseFeeFirstYear",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: ""
  },
  [Field.OFFERS_COURSES_FEE]: {
    summaryField: null,
    name: "courseFeeFirstYear",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: ""
  },
  [Field.OFFERS_COURSES_SCHOLARSHIP_AMOUNT1]: {
    summaryField: null,
    name: "courseScholarshipAmount1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_SCHOLARSHIP_TITLE1]: {
    summaryField: null,
    name: "courseScholarshipTitle1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_INNER_LONDON]: {
    summaryField: "innerLondon",
    name: "innerLondon",
    type: ImportFieldTypes.COURSE,
    summaryFieldType: "boolean",
    isPresessional: null,
    label: "Inner London"
  },
  [Field.OFFERS_COURSES_LAST_ACCEPTANCE_DATE]: {
    summaryField: null,
    name: "lastAcceptanceDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_IS_FULL_TIME]: {
    summaryField: null,
    name: "isFullTime",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_HOURS_PER_WEEK]: {
    summaryField: null,
    name: "hoursPerWeek",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_ATAS]: {
    summaryField: null,
    name: "isATASRequired",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT1]: {
    summaryField: null,
    name: "conditionText1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT2]: {
    summaryField: null,
    name: "conditionText2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT3]: {
    summaryField: null,
    name: "conditionText3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT4]: {
    summaryField: null,
    name: "conditionText4",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT5]: {
    summaryField: null,
    name: "conditionText5",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT6]: {
    summaryField: null,
    name: "conditionText6",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT7]: {
    summaryField: null,
    name: "conditionText7",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT8]: {
    summaryField: null,
    name: "conditionText8",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT9]: {
    summaryField: null,
    name: "conditionText9",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_FACULTY]: {
    summaryField: "faculty",
    summaryFieldType: "string",
    name: "faculty",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: "Faculty"
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_1]: {
    summaryField: null,
    name: "studyAddressLine1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_2]: {
    summaryField: null,
    name: "studyAddressLine2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_3]: {
    summaryField: null,
    name: "studyAddressLine3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_CITY]: {
    summaryField: null,
    name: "studyCity",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_COUNTRY]: {
    summaryField: null,
    name: "studyCountry",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_POSTCODE]: {
    summaryField: null,
    name: "studyPostcode",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_CITY]: {
    summaryField: null,
    name: "workPlacementCity",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_COUNTRY]: {
    summaryField: null,
    name: "workPlacementCountry",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_POSTCODE]: {
    summaryField: null,
    name: "workPlacementPostcode",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_OFFER_EVIDENCE]: {
    summaryField: null,
    name: "offerEvidence",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_ACCEPTED]: {
    summaryField: null,
    name: "coursesAccepted",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS1]: {
    summaryField: null,
    name: "offers_courses_qual_hecos1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS2]: {
    summaryField: null,
    name: "offers_courses_qual_hecos2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS3]: {
    summaryField: null,
    name: "offers_courses_qual_hecos3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS4]: {
    summaryField: null,
    name: "offers_courses_qual_hecos4",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS5]: {
    summaryField: null,
    name: "offers_courses_qual_hecos5",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION1]: {
    summaryField: null,
    name: "offers_courses_qual_proportion1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION2]: {
    summaryField: null,
    name: "offers_courses_qual_proportion2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION3]: {
    summaryField: null,
    name: "offers_courses_qual_proportion3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION4]: {
    summaryField: null,
    name: "offers_courses_qual_proportion4",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION5]: {
    summaryField: null,
    name: "offers_courses_qual_proportion5",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_CAT]: {
    summaryField: null,
    name: "offers_courses_qual_cat",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFER_ID]: {
    summaryField: "offerId",
    summaryFieldType: "string",
    name: "offerId",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Offer ID"
  },
  [Field.INTAKE_ID]: {
    summaryField: "intakeId",
    summaryFieldType: "string",
    name: "intakeId",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Intake ID"
  },
  [Field.UNI_PARTNER_ID]: {
    summaryField: "uniPartnerId",
    summaryFieldType: "string",
    name: "uniPartnerId",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Secondary Student Number"
  },
  [Field.UNI]: {
    summaryField: "uni",
    summaryFieldType: "string",
    name: "uni",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "University"
  },
  [Field.PATHWAY]: {
    summaryField: "pathway",
    summaryFieldType: "string",
    name: "pathway",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Pathway Provider"
  },
  [Field.EXTERNAL_CAS_STATUS]: {
    summaryField: "externalCasStatus",
    summaryFieldType: "string",
    name: "externalCasStatus",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "CAS Bypass"
  },
  [Field.OFFERS_DURATION_MONTHS]: {
    summaryField: "offersDurationMonths",
    summaryFieldType: "number",
    name: "offersDurationMonths",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Offers Duration Months"
  },
  [Field.TUITION_DEPOSIT]: {
    summaryField: "tuitionDeposit",
    summaryFieldType: "number",
    name: "depositAmount",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Tuition Deposit"
  },
  [Field.DEPOSIT_AMOUNT]: {
    summaryField: "depositAmount",
    summaryFieldType: "number",
    name: "depositAmount",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Tuition Deposit"
  },
  [Field.AGENT_FAMILY_NAME]: {
    summaryField: null,
    name: "agentFamilyName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Key Contact Family Name"
  },
  [Field.AGENT_GIVEN_NAME]: {
    summaryField: null,
    name: "agentGivenName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Key Contact Given Name"
  },
  [Field.BRANCH_ADDRESS_LINE_1]: {
    summaryField: null,
    name: "branchAddressLine1",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Address Line 1"
  },
  [Field.BRANCH_ADDRESS_LINE_2]: {
    summaryField: null,
    name: "branchAddressLine2",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Address Line 2"
  },
  [Field.BRANCH_ADDRESS_LINE_3]: {
    summaryField: null,
    name: "branchAddressLine3",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Address Line 3"
  },
  [Field.BRANCH_CITY]: {
    summaryField: null,
    name: "branchCity",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch City"
  },
  [Field.BRANCH_COUNTRY]: {
    summaryField: null,
    name: "branchCountry",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Country"
  },
  [Field.BRANCH_POSTCODE]: {
    summaryField: null,
    name: "branchPostcode",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Postcode"
  }
});

// src/config/offices.ts
var tuitionKey = EStudentImportAttributeFieldNames.TUITION_DEPOSIT;
var tuitionFieldName = importStudentFields[tuitionKey].name;
var officeSelectionFields = Object.entries(importStudentFields).map(
  ([fieldName, field]) => {
    return {
      label: field.label,
      summaryField: field.summaryField,
      value: fieldName === tuitionKey ? tuitionFieldName || "" : fieldName
    };
  }
);

// src/config/index.ts
var universityKeys = deepFreeze([
  { key: "UoG", name: "University of Greenwich" },
  { key: "USW", name: "University of South Wales" },
  { key: "ARU", name: "Anglia Ruskin University" },
  { key: "BCU", name: "Birmingham City University" },
  { key: "STR", name: "University of Strathclyde" }
]);
var SHARE_CODE_EXPIRY_DAYS_DEFAULT = 90;
var SHARE_CODE_EXPIRY_ALERT_DAYS_DEFAULT = 14;

// src/applyConfig/applyUniConfig.ts
var DefaultDashboardTabIds = /* @__PURE__ */ ((DefaultDashboardTabIds2) => {
  DefaultDashboardTabIds2["LEADS"] = "Leads";
  DefaultDashboardTabIds2["APPLIED"] = "Applied";
  DefaultDashboardTabIds2["DRAFT_OFFERS"] = "Draft";
  DefaultDashboardTabIds2["CONDITIONAL"] = "Conditional";
  DefaultDashboardTabIds2["UNCONDITIONAL"] = "Unconditional";
  DefaultDashboardTabIds2["COMPLETED"] = "Completed";
  DefaultDashboardTabIds2["CLOSED"] = "Closed";
  return DefaultDashboardTabIds2;
})(DefaultDashboardTabIds || {});
var applyUniConfig = {
  // TODO: Where and how do we define which variables are available to these "templates"?
  offerLetterStartTemplate: `We are delighted to issue you {conditionTypeWithArticle} offer to study {courseName} starting {intakeIdLabel}.`,
  offerLetterEndTemplate: `Admissions Team`,
  scholarships: [],
  termsAndConditionsUrl: "https://www.enroly.com",
  privacyPolicyUrl: "https://www.enroly.com",
  privacyPolicyConsentWording: {
    subtitle: "Our privacy policy and how it affects you",
    header: "I consent to the processing of sensitive data (e.g., health, ethnicity) to support my application and for monitoring purposes",
    buttonLabel: "Privacy policy",
    bodyText: "The information provided will be used to assess your eligibility and progress your application, in accordance with the {universityName} {privacyPolicyUrl}"
  },
  termsAndConditionConsentWording: {
    subtitle: "Read and consent to the University's terms and conditions",
    header: "Terms & conditions",
    buttonLabel: "Terms & conditions",
    bodyText: "I consent to the {universityName}"
  },
  welcomeScreen: {
    title: "Begin your application",
    content: `Using this app you will be able to complete your application for undergraduate and postgraduate courses at the university.

In this process you will be asked a series of questions and given a recommended set of documents to be uploaded in advance of your application to a course or programme offered by the university.

The list of documents and guidelines provided in this process do not constitute legal advice. The purpose is to speed up your application process.

We recommend that you have a photo or scan of your academic certificate or transcript as this information is used as part of your application, but you can get started without them.`
  },
  rejectionReasons: {
    entryCriteriaNotMet: "",
    failedAcademicAssessment: "",
    failedCredibilityAssessment: "",
    fraudulentApplication: "",
    courseClosure: "",
    courseFull: "",
    unableToOfferCourse: "",
    deadlineHasPassed: "",
    closedByApplicant: "",
    wrongApplicationForm: "",
    failedPreCasInterview: "",
    failedComplianceInterview: "",
    negativeQualificationVerification: "",
    duplicateApplication: "",
    inactiveApplication: "",
    regionExclusiveToAgent: "",
    other: ""
  }
  // New configuration flags with default values (all fields visible by default) (commented intentionally)
  // disableFundingTuitionFeeQuestion: false,
  // disableFundingMaintenanceQuestion: false,
  // disableFundingWorkQuestion: false,
  // disableDeclarationTask: false,
  // disableDeclarationInterruptionQuestion: false,
  // disableDeclarationConvictionQuestion: false
};
var defaultApplyUniConfig = deepFreeze(applyUniConfig);

// src/applyConfig/applicationTasks.ts
var applicationTaskConfig = {
  EnglishLanguage: {
    default: true
  },
  Employment: {
    default: true
  },
  References: {
    default: true
  },
  PersonalStatement: {
    default: true
  },
  ResearchProposal: {
    default: false
  },
  Funding: {
    default: true
  },
  ImmigrationHistory: {
    default: true
  },
  DiversityInclusion: {
    default: true
  },
  Representation: {
    default: true
  },
  Referral: {
    default: true
  },
  Declarations: {
    default: true
  }
};
var defaultApplicationTaskConfig = deepFreeze(applicationTaskConfig);

// src/applyConfig/dashboardTabs.ts
import {
  ApplicantOfferStatus,
  ApplicationStatus,
  ApplyDocTypes
} from "types";
var standardTabs = Object.freeze({
  ["Pipeline"]: [
    { label: "Leads", id: "Leads" /* LEADS */ },
    { label: "Applied", id: "Applied" /* APPLIED */ },
    { label: "Conditional", id: "Conditional" /* CONDITIONAL */ },
    { label: "Unconditional", id: "Unconditional" /* UNCONDITIONAL */ }
  ],
  ["Outcome"]: [
    { label: "Completed", id: "Completed" /* COMPLETED */ },
    { label: "Closed", id: "Closed" /* CLOSED */ }
  ]
});
var agentTabs = Object.freeze({
  ["Pipeline"]: [
    { label: "Leads", id: "Leads" /* LEADS */ },
    { label: "Applied", id: "Applied" /* APPLIED */ },
    { label: "Conditional", id: "Conditional" /* CONDITIONAL */ },
    { label: "Unconditional", id: "Unconditional" /* UNCONDITIONAL */ }
  ],
  ["Outcome"]: [
    { label: "Completed", id: "Completed" /* COMPLETED */ },
    { label: "Closed", id: "Closed" /* CLOSED */ }
  ]
});
var TabIdDocumentMap = Object.freeze({
  ["Leads" /* LEADS */]: [ApplyDocTypes.ApplicationSummary],
  ["Applied" /* APPLIED */]: [ApplyDocTypes.OfferSummary],
  ["Conditional" /* CONDITIONAL */]: [ApplyDocTypes.OfferSummary],
  ["Unconditional" /* UNCONDITIONAL */]: [ApplyDocTypes.OfferSummary],
  ["Completed" /* COMPLETED */]: [ApplyDocTypes.OfferSummary],
  ["Closed" /* CLOSED */]: [ApplyDocTypes.OfferSummary, ApplyDocTypes.ApplicationSummary]
});
var TabIdStageMap = Object.freeze({
  ["Leads" /* LEADS */]: {
    applicationStatuses: [ApplicationStatus.InProgress, ApplicationStatus.Completed],
    offerStatuses: []
  },
  ["Applied" /* APPLIED */]: {
    offerStatuses: [ApplicantOfferStatus.Applied],
    applicationStatuses: []
  },
  ["Conditional" /* CONDITIONAL */]: { offerStatuses: [ApplicantOfferStatus.Conditional], applicationStatuses: [] },
  ["Unconditional" /* UNCONDITIONAL */]: {
    offerStatuses: [ApplicantOfferStatus.Unconditional],
    applicationStatuses: []
  },
  ["Completed" /* COMPLETED */]: { offerStatuses: [ApplicantOfferStatus.Completed], applicationStatuses: [] },
  ["Closed" /* CLOSED */]: {
    offerStatuses: [ApplicantOfferStatus.Rejected, ApplicantOfferStatus.Withdrawn],
    applicationStatuses: [ApplicationStatus.Rejected, ApplicationStatus.Withdrawn]
  }
});
var TabIdStageMapForAgent = Object.freeze({
  ["Leads" /* LEADS */]: {
    applicationStatuses: [ApplicationStatus.InProgress, ApplicationStatus.Completed],
    offerStatuses: []
  },
  ["Applied" /* APPLIED */]: {
    offerStatuses: [ApplicantOfferStatus.Applied],
    applicationStatuses: []
  },
  ["Conditional" /* CONDITIONAL */]: { offerStatuses: [ApplicantOfferStatus.Conditional], applicationStatuses: [] },
  ["Unconditional" /* UNCONDITIONAL */]: {
    offerStatuses: [ApplicantOfferStatus.Unconditional],
    applicationStatuses: []
  },
  ["Completed" /* COMPLETED */]: { offerStatuses: [ApplicantOfferStatus.Completed], applicationStatuses: [] },
  ["Closed" /* CLOSED */]: {
    offerStatuses: [ApplicantOfferStatus.Rejected, ApplicantOfferStatus.Withdrawn],
    applicationStatuses: [ApplicationStatus.Rejected, ApplicationStatus.Withdrawn]
  }
});
var dashboardTabs = Object.freeze({
  "[UniAdmin]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[Uni]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[UniLite]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[UniSecure]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[Admin]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[Agent]": { tabs: agentTabs, map: TabIdStageMapForAgent, documentMap: TabIdDocumentMap },
  "[AgencyAdmin]": { tabs: agentTabs, map: TabIdStageMapForAgent, documentMap: TabIdDocumentMap },
  "[Partner]": { tabs: agentTabs, map: TabIdStageMapForAgent, documentMap: TabIdDocumentMap }
});

// src/applyConfig/uniRequirements.ts
import {
  ApplicantOfferRequirementTask,
  ApplicantOfferRequirementTaskLevel,
  OfferTaskLabel,
  UniConfigRequirementTaskFulfilmentMethod
} from "types";
var applyUniCRequirements = [
  {
    id: ApplicantOfferRequirementTask.Passport,
    enabled: true,
    type: ApplicantOfferRequirementTask.Passport,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Passport,
    label: OfferTaskLabel.Passport,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a copy of your passport"
    }
  },
  {
    id: ApplicantOfferRequirementTask.PhotoID,
    enabled: true,
    type: ApplicantOfferRequirementTask.PhotoID,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.PhotoID,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload your photographic proof of identity.  For example, this could be your Passport or National Identity Card."
    }
  },
  {
    id: ApplicantOfferRequirementTask.AcademicResults,
    enabled: true,
    type: ApplicantOfferRequirementTask.AcademicResults,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.AcademicResults,
    label: OfferTaskLabel.AcademicResults,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: `Your offer is subject to meeting the academic entry requirement of {${ApplicantOfferRequirementTask.AcademicResults}}.`
    }
  },
  {
    id: ApplicantOfferRequirementTask.FinalAcademicResults,
    enabled: true,
    type: ApplicantOfferRequirementTask.FinalAcademicResults,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.FinalAcademicResults,
    label: OfferTaskLabel.FinalAcademicResults,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Off,
    conditions: {
      default: "You previously specified you did not have final results yet for your study. Please complete this task when you have your final results."
    }
  },
  {
    id: ApplicantOfferRequirementTask.AcademicCertificate,
    enabled: true,
    type: ApplicantOfferRequirementTask.AcademicCertificate,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.AcademicCertificate,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Upload of academic certificate proving grades, if not in English, also upload the certified English translation"
    }
  },
  {
    id: ApplicantOfferRequirementTask.AcademicTranscript,
    enabled: true,
    type: ApplicantOfferRequirementTask.AcademicTranscript,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.AcademicTranscript,
    label: OfferTaskLabel.AcademicTranscript,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Upload of academic transcript proving grades, if not in English, also upload the certified English translation"
    }
  },
  {
    id: ApplicantOfferRequirementTask.EnglishLanguageResults,
    enabled: true,
    type: ApplicantOfferRequirementTask.EnglishLanguageResults,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.EnglishLanguageResults,
    label: OfferTaskLabel.EnglishLanguageResults,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: `Your offer is subject to meeting the English language requirement of {${ApplicantOfferRequirementTask.EnglishLanguageResults}}.`
    }
  },
  {
    id: ApplicantOfferRequirementTask.EnglishLanguageCertificate,
    enabled: true,
    type: ApplicantOfferRequirementTask.EnglishLanguageCertificate,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.EnglishLanguageCertificate,
    label: OfferTaskLabel.EnglishLanguageCertificate,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload your English Language Qualification or test results."
    }
  },
  {
    id: ApplicantOfferRequirementTask.CV,
    enabled: true,
    type: ApplicantOfferRequirementTask.CV,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.CV,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a current up to date CV to support your application"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfManagerialExperience,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfManagerialExperience,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.ProofOfManagerialExperience,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload proof of your managerial experience"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfAddress,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfAddress,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.ProofOfAddress,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload proof of your current address"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfImmigrationStatus,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfImmigrationStatus,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.ProofOfImmigrationStatus,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload proof of your UK immigration status"
    }
  },
  {
    id: ApplicantOfferRequirementTask.LetterOfRecommendation,
    enabled: true,
    type: ApplicantOfferRequirementTask.LetterOfRecommendation,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.LetterOfRecommendation,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a letter of recommendation"
    }
  },
  {
    id: ApplicantOfferRequirementTask.PersonalStatement,
    enabled: true,
    type: ApplicantOfferRequirementTask.PersonalStatement,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.PersonalStatement,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a personal statement to support your application"
    }
  },
  {
    id: ApplicantOfferRequirementTask.Portfolio,
    enabled: false,
    type: ApplicantOfferRequirementTask.Portfolio,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.Portfolio,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a portfolio to support your application"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfNameChange,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfNameChange,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.ProofOfNameChange,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload evidence of the official document that confirm your change of name."
    }
  },
  {
    id: ApplicantOfferRequirementTask.NameAffidavit,
    enabled: true,
    type: ApplicantOfferRequirementTask.NameAffidavit,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.NameAffidavit,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a name affidavit confirming your name change"
    }
  },
  {
    id: ApplicantOfferRequirementTask.BirthCert,
    enabled: true,
    type: ApplicantOfferRequirementTask.BirthCert,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.BirthCert,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please provide a birth or adoption certificate."
    }
  },
  {
    id: ApplicantOfferRequirementTask.ResearchProposal,
    enabled: false,
    type: ApplicantOfferRequirementTask.ResearchProposal,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel.ResearchProposal,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a research proposal to support your application."
    }
  },
  {
    id: ApplicantOfferRequirementTask.RefereeDetails,
    enabled: true,
    type: ApplicantOfferRequirementTask.RefereeDetails,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.RefereeDetails,
    label: OfferTaskLabel.RefereeDetails,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please provide the details of your referee, from whom we can request a reference."
    }
  }
];
var defaultApplyUniConfigRequirement = deepFreeze(applyUniCRequirements);

// src/core/index.ts
var defaultCore = deepFreeze({
  student_id: "",
  student_number: "",
  university: "",
  createdAt: 0,
  updatedAt: 0,
  legalAdviseDisclaimer: false,
  infoProcessingConsent: false,
  casIssued: false,
  email: "",
  assignedAgents: [],
  isPendingCognitoUser: false
});

// src/countries/countryCodes.ts
var countryCodes = {
  AUSTRALIA: { alphaTwo: "AU", alphaThree: "AUS", numeric: "036" },
  AUSTRIA: { alphaTwo: "AT", alphaThree: "AUT", numeric: "040" },
  BAHRAIN: { alphaTwo: "BH", alphaThree: "BHR", numeric: "048" },
  BARBADOS: { alphaTwo: "BB", alphaThree: "BRB", numeric: "052" },
  BELGIUM: { alphaTwo: "BE", alphaThree: "BEL", numeric: "056" },
  BOTSWANA: { alphaTwo: "BW", alphaThree: "BWA", numeric: "072" },
  BRAZIL: { alphaTwo: "BR", alphaThree: "BRA", numeric: "076" },
  BRUNEI_DARUSSALAM: { alphaTwo: "BN", alphaThree: "BRN", numeric: "096" },
  BULGARIA: { alphaTwo: "BG", alphaThree: "BGR", numeric: "100" },
  CAMBODIA: { alphaTwo: "KH", alphaThree: "KHM", numeric: "116" },
  CANADA: { alphaTwo: "CA", alphaThree: "CAN", numeric: "124" },
  CHILE: { alphaTwo: "CL", alphaThree: "CHL", numeric: "152" },
  CHINA: { alphaTwo: "CN", alphaThree: "CHN", numeric: "156" },
  CROATIA: { alphaTwo: "HR", alphaThree: "HRV", numeric: "191" },
  CYPRUS: { alphaTwo: "CY", alphaThree: "CYP", numeric: "196" },
  CZECH_REPUBLIC: { alphaTwo: "CZ", alphaThree: "CZE", numeric: "203" },
  DENMARK: { alphaTwo: "DK", alphaThree: "DNK", numeric: "208" },
  DOMINICA: { alphaTwo: "DM", alphaThree: "DMA", numeric: "212" },
  ESTONIA: { alphaTwo: "EE", alphaThree: "EST", numeric: "233" },
  FINLAND: { alphaTwo: "FI", alphaThree: "FIN", numeric: "246" },
  FRANCE: { alphaTwo: "FR", alphaThree: "FRA", numeric: "250" },
  GERMANY: { alphaTwo: "DE", alphaThree: "DEU", numeric: "276" },
  GREECE: { alphaTwo: "GR", alphaThree: "GRC", numeric: "300" },
  HONG_KONG: { alphaTwo: "HK", alphaThree: "HKG", numeric: "344" },
  HUNGARY: { alphaTwo: "HU", alphaThree: "HUN", numeric: "348" },
  ICELAND: { alphaTwo: "IS", alphaThree: "ISL", numeric: "352" },
  INDONESIA: { alphaTwo: "ID", alphaThree: "IDN", numeric: "360" },
  IRELAND: { alphaTwo: "IE", alphaThree: "IRL", numeric: "372" },
  ITALY: { alphaTwo: "IT", alphaThree: "ITA", numeric: "380" },
  JAPAN: { alphaTwo: "JP", alphaThree: "JPN", numeric: "392" },
  KAZAKHSTAN: { alphaTwo: "KZ", alphaThree: "KAZ", numeric: "398" },
  SOUTH_KOREA: { alphaTwo: "KR", alphaThree: "KOR", numeric: "410" },
  KUWAIT: { alphaTwo: "KW", alphaThree: "KWT", numeric: "414" },
  LATVIA: { alphaTwo: "LV", alphaThree: "LVA", numeric: "428" },
  LIECHTENSTEIN: { alphaTwo: "LI", alphaThree: "LIE", numeric: "438" },
  LITHUANIA: { alphaTwo: "LT", alphaThree: "LTU", numeric: "440" },
  LUXEMBOURG: { alphaTwo: "LU", alphaThree: "LUX", numeric: "442" },
  MACAU: { alphaTwo: "MO", alphaThree: "MAC", numeric: "446" },
  MALAYSIA: { alphaTwo: "MY", alphaThree: "MYS", numeric: "458" },
  MALTA: { alphaTwo: "MT", alphaThree: "MLT", numeric: "470" },
  MAURITIUS: { alphaTwo: "MU", alphaThree: "MUS", numeric: "480" },
  MEXICO: { alphaTwo: "MX", alphaThree: "MEX", numeric: "484" },
  NETHERLANDS: { alphaTwo: "NL", alphaThree: "NLD", numeric: "528" },
  NEW_ZEALAND: { alphaTwo: "NZ", alphaThree: "NZL", numeric: "554" },
  NORWAY: { alphaTwo: "NO", alphaThree: "NOR", numeric: "578" },
  OMAN: { alphaTwo: "OM", alphaThree: "OMN", numeric: "512" },
  PERU: { alphaTwo: "PE", alphaThree: "PER", numeric: "604" },
  POLAND: { alphaTwo: "PL", alphaThree: "POL", numeric: "616" },
  PORTUGAL: { alphaTwo: "PT", alphaThree: "PRT", numeric: "620" },
  QATAR: { alphaTwo: "QA", alphaThree: "QAT", numeric: "634" },
  ROMANIA: { alphaTwo: "RO", alphaThree: "ROU", numeric: "642" },
  SINGAPORE: { alphaTwo: "SG", alphaThree: "SGP", numeric: "702" },
  SLOVAKIA: { alphaTwo: "SK", alphaThree: "SVK", numeric: "703" },
  SLOVENIA: { alphaTwo: "SI", alphaThree: "SVN", numeric: "705" },
  SPAIN: { alphaTwo: "ES", alphaThree: "ESP", numeric: "724" },
  SWEDEN: { alphaTwo: "SE", alphaThree: "SWE", numeric: "752" },
  SWITZERLAND: { alphaTwo: "CH", alphaThree: "CHE", numeric: "756" },
  TAIWAN: { alphaTwo: "TW", alphaThree: "TWN", numeric: "158" },
  THAILAND: { alphaTwo: "TH", alphaThree: "THA", numeric: "764" },
  TUNISIA: { alphaTwo: "TN", alphaThree: "TUN", numeric: "788" },
  UNITED_ARAB_EMIRATES: { alphaTwo: "AE", alphaThree: "ARE", numeric: "784" },
  UNITED_STATES_OF_AMERICA: { alphaTwo: "US", alphaThree: "USA", numeric: "840" },
  SERBIA: { alphaTwo: "RS", alphaThree: "SRB", numeric: "688" },
  AFGHANISTAN: { alphaTwo: "AF", alphaThree: "AFG", numeric: "004" },
  ALBANIA: { alphaTwo: "AL", alphaThree: "ALB", numeric: "008" },
  ALGERIA: { alphaTwo: "DZ", alphaThree: "DZA", numeric: "012" },
  AMERICAN_SAMOA: { alphaTwo: "AS", alphaThree: "ASM", numeric: "016" },
  ANDORRA: { alphaTwo: "AD", alphaThree: "AND", numeric: "020" },
  ANGOLA: { alphaTwo: "AO", alphaThree: "AGO", numeric: "024" },
  ANGUILLA: { alphaTwo: "AI", alphaThree: "AIA", numeric: "660" },
  ANTARCTICA: { alphaTwo: "AQ", alphaThree: "ATA", numeric: "010" },
  ANTIGUA_AND_BARBUDA: { alphaTwo: "AG", alphaThree: "ATG", numeric: "028" },
  ARGENTINA: { alphaTwo: "AR", alphaThree: "ARG", numeric: "032" },
  ARMENIA: { alphaTwo: "AM", alphaThree: "ARM", numeric: "051" },
  ARUBA: { alphaTwo: "AW", alphaThree: "ABW", numeric: "533" },
  AZERBAIJAN: { alphaTwo: "AZ", alphaThree: "AZE", numeric: "031" },
  BAHAMAS: { alphaTwo: "BS", alphaThree: "BHS", numeric: "044" },
  BANGLADESH: { alphaTwo: "BD", alphaThree: "BGD", numeric: "050" },
  BELARUS: { alphaTwo: "BY", alphaThree: "BLR", numeric: "112" },
  BELIZE: { alphaTwo: "BZ", alphaThree: "BLZ", numeric: "084" },
  BENIN: { alphaTwo: "BJ", alphaThree: "BEN", numeric: "204" },
  BERMUDA: { alphaTwo: "BM", alphaThree: "BMU", numeric: "060" },
  BHUTAN: { alphaTwo: "BT", alphaThree: "BTN", numeric: "064" },
  BOLIVIA: { alphaTwo: "BO", alphaThree: "BOL", numeric: "068" },
  BOSNIA_AND_HERZEGOVINA: { alphaTwo: "BA", alphaThree: "BIH", numeric: "070" },
  BOUVET_ISLAND: { alphaTwo: "BV", alphaThree: "BVT", numeric: "074" },
  BRITISH_INDIAN_OCEAN_TERRITORY: { alphaTwo: "IO", alphaThree: "IOT", numeric: "086" },
  BURKINA_FASO: { alphaTwo: "BF", alphaThree: "BFA", numeric: "854" },
  BURUNDI: { alphaTwo: "BI", alphaThree: "BDI", numeric: "108" },
  CAMEROON: { alphaTwo: "CM", alphaThree: "CMR", numeric: "120" },
  CAPE_VERDE: { alphaTwo: "CV", alphaThree: "CPV", numeric: "132" },
  CAYMAN_ISLANDS: { alphaTwo: "KY", alphaThree: "CYM", numeric: "136" },
  CENTRAL_AFRICAN_REPUBLIC: { alphaTwo: "CF", alphaThree: "CAF", numeric: "140" },
  CHAD: { alphaTwo: "TD", alphaThree: "TCD", numeric: "148" },
  CHRISTMAS_ISLAND: { alphaTwo: "CX", alphaThree: "CXR", numeric: "162" },
  COCOS_KEELING_ISLANDS: { alphaTwo: "CC", alphaThree: "CCK", numeric: "166" },
  COLOMBIA: { alphaTwo: "CO", alphaThree: "COL", numeric: "170" },
  COMOROS: { alphaTwo: "KM", alphaThree: "COM", numeric: "174" },
  CONGO: { alphaTwo: "CG", alphaThree: "COG", numeric: "178" },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: { alphaTwo: "CD", alphaThree: "COD", numeric: "180" },
  COOK_ISLANDS: { alphaTwo: "CK", alphaThree: "COK", numeric: "184" },
  COSTA_RICA: { alphaTwo: "CR", alphaThree: "CRI", numeric: "188" },
  COTE_DIVOIRE: { alphaTwo: "CI", alphaThree: "CIV", numeric: "384" },
  CUBA: { alphaTwo: "CU", alphaThree: "CUB", numeric: "192" },
  DJIBOUTI: { alphaTwo: "DJ", alphaThree: "DJI", numeric: "262" },
  DOMINICAN_REPUBLIC: { alphaTwo: "DO", alphaThree: "DOM", numeric: "214" },
  ECUADOR: { alphaTwo: "EC", alphaThree: "ECU", numeric: "218" },
  EGYPT: { alphaTwo: "EG", alphaThree: "EGY", numeric: "818" },
  EL_SALVADOR: { alphaTwo: "SV", alphaThree: "SLV", numeric: "222" },
  EQUATORIAL_GUINEA: { alphaTwo: "GQ", alphaThree: "GNQ", numeric: "226" },
  ERITREA: { alphaTwo: "ER", alphaThree: "ERI", numeric: "232" },
  ETHIOPIA: { alphaTwo: "ET", alphaThree: "ETH", numeric: "231" },
  FALKLAND_ISLANDS_MALVINAS: { alphaTwo: "FK", alphaThree: "FLK", numeric: "238" },
  FAROE_ISLANDS: { alphaTwo: "FO", alphaThree: "FRO", numeric: "234" },
  FIJI: { alphaTwo: "FJ", alphaThree: "FJI", numeric: "242" },
  FRENCH_GUIANA: { alphaTwo: "GF", alphaThree: "GUF", numeric: "254" },
  FRENCH_POLYNESIA: { alphaTwo: "PF", alphaThree: "PYF", numeric: "258" },
  FRENCH_SOUTHERN_TERRITORIES: { alphaTwo: "TF", alphaThree: "ATF", numeric: "260" },
  GABON: { alphaTwo: "GA", alphaThree: "GAB", numeric: "266" },
  GAMBIA: { alphaTwo: "GM", alphaThree: "GMB", numeric: "270" },
  GEORGIA: { alphaTwo: "GE", alphaThree: "GEO", numeric: "268" },
  GHANA: { alphaTwo: "GH", alphaThree: "GHA", numeric: "288" },
  GIBRALTAR: { alphaTwo: "GI", alphaThree: "GIB", numeric: "292" },
  GREENLAND: { alphaTwo: "GL", alphaThree: "GRL", numeric: "304" },
  GRENADA: { alphaTwo: "GD", alphaThree: "GRD", numeric: "308" },
  GUADELOUPE: { alphaTwo: "GP", alphaThree: "GLP", numeric: "312" },
  GUAM: { alphaTwo: "GU", alphaThree: "GUM", numeric: "316" },
  GUATEMALA: { alphaTwo: "GT", alphaThree: "GTM", numeric: "320" },
  GUINEA: { alphaTwo: "GN", alphaThree: "GIN", numeric: "324" },
  GUINEA_BISSAU: { alphaTwo: "GW", alphaThree: "GNB", numeric: "624" },
  GUYANA: { alphaTwo: "GY", alphaThree: "GUY", numeric: "328" },
  HAITI: { alphaTwo: "HT", alphaThree: "HTI", numeric: "332" },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: { alphaTwo: "HM", alphaThree: "HMD", numeric: "334" },
  VATICAN: { alphaTwo: "VA", alphaThree: "VAT", numeric: "336" },
  HONDURAS: { alphaTwo: "HN", alphaThree: "HND", numeric: "340" },
  INDIA: { alphaTwo: "IN", alphaThree: "IND", numeric: "356" },
  IRAN_ISLAMIC_REPUBLIC_OF: { alphaTwo: "IR", alphaThree: "IRN", numeric: "364" },
  IRAQ: { alphaTwo: "IQ", alphaThree: "IRQ", numeric: "368" },
  ISRAEL: { alphaTwo: "IL", alphaThree: "ISR", numeric: "376" },
  JAMAICA: { alphaTwo: "JM", alphaThree: "JAM", numeric: "388" },
  JORDAN: { alphaTwo: "JO", alphaThree: "JOR", numeric: "400" },
  KENYA: { alphaTwo: "KE", alphaThree: "KEN", numeric: "404" },
  KIRIBATI: { alphaTwo: "KI", alphaThree: "KIR", numeric: "296" },
  NORTH_KOREA: { alphaTwo: "KP", alphaThree: "PRK", numeric: "408" },
  KYRGYZSTAN: { alphaTwo: "KG", alphaThree: "KGZ", numeric: "417" },
  LAOS: { alphaTwo: "LA", alphaThree: "LAO", numeric: "418" },
  LEBANON: { alphaTwo: "LB", alphaThree: "LBN", numeric: "422" },
  LESOTHO: { alphaTwo: "LS", alphaThree: "LSO", numeric: "426" },
  LIBERIA: { alphaTwo: "LR", alphaThree: "LBR", numeric: "430" },
  LIBYA: { alphaTwo: "LY", alphaThree: "LBY", numeric: "434" },
  MADAGASCAR: { alphaTwo: "MG", alphaThree: "MDG", numeric: "450" },
  MALAWI: { alphaTwo: "MW", alphaThree: "MWI", numeric: "454" },
  MALDIVES: { alphaTwo: "MV", alphaThree: "MDV", numeric: "462" },
  MALI: { alphaTwo: "ML", alphaThree: "MLI", numeric: "466" },
  MARSHALL_ISLANDS: { alphaTwo: "MH", alphaThree: "MHL", numeric: "584" },
  MARTINIQUE: { alphaTwo: "MQ", alphaThree: "MTQ", numeric: "474" },
  MAURITANIA: { alphaTwo: "MR", alphaThree: "MRT", numeric: "478" },
  MAYOTTE: { alphaTwo: "YT", alphaThree: "MYT", numeric: "175" },
  MICRONESIA_FEDERATED_STATES_OF: { alphaTwo: "FM", alphaThree: "FSM", numeric: "583" },
  MOLDOVA_REPUBLIC_OF: { alphaTwo: "MD", alphaThree: "MDA", numeric: "498" },
  MONACO: { alphaTwo: "MC", alphaThree: "MCO", numeric: "492" },
  MONGOLIA: { alphaTwo: "MN", alphaThree: "MNG", numeric: "496" },
  MONTSERRAT: { alphaTwo: "MS", alphaThree: "MSR", numeric: "500" },
  MOROCCO: { alphaTwo: "MA", alphaThree: "MAR", numeric: "504" },
  MOZAMBIQUE: { alphaTwo: "MZ", alphaThree: "MOZ", numeric: "508" },
  MYANMAR: { alphaTwo: "MM", alphaThree: "MMR", numeric: "104" },
  NAMIBIA: { alphaTwo: "NA", alphaThree: "NAM", numeric: "516" },
  NAURU: { alphaTwo: "NR", alphaThree: "NRU", numeric: "520" },
  NEPAL: { alphaTwo: "NP", alphaThree: "NPL", numeric: "524" },
  NEW_CALEDONIA: { alphaTwo: "NC", alphaThree: "NCL", numeric: "540" },
  NICARAGUA: { alphaTwo: "NI", alphaThree: "NIC", numeric: "558" },
  NIGER: { alphaTwo: "NE", alphaThree: "NER", numeric: "562" },
  NIGERIA: { alphaTwo: "NG", alphaThree: "NGA", numeric: "566" },
  NIUE: { alphaTwo: "NU", alphaThree: "NIU", numeric: "570" },
  NORFOLK_ISLAND: { alphaTwo: "NF", alphaThree: "NFK", numeric: "574" },
  NORTH_MACEDONIA_REPUBLIC_OF: { alphaTwo: "MK", alphaThree: "MKD", numeric: "807" },
  NORTHERN_MARIANA_ISLANDS: { alphaTwo: "MP", alphaThree: "MNP", numeric: "580" },
  PAKISTAN: { alphaTwo: "PK", alphaThree: "PAK", numeric: "586" },
  PALAU: { alphaTwo: "PW", alphaThree: "PLW", numeric: "585" },
  PALESTINE: { alphaTwo: "PS", alphaThree: "PSE", numeric: "275" },
  PANAMA: { alphaTwo: "PA", alphaThree: "PAN", numeric: "591" },
  PAPUA_NEW_GUINEA: { alphaTwo: "PG", alphaThree: "PNG", numeric: "598" },
  PARAGUAY: { alphaTwo: "PY", alphaThree: "PRY", numeric: "600" },
  PHILIPPINES: { alphaTwo: "PH", alphaThree: "PHL", numeric: "608" },
  PITCAIRN: { alphaTwo: "PN", alphaThree: "PCN", numeric: "612" },
  PUERTO_RICO: { alphaTwo: "PR", alphaThree: "PRI", numeric: "630" },
  REUNION: { alphaTwo: "RE", alphaThree: "REU", numeric: "638" },
  RUSSIA: { alphaTwo: "RU", alphaThree: "RUS", numeric: "643" },
  RWANDA: { alphaTwo: "RW", alphaThree: "RWA", numeric: "646" },
  SAINT_HELENA: { alphaTwo: "SH", alphaThree: "SHN", numeric: "654" },
  SAINT_KITTS_AND_NEVIS: { alphaTwo: "KN", alphaThree: "KNA", numeric: "659" },
  SAINT_LUCIA: { alphaTwo: "LC", alphaThree: "LCA", numeric: "662" },
  SAINT_PIERRE_AND_MIQUELON: { alphaTwo: "PM", alphaThree: "SPM", numeric: "666" },
  SAINT_VINCENT_AND_THE_GRENADINES: { alphaTwo: "VC", alphaThree: "VCT", numeric: "670" },
  SAMOA: { alphaTwo: "WS", alphaThree: "WSM", numeric: "882" },
  SAN_MARINO: { alphaTwo: "SM", alphaThree: "SMR", numeric: "674" },
  SAO_TOME_AND_PRINCIPE: { alphaTwo: "ST", alphaThree: "STP", numeric: "678" },
  SAUDI_ARABIA: { alphaTwo: "SA", alphaThree: "SAU", numeric: "682" },
  SENEGAL: { alphaTwo: "SN", alphaThree: "SEN", numeric: "686" },
  SEYCHELLES: { alphaTwo: "SC", alphaThree: "SYC", numeric: "690" },
  SIERRA_LEONE: { alphaTwo: "SL", alphaThree: "SLE", numeric: "694" },
  SOLOMON_ISLANDS: { alphaTwo: "SB", alphaThree: "SLB", numeric: "090" },
  SOMALIA: { alphaTwo: "SO", alphaThree: "SOM", numeric: "706" },
  SOUTH_AFRICA: { alphaTwo: "ZA", alphaThree: "ZAF", numeric: "710" },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: { alphaTwo: "GS", alphaThree: "SGS", numeric: "239" },
  SRI_LANKA: { alphaTwo: "LK", alphaThree: "LKA", numeric: "144" },
  SUDAN: { alphaTwo: "SD", alphaThree: "SDN", numeric: "729" },
  SURINAME: { alphaTwo: "SR", alphaThree: "SUR", numeric: "740" },
  SVALBARD_AND_JAN_MAYEN: { alphaTwo: "SJ", alphaThree: "SJM", numeric: "744" },
  SWAZILAND: { alphaTwo: "SZ", alphaThree: "SWZ", numeric: "748" },
  SYRIA: { alphaTwo: "SY", alphaThree: "SYR", numeric: "760" },
  TAJIKISTAN: { alphaTwo: "TJ", alphaThree: "TJK", numeric: "762" },
  TANZANIA_UNITED_REPUBLIC_OF: { alphaTwo: "TZ", alphaThree: "TZA", numeric: "834" },
  TIMOR_LESTE: { alphaTwo: "TL", alphaThree: "TLS", numeric: "626" },
  TOGO: { alphaTwo: "TG", alphaThree: "TGO", numeric: "768" },
  TOKELAU: { alphaTwo: "TK", alphaThree: "TKL", numeric: "772" },
  TONGA: { alphaTwo: "TO", alphaThree: "TON", numeric: "776" },
  TRINIDAD_AND_TOBAGO: { alphaTwo: "TT", alphaThree: "TTO", numeric: "780" },
  TURKEY: { alphaTwo: "TR", alphaThree: "TUR", numeric: "792" },
  TURKMENISTAN: { alphaTwo: "TM", alphaThree: "TKM", numeric: "795" },
  TURKS_AND_CAICOS_ISLANDS: { alphaTwo: "TC", alphaThree: "TCA", numeric: "796" },
  TUVALU: { alphaTwo: "TV", alphaThree: "TUV", numeric: "798" },
  UGANDA: { alphaTwo: "UG", alphaThree: "UGA", numeric: "800" },
  UKRAINE: { alphaTwo: "UA", alphaThree: "UKR", numeric: "804" },
  UNITED_KINGDOM: { alphaTwo: "GB", alphaThree: "GBR", numeric: "826" },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: { alphaTwo: "UM", alphaThree: "UMI", numeric: "581" },
  URUGUAY: { alphaTwo: "UY", alphaThree: "URY", numeric: "858" },
  UZBEKISTAN: { alphaTwo: "UZ", alphaThree: "UZB", numeric: "860" },
  VANUATU: { alphaTwo: "VU", alphaThree: "VUT", numeric: "548" },
  VENEZUELA: { alphaTwo: "VE", alphaThree: "VEN", numeric: "862" },
  VIETNAM: { alphaTwo: "VN", alphaThree: "VNM", numeric: "704" },
  VIRGIN_ISLANDS_BRITISH: { alphaTwo: "VG", alphaThree: "VGB", numeric: "092" },
  VIRGIN_ISLANDS_US: { alphaTwo: "VI", alphaThree: "VIR", numeric: "850" },
  WALLIS_AND_FUTUNA: { alphaTwo: "WF", alphaThree: "WLF", numeric: "876" },
  WESTERN_SAHARA: { alphaTwo: "EH", alphaThree: "ESH", numeric: "732" },
  YEMEN: { alphaTwo: "YE", alphaThree: "YEM", numeric: "887" },
  ZAMBIA: { alphaTwo: "ZM", alphaThree: "ZMB", numeric: "894" },
  ZIMBABWE: { alphaTwo: "ZW", alphaThree: "ZWE", numeric: "716" },
  ALAND_ISLANDS: { alphaTwo: "AX", alphaThree: "ALA", numeric: "248" },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: { alphaTwo: "BQ", alphaThree: "BES", numeric: "535" },
  CURACAO: { alphaTwo: "CW", alphaThree: "CUW", numeric: "531" },
  GUERNSEY: { alphaTwo: "GG", alphaThree: "GGY", numeric: "831" },
  ISLE_OF_MAN: { alphaTwo: "IM", alphaThree: "IMN", numeric: "833" },
  JERSEY: { alphaTwo: "JE", alphaThree: "JEY", numeric: "832" },
  MONTENEGRO: { alphaTwo: "ME", alphaThree: "MNE", numeric: "499" },
  SAINT_BARTHELEMY: { alphaTwo: "BL", alphaThree: "BLM", numeric: "652" },
  SAINT_MARTIN_FRANCE: { alphaTwo: "MF", alphaThree: "MAF", numeric: "663" },
  SINT_MAARTEN_DUTCH: { alphaTwo: "SX", alphaThree: "SXM", numeric: "534" },
  SOUTH_SUDAN: { alphaTwo: "SS", alphaThree: "SSD", numeric: "728" },
  KOSOVO: { alphaTwo: "XK", alphaThree: "XKX", numeric: "" }
};

// src/countries/countryDefinitions.ts
var recognisedCountries = {
  AUSTRALIA: {
    key: "AUSTRALIA",
    region: "Oceania",
    countryName: "Australia",
    transferMate: 14,
    nationality: "Australian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.AUSTRALIA
  },
  AUSTRIA: {
    key: "AUSTRIA",
    region: "Europe",
    countryName: "Austria",
    transferMate: 16,
    nationality: "Austrian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.AUSTRIA
  },
  BAHRAIN: {
    key: "BAHRAIN",
    region: "Middle East",
    countryName: "Bahrain",
    transferMate: 19,
    nationality: "Bahraini",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BAHRAIN
  },
  BARBADOS: {
    key: "BARBADOS",
    region: "North America",
    countryName: "Barbados",
    transferMate: 21,
    nationality: "Barbadian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BARBADOS
  },
  BELGIUM: {
    key: "BELGIUM",
    region: "Europe",
    countryName: "Belgium",
    transferMate: 23,
    nationality: "Belgian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.BELGIUM
  },
  BOTSWANA: {
    key: "BOTSWANA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Botswana",
    transferMate: 30,
    nationality: "Motswana",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BOTSWANA
  },
  BRAZIL: {
    key: "BRAZIL",
    region: "South America",
    countryName: "Brazil",
    transferMate: 32,
    nationality: "Brazilian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BRAZIL
  },
  BRUNEI_DARUSSALAM: {
    key: "BRUNEI_DARUSSALAM",
    region: "Southeast Asia",
    countryName: "Brunei Darussalam",
    nationality: "Bruneian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BRUNEI_DARUSSALAM
  },
  BULGARIA: {
    key: "BULGARIA",
    region: "Europe",
    countryName: "Bulgaria",
    transferMate: 35,
    nationality: "Bulgarian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.BULGARIA
  },
  CAMBODIA: {
    key: "CAMBODIA",
    region: "Southeast Asia",
    countryName: "Cambodia",
    transferMate: 38,
    nationality: "Cambodian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CAMBODIA
  },
  CANADA: {
    key: "CANADA",
    region: "North America",
    countryName: "Canada",
    transferMate: 40,
    nationality: "Canadian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CANADA
  },
  CHILE: {
    key: "CHILE",
    region: "South America",
    countryName: "Chile",
    transferMate: 46,
    nationality: "Chilean",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CHILE
  },
  CHINA: {
    key: "CHINA",
    region: "East Asia",
    countryName: "China",
    transferMate: 47,
    nationality: "Chinese",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CHINA
  },
  CROATIA: {
    key: "CROATIA",
    region: "Europe",
    countryName: "Croatia",
    transferMate: 56,
    nationality: "Croatian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CROATIA
  },
  CYPRUS: {
    key: "CYPRUS",
    region: "Europe",
    countryName: "Cyprus",
    transferMate: 58,
    nationality: "Cypriot",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CYPRUS
  },
  CZECH_REPUBLIC: {
    key: "CZECH_REPUBLIC",
    region: "Europe",
    countryName: "Czech Republic",
    transferMate: 60,
    nationality: "Czech",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CZECH_REPUBLIC
  },
  DENMARK: {
    key: "DENMARK",
    region: "Europe",
    countryName: "Denmark",
    transferMate: 61,
    nationality: "Danish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.DENMARK
  },
  DOMINICA: {
    key: "DOMINICA",
    region: "North America",
    countryName: "Dominica",
    transferMate: 64,
    nationality: "Dominican",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.DOMINICA
  },
  ESTONIA: {
    key: "ESTONIA",
    region: "Europe",
    countryName: "Estonia",
    transferMate: 72,
    nationality: "Estonian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ESTONIA
  },
  FINLAND: {
    key: "FINLAND",
    region: "Europe",
    countryName: "Finland",
    transferMate: 77,
    nationality: "Finnish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.FINLAND
  },
  FRANCE: {
    key: "FRANCE",
    region: "Europe",
    countryName: "France",
    transferMate: 79,
    nationality: "French",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.FRANCE
  },
  GERMANY: {
    key: "GERMANY",
    region: "Europe",
    countryName: "Germany",
    transferMate: 87,
    nationality: "German",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.GERMANY
  },
  GREECE: {
    key: "GREECE",
    region: "Europe",
    countryName: "Greece",
    transferMate: 91,
    nationality: "Greek",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.GREECE
  },
  HONG_KONG: {
    key: "HONG_KONG",
    region: "East Asia",
    countryName: "Hong Kong",
    nationality: "Hong Konger",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.HONG_KONG
  },
  HUNGARY: {
    key: "HUNGARY",
    region: "Europe",
    countryName: "Hungary",
    transferMate: 107,
    nationality: "Hungarian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.HUNGARY
  },
  ICELAND: {
    key: "ICELAND",
    region: "Non_EU Europe",
    countryName: "Iceland",
    transferMate: 108,
    nationality: "Icelander",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ICELAND
  },
  INDONESIA: {
    key: "INDONESIA",
    region: "Southeast Asia",
    countryName: "Indonesia",
    transferMate: 110,
    nationality: "Indonesian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.INDONESIA
  },
  IRELAND: {
    key: "IRELAND",
    region: "Europe",
    countryName: "Ireland",
    transferMate: 113,
    nationality: "Irish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.IRELAND
  },
  ITALY: {
    key: "ITALY",
    region: "Europe",
    countryName: "Italy",
    transferMate: 116,
    nationality: "Italian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ITALY
  },
  JAPAN: {
    key: "JAPAN",
    region: "East Asia",
    countryName: "Japan",
    transferMate: 119,
    nationality: "Japanese",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.JAPAN
  },
  KAZAKHSTAN: {
    key: "KAZAKHSTAN",
    region: "Central Asia (CIS)",
    countryName: "Kazakhstan",
    transferMate: 122,
    nationality: "Kazakhstani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.KAZAKHSTAN
  },
  SOUTH_KOREA: {
    key: "SOUTH_KOREA",
    region: "East Asia",
    countryName: "South Korea",
    nationality: "South Korean",
    atas: false,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SOUTH_KOREA
  },
  KUWAIT: {
    key: "KUWAIT",
    region: "Middle East",
    countryName: "Kuwait",
    transferMate: 126,
    nationality: "Kuwaiti",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.KUWAIT
  },
  LATVIA: {
    key: "LATVIA",
    region: "Europe",
    countryName: "Latvia",
    transferMate: 129,
    nationality: "Latvian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LATVIA
  },
  LIECHTENSTEIN: {
    key: "LIECHTENSTEIN",
    region: "Non_EU Europe",
    countryName: "Liechtenstein",
    transferMate: 134,
    nationality: "Liechtensteiner",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LIECHTENSTEIN
  },
  LITHUANIA: {
    key: "LITHUANIA",
    region: "Europe",
    countryName: "Lithuania",
    transferMate: 135,
    nationality: "Lithuanian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LITHUANIA
  },
  LUXEMBOURG: {
    key: "LUXEMBOURG",
    region: "Europe",
    countryName: "Luxembourg",
    transferMate: 136,
    nationality: "Luxembourger",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LUXEMBOURG
  },
  MACAU: {
    key: "MACAU",
    region: "East Asia",
    countryName: "Macau",
    nationality: "Macanese",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MACAU
  },
  MALAYSIA: {
    key: "MALAYSIA",
    region: "Southeast Asia",
    countryName: "Malaysia",
    transferMate: 141,
    nationality: "Malaysian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MALAYSIA
  },
  MALTA: {
    key: "MALTA",
    region: "Europe",
    countryName: "Malta",
    transferMate: 144,
    nationality: "Maltese",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.MALTA
  },
  MAURITIUS: {
    key: "MAURITIUS",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Mauritius",
    transferMate: 149,
    nationality: "Mauritian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MAURITIUS
  },
  MEXICO: {
    key: "MEXICO",
    region: "North America",
    countryName: "Mexico",
    transferMate: 151,
    nationality: "Mexican",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MEXICO
  },
  NETHERLANDS: {
    key: "NETHERLANDS",
    region: "Europe",
    countryName: "Netherlands",
    nationality: "Dutch",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.NETHERLANDS
  },
  NEW_ZEALAND: {
    key: "NEW_ZEALAND",
    region: "Oceania",
    countryName: "New Zealand",
    transferMate: 164,
    nationality: "New Zealander",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.NEW_ZEALAND
  },
  NORWAY: {
    key: "NORWAY",
    region: "Non_EU Europe",
    countryName: "Norway",
    transferMate: 171,
    nationality: "Norwegian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.NORWAY
  },
  OMAN: {
    key: "OMAN",
    region: "Middle East",
    countryName: "Oman",
    transferMate: 172,
    nationality: "Omani",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.OMAN
  },
  PERU: {
    key: "PERU",
    region: "South America",
    countryName: "Peru",
    transferMate: 178,
    nationality: "Peruvian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.PERU
  },
  POLAND: {
    key: "POLAND",
    region: "Europe",
    countryName: "Poland",
    transferMate: 181,
    nationality: "Polish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.POLAND
  },
  PORTUGAL: {
    key: "PORTUGAL",
    region: "Europe",
    countryName: "Portugal",
    transferMate: 182,
    nationality: "Portuguese",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.PORTUGAL
  },
  QATAR: {
    key: "QATAR",
    region: "Middle East",
    countryName: "Qatar",
    transferMate: 184,
    nationality: "Qatari",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.QATAR
  },
  ROMANIA: {
    key: "ROMANIA",
    region: "Europe",
    countryName: "Romania",
    transferMate: 186,
    nationality: "Romanian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ROMANIA
  },
  SINGAPORE: {
    key: "SINGAPORE",
    region: "Southeast Asia",
    countryName: "Singapore",
    transferMate: 203,
    nationality: "Singaporean",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SINGAPORE
  },
  SLOVAKIA: {
    key: "SLOVAKIA",
    region: "Europe",
    countryName: "Slovakia",
    transferMate: 204,
    nationality: "Slovakian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SLOVAKIA
  },
  SLOVENIA: {
    key: "SLOVENIA",
    region: "Europe",
    countryName: "Slovenia",
    transferMate: 205,
    nationality: "Slovenian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SLOVENIA
  },
  SPAIN: {
    key: "SPAIN",
    region: "Europe",
    countryName: "Spain",
    transferMate: 211,
    nationality: "Spanish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SPAIN
  },
  SWEDEN: {
    key: "SWEDEN",
    region: "Europe",
    countryName: "Sweden",
    transferMate: 217,
    nationality: "Swedish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SWEDEN
  },
  SWITZERLAND: {
    key: "SWITZERLAND",
    region: "Non_EU Europe",
    countryName: "Switzerland",
    transferMate: 218,
    nationality: "Swiss",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SWITZERLAND
  },
  TAIWAN: {
    key: "TAIWAN",
    region: "East Asia",
    countryName: "Taiwan",
    transferMate: 220,
    nationality: "Taiwanese",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.TAIWAN
  },
  THAILAND: {
    key: "THAILAND",
    region: "Southeast Asia",
    countryName: "Thailand",
    transferMate: 223,
    nationality: "Thai",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.THAILAND
  },
  TUNISIA: {
    key: "TUNISIA",
    region: "Africa",
    countryName: "Tunisia",
    transferMate: 228,
    nationality: "Tunisian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.TUNISIA
  },
  UNITED_ARAB_EMIRATES: {
    key: "UNITED_ARAB_EMIRATES",
    region: "Middle East",
    countryName: "United Arab Emirates",
    transferMate: 235,
    nationality: "Emirati",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.UNITED_ARAB_EMIRATES
  },
  UNITED_STATES_OF_AMERICA: {
    key: "UNITED_STATES_OF_AMERICA",
    region: "North America",
    countryName: "United States of America",
    nationality: "American",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.UNITED_STATES_OF_AMERICA
  },
  SERBIA: {
    key: "SERBIA",
    region: "Non_EU Europe",
    countryName: "Serbia",
    transferMate: 200,
    nationality: "Serbian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SERBIA
  },
  AFGHANISTAN: {
    key: "AFGHANISTAN",
    region: "Middle East",
    countryName: "Afghanistan",
    transferMate: 2,
    nationality: "Afghan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AFGHANISTAN
  },
  ALBANIA: {
    key: "ALBANIA",
    region: "Non_EU Europe",
    countryName: "Albania",
    transferMate: 3,
    nationality: "Albanian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALBANIA
  },
  ALGERIA: {
    key: "ALGERIA",
    region: "Africa",
    countryName: "Algeria",
    transferMate: 4,
    nationality: "Algerian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALGERIA
  },
  AMERICAN_SAMOA: {
    key: "AMERICAN_SAMOA",
    region: "Oceania",
    countryName: "American Samoa",
    transferMate: 5,
    nationality: "Samoan (American)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AMERICAN_SAMOA
  },
  ANDORRA: {
    key: "ANDORRA",
    region: "Europe",
    countryName: "Andorra",
    transferMate: 6,
    nationality: "Andorran",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANDORRA
  },
  ANGOLA: {
    key: "ANGOLA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Angola",
    transferMate: 7,
    nationality: "Angolan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANGOLA
  },
  ANGUILLA: {
    key: "ANGUILLA",
    region: "North America",
    countryName: "Anguilla",
    transferMate: 8,
    nationality: "Anguillan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANGUILLA
  },
  ANTARCTICA: {
    key: "ANTARCTICA",
    region: "Antarctica",
    countryName: "Antarctica",
    transferMate: 9,
    nationality: "Antarctic",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANTARCTICA
  },
  ANTIGUA_AND_BARBUDA: {
    key: "ANTIGUA_AND_BARBUDA",
    region: "North America",
    countryName: "Antigua and Barbuda",
    transferMate: 10,
    nationality: "Antiguans",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANTIGUA_AND_BARBUDA
  },
  ARGENTINA: {
    key: "ARGENTINA",
    region: "South America",
    countryName: "Argentina",
    transferMate: 11,
    nationality: "Argentinean",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARGENTINA
  },
  ARMENIA: {
    key: "ARMENIA",
    region: "Central Asia (CIS)",
    countryName: "Armenia",
    transferMate: 12,
    nationality: "Armenian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARMENIA
  },
  ARUBA: {
    key: "ARUBA",
    region: "South America",
    countryName: "Aruba",
    transferMate: 13,
    nationality: "Arubian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARUBA
  },
  AZERBAIJAN: {
    key: "AZERBAIJAN",
    region: "Central Asia (CIS)",
    countryName: "Azerbaijan",
    transferMate: 17,
    nationality: "Azerbaijani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AZERBAIJAN
  },
  BAHAMAS: {
    key: "BAHAMAS",
    region: "North America",
    countryName: "Bahamas",
    transferMate: 18,
    nationality: "Bahamian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BAHAMAS
  },
  BANGLADESH: {
    key: "BANGLADESH",
    region: "South Asia",
    countryName: "Bangladesh",
    transferMate: 20,
    nationality: "Bangladeshi",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BANGLADESH
  },
  BELARUS: {
    key: "BELARUS",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Belarus",
    transferMate: 22,
    nationality: "Belarusian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BELARUS
  },
  BELIZE: {
    key: "BELIZE",
    region: "North America",
    countryName: "Belize",
    transferMate: 24,
    nationality: "Belizean",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BELIZE
  },
  BENIN: {
    key: "BENIN",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Benin",
    transferMate: 25,
    nationality: "Beninese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BENIN
  },
  BERMUDA: {
    key: "BERMUDA",
    region: "North America",
    countryName: "Bermuda",
    transferMate: 26,
    nationality: "Bermudan",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BERMUDA
  },
  BHUTAN: {
    key: "BHUTAN",
    region: "South Asia",
    countryName: "Bhutan",
    transferMate: 27,
    nationality: "Bhutanese",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BHUTAN
  },
  BOLIVIA: {
    key: "BOLIVIA",
    region: "South America",
    countryName: "Bolivia",
    transferMate: 28,
    nationality: "Bolivian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOLIVIA
  },
  BOSNIA_AND_HERZEGOVINA: {
    key: "BOSNIA_AND_HERZEGOVINA",
    region: "Non_EU Europe",
    countryName: "Bosnia and Herzegovina",
    transferMate: 29,
    nationality: "Bosnian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOSNIA_AND_HERZEGOVINA
  },
  BOUVET_ISLAND: {
    key: "BOUVET_ISLAND",
    region: "South America",
    countryName: "Bouvet Island",
    transferMate: 31,
    nationality: "Bouvet Island",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOUVET_ISLAND
  },
  BRITISH_INDIAN_OCEAN_TERRITORY: {
    key: "BRITISH_INDIAN_OCEAN_TERRITORY",
    region: "South Asia",
    countryName: "British Indian Ocean Territory",
    transferMate: 33,
    nationality: "British (IOT)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY
  },
  BURKINA_FASO: {
    key: "BURKINA_FASO",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Burkina Faso",
    transferMate: 36,
    nationality: "Burkinabe",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BURKINA_FASO
  },
  BURUNDI: {
    key: "BURUNDI",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Burundi",
    transferMate: 37,
    nationality: "Burundian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BURUNDI
  },
  CAMEROON: {
    key: "CAMEROON",
    region: "Africa",
    countryName: "Cameroon",
    transferMate: 39,
    nationality: "Cameroonian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAMEROON
  },
  CAPE_VERDE: {
    key: "CAPE_VERDE",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Cape Verde",
    transferMate: 42,
    nationality: "Cape Verdean",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAPE_VERDE
  },
  CAYMAN_ISLANDS: {
    key: "CAYMAN_ISLANDS",
    region: "North America",
    countryName: "Cayman Islands",
    transferMate: 43,
    nationality: "Caymanian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAYMAN_ISLANDS
  },
  CENTRAL_AFRICAN_REPUBLIC: {
    key: "CENTRAL_AFRICAN_REPUBLIC",
    region: "Africa",
    countryName: "Central African Republic",
    transferMate: 44,
    nationality: "Central African",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CENTRAL_AFRICAN_REPUBLIC
  },
  CHAD: {
    key: "CHAD",
    region: "Africa",
    countryName: "Chad",
    transferMate: 45,
    nationality: "Chadian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CHAD
  },
  CHRISTMAS_ISLAND: {
    key: "CHRISTMAS_ISLAND",
    region: "Southeast Asia",
    countryName: "Christmas Island",
    transferMate: 48,
    nationality: "Christmas Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CHRISTMAS_ISLAND
  },
  COCOS_KEELING_ISLANDS: {
    key: "COCOS_KEELING_ISLANDS",
    region: "Southeast Asia",
    countryName: "Cocos (Keeling) Islands",
    transferMate: 49,
    nationality: "Cocossian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COCOS_KEELING_ISLANDS
  },
  COLOMBIA: {
    key: "COLOMBIA",
    region: "South America",
    countryName: "Colombia",
    transferMate: 50,
    nationality: "Colombian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COLOMBIA
  },
  COMOROS: {
    key: "COMOROS",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Comoros",
    transferMate: 51,
    nationality: "Comoran",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COMOROS
  },
  CONGO: {
    key: "CONGO",
    region: "Africa",
    countryName: "Congo",
    transferMate: 52,
    nationality: "Congolese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CONGO
  },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: {
    key: "CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE",
    region: "Africa",
    transferMate: 256,
    countryName: "Congo, the Democratic Republic of the",
    nationality: "Congolese (DRC)",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE
  },
  COOK_ISLANDS: {
    key: "COOK_ISLANDS",
    region: "Oceania",
    countryName: "Cook Islands",
    transferMate: 53,
    nationality: "Cook Islander",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COOK_ISLANDS
  },
  COSTA_RICA: {
    key: "COSTA_RICA",
    region: "North America",
    countryName: "Costa Rica",
    transferMate: 54,
    nationality: "Costa Rican",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COSTA_RICA
  },
  COTE_DIVOIRE: {
    key: "COTE_DIVOIRE",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Cote D'Ivoire",
    nationality: "Ivorian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COTE_DIVOIRE
  },
  CUBA: {
    key: "CUBA",
    region: "North America",
    countryName: "Cuba",
    transferMate: 57,
    nationality: "Cuban",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CUBA
  },
  DJIBOUTI: {
    key: "DJIBOUTI",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Djibouti",
    transferMate: 63,
    nationality: "Djiboutian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.DJIBOUTI
  },
  DOMINICAN_REPUBLIC: {
    key: "DOMINICAN_REPUBLIC",
    region: "North America",
    countryName: "Dominican Republic",
    transferMate: 65,
    nationality: "Dominican (Republic)",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.DOMINICAN_REPUBLIC
  },
  ECUADOR: {
    key: "ECUADOR",
    region: "South America",
    countryName: "Ecuador",
    transferMate: 67,
    nationality: "Ecuadorean",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ECUADOR
  },
  EGYPT: {
    key: "EGYPT",
    region: "Middle East|Africa",
    countryName: "Egypt",
    transferMate: 68,
    nationality: "Egyptian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EGYPT
  },
  EL_SALVADOR: {
    key: "EL_SALVADOR",
    region: "North America",
    countryName: "El Salvador",
    transferMate: 69,
    nationality: "Salvadorean",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EL_SALVADOR
  },
  EQUATORIAL_GUINEA: {
    key: "EQUATORIAL_GUINEA",
    region: "Africa",
    countryName: "Equatorial Guinea",
    transferMate: 70,
    nationality: "Equatorial Guinean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EQUATORIAL_GUINEA
  },
  ERITREA: {
    key: "ERITREA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Eritrea",
    transferMate: 71,
    nationality: "Eritrean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ERITREA
  },
  ETHIOPIA: {
    key: "ETHIOPIA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Ethiopia",
    transferMate: 73,
    nationality: "Ethiopian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ETHIOPIA
  },
  FALKLAND_ISLANDS_MALVINAS: {
    key: "FALKLAND_ISLANDS_MALVINAS",
    region: "South America",
    countryName: "Falkland Islands (Malvinas)",
    nationality: "Falkland Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FALKLAND_ISLANDS_MALVINAS
  },
  FAROE_ISLANDS: {
    key: "FAROE_ISLANDS",
    region: "Europe",
    countryName: "Faroe Islands",
    transferMate: 75,
    nationality: "Faroese",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FAROE_ISLANDS
  },
  FIJI: {
    key: "FIJI",
    region: "Oceania",
    countryName: "Fiji",
    nationality: "Fijian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FIJI
  },
  FRENCH_GUIANA: {
    key: "FRENCH_GUIANA",
    region: "South America",
    countryName: "French Guiana",
    transferMate: 81,
    nationality: "French Guianese",
    atas: false,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_GUIANA
  },
  FRENCH_POLYNESIA: {
    key: "FRENCH_POLYNESIA",
    region: "Oceania",
    countryName: "French Polynesia",
    transferMate: 82,
    nationality: "French Polynesian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_POLYNESIA
  },
  FRENCH_SOUTHERN_TERRITORIES: {
    key: "FRENCH_SOUTHERN_TERRITORIES",
    region: "South Asia",
    countryName: "French Southern Territories",
    transferMate: 83,
    nationality: "French (Southern Territories)",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_SOUTHERN_TERRITORIES
  },
  GABON: {
    key: "GABON",
    region: "Africa",
    countryName: "Gabon",
    transferMate: 84,
    nationality: "Gabonese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GABON
  },
  GAMBIA: {
    key: "GAMBIA",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Gambia",
    transferMate: 85,
    nationality: "Gambian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GAMBIA
  },
  GEORGIA: {
    key: "GEORGIA",
    region: "Non_EU Europe",
    countryName: "Georgia",
    transferMate: 86,
    nationality: "Georgian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GEORGIA
  },
  GHANA: {
    key: "GHANA",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Ghana",
    transferMate: 89,
    nationality: "Ghanaian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GHANA
  },
  GIBRALTAR: {
    key: "GIBRALTAR",
    region: "Europe",
    countryName: "Gibraltar",
    transferMate: 90,
    nationality: "Gibraltarian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GIBRALTAR
  },
  GREENLAND: {
    key: "GREENLAND",
    region: "Europe",
    countryName: "Greenland",
    transferMate: 92,
    nationality: "Greenlander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GREENLAND
  },
  GRENADA: {
    key: "GRENADA",
    region: "North America",
    countryName: "Grenada",
    transferMate: 93,
    nationality: "Grenadian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GRENADA
  },
  GUADELOUPE: {
    key: "GUADELOUPE",
    region: "North America",
    countryName: "Guadeloupe",
    transferMate: 94,
    nationality: "Guadeloupean",
    atas: false,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUADELOUPE
  },
  GUAM: {
    key: "GUAM",
    region: "East Asia",
    countryName: "Guam",
    transferMate: 95,
    nationality: "Guamanian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUAM
  },
  GUATEMALA: {
    key: "GUATEMALA",
    region: "North America",
    countryName: "Guatemala",
    transferMate: 96,
    nationality: "Guatemalan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUATEMALA
  },
  GUINEA: {
    key: "GUINEA",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Guinea",
    transferMate: 97,
    nationality: "Guinean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUINEA
  },
  GUINEA_BISSAU: {
    key: "GUINEA_BISSAU",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Guinea-Bissau",
    transferMate: 98,
    nationality: "Guinean (Bissau)",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUINEA_BISSAU
  },
  GUYANA: {
    key: "GUYANA",
    region: "South America",
    countryName: "Guyana",
    transferMate: 99,
    nationality: "Guyanese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUYANA
  },
  HAITI: {
    key: "HAITI",
    region: "North America",
    countryName: "Haiti",
    transferMate: 100,
    nationality: "Haitian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HAITI
  },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: {
    key: "HEARD_ISLAND_AND_MCDONALD_ISLANDS",
    region: "Oceania",
    countryName: "Heard Island and Mcdonald Islands",
    nationality: "Heard Island and Mcdonald Island",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS
  },
  VATICAN: {
    key: "VATICAN",
    region: "Europe",
    countryName: "Vatican",
    nationality: "Vatican",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VATICAN
  },
  HONDURAS: {
    key: "HONDURAS",
    region: "North America",
    countryName: "Honduras",
    transferMate: 104,
    nationality: "Honduran",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HONDURAS
  },
  INDIA: {
    key: "INDIA",
    region: "South Asia",
    countryName: "India",
    transferMate: 109,
    nationality: "Indian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.INDIA
  },
  IRAN_ISLAMIC_REPUBLIC_OF: {
    key: "IRAN_ISLAMIC_REPUBLIC_OF",
    region: "Middle East",
    countryName: "Iran, Islamic Republic of",
    nationality: "Iranian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.IRAN_ISLAMIC_REPUBLIC_OF
  },
  IRAQ: {
    key: "IRAQ",
    region: "Middle East",
    countryName: "Iraq",
    transferMate: 112,
    nationality: "Iraqi",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.IRAQ
  },
  ISRAEL: {
    key: "ISRAEL",
    region: "Middle East",
    countryName: "Israel",
    transferMate: 115,
    nationality: "Israeli",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ISRAEL
  },
  JAMAICA: {
    key: "JAMAICA",
    region: "North America",
    countryName: "Jamaica",
    transferMate: 118,
    nationality: "Jamaican",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JAMAICA
  },
  JORDAN: {
    key: "JORDAN",
    region: "Middle East",
    countryName: "Jordan",
    transferMate: 121,
    nationality: "Jordanian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JORDAN
  },
  KENYA: {
    key: "KENYA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Kenya",
    transferMate: 123,
    nationality: "Kenyan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KENYA
  },
  KIRIBATI: {
    key: "KIRIBATI",
    region: "Oceania",
    countryName: "Kiribati",
    transferMate: 124,
    nationality: "I_Kiribati",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KIRIBATI
  },
  NORTH_KOREA: {
    key: "NORTH_KOREA",
    region: "East Asia",
    countryName: "North Korea",
    nationality: "North Korean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTH_KOREA
  },
  KYRGYZSTAN: {
    key: "KYRGYZSTAN",
    region: "Central Asia (CIS)",
    countryName: "Kyrgyzstan",
    transferMate: 127,
    nationality: "Kyrgyzstani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KYRGYZSTAN
  },
  LAOS: {
    key: "LAOS",
    region: "Southeast Asia",
    countryName: "Laos",
    transferMate: 128,
    nationality: "Laotian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LAOS
  },
  LEBANON: {
    key: "LEBANON",
    region: "Middle East",
    countryName: "Lebanon",
    transferMate: 130,
    nationality: "Lebanese",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LEBANON
  },
  LESOTHO: {
    key: "LESOTHO",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Lesotho",
    transferMate: 131,
    nationality: "Mosotho",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LESOTHO
  },
  LIBERIA: {
    key: "LIBERIA",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Liberia",
    transferMate: 132,
    nationality: "Liberian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LIBERIA
  },
  LIBYA: {
    key: "LIBYA",
    region: "Africa",
    countryName: "Libya",
    nationality: "Libyan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LIBYA
  },
  MADAGASCAR: {
    key: "MADAGASCAR",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Madagascar",
    transferMate: 139,
    nationality: "Malagasy",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MADAGASCAR
  },
  MALAWI: {
    key: "MALAWI",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Malawi",
    transferMate: 140,
    nationality: "Malawian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALAWI
  },
  MALDIVES: {
    key: "MALDIVES",
    region: "South Asia",
    countryName: "Maldives",
    transferMate: 142,
    nationality: "Maldivan",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALDIVES
  },
  MALI: {
    key: "MALI",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Mali",
    transferMate: 143,
    nationality: "Malian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALI
  },
  MARSHALL_ISLANDS: {
    key: "MARSHALL_ISLANDS",
    region: "Oceania",
    countryName: "Marshall Islands",
    transferMate: 146,
    nationality: "Marshallese",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MARSHALL_ISLANDS
  },
  MARTINIQUE: {
    key: "MARTINIQUE",
    region: "North America",
    countryName: "Martinique",
    transferMate: 147,
    nationality: "Martinican",
    atas: false,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MARTINIQUE
  },
  MAURITANIA: {
    key: "MAURITANIA",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Mauritania",
    transferMate: 148,
    nationality: "Mauritanian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MAURITANIA
  },
  MAYOTTE: {
    key: "MAYOTTE",
    region: "Africa",
    countryName: "Mayotte",
    transferMate: 150,
    nationality: "Mahoran",
    atas: false,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MAYOTTE
  },
  MICRONESIA_FEDERATED_STATES_OF: {
    key: "MICRONESIA_FEDERATED_STATES_OF",
    region: "Oceania",
    countryName: "Micronesia, Federated States of",
    nationality: "Micronesian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MICRONESIA_FEDERATED_STATES_OF
  },
  MOLDOVA_REPUBLIC_OF: {
    key: "MOLDOVA_REPUBLIC_OF",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Moldova, Republic of",
    nationality: "Moldovan",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOLDOVA_REPUBLIC_OF
  },
  MONACO: {
    key: "MONACO",
    region: "Europe",
    countryName: "Monaco",
    transferMate: 154,
    nationality: "Monacan",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONACO
  },
  MONGOLIA: {
    key: "MONGOLIA",
    region: "East Asia",
    countryName: "Mongolia",
    transferMate: 155,
    nationality: "Mongolian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONGOLIA
  },
  MONTSERRAT: {
    key: "MONTSERRAT",
    region: "North America",
    countryName: "Montserrat",
    transferMate: 156,
    nationality: "Montserratian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONTSERRAT
  },
  MOROCCO: {
    key: "MOROCCO",
    region: "Africa",
    countryName: "Morocco",
    transferMate: 157,
    nationality: "Moroccan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOROCCO
  },
  MOZAMBIQUE: {
    key: "MOZAMBIQUE",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Mozambique",
    transferMate: 158,
    nationality: "Mozambican",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOZAMBIQUE
  },
  MYANMAR: {
    key: "MYANMAR",
    region: "Southeast Asia",
    countryName: "Myanmar",
    transferMate: 159,
    nationality: "Myanmarese",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MYANMAR
  },
  NAMIBIA: {
    key: "NAMIBIA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Namibia",
    transferMate: 160,
    nationality: "Namibian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NAMIBIA
  },
  NAURU: {
    key: "NAURU",
    region: "Oceania",
    countryName: "Nauru",
    transferMate: 161,
    nationality: "Nauruan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NAURU
  },
  NEPAL: {
    key: "NEPAL",
    region: "South Asia",
    countryName: "Nepal",
    transferMate: 162,
    nationality: "Nepalese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NEPAL
  },
  NEW_CALEDONIA: {
    key: "NEW_CALEDONIA",
    region: "Oceania",
    countryName: "New Caledonia",
    transferMate: 262,
    nationality: "New Caledonian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NEW_CALEDONIA
  },
  NICARAGUA: {
    key: "NICARAGUA",
    region: "North America",
    countryName: "Nicaragua",
    transferMate: 165,
    nationality: "Nicaraguan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NICARAGUA
  },
  NIGER: {
    key: "NIGER",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Niger",
    transferMate: 166,
    nationality: "Nigerien",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIGER
  },
  NIGERIA: {
    key: "NIGERIA",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Nigeria",
    transferMate: 167,
    nationality: "Nigerian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIGERIA
  },
  NIUE: {
    key: "NIUE",
    region: "Oceania",
    countryName: "Niue",
    transferMate: 168,
    nationality: "Niuean",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIUE
  },
  NORFOLK_ISLAND: {
    key: "NORFOLK_ISLAND",
    region: "Oceania",
    countryName: "Norfolk Island",
    transferMate: 169,
    nationality: "Norfolk Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORFOLK_ISLAND
  },
  NORTH_MACEDONIA_REPUBLIC_OF: {
    key: "NORTH_MACEDONIA_REPUBLIC_OF",
    region: "Non_EU Europe",
    countryName: "North Macedonia, Republic of",
    nationality: "Macedonian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTH_MACEDONIA_REPUBLIC_OF
  },
  NORTHERN_MARIANA_ISLANDS: {
    key: "NORTHERN_MARIANA_ISLANDS",
    region: "Oceania",
    countryName: "Northern Mariana Islands",
    transferMate: 170,
    nationality: "Northern Mariana Islander",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTHERN_MARIANA_ISLANDS
  },
  PAKISTAN: {
    key: "PAKISTAN",
    region: "South Asia",
    countryName: "Pakistan",
    transferMate: 173,
    nationality: "Pakistani",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PAKISTAN
  },
  PALAU: {
    key: "PALAU",
    region: "Oceania",
    countryName: "Palau",
    transferMate: 174,
    nationality: "Palauan",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PALAU
  },
  PALESTINE: {
    key: "PALESTINE",
    region: "Middle East",
    countryName: "Palestine",
    nationality: "Palestinian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PALESTINE
  },
  PANAMA: {
    key: "PANAMA",
    region: "North America",
    countryName: "Panama",
    transferMate: 175,
    nationality: "Panamanian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PANAMA
  },
  PAPUA_NEW_GUINEA: {
    key: "PAPUA_NEW_GUINEA",
    region: "Oceania",
    countryName: "Papua New Guinea",
    nationality: "Papua New Guinean",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PAPUA_NEW_GUINEA
  },
  PARAGUAY: {
    key: "PARAGUAY",
    region: "South America",
    countryName: "Paraguay",
    transferMate: 177,
    nationality: "Paraguayan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PARAGUAY
  },
  PHILIPPINES: {
    key: "PHILIPPINES",
    region: "Southeast Asia",
    countryName: "Philippines",
    transferMate: 179,
    nationality: "Filipino",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PHILIPPINES
  },
  PITCAIRN: {
    key: "PITCAIRN",
    region: "Oceania",
    countryName: "Pitcairn",
    nationality: "Pitcairn Islander",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PITCAIRN
  },
  PUERTO_RICO: {
    key: "PUERTO_RICO",
    region: "North America",
    countryName: "Puerto Rico",
    transferMate: 183,
    nationality: "Puerto Rican",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PUERTO_RICO
  },
  REUNION: {
    key: "REUNION",
    region: "South Asia",
    countryName: "Reunion",
    transferMate: 185,
    nationality: "Reunion",
    atas: false,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.REUNION
  },
  RUSSIA: {
    key: "RUSSIA",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Russia",
    transferMate: 187,
    nationality: "Russian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.RUSSIA
  },
  RWANDA: {
    key: "RWANDA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Rwanda",
    transferMate: 188,
    nationality: "Rwandan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.RWANDA
  },
  SAINT_HELENA: {
    key: "SAINT_HELENA",
    region: "Africa",
    countryName: "Saint Helena",
    transferMate: 190,
    nationality: "Saint Helenian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_HELENA
  },
  SAINT_KITTS_AND_NEVIS: {
    key: "SAINT_KITTS_AND_NEVIS",
    region: "North America",
    countryName: "Saint Kitts and Nevis",
    nationality: "Kittian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_KITTS_AND_NEVIS
  },
  SAINT_LUCIA: {
    key: "SAINT_LUCIA",
    region: "North America",
    countryName: "Saint Lucia",
    transferMate: 192,
    nationality: "Saint Lucian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_LUCIA
  },
  SAINT_PIERRE_AND_MIQUELON: {
    key: "SAINT_PIERRE_AND_MIQUELON",
    region: "North America",
    countryName: "Saint Pierre and Miquelon",
    transferMate: 193,
    nationality: "Saint_Pierrais",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_PIERRE_AND_MIQUELON
  },
  SAINT_VINCENT_AND_THE_GRENADINES: {
    key: "SAINT_VINCENT_AND_THE_GRENADINES",
    region: "North America",
    countryName: "Saint Vincent and the Grenadines",
    nationality: "Saint Vincentian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_VINCENT_AND_THE_GRENADINES
  },
  SAMOA: {
    key: "SAMOA",
    region: "Oceania",
    countryName: "Samoa",
    transferMate: 195,
    nationality: "Samoan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAMOA
  },
  SAN_MARINO: {
    key: "SAN_MARINO",
    region: "Europe",
    countryName: "San Marino",
    transferMate: 196,
    nationality: "Sanmarinese",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAN_MARINO
  },
  SAO_TOME_AND_PRINCIPE: {
    key: "SAO_TOME_AND_PRINCIPE",
    region: "Africa",
    countryName: "Sao Tome and Principe",
    transferMate: 197,
    nationality: "Sao Tomean",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAO_TOME_AND_PRINCIPE
  },
  SAUDI_ARABIA: {
    key: "SAUDI_ARABIA",
    region: "Middle East",
    countryName: "Saudi Arabia",
    transferMate: 198,
    nationality: "Saudi Arabian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAUDI_ARABIA
  },
  SENEGAL: {
    key: "SENEGAL",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Senegal",
    transferMate: 199,
    nationality: "Senegalese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SENEGAL
  },
  SEYCHELLES: {
    key: "SEYCHELLES",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Seychelles",
    transferMate: 201,
    nationality: "Seychellois",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SEYCHELLES
  },
  SIERRA_LEONE: {
    key: "SIERRA_LEONE",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Sierra Leone",
    transferMate: 202,
    nationality: "Sierra Leonean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SIERRA_LEONE
  },
  SOLOMON_ISLANDS: {
    key: "SOLOMON_ISLANDS",
    region: "Oceania",
    countryName: "Solomon Islands",
    transferMate: 206,
    nationality: "Solomon Islander",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOLOMON_ISLANDS
  },
  SOMALIA: {
    key: "SOMALIA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Somalia",
    transferMate: 207,
    nationality: "Somali",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOMALIA
  },
  SOUTH_AFRICA: {
    key: "SOUTH_AFRICA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "South Africa",
    transferMate: 208,
    nationality: "South African",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_AFRICA
  },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: {
    key: "SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS",
    region: "Central Asia (CIS)",
    countryName: "South Georgia and the South Sandwich Islands",
    nationality: "South Georgia and the South Sandwich Islands",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS
  },
  SRI_LANKA: {
    key: "SRI_LANKA",
    region: "South Asia",
    countryName: "Sri Lanka",
    transferMate: 212,
    nationality: "Sri Lankan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SRI_LANKA
  },
  SUDAN: {
    key: "SUDAN",
    region: "Africa",
    countryName: "Sudan",
    transferMate: 213,
    nationality: "Sudanese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SUDAN
  },
  SURINAME: {
    key: "SURINAME",
    region: "South America",
    countryName: "Suriname",
    transferMate: 214,
    nationality: "Surinamer",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SURINAME
  },
  SVALBARD_AND_JAN_MAYEN: {
    key: "SVALBARD_AND_JAN_MAYEN",
    region: "Europe",
    countryName: "Svalbard and Jan Mayen",
    nationality: "Svalbard and Jan Mayen",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SVALBARD_AND_JAN_MAYEN
  },
  SWAZILAND: {
    key: "SWAZILAND",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Swaziland",
    transferMate: 216,
    nationality: "Swazi",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SWAZILAND
  },
  SYRIA: {
    key: "SYRIA",
    region: "Middle East",
    countryName: "Syria",
    nationality: "Syrian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SYRIA
  },
  TAJIKISTAN: {
    key: "TAJIKISTAN",
    region: "Central Asia (CIS)",
    countryName: "Tajikistan",
    transferMate: 221,
    nationality: "Tajikistani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TAJIKISTAN
  },
  TANZANIA_UNITED_REPUBLIC_OF: {
    key: "TANZANIA_UNITED_REPUBLIC_OF",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Tanzania, United Republic of",
    nationality: "Tanzanian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TANZANIA_UNITED_REPUBLIC_OF
  },
  TIMOR_LESTE: {
    key: "TIMOR_LESTE",
    region: "Southeast Asia",
    countryName: "Timor-Leste",
    nationality: "Timorese",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TIMOR_LESTE
  },
  TOGO: {
    key: "TOGO",
    region: "Africa",
    subRegion: "WestAfrica",
    countryName: "Togo",
    transferMate: 224,
    nationality: "Togolese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TOGO
  },
  TOKELAU: {
    key: "TOKELAU",
    region: "Oceania",
    countryName: "Tokelau",
    transferMate: 225,
    nationality: "Tokelauan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TOKELAU
  },
  TONGA: {
    key: "TONGA",
    region: "Oceania",
    countryName: "Tonga",
    transferMate: 226,
    nationality: "Tongan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TONGA
  },
  TRINIDAD_AND_TOBAGO: {
    key: "TRINIDAD_AND_TOBAGO",
    region: "North America",
    countryName: "Trinidad and Tobago",
    nationality: "Trinidadian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TRINIDAD_AND_TOBAGO
  },
  TURKEY: {
    key: "TURKEY",
    region: "Non_EU Europe",
    countryName: "Turkey",
    transferMate: 229,
    nationality: "Turkish",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKEY
  },
  TURKMENISTAN: {
    key: "TURKMENISTAN",
    region: "Central Asia (CIS)",
    countryName: "Turkmenistan",
    transferMate: 230,
    nationality: "Turkmen",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKMENISTAN
  },
  TURKS_AND_CAICOS_ISLANDS: {
    key: "TURKS_AND_CAICOS_ISLANDS",
    region: "North America",
    countryName: "Turks and Caicos Islands",
    nationality: "Turks and Caicos Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKS_AND_CAICOS_ISLANDS
  },
  TUVALU: {
    key: "TUVALU",
    region: "Oceania",
    countryName: "Tuvalu",
    transferMate: 232,
    nationality: "Tuvaluan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TUVALU
  },
  UGANDA: {
    key: "UGANDA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Uganda",
    transferMate: 233,
    nationality: "Ugandan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UGANDA
  },
  UKRAINE: {
    key: "UKRAINE",
    region: "Non_EU Europe",
    countryName: "Ukraine",
    transferMate: 234,
    nationality: "Ukrainian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UKRAINE
  },
  UNITED_KINGDOM: {
    key: "UNITED_KINGDOM",
    region: "UK",
    countryName: "United Kingdom",
    transferMate: 236,
    nationality: "British",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UNITED_KINGDOM
  },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: {
    key: "UNITED_STATES_MINOR_OUTLYING_ISLANDS",
    region: "Oceania",
    countryName: "United States Minor Outlying Islands",
    nationality: "American (MOI)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS
  },
  URUGUAY: {
    key: "URUGUAY",
    region: "South America",
    countryName: "Uruguay",
    transferMate: 239,
    nationality: "Uruguayan",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.URUGUAY
  },
  UZBEKISTAN: {
    key: "UZBEKISTAN",
    region: "Central Asia (CIS)",
    countryName: "Uzbekistan",
    transferMate: 241,
    nationality: "Uzbekistani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UZBEKISTAN
  },
  VANUATU: {
    key: "VANUATU",
    region: "Oceania",
    countryName: "Vanuatu",
    transferMate: 242,
    nationality: "Ni_Vanuatu",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VANUATU
  },
  VENEZUELA: {
    key: "VENEZUELA",
    region: "South America",
    countryName: "Venezuela",
    transferMate: 244,
    nationality: "Venezuelan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VENEZUELA
  },
  VIETNAM: {
    key: "VIETNAM",
    region: "Southeast Asia",
    countryName: "Vietnam",
    transferMate: 245,
    nationality: "Vietnamese",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIETNAM
  },
  VIRGIN_ISLANDS_BRITISH: {
    key: "VIRGIN_ISLANDS_BRITISH",
    region: "North America",
    countryName: "Virgin Islands, British",
    nationality: "Virgin Islander (British)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIRGIN_ISLANDS_BRITISH
  },
  VIRGIN_ISLANDS_US: {
    key: "VIRGIN_ISLANDS_US",
    region: "North America",
    countryName: "Virgin Islands, U.S.",
    nationality: "Virgin Islander (American)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIRGIN_ISLANDS_US
  },
  WALLIS_AND_FUTUNA: {
    key: "WALLIS_AND_FUTUNA",
    region: "Oceania",
    countryName: "Wallis and Futuna",
    nationality: "Wallisian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.WALLIS_AND_FUTUNA
  },
  WESTERN_SAHARA: {
    key: "WESTERN_SAHARA",
    region: "Africa",
    countryName: "Western Sahara",
    transferMate: 266,
    nationality: "Western Saharan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.WESTERN_SAHARA
  },
  YEMEN: {
    key: "YEMEN",
    region: "Middle East",
    countryName: "Yemen",
    transferMate: 249,
    nationality: "Yemenese",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.YEMEN
  },
  ZAMBIA: {
    key: "ZAMBIA",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Zambia",
    transferMate: 250,
    nationality: "Zambian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ZAMBIA
  },
  ZIMBABWE: {
    key: "ZIMBABWE",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "Zimbabwe",
    transferMate: 251,
    nationality: "Zimbabwean",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ZIMBABWE
  },
  ALAND_ISLANDS: {
    key: "ALAND_ISLANDS",
    region: "Europe",
    countryName: "\xC5land Islands",
    nationality: "\xC5landic",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALAND_ISLANDS
  },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: {
    key: "BONAIRE_SINT_EUSTATIUS_AND_SABA",
    region: "North America",
    countryName: "Bonaire, Sint Eustatius and Saba",
    nationality: "Dutch (Caribbean)",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA
  },
  CURACAO: {
    key: "CURACAO",
    region: "North America",
    countryName: "Cura\xE7ao",
    nationality: "Cura\xE7aoan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CURACAO
  },
  GUERNSEY: {
    key: "GUERNSEY",
    region: "Europe",
    countryName: "Guernsey",
    transferMate: 258,
    nationality: "Guernsey",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUERNSEY
  },
  ISLE_OF_MAN: {
    key: "ISLE_OF_MAN",
    region: "Europe",
    countryName: "Isle of Man",
    transferMate: 259,
    nationality: "Manx",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ISLE_OF_MAN
  },
  JERSEY: {
    key: "JERSEY",
    region: "Europe",
    countryName: "Jersey",
    transferMate: 260,
    nationality: "Jersey",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JERSEY
  },
  MONTENEGRO: {
    key: "MONTENEGRO",
    region: "Non_EU Europe",
    countryName: "Montenegro",
    nationality: "Montenegrin",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONTENEGRO
  },
  SAINT_BARTHELEMY: {
    key: "SAINT_BARTHELEMY",
    region: "North America",
    countryName: "Saint Barth\xE9lemy",
    nationality: "Barth\xE9lemois",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_BARTHELEMY
  },
  SAINT_MARTIN_FRANCE: {
    key: "SAINT_MARTIN_FRANCE",
    region: "North America",
    countryName: "Saint Martin (France)",
    nationality: "French (Saint Martin)",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_MARTIN_FRANCE
  },
  SINT_MAARTEN_DUTCH: {
    key: "SINT_MAARTEN_DUTCH",
    region: "North America",
    countryName: "Sint Maarten (Dutch)",
    nationality: "Dutch (St. Martin)",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SINT_MAARTEN_DUTCH
  },
  SOUTH_SUDAN: {
    key: "SOUTH_SUDAN",
    region: "Africa",
    subRegion: "EastSouthAfrica",
    countryName: "South Sudan",
    nationality: "Sudanese (South)",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_SUDAN
  },
  KOSOVO: {
    key: "KOSOVO",
    region: "Non_EU Europe",
    countryName: "Kosovo",
    nationality: "Kosovian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KOSOVO
  }
};

// src/countries/countryArray.ts
var countries = [
  recognisedCountries.AUSTRALIA,
  recognisedCountries.AUSTRIA,
  recognisedCountries.BAHRAIN,
  recognisedCountries.BARBADOS,
  recognisedCountries.BELGIUM,
  recognisedCountries.BERMUDA,
  recognisedCountries.BOTSWANA,
  recognisedCountries.BRAZIL,
  recognisedCountries.BRUNEI_DARUSSALAM,
  recognisedCountries.BULGARIA,
  recognisedCountries.CANADA,
  recognisedCountries.CAYMAN_ISLANDS,
  recognisedCountries.CHILE,
  recognisedCountries.CHINA,
  recognisedCountries.COLOMBIA,
  recognisedCountries.COSTA_RICA,
  recognisedCountries.CROATIA,
  recognisedCountries.CYPRUS,
  recognisedCountries.CZECH_REPUBLIC,
  recognisedCountries.DENMARK,
  recognisedCountries.ESTONIA,
  recognisedCountries.FINLAND,
  recognisedCountries.FRANCE,
  recognisedCountries.GERMANY,
  recognisedCountries.GREECE,
  recognisedCountries.HUNGARY,
  recognisedCountries.INDIA,
  recognisedCountries.INDONESIA,
  recognisedCountries.IRAN_ISLAMIC_REPUBLIC_OF,
  recognisedCountries.IRELAND,
  recognisedCountries.ISRAEL,
  recognisedCountries.ITALY,
  recognisedCountries.JAPAN,
  recognisedCountries.KENYA,
  recognisedCountries.NORTH_KOREA,
  recognisedCountries.SOUTH_KOREA,
  recognisedCountries.KUWAIT,
  recognisedCountries.LATVIA,
  recognisedCountries.LITHUANIA,
  recognisedCountries.LUXEMBOURG,
  recognisedCountries.MALAYSIA,
  recognisedCountries.MALTA,
  recognisedCountries.MEXICO,
  recognisedCountries.NETHERLANDS,
  recognisedCountries.NEW_ZEALAND,
  recognisedCountries.NORWAY,
  recognisedCountries.OMAN,
  recognisedCountries.PAKISTAN,
  recognisedCountries.PHILIPPINES,
  recognisedCountries.POLAND,
  recognisedCountries.PORTUGAL,
  recognisedCountries.QATAR,
  recognisedCountries.ROMANIA,
  recognisedCountries.SAUDI_ARABIA,
  recognisedCountries.SINGAPORE,
  recognisedCountries.SLOVAKIA,
  recognisedCountries.SLOVENIA,
  recognisedCountries.SOUTH_AFRICA,
  recognisedCountries.SPAIN,
  recognisedCountries.SWEDEN,
  recognisedCountries.SWITZERLAND,
  recognisedCountries.TAIWAN,
  recognisedCountries.THAILAND,
  recognisedCountries.TUNISIA,
  recognisedCountries.TURKEY,
  recognisedCountries.UNITED_ARAB_EMIRATES,
  recognisedCountries.UNITED_KINGDOM,
  recognisedCountries.UNITED_STATES_OF_AMERICA,
  recognisedCountries.VIETNAM,
  recognisedCountries.ZAMBIA,
  recognisedCountries.EGYPT,
  recognisedCountries.SRI_LANKA,
  recognisedCountries.MOROCCO,
  recognisedCountries.NIGERIA,
  recognisedCountries.NIGER,
  recognisedCountries.GHANA,
  recognisedCountries.BANGLADESH,
  recognisedCountries.PERU,
  recognisedCountries.VENEZUELA,
  recognisedCountries.ICELAND,
  recognisedCountries.CAMBODIA,
  recognisedCountries.BOLIVIA,
  recognisedCountries.URUGUAY,
  recognisedCountries.JORDAN,
  recognisedCountries.LIECHTENSTEIN,
  recognisedCountries.MACAU,
  recognisedCountries.MOLDOVA_REPUBLIC_OF,
  recognisedCountries.MONACO,
  recognisedCountries.NEPAL,
  recognisedCountries.SENEGAL,
  recognisedCountries.UZBEKISTAN,
  recognisedCountries.FIJI,
  recognisedCountries.BURUNDI,
  recognisedCountries.BENIN,
  recognisedCountries.CHAD,
  recognisedCountries.DJIBOUTI,
  recognisedCountries.ERITREA,
  recognisedCountries.GABON,
  recognisedCountries.LIBERIA,
  recognisedCountries.MAURITIUS,
  recognisedCountries.RWANDA,
  recognisedCountries.SIERRA_LEONE,
  recognisedCountries.SOMALIA,
  recognisedCountries.SWAZILAND,
  recognisedCountries.YEMEN,
  recognisedCountries.MALAWI,
  recognisedCountries.ZIMBABWE,
  recognisedCountries.MYANMAR,
  recognisedCountries.LAOS,
  recognisedCountries.NAMIBIA,
  recognisedCountries.BAHAMAS,
  recognisedCountries.GUATEMALA,
  recognisedCountries.HONDURAS,
  recognisedCountries.EL_SALVADOR,
  recognisedCountries.CUBA,
  recognisedCountries.JAMAICA,
  recognisedCountries.TRINIDAD_AND_TOBAGO,
  recognisedCountries.DOMINICAN_REPUBLIC,
  recognisedCountries.PARAGUAY,
  recognisedCountries.FAROE_ISLANDS,
  recognisedCountries.GREENLAND,
  recognisedCountries.ISLE_OF_MAN,
  recognisedCountries.JERSEY,
  recognisedCountries.GUERNSEY,
  recognisedCountries.SAINT_LUCIA,
  recognisedCountries.ANGUILLA,
  recognisedCountries.COOK_ISLANDS,
  recognisedCountries.GIBRALTAR,
  recognisedCountries.MONTENEGRO,
  recognisedCountries.SAINT_VINCENT_AND_THE_GRENADINES,
  recognisedCountries.TURKS_AND_CAICOS_ISLANDS,
  recognisedCountries.NORTH_MACEDONIA_REPUBLIC_OF,
  recognisedCountries.SAINT_KITTS_AND_NEVIS,
  recognisedCountries.ANTIGUA_AND_BARBUDA,
  recognisedCountries.DOMINICA,
  recognisedCountries.HONG_KONG,
  recognisedCountries.KAZAKHSTAN,
  recognisedCountries.SERBIA,
  recognisedCountries.AFGHANISTAN,
  recognisedCountries.ALBANIA,
  recognisedCountries.ALGERIA,
  recognisedCountries.AMERICAN_SAMOA,
  recognisedCountries.ANDORRA,
  recognisedCountries.ANGOLA,
  recognisedCountries.ANTARCTICA,
  recognisedCountries.ARGENTINA,
  recognisedCountries.ARMENIA,
  recognisedCountries.ARUBA,
  recognisedCountries.AZERBAIJAN,
  recognisedCountries.BELARUS,
  recognisedCountries.BELIZE,
  recognisedCountries.BHUTAN,
  recognisedCountries.BOSNIA_AND_HERZEGOVINA,
  recognisedCountries.BOUVET_ISLAND,
  recognisedCountries.BRITISH_INDIAN_OCEAN_TERRITORY,
  recognisedCountries.BURKINA_FASO,
  recognisedCountries.CAMEROON,
  recognisedCountries.CAPE_VERDE,
  recognisedCountries.CENTRAL_AFRICAN_REPUBLIC,
  recognisedCountries.CHRISTMAS_ISLAND,
  recognisedCountries.COCOS_KEELING_ISLANDS,
  recognisedCountries.COMOROS,
  recognisedCountries.CONGO,
  recognisedCountries.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  recognisedCountries.ECUADOR,
  recognisedCountries.EQUATORIAL_GUINEA,
  recognisedCountries.ETHIOPIA,
  recognisedCountries.FALKLAND_ISLANDS_MALVINAS,
  recognisedCountries.FRENCH_GUIANA,
  recognisedCountries.FRENCH_POLYNESIA,
  recognisedCountries.FRENCH_SOUTHERN_TERRITORIES,
  recognisedCountries.GAMBIA,
  recognisedCountries.GEORGIA,
  recognisedCountries.GRENADA,
  recognisedCountries.GUADELOUPE,
  recognisedCountries.GUAM,
  recognisedCountries.GUINEA,
  recognisedCountries.GUINEA_BISSAU,
  recognisedCountries.GUYANA,
  recognisedCountries.HAITI,
  recognisedCountries.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  recognisedCountries.VATICAN,
  recognisedCountries.IRAQ,
  recognisedCountries.KIRIBATI,
  recognisedCountries.KYRGYZSTAN,
  recognisedCountries.LEBANON,
  recognisedCountries.LESOTHO,
  recognisedCountries.LIBYA,
  recognisedCountries.MADAGASCAR,
  recognisedCountries.MALDIVES,
  recognisedCountries.MALI,
  recognisedCountries.MARSHALL_ISLANDS,
  recognisedCountries.MARTINIQUE,
  recognisedCountries.MAURITANIA,
  recognisedCountries.MAYOTTE,
  recognisedCountries.MICRONESIA_FEDERATED_STATES_OF,
  recognisedCountries.MONGOLIA,
  recognisedCountries.MONTSERRAT,
  recognisedCountries.MOZAMBIQUE,
  recognisedCountries.NAURU,
  recognisedCountries.NEW_CALEDONIA,
  recognisedCountries.NICARAGUA,
  recognisedCountries.NIUE,
  recognisedCountries.NORFOLK_ISLAND,
  recognisedCountries.NORTHERN_MARIANA_ISLANDS,
  recognisedCountries.PALAU,
  recognisedCountries.PALESTINE,
  recognisedCountries.PANAMA,
  recognisedCountries.PAPUA_NEW_GUINEA,
  recognisedCountries.PITCAIRN,
  recognisedCountries.PUERTO_RICO,
  recognisedCountries.REUNION,
  recognisedCountries.RUSSIA,
  recognisedCountries.SAINT_HELENA,
  recognisedCountries.SAINT_PIERRE_AND_MIQUELON,
  recognisedCountries.SAMOA,
  recognisedCountries.SAN_MARINO,
  recognisedCountries.SAO_TOME_AND_PRINCIPE,
  recognisedCountries.SEYCHELLES,
  recognisedCountries.SOLOMON_ISLANDS,
  recognisedCountries.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  recognisedCountries.SUDAN,
  recognisedCountries.SURINAME,
  recognisedCountries.SVALBARD_AND_JAN_MAYEN,
  recognisedCountries.SYRIA,
  recognisedCountries.TAJIKISTAN,
  recognisedCountries.TANZANIA_UNITED_REPUBLIC_OF,
  recognisedCountries.TIMOR_LESTE,
  recognisedCountries.TOGO,
  recognisedCountries.TOKELAU,
  recognisedCountries.TONGA,
  recognisedCountries.TURKMENISTAN,
  recognisedCountries.TUVALU,
  recognisedCountries.UGANDA,
  recognisedCountries.UKRAINE,
  recognisedCountries.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  recognisedCountries.VANUATU,
  recognisedCountries.VIRGIN_ISLANDS_BRITISH,
  recognisedCountries.VIRGIN_ISLANDS_US,
  recognisedCountries.WALLIS_AND_FUTUNA,
  recognisedCountries.WESTERN_SAHARA,
  recognisedCountries.ALAND_ISLANDS,
  recognisedCountries.BONAIRE_SINT_EUSTATIUS_AND_SABA,
  recognisedCountries.CURACAO,
  recognisedCountries.SAINT_BARTHELEMY,
  recognisedCountries.SAINT_MARTIN_FRANCE,
  recognisedCountries.SINT_MAARTEN_DUTCH,
  recognisedCountries.SOUTH_SUDAN,
  recognisedCountries.KOSOVO,
  recognisedCountries.COTE_DIVOIRE
];

// src/countries/countryLookups.ts
var nationalityCountriesMapTemp = {};
for (const country of countries) {
  const { nationality, countryName } = country;
  nationalityCountriesMapTemp[nationality] = [...nationalityCountriesMapTemp[nationality] || [], countryName];
}
var nationalityCountriesMap = deepFreeze(nationalityCountriesMapTemp);
var countryByNationality = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.nationality]: country });
    return prev;
  }, {})
);
var countryByCountryName = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.countryName]: country });
    return prev;
  }, {})
);
var countryByAlpha3 = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.alphaThree]: country });
    return prev;
  }, {})
);
var countryByNumeric = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.numeric]: country });
    return prev;
  }, {})
);
var countryByRegionName = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.region]: country });
    return prev;
  }, {})
);

// src/countries/phoneCodes.ts
var countryPhoneCodes = deepFreeze({
  [countryCodes.BANGLADESH.alphaTwo]: "880",
  [countryCodes.BELGIUM.alphaTwo]: "32",
  [countryCodes.BURKINA_FASO.alphaTwo]: "226",
  [countryCodes.BULGARIA.alphaTwo]: "359",
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: "387",
  [countryCodes.BARBADOS.alphaTwo]: "1246",
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: "681",
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: "590",
  [countryCodes.BERMUDA.alphaTwo]: "1441",
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: "673",
  [countryCodes.BOLIVIA.alphaTwo]: "591",
  [countryCodes.BAHRAIN.alphaTwo]: "973",
  [countryCodes.BURUNDI.alphaTwo]: "257",
  [countryCodes.BENIN.alphaTwo]: "229",
  [countryCodes.BHUTAN.alphaTwo]: "975",
  [countryCodes.JAMAICA.alphaTwo]: "1876",
  [countryCodes.BOUVET_ISLAND.alphaTwo]: "",
  [countryCodes.BOTSWANA.alphaTwo]: "267",
  [countryCodes.SAMOA.alphaTwo]: "685",
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: "599",
  [countryCodes.BRAZIL.alphaTwo]: "55",
  [countryCodes.BAHAMAS.alphaTwo]: "1242",
  [countryCodes.JERSEY.alphaTwo]: "441534",
  [countryCodes.BELARUS.alphaTwo]: "375",
  [countryCodes.BELIZE.alphaTwo]: "501",
  [countryCodes.RUSSIA.alphaTwo]: "7",
  [countryCodes.RWANDA.alphaTwo]: "250",
  [countryCodes.SERBIA.alphaTwo]: "381",
  [countryCodes.TIMOR_LESTE.alphaTwo]: "670",
  [countryCodes.REUNION.alphaTwo]: "262",
  [countryCodes.TURKMENISTAN.alphaTwo]: "993",
  [countryCodes.TAJIKISTAN.alphaTwo]: "992",
  [countryCodes.ROMANIA.alphaTwo]: "40",
  [countryCodes.TOKELAU.alphaTwo]: "690",
  [countryCodes.GUINEA_BISSAU.alphaTwo]: "245",
  [countryCodes.GUAM.alphaTwo]: "1671",
  [countryCodes.GUATEMALA.alphaTwo]: "502",
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: "",
  [countryCodes.GREECE.alphaTwo]: "30",
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: "240",
  [countryCodes.GUADELOUPE.alphaTwo]: "590",
  [countryCodes.JAPAN.alphaTwo]: "81",
  [countryCodes.GUYANA.alphaTwo]: "592",
  [countryCodes.GUERNSEY.alphaTwo]: "441481",
  [countryCodes.FRENCH_GUIANA.alphaTwo]: "594",
  [countryCodes.GEORGIA.alphaTwo]: "995",
  [countryCodes.GRENADA.alphaTwo]: "1473",
  [countryCodes.UNITED_KINGDOM.alphaTwo]: "44",
  [countryCodes.GABON.alphaTwo]: "241",
  [countryCodes.EL_SALVADOR.alphaTwo]: "503",
  [countryCodes.GUINEA.alphaTwo]: "224",
  [countryCodes.GAMBIA.alphaTwo]: "220",
  [countryCodes.GREENLAND.alphaTwo]: "299",
  [countryCodes.GIBRALTAR.alphaTwo]: "350",
  [countryCodes.GHANA.alphaTwo]: "233",
  [countryCodes.OMAN.alphaTwo]: "968",
  [countryCodes.TUNISIA.alphaTwo]: "216",
  [countryCodes.JORDAN.alphaTwo]: "962",
  [countryCodes.CROATIA.alphaTwo]: "385",
  [countryCodes.HAITI.alphaTwo]: "509",
  [countryCodes.HUNGARY.alphaTwo]: "36",
  [countryCodes.HONG_KONG.alphaTwo]: "852",
  [countryCodes.HONDURAS.alphaTwo]: "504",
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: " ",
  [countryCodes.VENEZUELA.alphaTwo]: "58",
  [countryCodes.PUERTO_RICO.alphaTwo]: "1787 and 1939",
  [countryCodes.PALESTINE.alphaTwo]: "970",
  [countryCodes.PALAU.alphaTwo]: "680",
  [countryCodes.PORTUGAL.alphaTwo]: "351",
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: "47",
  [countryCodes.PARAGUAY.alphaTwo]: "595",
  [countryCodes.IRAQ.alphaTwo]: "964",
  [countryCodes.PANAMA.alphaTwo]: "507",
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: "689",
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: "675",
  [countryCodes.PERU.alphaTwo]: "51",
  [countryCodes.PAKISTAN.alphaTwo]: "92",
  [countryCodes.PHILIPPINES.alphaTwo]: "63",
  [countryCodes.PITCAIRN.alphaTwo]: "870",
  [countryCodes.POLAND.alphaTwo]: "48",
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: "508",
  [countryCodes.ZAMBIA.alphaTwo]: "260",
  [countryCodes.WESTERN_SAHARA.alphaTwo]: "212",
  [countryCodes.ESTONIA.alphaTwo]: "372",
  [countryCodes.EGYPT.alphaTwo]: "20",
  [countryCodes.SOUTH_AFRICA.alphaTwo]: "27",
  [countryCodes.ECUADOR.alphaTwo]: "593",
  [countryCodes.ITALY.alphaTwo]: "39",
  [countryCodes.VIETNAM.alphaTwo]: "84",
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: "677",
  [countryCodes.ETHIOPIA.alphaTwo]: "251",
  [countryCodes.SOMALIA.alphaTwo]: "252",
  [countryCodes.ZIMBABWE.alphaTwo]: "263",
  [countryCodes.SAUDI_ARABIA.alphaTwo]: "966",
  [countryCodes.SPAIN.alphaTwo]: "34",
  [countryCodes.ERITREA.alphaTwo]: "291",
  [countryCodes.MONTENEGRO.alphaTwo]: "382",
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: "373",
  [countryCodes.MADAGASCAR.alphaTwo]: "261",
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: "590",
  [countryCodes.MOROCCO.alphaTwo]: "212",
  [countryCodes.MONACO.alphaTwo]: "377",
  [countryCodes.UZBEKISTAN.alphaTwo]: "998",
  [countryCodes.MYANMAR.alphaTwo]: "95",
  [countryCodes.MALI.alphaTwo]: "223",
  [countryCodes.MACAU.alphaTwo]: "853",
  [countryCodes.MONGOLIA.alphaTwo]: "976",
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: "692",
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: "389",
  [countryCodes.MAURITIUS.alphaTwo]: "230",
  [countryCodes.MALTA.alphaTwo]: "356",
  [countryCodes.MALAWI.alphaTwo]: "265",
  [countryCodes.MALDIVES.alphaTwo]: "960",
  [countryCodes.MARTINIQUE.alphaTwo]: "596",
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: "1670",
  [countryCodes.MONTSERRAT.alphaTwo]: "1664",
  [countryCodes.MAURITANIA.alphaTwo]: "222",
  [countryCodes.ISLE_OF_MAN.alphaTwo]: "441624",
  [countryCodes.UGANDA.alphaTwo]: "256",
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: "255",
  [countryCodes.MALAYSIA.alphaTwo]: "60",
  [countryCodes.MEXICO.alphaTwo]: "52",
  [countryCodes.ISRAEL.alphaTwo]: "972",
  [countryCodes.FRANCE.alphaTwo]: "33",
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: "246",
  [countryCodes.SAINT_HELENA.alphaTwo]: "290",
  [countryCodes.FINLAND.alphaTwo]: "358",
  [countryCodes.FIJI.alphaTwo]: "679",
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: "500",
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: "691",
  [countryCodes.FAROE_ISLANDS.alphaTwo]: "298",
  [countryCodes.NICARAGUA.alphaTwo]: "505",
  [countryCodes.NETHERLANDS.alphaTwo]: "31",
  [countryCodes.NORWAY.alphaTwo]: "47",
  [countryCodes.NAMIBIA.alphaTwo]: "264",
  [countryCodes.VANUATU.alphaTwo]: "678",
  [countryCodes.NEW_CALEDONIA.alphaTwo]: "687",
  [countryCodes.NIGER.alphaTwo]: "227",
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: "672",
  [countryCodes.NIGERIA.alphaTwo]: "234",
  [countryCodes.NEW_ZEALAND.alphaTwo]: "64",
  [countryCodes.NEPAL.alphaTwo]: "977",
  [countryCodes.NAURU.alphaTwo]: "674",
  [countryCodes.NIUE.alphaTwo]: "683",
  [countryCodes.COOK_ISLANDS.alphaTwo]: "682",
  [countryCodes.KOSOVO.alphaTwo]: "",
  [countryCodes.COTE_DIVOIRE.alphaTwo]: "225",
  [countryCodes.SWITZERLAND.alphaTwo]: "41",
  [countryCodes.COLOMBIA.alphaTwo]: "57",
  [countryCodes.CHINA.alphaTwo]: "86",
  [countryCodes.CAMEROON.alphaTwo]: "237",
  [countryCodes.CHILE.alphaTwo]: "56",
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: "61",
  [countryCodes.CANADA.alphaTwo]: "1",
  [countryCodes.CONGO.alphaTwo]: "242",
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: "236",
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: "243",
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: "420",
  [countryCodes.CYPRUS.alphaTwo]: "357",
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: "61",
  [countryCodes.COSTA_RICA.alphaTwo]: "506",
  [countryCodes.CURACAO.alphaTwo]: "599",
  [countryCodes.CAPE_VERDE.alphaTwo]: "238",
  [countryCodes.CUBA.alphaTwo]: "53",
  [countryCodes.SWAZILAND.alphaTwo]: "268",
  [countryCodes.SYRIA.alphaTwo]: "963",
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: "599",
  [countryCodes.KYRGYZSTAN.alphaTwo]: "996",
  [countryCodes.KENYA.alphaTwo]: "254",
  [countryCodes.SOUTH_SUDAN.alphaTwo]: "211",
  [countryCodes.SURINAME.alphaTwo]: "597",
  [countryCodes.KIRIBATI.alphaTwo]: "686",
  [countryCodes.CAMBODIA.alphaTwo]: "855",
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: "1869",
  [countryCodes.COMOROS.alphaTwo]: "269",
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: "239",
  [countryCodes.SLOVAKIA.alphaTwo]: "421",
  [countryCodes.SOUTH_KOREA.alphaTwo]: "82",
  [countryCodes.SLOVENIA.alphaTwo]: "386",
  [countryCodes.NORTH_KOREA.alphaTwo]: "850",
  [countryCodes.KUWAIT.alphaTwo]: "965",
  [countryCodes.SENEGAL.alphaTwo]: "221",
  [countryCodes.SAN_MARINO.alphaTwo]: "378",
  [countryCodes.SIERRA_LEONE.alphaTwo]: "232",
  [countryCodes.SEYCHELLES.alphaTwo]: "248",
  [countryCodes.KAZAKHSTAN.alphaTwo]: "7",
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: "1345",
  [countryCodes.SINGAPORE.alphaTwo]: "65",
  [countryCodes.SWEDEN.alphaTwo]: "46",
  [countryCodes.SUDAN.alphaTwo]: "249",
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: "1809 and 1829",
  [countryCodes.DOMINICA.alphaTwo]: "1767",
  [countryCodes.DJIBOUTI.alphaTwo]: "253",
  [countryCodes.DENMARK.alphaTwo]: "45",
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: "1284",
  [countryCodes.GERMANY.alphaTwo]: "49",
  [countryCodes.YEMEN.alphaTwo]: "967",
  [countryCodes.ALGERIA.alphaTwo]: "213",
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: "1",
  [countryCodes.URUGUAY.alphaTwo]: "598",
  [countryCodes.MAYOTTE.alphaTwo]: "262",
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: "1",
  [countryCodes.LEBANON.alphaTwo]: "961",
  [countryCodes.SAINT_LUCIA.alphaTwo]: "1758",
  [countryCodes.LAOS.alphaTwo]: "856",
  [countryCodes.TUVALU.alphaTwo]: "688",
  [countryCodes.TAIWAN.alphaTwo]: "886",
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: "1868",
  [countryCodes.TURKEY.alphaTwo]: "90",
  [countryCodes.SRI_LANKA.alphaTwo]: "94",
  [countryCodes.LIECHTENSTEIN.alphaTwo]: "423",
  [countryCodes.LATVIA.alphaTwo]: "371",
  [countryCodes.TONGA.alphaTwo]: "676",
  [countryCodes.LITHUANIA.alphaTwo]: "370",
  [countryCodes.LUXEMBOURG.alphaTwo]: "352",
  [countryCodes.LIBERIA.alphaTwo]: "231",
  [countryCodes.LESOTHO.alphaTwo]: "266",
  [countryCodes.THAILAND.alphaTwo]: "66",
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: "",
  [countryCodes.TOGO.alphaTwo]: "228",
  [countryCodes.CHAD.alphaTwo]: "235",
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: "1649",
  [countryCodes.LIBYA.alphaTwo]: "218",
  [countryCodes.VATICAN.alphaTwo]: "379",
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: "1784",
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: "971",
  [countryCodes.ANDORRA.alphaTwo]: "376",
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: "1268",
  [countryCodes.AFGHANISTAN.alphaTwo]: "93",
  [countryCodes.ANGUILLA.alphaTwo]: "1264",
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: "1340",
  [countryCodes.ICELAND.alphaTwo]: "354",
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: "98",
  [countryCodes.ARMENIA.alphaTwo]: "374",
  [countryCodes.ALBANIA.alphaTwo]: "355",
  [countryCodes.ANGOLA.alphaTwo]: "244",
  [countryCodes.ANTARCTICA.alphaTwo]: "",
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: "1684",
  [countryCodes.ARGENTINA.alphaTwo]: "54",
  [countryCodes.AUSTRALIA.alphaTwo]: "61",
  [countryCodes.AUSTRIA.alphaTwo]: "43",
  [countryCodes.ARUBA.alphaTwo]: "297",
  [countryCodes.INDIA.alphaTwo]: "91",
  [countryCodes.ALAND_ISLANDS.alphaTwo]: "35818",
  [countryCodes.AZERBAIJAN.alphaTwo]: "994",
  [countryCodes.IRELAND.alphaTwo]: "353",
  [countryCodes.INDONESIA.alphaTwo]: "62",
  [countryCodes.UKRAINE.alphaTwo]: "380",
  [countryCodes.QATAR.alphaTwo]: "974",
  [countryCodes.MOZAMBIQUE.alphaTwo]: "258"
});
var countryNames = deepFreeze({
  [countryCodes.BANGLADESH.alphaTwo]: "Bangladesh",
  [countryCodes.BELGIUM.alphaTwo]: "Belgium",
  [countryCodes.BURKINA_FASO.alphaTwo]: "Burkina Faso",
  [countryCodes.BULGARIA.alphaTwo]: "Bulgaria",
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: "Bosnia and Herzegovina",
  [countryCodes.BARBADOS.alphaTwo]: "Barbados",
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: "Wallis and Futuna",
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: "Saint Barthelemy",
  [countryCodes.BERMUDA.alphaTwo]: "Bermuda",
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: "Brunei",
  [countryCodes.BOLIVIA.alphaTwo]: "Bolivia",
  [countryCodes.BAHRAIN.alphaTwo]: "Bahrain",
  [countryCodes.BURUNDI.alphaTwo]: "Burundi",
  [countryCodes.BENIN.alphaTwo]: "Benin",
  [countryCodes.BHUTAN.alphaTwo]: "Bhutan",
  [countryCodes.JAMAICA.alphaTwo]: "Jamaica",
  [countryCodes.BOUVET_ISLAND.alphaTwo]: "Bouvet Island",
  [countryCodes.BOTSWANA.alphaTwo]: "Botswana",
  [countryCodes.SAMOA.alphaTwo]: "Samoa",
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: "Bonaire, Saint Eustatius and Saba ",
  [countryCodes.BRAZIL.alphaTwo]: "Brazil",
  [countryCodes.BAHAMAS.alphaTwo]: "Bahamas",
  [countryCodes.JERSEY.alphaTwo]: "Jersey",
  [countryCodes.BELARUS.alphaTwo]: "Belarus",
  [countryCodes.BELIZE.alphaTwo]: "Belize",
  [countryCodes.RUSSIA.alphaTwo]: "Russia",
  [countryCodes.RWANDA.alphaTwo]: "Rwanda",
  [countryCodes.SERBIA.alphaTwo]: "Serbia",
  [countryCodes.TIMOR_LESTE.alphaTwo]: "East Timor",
  [countryCodes.REUNION.alphaTwo]: "Reunion",
  [countryCodes.TURKMENISTAN.alphaTwo]: "Turkmenistan",
  [countryCodes.TAJIKISTAN.alphaTwo]: "Tajikistan",
  [countryCodes.ROMANIA.alphaTwo]: "Romania",
  [countryCodes.TOKELAU.alphaTwo]: "Tokelau",
  [countryCodes.GUINEA_BISSAU.alphaTwo]: "Guinea-Bissau",
  [countryCodes.GUAM.alphaTwo]: "Guam",
  [countryCodes.GUATEMALA.alphaTwo]: "Guatemala",
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: "South Georgia and the South Sandwich Islands",
  [countryCodes.GREECE.alphaTwo]: "Greece",
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: "Equatorial Guinea",
  [countryCodes.GUADELOUPE.alphaTwo]: "Guadeloupe",
  [countryCodes.JAPAN.alphaTwo]: "Japan",
  [countryCodes.GUYANA.alphaTwo]: "Guyana",
  [countryCodes.GUERNSEY.alphaTwo]: "Guernsey",
  [countryCodes.FRENCH_GUIANA.alphaTwo]: "French Guiana",
  [countryCodes.GEORGIA.alphaTwo]: "Georgia",
  [countryCodes.GRENADA.alphaTwo]: "Grenada",
  [countryCodes.UNITED_KINGDOM.alphaTwo]: "United Kingdom",
  [countryCodes.GABON.alphaTwo]: "Gabon",
  [countryCodes.EL_SALVADOR.alphaTwo]: "El Salvador",
  [countryCodes.GUINEA.alphaTwo]: "Guinea",
  [countryCodes.GAMBIA.alphaTwo]: "Gambia",
  [countryCodes.GREENLAND.alphaTwo]: "Greenland",
  [countryCodes.GIBRALTAR.alphaTwo]: "Gibraltar",
  [countryCodes.GHANA.alphaTwo]: "Ghana",
  [countryCodes.OMAN.alphaTwo]: "Oman",
  [countryCodes.TUNISIA.alphaTwo]: "Tunisia",
  [countryCodes.JORDAN.alphaTwo]: "Jordan",
  [countryCodes.CROATIA.alphaTwo]: "Croatia",
  [countryCodes.HAITI.alphaTwo]: "Haiti",
  [countryCodes.HUNGARY.alphaTwo]: "Hungary",
  [countryCodes.HONG_KONG.alphaTwo]: "Hong Kong",
  [countryCodes.HONDURAS.alphaTwo]: "Honduras",
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: "Heard Island and McDonald Islands",
  [countryCodes.VENEZUELA.alphaTwo]: "Venezuela",
  [countryCodes.PUERTO_RICO.alphaTwo]: "Puerto Rico",
  [countryCodes.PALESTINE.alphaTwo]: "Palestinian Territory",
  [countryCodes.PALAU.alphaTwo]: "Palau",
  [countryCodes.PORTUGAL.alphaTwo]: "Portugal",
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: "Svalbard and Jan Mayen",
  [countryCodes.PARAGUAY.alphaTwo]: "Paraguay",
  [countryCodes.IRAQ.alphaTwo]: "Iraq",
  [countryCodes.PANAMA.alphaTwo]: "Panama",
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: "French Polynesia",
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: "Papua New Guinea",
  [countryCodes.PERU.alphaTwo]: "Peru",
  [countryCodes.PAKISTAN.alphaTwo]: "Pakistan",
  [countryCodes.PHILIPPINES.alphaTwo]: "Philippines",
  [countryCodes.PITCAIRN.alphaTwo]: "Pitcairn",
  [countryCodes.POLAND.alphaTwo]: "Poland",
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: "Saint Pierre and Miquelon",
  [countryCodes.ZAMBIA.alphaTwo]: "Zambia",
  [countryCodes.WESTERN_SAHARA.alphaTwo]: "Western Sahara",
  [countryCodes.ESTONIA.alphaTwo]: "Estonia",
  [countryCodes.EGYPT.alphaTwo]: "Egypt",
  [countryCodes.SOUTH_AFRICA.alphaTwo]: "South Africa",
  [countryCodes.ECUADOR.alphaTwo]: "Ecuador",
  [countryCodes.ITALY.alphaTwo]: "Italy",
  [countryCodes.VIETNAM.alphaTwo]: "Vietnam",
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: "Solomon Islands",
  [countryCodes.ETHIOPIA.alphaTwo]: "Ethiopia",
  [countryCodes.SOMALIA.alphaTwo]: "Somalia",
  [countryCodes.ZIMBABWE.alphaTwo]: "Zimbabwe",
  [countryCodes.SAUDI_ARABIA.alphaTwo]: "Saudi Arabia",
  [countryCodes.SPAIN.alphaTwo]: "Spain",
  [countryCodes.ERITREA.alphaTwo]: "Eritrea",
  [countryCodes.MONTENEGRO.alphaTwo]: "Montenegro",
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: "Moldova",
  [countryCodes.MADAGASCAR.alphaTwo]: "Madagascar",
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: "Saint Martin",
  [countryCodes.MOROCCO.alphaTwo]: "Morocco",
  [countryCodes.MONACO.alphaTwo]: "Monaco",
  [countryCodes.UZBEKISTAN.alphaTwo]: "Uzbekistan",
  [countryCodes.MYANMAR.alphaTwo]: "Myanmar",
  [countryCodes.MALI.alphaTwo]: "Mali",
  [countryCodes.MACAU.alphaTwo]: "Macao",
  [countryCodes.MONGOLIA.alphaTwo]: "Mongolia",
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: "Marshall Islands",
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: "Macedonia",
  [countryCodes.MAURITIUS.alphaTwo]: "Mauritius",
  [countryCodes.MALTA.alphaTwo]: "Malta",
  [countryCodes.MALAWI.alphaTwo]: "Malawi",
  [countryCodes.MALDIVES.alphaTwo]: "Maldives",
  [countryCodes.MARTINIQUE.alphaTwo]: "Martinique",
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: "Northern Mariana Islands",
  [countryCodes.MONTSERRAT.alphaTwo]: "Montserrat",
  [countryCodes.MAURITANIA.alphaTwo]: "Mauritania",
  [countryCodes.ISLE_OF_MAN.alphaTwo]: "Isle of Man",
  [countryCodes.UGANDA.alphaTwo]: "Uganda",
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: "Tanzania",
  [countryCodes.MALAYSIA.alphaTwo]: "Malaysia",
  [countryCodes.MEXICO.alphaTwo]: "Mexico",
  [countryCodes.ISRAEL.alphaTwo]: "Israel",
  [countryCodes.FRANCE.alphaTwo]: "France",
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: "British Indian Ocean Territory",
  [countryCodes.SAINT_HELENA.alphaTwo]: "Saint Helena",
  [countryCodes.FINLAND.alphaTwo]: "Finland",
  [countryCodes.FIJI.alphaTwo]: "Fiji",
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: "Falkland Islands",
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: "Micronesia",
  [countryCodes.FAROE_ISLANDS.alphaTwo]: "Faroe Islands",
  [countryCodes.NICARAGUA.alphaTwo]: "Nicaragua",
  [countryCodes.NETHERLANDS.alphaTwo]: "Netherlands",
  [countryCodes.NORWAY.alphaTwo]: "Norway",
  [countryCodes.NAMIBIA.alphaTwo]: "Namibia",
  [countryCodes.VANUATU.alphaTwo]: "Vanuatu",
  [countryCodes.NEW_CALEDONIA.alphaTwo]: "New Caledonia",
  [countryCodes.NIGER.alphaTwo]: "Niger",
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: "Norfolk Island",
  [countryCodes.NIGERIA.alphaTwo]: "Nigeria",
  [countryCodes.NEW_ZEALAND.alphaTwo]: "New Zealand",
  [countryCodes.NEPAL.alphaTwo]: "Nepal",
  [countryCodes.NAURU.alphaTwo]: "Nauru",
  [countryCodes.NIUE.alphaTwo]: "Niue",
  [countryCodes.COOK_ISLANDS.alphaTwo]: "Cook Islands",
  [countryCodes.KOSOVO.alphaTwo]: "Kosovo",
  [countryCodes.COTE_DIVOIRE.alphaTwo]: "Ivory Coast",
  [countryCodes.SWITZERLAND.alphaTwo]: "Switzerland",
  [countryCodes.COLOMBIA.alphaTwo]: "Colombia",
  [countryCodes.CHINA.alphaTwo]: "China",
  [countryCodes.CAMEROON.alphaTwo]: "Cameroon",
  [countryCodes.CHILE.alphaTwo]: "Chile",
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: "Cocos Islands",
  [countryCodes.CANADA.alphaTwo]: "Canada",
  [countryCodes.CONGO.alphaTwo]: "Republic of the Congo",
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: "Central African Republic",
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: "Democratic Republic of the Congo",
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: "Czech Republic",
  [countryCodes.CYPRUS.alphaTwo]: "Cyprus",
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: "Christmas Island",
  [countryCodes.COSTA_RICA.alphaTwo]: "Costa Rica",
  [countryCodes.CURACAO.alphaTwo]: "Curacao",
  [countryCodes.CAPE_VERDE.alphaTwo]: "Cape Verde",
  [countryCodes.CUBA.alphaTwo]: "Cuba",
  [countryCodes.SWAZILAND.alphaTwo]: "Swaziland",
  [countryCodes.SYRIA.alphaTwo]: "Syria",
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: "Sint Maarten",
  [countryCodes.KYRGYZSTAN.alphaTwo]: "Kyrgyzstan",
  [countryCodes.KENYA.alphaTwo]: "Kenya",
  [countryCodes.SOUTH_SUDAN.alphaTwo]: "South Sudan",
  [countryCodes.SURINAME.alphaTwo]: "Suriname",
  [countryCodes.KIRIBATI.alphaTwo]: "Kiribati",
  [countryCodes.CAMBODIA.alphaTwo]: "Cambodia",
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: "Saint Kitts and Nevis",
  [countryCodes.COMOROS.alphaTwo]: "Comoros",
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: "Sao Tome and Principe",
  [countryCodes.SLOVAKIA.alphaTwo]: "Slovakia",
  [countryCodes.SOUTH_KOREA.alphaTwo]: "South Korea",
  [countryCodes.SLOVENIA.alphaTwo]: "Slovenia",
  [countryCodes.NORTH_KOREA.alphaTwo]: "North Korea",
  [countryCodes.KUWAIT.alphaTwo]: "Kuwait",
  [countryCodes.SENEGAL.alphaTwo]: "Senegal",
  [countryCodes.SAN_MARINO.alphaTwo]: "San Marino",
  [countryCodes.SIERRA_LEONE.alphaTwo]: "Sierra Leone",
  [countryCodes.SEYCHELLES.alphaTwo]: "Seychelles",
  [countryCodes.KAZAKHSTAN.alphaTwo]: "Kazakhstan",
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: "Cayman Islands",
  [countryCodes.SINGAPORE.alphaTwo]: "Singapore",
  [countryCodes.SWEDEN.alphaTwo]: "Sweden",
  [countryCodes.SUDAN.alphaTwo]: "Sudan",
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: "Dominican Republic",
  [countryCodes.DOMINICA.alphaTwo]: "Dominica",
  [countryCodes.DJIBOUTI.alphaTwo]: "Djibouti",
  [countryCodes.DENMARK.alphaTwo]: "Denmark",
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: "British Virgin Islands",
  [countryCodes.GERMANY.alphaTwo]: "Germany",
  [countryCodes.YEMEN.alphaTwo]: "Yemen",
  [countryCodes.ALGERIA.alphaTwo]: "Algeria",
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: "United States",
  [countryCodes.URUGUAY.alphaTwo]: "Uruguay",
  [countryCodes.MAYOTTE.alphaTwo]: "Mayotte",
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: "United States Minor Outlying Islands",
  [countryCodes.LEBANON.alphaTwo]: "Lebanon",
  [countryCodes.SAINT_LUCIA.alphaTwo]: "Saint Lucia",
  [countryCodes.LAOS.alphaTwo]: "Laos",
  [countryCodes.TUVALU.alphaTwo]: "Tuvalu",
  [countryCodes.TAIWAN.alphaTwo]: "Taiwan",
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: "Trinidad and Tobago",
  [countryCodes.TURKEY.alphaTwo]: "Turkey",
  [countryCodes.SRI_LANKA.alphaTwo]: "Sri Lanka",
  [countryCodes.LIECHTENSTEIN.alphaTwo]: "Liechtenstein",
  [countryCodes.LATVIA.alphaTwo]: "Latvia",
  [countryCodes.TONGA.alphaTwo]: "Tonga",
  [countryCodes.LITHUANIA.alphaTwo]: "Lithuania",
  [countryCodes.LUXEMBOURG.alphaTwo]: "Luxembourg",
  [countryCodes.LIBERIA.alphaTwo]: "Liberia",
  [countryCodes.LESOTHO.alphaTwo]: "Lesotho",
  [countryCodes.THAILAND.alphaTwo]: "Thailand",
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: "French Southern Territories",
  [countryCodes.TOGO.alphaTwo]: "Togo",
  [countryCodes.CHAD.alphaTwo]: "Chad",
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: "Turks and Caicos Islands",
  [countryCodes.LIBYA.alphaTwo]: "Libya",
  [countryCodes.VATICAN.alphaTwo]: "Vatican",
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: "Saint Vincent and the Grenadines",
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: "United Arab Emirates",
  [countryCodes.ANDORRA.alphaTwo]: "Andorra",
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: "Antigua and Barbuda",
  [countryCodes.AFGHANISTAN.alphaTwo]: "Afghanistan",
  [countryCodes.ANGUILLA.alphaTwo]: "Anguilla",
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: "U.S. Virgin Islands",
  [countryCodes.ICELAND.alphaTwo]: "Iceland",
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: "Iran",
  [countryCodes.ARMENIA.alphaTwo]: "Armenia",
  [countryCodes.ALBANIA.alphaTwo]: "Albania",
  [countryCodes.ANGOLA.alphaTwo]: "Angola",
  [countryCodes.ANTARCTICA.alphaTwo]: "Antarctica",
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: "American Samoa",
  [countryCodes.ARGENTINA.alphaTwo]: "Argentina",
  [countryCodes.AUSTRALIA.alphaTwo]: "Australia",
  [countryCodes.AUSTRIA.alphaTwo]: "Austria",
  [countryCodes.ARUBA.alphaTwo]: "Aruba",
  [countryCodes.INDIA.alphaTwo]: "India",
  [countryCodes.ALAND_ISLANDS.alphaTwo]: "Aland Islands",
  [countryCodes.AZERBAIJAN.alphaTwo]: "Azerbaijan",
  [countryCodes.IRELAND.alphaTwo]: "Ireland",
  [countryCodes.INDONESIA.alphaTwo]: "Indonesia",
  [countryCodes.UKRAINE.alphaTwo]: "Ukraine",
  [countryCodes.QATAR.alphaTwo]: "Qatar",
  [countryCodes.MOZAMBIQUE.alphaTwo]: "Mozambique"
});

// src/countries/subdivisions.ts
var subdivisions = {
  [countryCodes.ANDORRA.alphaTwo]: {
    subdivisions: [
      { name: "Andorra la Vella", code: "AD-07" },
      { name: "Canillo", code: "AD-02" },
      { name: "Encamp", code: "AD-03" },
      { name: "Escaldes-Engordany", code: "AD-08" },
      { name: "La Massana", code: "AD-04" },
      { name: "Ordino", code: "AD-05" },
      { name: "Sant Julia de Loria", code: "AD-06" }
    ]
  },
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: {
    subdivisions: [
      { name: "Ajman", code: "AE-AJ" },
      { name: "Abu Zaby", code: "AE-AZ" },
      { name: "Al Fujayrah", code: "AE-FU" },
      { name: "Ash Shariqah", code: "AE-SH" },
      { name: "Dubayy", code: "AE-DU" },
      { name: "Ra's al Khaymah", code: "AE-RK" },
      { name: "Umm al Qaywayn", code: "AE-UQ" }
    ]
  },
  [countryCodes.AFGHANISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Badakhshan", code: "AF-BDS" },
      { name: "Badghis", code: "AF-BDG" },
      { name: "Baghlan", code: "AF-BGL" },
      { name: "Balkh", code: "AF-BAL" },
      { name: "Bamyan", code: "AF-BAM" },
      { name: "Daykundi", code: "AF-DAY" },
      { name: "Farah", code: "AF-FRA" },
      { name: "Faryab", code: "AF-FYB" },
      { name: "Ghazni", code: "AF-GHA" },
      { name: "Helmand", code: "AF-HEL" },
      { name: "Herat", code: "AF-HER" },
      { name: "Jowzjan", code: "AF-JOW" },
      { name: "Kabul", code: "AF-KAB" },
      { name: "Kandahar", code: "AF-KAN" },
      { name: "Khost", code: "AF-KHO" },
      { name: "Kunar", code: "AF-KNR" },
      { name: "Kunduz", code: "AF-KDZ" },
      { name: "Logar", code: "AF-LOG" },
      { name: "Nangarhar", code: "AF-NAN" },
      { name: "Nimroz", code: "AF-NIM" },
      { name: "Paktika", code: "AF-PKA" },
      { name: "Paktiya", code: "AF-PIA" },
      { name: "Panjshayr", code: "AF-PAN" },
      { name: "Parwan", code: "AF-PAR" },
      { name: "Samangan", code: "AF-SAM" },
      { name: "Sar-e Pul", code: "AF-SAR" },
      { name: "Takhar", code: "AF-TAK" },
      { name: "Uruzgan", code: "AF-URU" },
      { name: "Ghor", code: "AF-GHO" },
      { name: "Kapisa", code: "AF-KAP" },
      { name: "Laghman", code: "AF-LAG" },
      { name: "Nuristan", code: "AF-NUR" },
      { name: "Wardak", code: "AF-WAR" },
      { name: "Zabul", code: "AF-ZAB" }
    ]
  },
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: {
    subdivisions: [
      { name: "Barbuda", code: "AG-10" },
      { name: "Redonda", code: "AG-11" },
      { name: "Saint George", code: "AG-03" },
      { name: "Saint John", code: "AG-04" },
      { name: "Saint Mary", code: "AG-05" },
      { name: "Saint Peter", code: "AG-07" },
      { name: "Saint Philip", code: "AG-08" },
      { name: "Saint Paul", code: "AG-06" }
    ]
  },
  [countryCodes.ANGUILLA.alphaTwo]: { subdivisions: [{ name: "Anguilla", code: "-" }] },
  [countryCodes.ALBANIA.alphaTwo]: {
    subdivisions: [
      { name: "Berat", code: "AL-01" },
      { name: "Diber", code: "AL-09" },
      { name: "Durres", code: "AL-02" },
      { name: "Elbasan", code: "AL-03" },
      { name: "Fier", code: "AL-04" },
      { name: "Gjirokaster", code: "AL-05" },
      { name: "Korce", code: "AL-06" },
      { name: "Kukes", code: "AL-07" },
      { name: "Lezhe", code: "AL-08" },
      { name: "Shkoder", code: "AL-10" },
      { name: "Tirane", code: "AL-11" },
      { name: "Vlore", code: "AL-12" }
    ]
  },
  [countryCodes.ARMENIA.alphaTwo]: {
    subdivisions: [
      { name: "Aragacotn", code: "AM-AG" },
      { name: "Ararat", code: "AM-AR" },
      { name: "Armavir", code: "AM-AV" },
      { name: "Erevan", code: "AM-ER" },
      { name: "Gegark'unik'", code: "AM-GR" },
      { name: "Kotayk'", code: "AM-KT" },
      { name: "Lori", code: "AM-LO" },
      { name: "Sirak", code: "AM-SH" },
      { name: "Syunik'", code: "AM-SU" },
      { name: "Tavus", code: "AM-TV" },
      { name: "Vayoc Jor", code: "AM-VD" }
    ]
  },
  [countryCodes.ANGOLA.alphaTwo]: {
    subdivisions: [
      { name: "Bengo", code: "AO-BGO" },
      { name: "Benguela", code: "AO-BGU" },
      { name: "Bie", code: "AO-BIE" },
      { name: "Cabinda", code: "AO-CAB" },
      { name: "Cuando Cubango", code: "AO-CCU" },
      { name: "Cuanza-Norte", code: "AO-CNO" },
      { name: "Cuanza-Sul", code: "AO-CUS" },
      { name: "Cunene", code: "AO-CNN" },
      { name: "Huambo", code: "AO-HUA" },
      { name: "Huila", code: "AO-HUI" },
      { name: "Luanda", code: "AO-LUA" },
      { name: "Lunda-Norte", code: "AO-LNO" },
      { name: "Lunda-Sul", code: "AO-LSU" },
      { name: "Malange", code: "AO-MAL" },
      { name: "Moxico", code: "AO-MOX" },
      { name: "Namibe", code: "AO-NAM" },
      { name: "Uige", code: "AO-UIG" },
      { name: "Zaire", code: "AO-ZAI" }
    ]
  },
  [countryCodes.ANTARCTICA.alphaTwo]: { subdivisions: [{ name: "Antarctica", code: "-" }] },
  [countryCodes.ARGENTINA.alphaTwo]: {
    subdivisions: [
      { name: "Buenos Aires", code: "AR-B" },
      { name: "Catamarca", code: "AR-K" },
      { name: "Chaco", code: "AR-H" },
      { name: "Chubut", code: "AR-U" },
      { name: "Ciudad Autonoma de Buenos Aires", code: "AR-C" },
      { name: "Cordoba", code: "AR-X" },
      { name: "Corrientes", code: "AR-W" },
      { name: "Entre Rios", code: "AR-E" },
      { name: "Formosa", code: "AR-P" },
      { name: "Jujuy", code: "AR-Y" },
      { name: "La Pampa", code: "AR-L" },
      { name: "La Rioja", code: "AR-F" },
      { name: "Mendoza", code: "AR-M" },
      { name: "Misiones", code: "AR-N" },
      { name: "Neuquen", code: "AR-Q" },
      { name: "Rio Negro", code: "AR-R" },
      { name: "Salta", code: "AR-A" },
      { name: "San Juan", code: "AR-J" },
      { name: "San Luis", code: "AR-D" },
      { name: "Santa Cruz", code: "AR-Z" },
      { name: "Santa Fe", code: "AR-S" },
      { name: "Santiago del Estero", code: "AR-G" },
      { name: "Tierra del Fuego", code: "AR-V" },
      { name: "Tucuman", code: "AR-T" }
    ]
  },
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: {
    subdivisions: [
      { name: "Eastern District", code: "-" },
      { name: "Western District", code: "-" }
    ]
  },
  [countryCodes.AUSTRIA.alphaTwo]: {
    subdivisions: [
      { name: "Burgenland", code: "AT-1" },
      { name: "Karnten", code: "AT-2" },
      { name: "Niederosterreich", code: "AT-3" },
      { name: "Oberosterreich", code: "AT-4" },
      { name: "Salzburg", code: "AT-5" },
      { name: "Steiermark", code: "AT-6" },
      { name: "Tirol", code: "AT-7" },
      { name: "Vorarlberg", code: "AT-8" },
      { name: "Wien", code: "AT-9" }
    ]
  },
  [countryCodes.AUSTRALIA.alphaTwo]: {
    subdivisions: [
      { name: "Australian Capital Territory", code: "AU-ACT" },
      { name: "New South Wales", code: "AU-NSW" },
      { name: "Northern Territory", code: "AU-NT" },
      { name: "Queensland", code: "AU-QLD" },
      { name: "South Australia", code: "AU-SA" },
      { name: "Tasmania", code: "AU-TAS" },
      { name: "Victoria", code: "AU-VIC" },
      { name: "Western Australia", code: "AU-WA" }
    ]
  },
  [countryCodes.ARUBA.alphaTwo]: { subdivisions: [{ name: "Aruba", code: "-" }] },
  [countryCodes.ALAND_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Eckeroe", code: "-" },
      { name: "Finstroem", code: "-" },
      { name: "Hammarland", code: "-" },
      { name: "Jomala", code: "-" },
      { name: "Lemland", code: "-" },
      { name: "Mariehamn", code: "-" },
      { name: "Saltvik", code: "-" }
    ]
  },
  [countryCodes.AZERBAIJAN.alphaTwo]: {
    subdivisions: [
      { name: "Abseron", code: "AZ-ABS" },
      { name: "Agcabadi", code: "AZ-AGC" },
      { name: "Agdas", code: "AZ-AGS" },
      { name: "Agstafa", code: "AZ-AGA" },
      { name: "Agsu", code: "AZ-AGU" },
      { name: "Astara", code: "AZ-AST" },
      { name: "Baki", code: "AZ-BA" },
      { name: "Balakan", code: "AZ-BAL" },
      { name: "Barda", code: "AZ-BAR" },
      { name: "Beylaqan", code: "AZ-BEY" },
      { name: "Calilabad", code: "AZ-CAL" },
      { name: "Ganca", code: "AZ-GA" },
      { name: "Goranboy", code: "AZ-GOR" },
      { name: "Goycay", code: "AZ-GOY" },
      { name: "Goygol", code: "AZ-GYG" },
      { name: "Haciqabul", code: "AZ-HAC" },
      { name: "Imisli", code: "AZ-IMI" },
      { name: "Kalbacar", code: "AZ-KAL" },
      { name: "Kurdamir", code: "AZ-KUR" },
      { name: "Lankaran", code: "AZ-LA" },
      { name: "Lerik", code: "AZ-LER" },
      { name: "Masalli", code: "AZ-MAS" },
      { name: "Mingacevir", code: "AZ-MI" },
      { name: "Naftalan", code: "AZ-NA" },
      { name: "Naxcivan", code: "AZ-NX" },
      { name: "Oguz", code: "AZ-OGU" },
      { name: "Qabala", code: "AZ-QAB" },
      { name: "Qazax", code: "AZ-QAZ" },
      { name: "Quba", code: "AZ-QBA" },
      { name: "Qusar", code: "AZ-QUS" },
      { name: "Sabirabad", code: "AZ-SAB" },
      { name: "Saki", code: "AZ-SAK" },
      { name: "Salyan", code: "AZ-SAL" },
      { name: "Samaxi", code: "AZ-SMI" },
      { name: "Samkir", code: "AZ-SKR" },
      { name: "Samux", code: "AZ-SMX" },
      { name: "Sirvan", code: "AZ-SR" },
      { name: "Siyazan", code: "AZ-SIY" },
      { name: "Sumqayit", code: "AZ-SM" },
      { name: "Tartar", code: "AZ-TAR" },
      { name: "Tovuz", code: "AZ-TOV" },
      { name: "Ucar", code: "AZ-UCA" },
      { name: "Xacmaz", code: "AZ-XAC" },
      { name: "Xizi", code: "AZ-XIZ" },
      { name: "Yardimli", code: "AZ-YAR" },
      { name: "Yevlax", code: "AZ-YEV" },
      { name: "Zaqatala", code: "AZ-ZAQ" },
      { name: "Zardab", code: "AZ-ZARD" },
      { name: "Agdam", code: "AZ-AGM" },
      { name: "Bilasuvar", code: "AZ-BIL" },
      { name: "Cabrayil", code: "AZ-CAB" },
      { name: "Dashkasan", code: "AZ-DAS" },
      { name: "Fuzuli", code: "AZ-FUZ" },
      { name: "Gadabay", code: "AZ-GAD" },
      { name: "Ismayilli", code: "AZ-ISM" },
      { name: "Lacin", code: "AZ-LAC" },
      { name: "Neftcala", code: "AZ-NEF" },
      { name: "Qax", code: "AZ-QAX" },
      { name: "Qubadli", code: "AZ-QBI" },
      { name: "Qobustan", code: "AZ-QOB" },
      { name: "Sahbuz", code: "AZ-SAH" },
      { name: "Saatli", code: "AZ-SAT" },
      { name: "Sabran", code: "AZ-SBN" },
      { name: "Susa", code: "AZ-SUS" },
      { name: "Xocali", code: "AZ-XCI" },
      { name: "Xocavand", code: "AZ-XVD" },
      { name: "Z@ngilan", code: "AZ-ZAN" }
    ]
  },
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: {
    subdivisions: [
      { name: "Brcko distrikt", code: "BA-BRC" },
      { name: "Federacija Bosne i Hercegovine", code: "BA-BIH" },
      { name: "Republika Srpska", code: "BA-SRP" }
    ]
  },
  [countryCodes.BARBADOS.alphaTwo]: {
    subdivisions: [
      { name: "Christ Church", code: "BB-01" },
      { name: "Saint Andrew", code: "BB-02" },
      { name: "Saint George", code: "BB-03" },
      { name: "Saint James", code: "BB-04" },
      { name: "Saint John", code: "BB-05" },
      { name: "Saint Joseph", code: "BB-06" },
      { name: "Saint Lucy", code: "BB-07" },
      { name: "Saint Michael", code: "BB-08" },
      { name: "Saint Peter", code: "BB-09" },
      { name: "Saint Philip", code: "BB-10" },
      { name: "Saint Thomas", code: "BB-11" }
    ]
  },
  [countryCodes.BANGLADESH.alphaTwo]: {
    subdivisions: [
      { name: "Barishal", code: "BD-A" },
      { name: "Chattogram", code: "BD-B" },
      { name: "Dhaka", code: "BD-C" },
      { name: "Khulna", code: "BD-D" },
      { name: "Rajshahi", code: "BD-E" },
      { name: "Rangpur", code: "BD-F" },
      { name: "Sylhet", code: "BD-G" },
      { name: "Mymensingh", code: "BD-H" }
    ]
  },
  [countryCodes.BELGIUM.alphaTwo]: {
    subdivisions: [
      { name: "Antwerpen", code: "BE-VAN" },
      { name: "Brabant wallon", code: "BE-WBR" },
      { name: "Brussels Hoofdstedelijk Gewest", code: "BE-BRU" },
      { name: "Hainaut", code: "BE-WHT" },
      { name: "Liege", code: "BE-WLG" },
      { name: "Limburg", code: "BE-VLI" },
      { name: "Luxembourg", code: "BE-WLX" },
      { name: "Namur", code: "BE-WNA" },
      { name: "Oost-Vlaanderen", code: "BE-VOV" },
      { name: "Vlaams-Brabant", code: "BE-VBR" },
      { name: "West-Vlaanderen", code: "BE-VWV" }
    ]
  },
  [countryCodes.BURKINA_FASO.alphaTwo]: {
    subdivisions: [
      { name: "Bale", code: "BF-BAL" },
      { name: "Bam", code: "BF-BAM" },
      { name: "Bazega", code: "BF-BAZ" },
      { name: "Boulgou", code: "BF-BLG" },
      { name: "Boulkiemde", code: "BF-BLK" },
      { name: "Comoe", code: "BF-COM" },
      { name: "Ganzourgou", code: "BF-GAN" },
      { name: "Gnagna", code: "BF-GNA" },
      { name: "Gourma", code: "BF-GOU" },
      { name: "Houet", code: "BF-HOU" },
      { name: "Kadiogo", code: "BF-KAD" },
      { name: "Kenedougou", code: "BF-KEN" },
      { name: "Kossi", code: "BF-KOS" },
      { name: "Kouritenga", code: "BF-KOT" },
      { name: "Kourweogo", code: "BF-KOW" },
      { name: "Leraba", code: "BF-LER" },
      { name: "Loroum", code: "BF-LOR" },
      { name: "Mouhoun", code: "BF-MOU" },
      { name: "Nahouri", code: "BF-NAO" },
      { name: "Namentenga", code: "BF-NAM" },
      { name: "Nayala", code: "BF-NAY" },
      { name: "Oubritenga", code: "BF-OUB" },
      { name: "Oudalan", code: "BF-OUD" },
      { name: "Passore", code: "BF-PAS" },
      { name: "Poni", code: "BF-PON" },
      { name: "Sanmatenga", code: "BF-SMT" },
      { name: "Seno", code: "BF-SEN" },
      { name: "Sissili", code: "BF-SIS" },
      { name: "Soum", code: "BF-SOM" },
      { name: "Tapoa", code: "BF-TAP" },
      { name: "Tuy", code: "BF-TUI" },
      { name: "Yatenga", code: "BF-YAT" },
      { name: "Ziro", code: "BF-ZIR" },
      { name: "Zondoma", code: "BF-ZON" },
      { name: "Zoundweogo", code: "BF-ZOU" },
      { name: "Banwa", code: "BF-BAN" },
      { name: "Bougouriba", code: "BF-BGR" },
      { name: "Ioba", code: "BF-IOB" },
      { name: "Komondjari", code: "BF-KMD" },
      { name: "Kompienga", code: "BF-KMP" },
      { name: "Koulpelogo", code: "BF-KOP" },
      { name: "Noumbiel", code: "BF-NOU" },
      { name: "Sanguie", code: "BF-SNG" },
      { name: "Sourou", code: "BF-SOR" },
      { name: "Yagha", code: "BF-YAG" }
    ]
  },
  [countryCodes.BULGARIA.alphaTwo]: {
    subdivisions: [
      { name: "Blagoevgrad", code: "BG-01" },
      { name: "Burgas", code: "BG-02" },
      { name: "Dobrich", code: "BG-08" },
      { name: "Gabrovo", code: "BG-07" },
      { name: "Haskovo", code: "BG-26" },
      { name: "Kardzhali", code: "BG-09" },
      { name: "Kyustendil", code: "BG-10" },
      { name: "Lovech", code: "BG-11" },
      { name: "Montana", code: "BG-12" },
      { name: "Pazardzhik", code: "BG-13" },
      { name: "Pernik", code: "BG-14" },
      { name: "Pleven", code: "BG-15" },
      { name: "Plovdiv", code: "BG-16" },
      { name: "Razgrad", code: "BG-17" },
      { name: "Ruse", code: "BG-18" },
      { name: "Shumen", code: "BG-27" },
      { name: "Silistra", code: "BG-19" },
      { name: "Sliven", code: "BG-20" },
      { name: "Smolyan", code: "BG-21" },
      { name: "Sofia", code: "BG-23" },
      { name: "Sofia (stolitsa)", code: "BG-22" },
      { name: "Stara Zagora", code: "BG-24" },
      { name: "Targovishte", code: "BG-25" },
      { name: "Varna", code: "BG-03" },
      { name: "Veliko Tarnovo", code: "BG-04" },
      { name: "Vidin", code: "BG-05" },
      { name: "Vratsa", code: "BG-06" },
      { name: "Yambol", code: "BG-28" }
    ]
  },
  [countryCodes.BAHRAIN.alphaTwo]: {
    subdivisions: [
      { name: "Al 'Asimah", code: "BH-13" },
      { name: "Al Janubiyah", code: "BH-14" },
      { name: "Al Muharraq", code: "BH-15" },
      { name: "Ash Shamaliyah", code: "BH-17" }
    ]
  },
  [countryCodes.BURUNDI.alphaTwo]: {
    subdivisions: [
      { name: "Bujumbura Mairie", code: "BI-BM" },
      { name: "Bururi", code: "BI-BR" },
      { name: "Cibitoke", code: "BI-CI" },
      { name: "Gitega", code: "BI-GI" },
      { name: "Karuzi", code: "BI-KR" },
      { name: "Kayanza", code: "BI-KY" },
      { name: "Kirundo", code: "BI-KI" },
      { name: "Makamba", code: "BI-MA" },
      { name: "Mwaro", code: "BI-MW" },
      { name: "Ngozi", code: "BI-NG" },
      { name: "Rumonge", code: "BI-RM" },
      { name: "Rutana", code: "BI-RT" },
      { name: "Ruyigi", code: "BI-RY" },
      { name: "Bubanza", code: "BI-BB" },
      { name: "Bujumbura Rural", code: "BI-BL" },
      { name: "Cankuzo", code: "BI-CA" },
      { name: "Muramvya", code: "BI-MU" },
      { name: "Muyinga", code: "BI-MY" }
    ]
  },
  [countryCodes.BENIN.alphaTwo]: {
    subdivisions: [
      { name: "Atacora", code: "BJ-AK" },
      { name: "Atlantique", code: "BJ-AQ" },
      { name: "Borgou", code: "BJ-BO" },
      { name: "Collines", code: "BJ-CO" },
      { name: "Donga", code: "BJ-DO" },
      { name: "Littoral", code: "BJ-LI" },
      { name: "Oueme", code: "BJ-OU" },
      { name: "Plateau", code: "BJ-PL" },
      { name: "Zou", code: "BJ-ZO" },
      { name: "Alibori", code: "BJ-AL" },
      { name: "Couffo", code: "BJ-KO" },
      { name: "Mono", code: "BJ-MO" }
    ]
  },
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: { subdivisions: [{ name: "Saint Barthelemy", code: "-" }] },
  [countryCodes.BERMUDA.alphaTwo]: {
    subdivisions: [
      { name: "Hamilton", code: "-" },
      { name: "Saint George", code: "-" }
    ]
  },
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: {
    subdivisions: [
      { name: "Belait", code: "BN-BE" },
      { name: "Brunei-Muara", code: "BN-BM" },
      { name: "Temburong", code: "BN-TE" },
      { name: "Tutong", code: "BN-TU" }
    ]
  },
  [countryCodes.BOLIVIA.alphaTwo]: {
    subdivisions: [
      { name: "Chuquisaca", code: "BO-H" },
      { name: "Cochabamba", code: "BO-C" },
      { name: "El Beni", code: "BO-B" },
      { name: "La Paz", code: "BO-L" },
      { name: "Oruro", code: "BO-O" },
      { name: "Pando", code: "BO-N" },
      { name: "Potosi", code: "BO-P" },
      { name: "Santa Cruz", code: "BO-S" },
      { name: "Tarija", code: "BO-T" }
    ]
  },
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: {
    subdivisions: [
      { name: "Bonaire", code: "BQ-BO" },
      { name: "Saba", code: "BQ-SA" },
      { name: "Sint Eustatius", code: "BQ-SE" }
    ]
  },
  [countryCodes.BRAZIL.alphaTwo]: {
    subdivisions: [
      { name: "Acre", code: "BR-AC" },
      { name: "Alagoas", code: "BR-AL" },
      { name: "Amapa", code: "BR-AP" },
      { name: "Amazonas", code: "BR-AM" },
      { name: "Bahia", code: "BR-BA" },
      { name: "Ceara", code: "BR-CE" },
      { name: "Distrito Federal", code: "BR-DF" },
      { name: "Espirito Santo", code: "BR-ES" },
      { name: "Goias", code: "BR-GO" },
      { name: "Maranhao", code: "BR-MA" },
      { name: "Mato Grosso", code: "BR-MT" },
      { name: "Mato Grosso do Sul", code: "BR-MS" },
      { name: "Minas Gerais", code: "BR-MG" },
      { name: "Para", code: "BR-PA" },
      { name: "Paraiba", code: "BR-PB" },
      { name: "Parana", code: "BR-PR" },
      { name: "Pernambuco", code: "BR-PE" },
      { name: "Piaui", code: "BR-PI" },
      { name: "Rio Grande do Norte", code: "BR-RN" },
      { name: "Rio Grande do Sul", code: "BR-RS" },
      { name: "Rio de Janeiro", code: "BR-RJ" },
      { name: "Rondonia", code: "BR-RO" },
      { name: "Roraima", code: "BR-RR" },
      { name: "Santa Catarina", code: "BR-SC" },
      { name: "Sao Paulo", code: "BR-SP" },
      { name: "Sergipe", code: "BR-SE" },
      { name: "Tocantins", code: "BR-TO" }
    ]
  },
  [countryCodes.BAHAMAS.alphaTwo]: {
    subdivisions: [
      { name: "Black Point", code: "BS-BP" },
      { name: "Central Abaco", code: "BS-CO" },
      { name: "City of Freeport", code: "BS-FP" },
      { name: "East Grand Bahama", code: "BS-EG" },
      { name: "Harbour Island", code: "BS-HI" },
      { name: "Moore's Island", code: "BS-MI" },
      { name: "New Providence", code: "BS-NP" },
      { name: "North Andros", code: "BS-NS" },
      { name: "North Eleuthera", code: "BS-NE" },
      { name: "San Salvador", code: "BS-SS" },
      { name: "South Eleuthera", code: "BS-SE" },
      { name: "West Grand Bahama", code: "BS-WG" },
      { name: "Acklins", code: "BS-AK" },
      { name: "Bimini", code: "BS-BI" },
      { name: "Berry Islands", code: "BS-BY" },
      { name: "Central Eleuthera", code: "BS-CE" },
      { name: "Cat Island", code: "BS-CI" },
      { name: "Crooked Island and Long Cay", code: "BS-CK" },
      { name: "Central Andros", code: "BS-CS" },
      { name: "Exuma", code: "BS-EX" },
      { name: "Grand Cay", code: "BS-GC" },
      { name: "Hope Town", code: "BS-HT" },
      { name: "Inagua", code: "BS-IN" },
      { name: "Long Island", code: "BS-LI" },
      { name: "Mangrove Cay", code: "BS-MC" },
      { name: "Mayaguana", code: "BS-MG" },
      { name: "North Abaco", code: "BS-NO" },
      { name: "Rum Cay", code: "BS-RC" },
      { name: "Ragged Island", code: "BS-RI" },
      { name: "South Andros", code: "BS-SA" },
      { name: "South Abaco", code: "BS-SO" },
      { name: "Spanish Wells", code: "BS-SW" }
    ]
  },
  [countryCodes.BHUTAN.alphaTwo]: {
    subdivisions: [
      { name: "Bumthang", code: "BT-33" },
      { name: "Chhukha", code: "BT-12" },
      { name: "Gasa", code: "BT-GA" },
      { name: "Lhuentse", code: "BT-44" },
      { name: "Monggar", code: "BT-42" },
      { name: "Paro", code: "BT-11" },
      { name: "Pema Gatshel", code: "BT-43" },
      { name: "Punakha", code: "BT-23" },
      { name: "Samdrup Jongkhar", code: "BT-45" },
      { name: "Samtse", code: "BT-14" },
      { name: "Sarpang", code: "BT-31" },
      { name: "Thimphu", code: "BT-15" },
      { name: "Trashigang", code: "BT-41" },
      { name: "Trongsa", code: "BT-32" },
      { name: "Tsirang", code: "BT-21" },
      { name: "Wangdue Phodrang", code: "BT-24" },
      { name: "Haa", code: "BT-13" },
      { name: "Dagana", code: "BT-22" },
      { name: "Zhemgang", code: "BT-34" },
      { name: "Trashi Yangtse", code: "BT-TY" }
    ]
  },
  [countryCodes.BOUVET_ISLAND.alphaTwo]: { subdivisions: [{ name: "Bouvet Island", code: "-" }] },
  [countryCodes.BOTSWANA.alphaTwo]: {
    subdivisions: [
      { name: "Central", code: "BW-CE" },
      { name: "Chobe", code: "BW-CH" },
      { name: "Ghanzi", code: "BW-GH" },
      { name: "Kgalagadi", code: "BW-KG" },
      { name: "Kgatleng", code: "BW-KL" },
      { name: "Kweneng", code: "BW-KW" },
      { name: "North East", code: "BW-NE" },
      { name: "North West", code: "BW-NW" },
      { name: "South East", code: "BW-SE" },
      { name: "Southern", code: "BW-SO" },
      { name: "Francistown", code: "BW-FR" },
      { name: "Gaborone", code: "BW-GA" },
      { name: "Jwaneng", code: "BW-JW" },
      { name: "Lobatse", code: "BW-LO" },
      { name: "Selibe Phikwe", code: "BW-SP" },
      { name: "Sowa Town", code: "BW-ST" }
    ]
  },
  [countryCodes.BELARUS.alphaTwo]: {
    subdivisions: [
      { name: "Brestskaya voblasts'", code: "BY-BR" },
      { name: "Homyel'skaya voblasts'", code: "BY-HO" },
      { name: "Horad Minsk", code: "BY-HM" },
      { name: "Hrodzyenskaya voblasts'", code: "BY-HR" },
      { name: "Mahilyowskaya voblasts'", code: "BY-MA" },
      { name: "Minskaya voblasts'", code: "BY-MI" },
      { name: "Vitsyebskaya voblasts'", code: "BY-VI" }
    ]
  },
  [countryCodes.BELIZE.alphaTwo]: {
    subdivisions: [
      { name: "Belize", code: "BZ-BZ" },
      { name: "Cayo", code: "BZ-CY" },
      { name: "Corozal", code: "BZ-CZL" },
      { name: "Orange Walk", code: "BZ-OW" },
      { name: "Stann Creek", code: "BZ-SC" },
      { name: "Toledo", code: "BZ-TOL" }
    ]
  },
  [countryCodes.CANADA.alphaTwo]: {
    subdivisions: [
      { name: "Alberta", code: "CA-AB" },
      { name: "British Columbia", code: "CA-BC" },
      { name: "Manitoba", code: "CA-MB" },
      { name: "New Brunswick", code: "CA-NB" },
      { name: "Newfoundland and Labrador", code: "CA-NL" },
      { name: "Northwest Territories", code: "CA-NT" },
      { name: "Nova Scotia", code: "CA-NS" },
      { name: "Nunavut", code: "CA-NU" },
      { name: "Ontario", code: "CA-ON" },
      { name: "Prince Edward Island", code: "CA-PE" },
      { name: "Quebec", code: "CA-QC" },
      { name: "Saskatchewan", code: "CA-SK" },
      { name: "Yukon", code: "CA-YT" }
    ]
  },
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Cocos (Keeling) Islands", code: "-" }]
  },
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: {
    subdivisions: [
      { name: "Equateur", code: "CD-EQ" },
      { name: "Haut-Katanga", code: "CD-HK" },
      { name: "Haut-Lomami", code: "CD-HL" },
      { name: "Haut-Uele", code: "CD-HU" },
      { name: "Ituri", code: "CD-IT" },
      { name: "Kasai", code: "CD-KS" },
      { name: "Kasai Central", code: "CD-KC" },
      { name: "Kasai Oriental", code: "CD-KE" },
      { name: "Kinshasa", code: "CD-KN" },
      { name: "Lualaba", code: "CD-LU" },
      { name: "Maniema", code: "CD-MA" },
      { name: "Nord-Kivu", code: "CD-NK" },
      { name: "Sankuru", code: "CD-SA" },
      { name: "Sud-Kivu", code: "CD-SK" },
      { name: "Tanganyika", code: "CD-TA" },
      { name: "Tshopo", code: "CD-TO" },
      { name: "Tshuapa", code: "CD-TU" },
      { name: "Kongo Central", code: "CD-BC" },
      { name: "Bas-Uele", code: "CD-BU" },
      { name: "Kwango", code: "CD-KG" },
      { name: "Kwilu", code: "CD-KL" },
      { name: "Lomami", code: "CD-LO" },
      { name: "Mai-Ndombe", code: "CD-MN" },
      { name: "Mongala", code: "CD-MO" },
      { name: "Nord-Ubangi", code: "CD-NU" },
      { name: "Sud-Ubangi", code: "CD-SU" }
    ]
  },
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: {
    subdivisions: [
      { name: "Bamingui-Bangoran", code: "CF-BB" },
      { name: "Bangui", code: "CF-BGF" },
      { name: "Haut-Mbomou", code: "CF-HM" },
      { name: "Haute-Kotto", code: "CF-HK" },
      { name: "Kemo-Gribingui", code: "CF-KG" },
      { name: "Lobaye", code: "CF-LB" },
      { name: "Mambere-Kadei", code: "CF-HS" },
      { name: "Nana-Mambere", code: "CF-NM" },
      { name: "Ouaka", code: "CF-UK" },
      { name: "Ouham", code: "CF-AC" },
      { name: "Vakaga", code: "CF-VK" },
      { name: "Basse-Kotto", code: "CF-BK" },
      { name: "Gribingui", code: "CF-KB" },
      { name: "Mbomou", code: "CF-MB" },
      { name: "Ombella-Mpoko", code: "CF-MP" },
      { name: "Ouham-Pende", code: "CF-OP" },
      { name: "Sangha", code: "CF-SE" }
    ]
  },
  [countryCodes.CONGO.alphaTwo]: {
    subdivisions: [
      { name: "Brazzaville", code: "CG-BZV" },
      { name: "Cuvette", code: "CG-8" },
      { name: "Cuvette-Ouest", code: "CG-15" },
      { name: "Likouala", code: "CG-7" },
      { name: "Niari", code: "CG-9" },
      { name: "Pointe-Noire", code: "CG-16" },
      { name: "Sangha", code: "CG-13" },
      { name: "Bouenza", code: "CG-11" },
      { name: "Pool", code: "CG-12" },
      { name: "Plateaux", code: "CG-14" },
      { name: "Lekoumou", code: "CG-2" },
      { name: "Kouilou", code: "CG-5" }
    ]
  },
  [countryCodes.SWITZERLAND.alphaTwo]: {
    subdivisions: [
      { name: "Aargau", code: "CH-AG" },
      { name: "Appenzell Ausserrhoden", code: "CH-AR" },
      { name: "Appenzell Innerrhoden", code: "CH-AI" },
      { name: "Basel-Landschaft", code: "CH-BL" },
      { name: "Basel-Stadt", code: "CH-BS" },
      { name: "Bern", code: "CH-BE" },
      { name: "Fribourg", code: "CH-FR" },
      { name: "Geneve", code: "CH-GE" },
      { name: "Glarus", code: "CH-GL" },
      { name: "Graubunden", code: "CH-GR" },
      { name: "Jura", code: "CH-JU" },
      { name: "Luzern", code: "CH-LU" },
      { name: "Neuchatel", code: "CH-NE" },
      { name: "Nidwalden", code: "CH-NW" },
      { name: "Obwalden", code: "CH-OW" },
      { name: "Sankt Gallen", code: "CH-SG" },
      { name: "Schaffhausen", code: "CH-SH" },
      { name: "Schwyz", code: "CH-SZ" },
      { name: "Solothurn", code: "CH-SO" },
      { name: "Thurgau", code: "CH-TG" },
      { name: "Ticino", code: "CH-TI" },
      { name: "Uri", code: "CH-UR" },
      { name: "Valais", code: "CH-VS" },
      { name: "Vaud", code: "CH-VD" },
      { name: "Zug", code: "CH-ZG" },
      { name: "Zurich", code: "CH-ZH" }
    ]
  },
  [countryCodes.COTE_DIVOIRE.alphaTwo]: {
    subdivisions: [
      { name: "Abidjan", code: "CI-AB" },
      { name: "Bas-Sassandra", code: "CI-BS" },
      { name: "Comoe", code: "CI-CM" },
      { name: "Denguele", code: "CI-DN" },
      { name: "Goh-Djiboua", code: "CI-GD" },
      { name: "Lacs", code: "CI-LC" },
      { name: "Lagunes", code: "CI-LG" },
      { name: "Montagnes", code: "CI-MG" },
      { name: "Sassandra-Marahoue", code: "CI-SM" },
      { name: "Savanes", code: "CI-SV" },
      { name: "Vallee du Bandama", code: "CI-VB" },
      { name: "Woroba", code: "CI-WR" },
      { name: "Yamoussoukro", code: "CI-YM" },
      { name: "Zanzan", code: "CI-ZZ" }
    ]
  },
  [countryCodes.COOK_ISLANDS.alphaTwo]: { subdivisions: [{ name: "Cook Islands", code: "-" }] },
  [countryCodes.CHILE.alphaTwo]: {
    subdivisions: [
      { name: "Aisen del General Carlos Ibanez del Campo", code: "CL-AI" },
      { name: "Antofagasta", code: "CL-AN" },
      { name: "Arica y Parinacota", code: "CL-AP" },
      { name: "Atacama", code: "CL-AT" },
      { name: "Biobio", code: "CL-BI" },
      { name: "Coquimbo", code: "CL-CO" },
      { name: "La Araucania", code: "CL-AR" },
      { name: "Libertador General Bernardo O'Higgins", code: "CL-LI" },
      { name: "Los Lagos", code: "CL-LL" },
      { name: "Los Rios", code: "CL-LR" },
      { name: "Magallanes", code: "CL-MA" },
      { name: "Maule", code: "CL-ML" },
      { name: "Nuble", code: "CL-NB" },
      { name: "Region Metropolitana de Santiago", code: "CL-RM" },
      { name: "Tarapaca", code: "CL-TA" },
      { name: "Valparaiso", code: "CL-VS" }
    ]
  },
  [countryCodes.CAMEROON.alphaTwo]: {
    subdivisions: [
      { name: "Adamaoua", code: "CM-AD" },
      { name: "Centre", code: "CM-CE" },
      { name: "Est", code: "CM-ES" },
      { name: "Extreme-Nord", code: "CM-EN" },
      { name: "Littoral", code: "CM-LT" },
      { name: "Nord", code: "CM-NO" },
      { name: "Nord-Ouest", code: "CM-NW" },
      { name: "Ouest", code: "CM-OU" },
      { name: "Sud", code: "CM-SU" },
      { name: "Sud-Ouest", code: "CM-SW" }
    ]
  },
  [countryCodes.CHINA.alphaTwo]: {
    subdivisions: [
      { name: "Anhui", code: "CN-AH" },
      { name: "Beijing", code: "CN-BJ" },
      { name: "Chongqing", code: "CN-CQ" },
      { name: "Fujian", code: "CN-FJ" },
      { name: "Gansu", code: "CN-GS" },
      { name: "Guangdong", code: "CN-GD" },
      { name: "Guangxi Zhuangzu", code: "CN-GX" },
      { name: "Guizhou", code: "CN-GZ" },
      { name: "Hainan", code: "CN-HI" },
      { name: "Hebei", code: "CN-HE" },
      { name: "Heilongjiang", code: "CN-HL" },
      { name: "Henan", code: "CN-HA" },
      { name: "Hubei", code: "CN-HB" },
      { name: "Hunan", code: "CN-HN" },
      { name: "Jiangsu", code: "CN-JS" },
      { name: "Jiangxi", code: "CN-JX" },
      { name: "Jilin", code: "CN-JL" },
      { name: "Liaoning", code: "CN-LN" },
      { name: "Nei Mongol", code: "CN-NM" },
      { name: "Ningxia Huizu", code: "CN-NX" },
      { name: "Qinghai", code: "CN-QH" },
      { name: "Shaanxi", code: "CN-SN" },
      { name: "Shandong", code: "CN-SD" },
      { name: "Shanghai", code: "CN-SH" },
      { name: "Shanxi", code: "CN-SX" },
      { name: "Sichuan", code: "CN-SC" },
      { name: "Tianjin", code: "CN-TJ" },
      { name: "Xinjiang Uygur", code: "CN-XJ" },
      { name: "Xizang", code: "CN-XZ" },
      { name: "Yunnan", code: "CN-YN" },
      { name: "Zhejiang", code: "CN-ZJ" }
    ]
  },
  [countryCodes.COLOMBIA.alphaTwo]: {
    subdivisions: [
      { name: "Amazonas", code: "CO-AMA" },
      { name: "Antioquia", code: "CO-ANT" },
      { name: "Arauca", code: "CO-ARA" },
      { name: "Atlantico", code: "CO-ATL" },
      { name: "Bolivar", code: "CO-BOL" },
      { name: "Boyaca", code: "CO-BOY" },
      { name: "Caldas", code: "CO-CAL" },
      { name: "Caqueta", code: "CO-CAQ" },
      { name: "Casanare", code: "CO-CAS" },
      { name: "Cauca", code: "CO-CAU" },
      { name: "Cesar", code: "CO-CES" },
      { name: "Choco", code: "CO-CHO" },
      { name: "Cordoba", code: "CO-COR" },
      { name: "Cundinamarca", code: "CO-CUN" },
      { name: "Distrito Capital de Bogota", code: "CO-DC" },
      { name: "Guainia", code: "CO-GUA" },
      { name: "Guaviare", code: "CO-GUV" },
      { name: "Huila", code: "CO-HUI" },
      { name: "La Guajira", code: "CO-LAG" },
      { name: "Magdalena", code: "CO-MAG" },
      { name: "Meta", code: "CO-MET" },
      { name: "Narino", code: "CO-NAR" },
      { name: "Norte de Santander", code: "CO-NSA" },
      { name: "Putumayo", code: "CO-PUT" },
      { name: "Quindio", code: "CO-QUI" },
      { name: "Risaralda", code: "CO-RIS" },
      { name: "San Andres, Providencia y Santa Catalina", code: "CO-SAP" },
      { name: "Santander", code: "CO-SAN" },
      { name: "Sucre", code: "CO-SUC" },
      { name: "Tolima", code: "CO-TOL" },
      { name: "Valle del Cauca", code: "CO-VAC" },
      { name: "Vaupes", code: "CO-VAU" },
      { name: "Vichada", code: "CO-VID" }
    ]
  },
  [countryCodes.COSTA_RICA.alphaTwo]: {
    subdivisions: [
      { name: "Alajuela", code: "CR-A" },
      { name: "Cartago", code: "CR-C" },
      { name: "Guanacaste", code: "CR-G" },
      { name: "Heredia", code: "CR-H" },
      { name: "Limon", code: "CR-L" },
      { name: "Puntarenas", code: "CR-P" },
      { name: "San Jose", code: "CR-SJ" }
    ]
  },
  [countryCodes.CUBA.alphaTwo]: {
    subdivisions: [
      { name: "Artemisa", code: "CU-15" },
      { name: "Camaguey", code: "CU-09" },
      { name: "Ciego de Avila", code: "CU-08" },
      { name: "Cienfuegos", code: "CU-06" },
      { name: "Granma", code: "CU-12" },
      { name: "Guantanamo", code: "CU-14" },
      { name: "Holguin", code: "CU-11" },
      { name: "Isla de la Juventud", code: "CU-99" },
      { name: "La Habana", code: "CU-03" },
      { name: "Las Tunas", code: "CU-10" },
      { name: "Matanzas", code: "CU-04" },
      { name: "Mayabeque", code: "CU-16" },
      { name: "Pinar del Rio", code: "CU-01" },
      { name: "Sancti Spiritus", code: "CU-07" },
      { name: "Santiago de Cuba", code: "CU-13" },
      { name: "Villa Clara", code: "CU-05" }
    ]
  },
  [countryCodes.CAPE_VERDE.alphaTwo]: {
    subdivisions: [
      { name: "Boa Vista", code: "CV-BV" },
      { name: "Maio", code: "CV-MA" },
      { name: "Porto Novo", code: "CV-PN" },
      { name: "Praia", code: "CV-PR" },
      { name: "Ribeira Grande", code: "CV-RG" },
      { name: "Ribeira Grande de Santiago", code: "CV-RS" },
      { name: "Sal", code: "CV-SL" },
      { name: "Sao Domingos", code: "CV-SD" },
      { name: "Sao Filipe", code: "CV-SF" },
      { name: "Sao Lourenco dos Orgaos", code: "CV-SO" },
      { name: "Sao Miguel", code: "CV-SM" },
      { name: "Sao Salvador do Mundo", code: "CV-SS" },
      { name: "Sao Vicente", code: "CV-SV" },
      { name: "Tarrafal", code: "CV-TA" },
      { name: "Brava", code: "CV-BR" },
      { name: "Santa Catarina", code: "CV-CA" },
      { name: "Santa Catarina do Fogo", code: "CV-CF" },
      { name: "Santa Cruz", code: "CV-CR" },
      { name: "Mosteiros", code: "CV-MO" },
      { name: "Paul", code: "CV-PA" },
      { name: "Ribeira Brava", code: "CV-RB" },
      { name: "Tarrafal de Sao Nicolau", code: "CV-TS" }
    ]
  },
  [countryCodes.CURACAO.alphaTwo]: { subdivisions: [{ name: "Curacao", code: "-" }] },
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: { subdivisions: [{ name: "Christmas Island", code: "-" }] },
  [countryCodes.CYPRUS.alphaTwo]: {
    subdivisions: [
      { name: "Ammochostos", code: "CY-04" },
      { name: "Keryneia", code: "CY-06" },
      { name: "Larnaka", code: "CY-03" },
      { name: "Lefkosia", code: "CY-01" },
      { name: "Lemesos", code: "CY-02" },
      { name: "Pafos", code: "CY-05" }
    ]
  },
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: {
    subdivisions: [
      { name: "Jihocesky kraj", code: "CZ-31" },
      { name: "Jihomoravsky kraj", code: "CZ-64" },
      { name: "Karlovarsky kraj", code: "CZ-41" },
      { name: "Kraj Vysocina", code: "CZ-63" },
      { name: "Kralovehradecky kraj", code: "CZ-52" },
      { name: "Liberecky kraj", code: "CZ-51" },
      { name: "Moravskoslezsky kraj", code: "CZ-80" },
      { name: "Olomoucky kraj", code: "CZ-71" },
      { name: "Pardubicky kraj", code: "CZ-53" },
      { name: "Plzensky kraj", code: "CZ-32" },
      { name: "Praha, Hlavni mesto", code: "CZ-10" },
      { name: "Stredocesky kraj", code: "CZ-20" },
      { name: "Ustecky kraj", code: "CZ-42" },
      { name: "Zlinsky kraj", code: "CZ-72" }
    ]
  },
  [countryCodes.GERMANY.alphaTwo]: {
    subdivisions: [
      { name: "Baden-Wurttemberg", code: "DE-BW" },
      { name: "Bayern", code: "DE-BY" },
      { name: "Berlin", code: "DE-BE" },
      { name: "Brandenburg", code: "DE-BB" },
      { name: "Bremen", code: "DE-HB" },
      { name: "Hamburg", code: "DE-HH" },
      { name: "Hessen", code: "DE-HE" },
      { name: "Mecklenburg-Vorpommern", code: "DE-MV" },
      { name: "Niedersachsen", code: "DE-NI" },
      { name: "Nordrhein-Westfalen", code: "DE-NW" },
      { name: "Rheinland-Pfalz", code: "DE-RP" },
      { name: "Saarland", code: "DE-SL" },
      { name: "Sachsen", code: "DE-SN" },
      { name: "Sachsen-Anhalt", code: "DE-ST" },
      { name: "Schleswig-Holstein", code: "DE-SH" },
      { name: "Thuringen", code: "DE-TH" }
    ]
  },
  [countryCodes.DJIBOUTI.alphaTwo]: {
    subdivisions: [
      { name: "Arta", code: "DJ-AR" },
      { name: "Dikhil", code: "DJ-DI" },
      { name: "Djibouti", code: "DJ-DJ" },
      { name: "Ali Sabieh", code: "DJ-AS" },
      { name: "Obock", code: "DJ-OB" },
      { name: "Tadjourah", code: "DJ-TA" }
    ]
  },
  [countryCodes.DENMARK.alphaTwo]: {
    subdivisions: [
      { name: "Hovedstaden", code: "DK-84" },
      { name: "Midtjylland", code: "DK-82" },
      { name: "Nordjylland", code: "DK-81" },
      { name: "Sjaelland", code: "DK-85" },
      { name: "Syddanmark", code: "DK-83" }
    ]
  },
  [countryCodes.DOMINICA.alphaTwo]: {
    subdivisions: [
      { name: "Saint Andrew", code: "DM-02" },
      { name: "Saint George", code: "DM-04" },
      { name: "Saint John", code: "DM-05" },
      { name: "Saint Joseph", code: "DM-06" },
      { name: "Saint Luke", code: "DM-07" },
      { name: "Saint Patrick", code: "DM-09" },
      { name: "Saint Paul", code: "DM-10" },
      { name: "Saint Peter", code: "DM-11" },
      { name: "Saint David", code: "DM-03" },
      { name: "Saint Mark", code: "DM-08" }
    ]
  },
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: {
    subdivisions: [
      { name: "Azua", code: "DO-02" },
      { name: "Baoruco", code: "DO-03" },
      { name: "Barahona", code: "DO-04" },
      { name: "Dajabon", code: "DO-05" },
      { name: "Distrito Nacional (Santo Domingo)", code: "DO-01" },
      { name: "Duarte", code: "DO-06" },
      { name: "El Seibo", code: "DO-08" },
      { name: "Elias Pina", code: "DO-07" },
      { name: "Espaillat", code: "DO-09" },
      { name: "Hato Mayor", code: "DO-30" },
      { name: "Hermanas Mirabal", code: "DO-19" },
      { name: "Independencia", code: "DO-10" },
      { name: "La Altagracia", code: "DO-11" },
      { name: "La Romana", code: "DO-12" },
      { name: "La Vega", code: "DO-13" },
      { name: "Maria Trinidad Sanchez", code: "DO-14" },
      { name: "Monsenor Nouel", code: "DO-28" },
      { name: "Monte Cristi", code: "DO-15" },
      { name: "Monte Plata", code: "DO-29" },
      { name: "Pedernales", code: "DO-16" },
      { name: "Peravia", code: "DO-17" },
      { name: "Puerto Plata", code: "DO-18" },
      { name: "Samana", code: "DO-20" },
      { name: "San Cristobal", code: "DO-21" },
      { name: "San Jose de Ocoa", code: "DO-31" },
      { name: "San Juan", code: "DO-22" },
      { name: "San Pedro de Macoris", code: "DO-23" },
      { name: "Sanchez Ramirez", code: "DO-24" },
      { name: "Santiago", code: "DO-25" },
      { name: "Santiago Rodriguez", code: "DO-26" },
      { name: "Valverde", code: "DO-27" },
      { name: "Santo Domingo", code: "DO-32" }
    ]
  },
  [countryCodes.ALGERIA.alphaTwo]: {
    subdivisions: [
      { name: "Adrar", code: "DZ-01" },
      { name: "Ain Defla", code: "DZ-44" },
      { name: "Ain Temouchent", code: "DZ-46" },
      { name: "Alger", code: "DZ-16" },
      { name: "Annaba", code: "DZ-23" },
      { name: "Batna", code: "DZ-05" },
      { name: "Bechar", code: "DZ-08" },
      { name: "Bejaia", code: "DZ-06" },
      { name: "Biskra", code: "DZ-07" },
      { name: "Blida", code: "DZ-09" },
      { name: "Bordj Bou Arreridj", code: "DZ-34" },
      { name: "Bouira", code: "DZ-10" },
      { name: "Boumerdes", code: "DZ-35" },
      { name: "Chlef", code: "DZ-02" },
      { name: "Constantine", code: "DZ-25" },
      { name: "Djanet", code: "DZ-56" },
      { name: "Djelfa", code: "DZ-17" },
      { name: "El Bayadh", code: "DZ-32" },
      { name: "El Meghaier", code: "DZ-57" },
      { name: "El Oued", code: "DZ-39" },
      { name: "El Tarf", code: "DZ-36" },
      { name: "Ghardaia", code: "DZ-47" },
      { name: "Guelma", code: "DZ-24" },
      { name: "Illizi", code: "DZ-33" },
      { name: "In Salah", code: "DZ-53" },
      { name: "Jijel", code: "DZ-18" },
      { name: "Khenchela", code: "DZ-40" },
      { name: "Laghouat", code: "DZ-03" },
      { name: "M'sila", code: "DZ-28" },
      { name: "Mascara", code: "DZ-29" },
      { name: "Medea", code: "DZ-26" },
      { name: "Mila", code: "DZ-43" },
      { name: "Mostaganem", code: "DZ-27" },
      { name: "Naama", code: "DZ-45" },
      { name: "Oran", code: "DZ-31" },
      { name: "Ouargla", code: "DZ-30" },
      { name: "Ouled Djellal", code: "DZ-51" },
      { name: "Oum el Bouaghi", code: "DZ-04" },
      { name: "Relizane", code: "DZ-48" },
      { name: "Saida", code: "DZ-20" },
      { name: "Setif", code: "DZ-19" },
      { name: "Sidi Bel Abbes", code: "DZ-22" },
      { name: "Skikda", code: "DZ-21" },
      { name: "Souk Ahras", code: "DZ-41" },
      { name: "Tamanrasset", code: "DZ-11" },
      { name: "Tebessa", code: "DZ-12" },
      { name: "Tiaret", code: "DZ-14" },
      { name: "Timimoun", code: "DZ-49" },
      { name: "Tindouf", code: "DZ-37" },
      { name: "Tipaza", code: "DZ-42" },
      { name: "Tissemsilt", code: "DZ-38" },
      { name: "Tizi Ouzou", code: "DZ-15" },
      { name: "Tlemcen", code: "DZ-13" },
      { name: "Touggourt", code: "DZ-55" },
      { name: "Bordj Badji Mokhtar", code: "DZ-50" },
      { name: "Beni Abbes", code: "DZ-52" },
      { name: "In Guezzam", code: "DZ-54" },
      { name: "El Meniaa", code: "DZ-58" }
    ]
  },
  [countryCodes.ECUADOR.alphaTwo]: {
    subdivisions: [
      { name: "Azuay", code: "EC-A" },
      { name: "Bolivar", code: "EC-B" },
      { name: "Canar", code: "EC-F" },
      { name: "Carchi", code: "EC-C" },
      { name: "Chimborazo", code: "EC-H" },
      { name: "Cotopaxi", code: "EC-X" },
      { name: "El Oro", code: "EC-O" },
      { name: "Esmeraldas", code: "EC-E" },
      { name: "Galapagos", code: "EC-W" },
      { name: "Guayas", code: "EC-G" },
      { name: "Imbabura", code: "EC-I" },
      { name: "Loja", code: "EC-L" },
      { name: "Los Rios", code: "EC-R" },
      { name: "Manabi", code: "EC-M" },
      { name: "Morona Santiago", code: "EC-S" },
      { name: "Napo", code: "EC-N" },
      { name: "Orellana", code: "EC-D" },
      { name: "Pastaza", code: "EC-Y" },
      { name: "Pichincha", code: "EC-P" },
      { name: "Santa Elena", code: "EC-SE" },
      { name: "Santo Domingo de los Tsachilas", code: "EC-SD" },
      { name: "Sucumbios", code: "EC-U" },
      { name: "Tungurahua", code: "EC-T" },
      { name: "Zamora Chinchipe", code: "EC-Z" }
    ]
  },
  [countryCodes.ESTONIA.alphaTwo]: {
    subdivisions: [
      { name: "Harjumaa", code: "EE-37" },
      { name: "Hiiumaa", code: "EE-39" },
      { name: "Ida-Virumaa", code: "EE-45" },
      { name: "Jarvamaa", code: "EE-52" },
      { name: "Jogevamaa", code: "EE-50" },
      { name: "Laane-Virumaa", code: "EE-60" },
      { name: "Laanemaa", code: "EE-56" },
      { name: "Parnumaa", code: "EE-68" },
      { name: "Polvamaa", code: "EE-64" },
      { name: "Raplamaa", code: "EE-71" },
      { name: "Saaremaa", code: "EE-74" },
      { name: "Tartumaa", code: "EE-79" },
      { name: "Valgamaa", code: "EE-81" },
      { name: "Viljandimaa", code: "EE-84" },
      { name: "Vorumaa", code: "EE-87" }
    ]
  },
  [countryCodes.EGYPT.alphaTwo]: {
    subdivisions: [
      { name: "Ad Daqahliyah", code: "EG-DK" },
      { name: "Al Bahr al Ahmar", code: "EG-BA" },
      { name: "Al Buhayrah", code: "EG-BH" },
      { name: "Al Fayyum", code: "EG-FYM" },
      { name: "Al Gharbiyah", code: "EG-GH" },
      { name: "Al Iskandariyah", code: "EG-ALX" },
      { name: "Al Isma'iliyah", code: "EG-IS" },
      { name: "Al Jizah", code: "EG-GZ" },
      { name: "Al Minufiyah", code: "EG-MNF" },
      { name: "Al Minya", code: "EG-MN" },
      { name: "Al Qahirah", code: "EG-C" },
      { name: "Al Qalyubiyah", code: "EG-KB" },
      { name: "Al Uqsur", code: "EG-LX" },
      { name: "Al Wadi al Jadid", code: "EG-WAD" },
      { name: "As Suways", code: "EG-SUZ" },
      { name: "Ash Sharqiyah", code: "EG-SHR" },
      { name: "Aswan", code: "EG-ASN" },
      { name: "Asyut", code: "EG-AST" },
      { name: "Bani Suwayf", code: "EG-BNS" },
      { name: "Bur Sa'id", code: "EG-PTS" },
      { name: "Dumyat", code: "EG-DT" },
      { name: "Janub Sina'", code: "EG-JS" },
      { name: "Kafr ash Shaykh", code: "EG-KFS" },
      { name: "Matruh", code: "EG-MT" },
      { name: "Qina", code: "EG-KN" },
      { name: "Shamal Sina'", code: "EG-SIN" },
      { name: "Suhaj", code: "EG-SHG" }
    ]
  },
  [countryCodes.WESTERN_SAHARA.alphaTwo]: { subdivisions: [{ name: "Western Sahara", code: "-" }] },
  [countryCodes.ERITREA.alphaTwo]: {
    subdivisions: [
      { name: "Al Awsat", code: "ER-MA" },
      { name: "Qash-Barkah", code: "ER-GB" },
      { name: "Ansaba", code: "ER-AN" },
      { name: "Debubawi K'eyyih Bahri", code: "ER-DK" },
      { name: "Al Janubi", code: "ER-DU" },
      { name: "Semienawi K'eyyih Bahri", code: "ER-SK" }
    ]
  },
  [countryCodes.SPAIN.alphaTwo]: {
    subdivisions: [
      { name: "Andalucia", code: "ES-AN" },
      { name: "Aragon", code: "ES-AR" },
      { name: "Asturias, Principado de", code: "ES-AS" },
      { name: "Canarias", code: "ES-CN" },
      { name: "Cantabria", code: "ES-CB" },
      { name: "Castilla y Leon", code: "ES-CL" },
      { name: "Castilla-La Mancha", code: "ES-CM" },
      { name: "Catalunya", code: "ES-CT" },
      { name: "Ceuta", code: "ES-CE" },
      { name: "Extremadura", code: "ES-EX" },
      { name: "Galicia", code: "ES-GA" },
      { name: "Illes Balears", code: "ES-IB" },
      { name: "La Rioja", code: "ES-RI" },
      { name: "Madrid, Comunidad de", code: "ES-MD" },
      { name: "Melilla", code: "ES-ML" },
      { name: "Murcia, Region de", code: "ES-MC" },
      { name: "Navarra, Comunidad Foral de", code: "ES-NC" },
      { name: "Pais Vasco", code: "ES-PV" },
      { name: "Valenciana, Comunidad", code: "ES-VC" }
    ]
  },
  [countryCodes.ETHIOPIA.alphaTwo]: {
    subdivisions: [
      { name: "Addis Ababa", code: "ET-AA" },
      { name: "Afar", code: "ET-AF" },
      { name: "Amara", code: "ET-AM" },
      { name: "Benshangul-Gumaz", code: "ET-BE" },
      { name: "Dire Dawa", code: "ET-DD" },
      { name: "Gambela Peoples", code: "ET-GA" },
      { name: "Harari People", code: "ET-HA" },
      { name: "Oromia", code: "ET-OR" },
      { name: "Somali", code: "ET-SO" },
      { name: "Southern Nations, Nationalities and Peoples", code: "ET-SN" },
      { name: "Tigrai", code: "ET-TI" },
      { name: "Sidama", code: "ET-SI" },
      { name: "Southwest Ethiopia Peoples", code: "ET-SW" }
    ]
  },
  [countryCodes.FINLAND.alphaTwo]: {
    subdivisions: [
      { name: "Etela-Karjala", code: "FI-02" },
      { name: "Etela-Pohjanmaa", code: "FI-03" },
      { name: "Etela-Savo", code: "FI-04" },
      { name: "Kainuu", code: "FI-05" },
      { name: "Kanta-Hame", code: "FI-06" },
      { name: "Keski-Pohjanmaa", code: "FI-07" },
      { name: "Keski-Suomi", code: "FI-08" },
      { name: "Kymenlaakso", code: "FI-09" },
      { name: "Lappi", code: "FI-10" },
      { name: "Paijat-Hame", code: "FI-16" },
      { name: "Pirkanmaa", code: "FI-11" },
      { name: "Pohjanmaa", code: "FI-12" },
      { name: "Pohjois-Karjala", code: "FI-13" },
      { name: "Pohjois-Pohjanmaa", code: "FI-14" },
      { name: "Pohjois-Savo", code: "FI-15" },
      { name: "Satakunta", code: "FI-17" },
      { name: "Uusimaa", code: "FI-18" },
      { name: "Varsinais-Suomi", code: "FI-19" },
      { name: "Landskapet Aland", code: "FI-01" }
    ]
  },
  [countryCodes.FIJI.alphaTwo]: {
    subdivisions: [
      { name: "Central", code: "FJ-C" },
      { name: "Eastern", code: "FJ-E" },
      { name: "Rotuma", code: "FJ-R" },
      { name: "Western", code: "FJ-W" },
      { name: "Northern", code: "FJ-N" }
    ]
  },
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: {
    subdivisions: [{ name: "Falkland Islands (Malvinas)", code: "-" }]
  },
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: {
    subdivisions: [
      { name: "Chuuk", code: "FM-TRK" },
      { name: "Kosrae", code: "FM-KSA" },
      { name: "Pohnpei", code: "FM-PNI" },
      { name: "Yap", code: "FM-YAP" }
    ]
  },
  [countryCodes.FAROE_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Eysturoy", code: "-" },
      { name: "Nordoyar", code: "-" },
      { name: "Sandoy", code: "-" },
      { name: "Streymoy", code: "-" },
      { name: "Suduroy", code: "-" },
      { name: "Vagar", code: "-" }
    ]
  },
  [countryCodes.FRANCE.alphaTwo]: {
    subdivisions: [
      { name: "Auvergne-Rhone-Alpes", code: "FR-ARA" },
      { name: "Bourgogne-Franche-Comte", code: "FR-BFC" },
      { name: "Bretagne", code: "FR-BRE" },
      { name: "Centre-Val de Loire", code: "FR-CVL" },
      { name: "Corse", code: "FR-20R" },
      { name: "Grand-Est", code: "FR-GES" },
      { name: "Hauts-de-France", code: "FR-HDF" },
      { name: "Ile-de-France", code: "FR-IDF" },
      { name: "Normandie", code: "FR-NOR" },
      { name: "Nouvelle-Aquitaine", code: "FR-NAQ" },
      { name: "Occitanie", code: "FR-OCC" },
      { name: "Pays-de-la-Loire", code: "FR-PDL" },
      { name: "Provence-Alpes-Cote-d'Azur", code: "FR-PAC" }
    ]
  },
  [countryCodes.GABON.alphaTwo]: {
    subdivisions: [
      { name: "Estuaire", code: "GA-1" },
      { name: "Haut-Ogooue", code: "GA-2" },
      { name: "Moyen-Ogooue", code: "GA-3" },
      { name: "Ngounie", code: "GA-4" },
      { name: "Nyanga", code: "GA-5" },
      { name: "Ogooue-Ivindo", code: "GA-6" },
      { name: "Ogooue-Lolo", code: "GA-7" },
      { name: "Ogooue-Maritime", code: "GA-8" },
      { name: "Woleu-Ntem", code: "GA-9" }
    ]
  },
  [countryCodes.UNITED_KINGDOM.alphaTwo]: {
    subdivisions: [
      { name: "England", code: "GB-ENG" },
      { name: "Northern Ireland", code: "GB-NIR" },
      { name: "Scotland", code: "GB-SCT" },
      { name: "Wales", code: "GB-WLS" }
    ]
  },
  [countryCodes.GRENADA.alphaTwo]: {
    subdivisions: [
      { name: "Saint Andrew", code: "GD-01" },
      { name: "Saint David", code: "GD-02" },
      { name: "Saint George", code: "GD-03" },
      { name: "Saint Mark", code: "GD-05" },
      { name: "Saint Patrick", code: "GD-06" },
      { name: "Southern Grenadine Islands", code: "GD-10" },
      { name: "Saint John", code: "GD-04" }
    ]
  },
  [countryCodes.GEORGIA.alphaTwo]: {
    subdivisions: [
      { name: "Abkhazia", code: "GE-AB" },
      { name: "Ajaria", code: "GE-AJ" },
      { name: "Guria", code: "GE-GU" },
      { name: "Imereti", code: "GE-IM" },
      { name: "K'akheti", code: "GE-KA" },
      { name: "Kvemo Kartli", code: "GE-KK" },
      { name: "Mtskheta-Mtianeti", code: "GE-MM" },
      { name: "Rach'a-Lechkhumi-Kvemo Svaneti", code: "GE-RL" },
      { name: "Samegrelo-Zemo Svaneti", code: "GE-SZ" },
      { name: "Samtskhe-Javakheti", code: "GE-SJ" },
      { name: "Shida Kartli", code: "GE-SK" },
      { name: "Tbilisi", code: "GE-TB" }
    ]
  },
  [countryCodes.FRENCH_GUIANA.alphaTwo]: { subdivisions: [{ name: "Guyane", code: "-" }] },
  [countryCodes.GUERNSEY.alphaTwo]: { subdivisions: [{ name: "Guernsey", code: "-" }] },
  [countryCodes.GHANA.alphaTwo]: {
    subdivisions: [
      { name: "Ahafo", code: "GH-AF" },
      { name: "Ashanti", code: "GH-AH" },
      { name: "Bono", code: "GH-BO" },
      { name: "Bono East", code: "GH-BE" },
      { name: "Central", code: "GH-CP" },
      { name: "Eastern", code: "GH-EP" },
      { name: "Greater Accra", code: "GH-AA" },
      { name: "Northern", code: "GH-NP" },
      { name: "Upper East", code: "GH-UE" },
      { name: "Upper West", code: "GH-UW" },
      { name: "Volta", code: "GH-TV" },
      { name: "Western", code: "GH-WP" },
      { name: "Oti", code: "GH-OT" },
      { name: "Savannah", code: "GH-SV" },
      { name: "Western North", code: "GH-WN" }
    ]
  },
  [countryCodes.GIBRALTAR.alphaTwo]: { subdivisions: [{ name: "Gibraltar", code: "-" }] },
  [countryCodes.GREENLAND.alphaTwo]: {
    subdivisions: [
      { name: "Avannaata Kommunia", code: "GL-AV" },
      { name: "Kommune Kujalleq", code: "GL-KU" },
      { name: "Kommune Qeqertalik", code: "GL-QT" },
      { name: "Kommuneqarfik Sermersooq", code: "GL-SM" },
      { name: "Qeqqata Kommunia", code: "GL-QE" }
    ]
  },
  [countryCodes.GAMBIA.alphaTwo]: {
    subdivisions: [
      { name: "Banjul", code: "GM-B" },
      { name: "Central River", code: "GM-M" },
      { name: "Lower River", code: "GM-L" },
      { name: "North Bank", code: "GM-N" },
      { name: "Upper River", code: "GM-U" },
      { name: "Western", code: "GM-W" }
    ]
  },
  [countryCodes.GUINEA.alphaTwo]: {
    subdivisions: [
      { name: "Beyla", code: "GN-BE" },
      { name: "Boke", code: "GN-BK" },
      { name: "Conakry", code: "GN-C" },
      { name: "Coyah", code: "GN-CO" },
      { name: "Dabola", code: "GN-DB" },
      { name: "Dinguiraye", code: "GN-DI" },
      { name: "Dubreka", code: "GN-DU" },
      { name: "Fria", code: "GN-FR" },
      { name: "Kankan", code: "GN-KA" },
      { name: "Kindia", code: "GN-KD" },
      { name: "Kouroussa", code: "GN-KO" },
      { name: "Labe", code: "GN-LA" },
      { name: "Mamou", code: "GN-MM" },
      { name: "Siguiri", code: "GN-SI" },
      { name: "Boffa", code: "GN-BF" },
      { name: "Dalaba", code: "GN-DL" },
      { name: "Faranah", code: "GN-FA" },
      { name: "Forecariah", code: "GN-FO" },
      { name: "Gaoual", code: "GN-GA" },
      { name: "Guekedou", code: "GN-GU" },
      { name: "Koubia", code: "GN-KB" },
      { name: "Kerouane", code: "GN-KE" },
      { name: "Koundara", code: "GN-KN" },
      { name: "Kissidougou", code: "GN-KS" },
      { name: "Lelouma", code: "GN-LE" },
      { name: "Lola", code: "GN-LO" },
      { name: "Macenta", code: "GN-MC" },
      { name: "Mandiana", code: "GN-MD" },
      { name: "Mali", code: "GN-ML" },
      { name: "Nzerekore", code: "GN-NZ" },
      { name: "Pita", code: "GN-PI" },
      { name: "Telimele", code: "GN-TE" },
      { name: "Tougue", code: "GN-TO" },
      { name: "Yomou", code: "GN-YO" }
    ]
  },
  [countryCodes.GUADELOUPE.alphaTwo]: { subdivisions: [{ name: "Guadeloupe", code: "-" }] },
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: {
    subdivisions: [
      { name: "Bioko Norte", code: "GQ-BN" },
      { name: "Bioko Sur", code: "GQ-BS" },
      { name: "Centro Sur", code: "GQ-CS" },
      { name: "Kie-Ntem", code: "GQ-KN" },
      { name: "Litoral", code: "GQ-LI" },
      { name: "Wele-Nzas", code: "GQ-WN" },
      { name: "Annobon", code: "GQ-AN" },
      { name: "Djibloho", code: "GQ-DJ" }
    ]
  },
  [countryCodes.GREECE.alphaTwo]: {
    subdivisions: [
      { name: "Agion Oros", code: "GR-69" },
      { name: "Anatoliki Makedonia kai Thraki", code: "GR-A" },
      { name: "Attiki", code: "GR-I" },
      { name: "Dytiki Ellada", code: "GR-G" },
      { name: "Dytiki Makedonia", code: "GR-C" },
      { name: "Ionia Nisia", code: "GR-F" },
      { name: "Ipeiros", code: "GR-D" },
      { name: "Kentriki Makedonia", code: "GR-B" },
      { name: "Kriti", code: "GR-M" },
      { name: "Notio Aigaio", code: "GR-L" },
      { name: "Peloponnisos", code: "GR-J" },
      { name: "Sterea Ellada", code: "GR-H" },
      { name: "Thessalia", code: "GR-E" },
      { name: "Voreio Aigaio", code: "GR-K" }
    ]
  },
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "South Georgia and the South Sandwich Islands", code: "-" }]
  },
  [countryCodes.GUATEMALA.alphaTwo]: {
    subdivisions: [
      { name: "Alta Verapaz", code: "GT-16" },
      { name: "Baja Verapaz", code: "GT-15" },
      { name: "Chimaltenango", code: "GT-04" },
      { name: "Chiquimula", code: "GT-20" },
      { name: "El Progreso", code: "GT-02" },
      { name: "Escuintla", code: "GT-05" },
      { name: "Guatemala", code: "GT-01" },
      { name: "Huehuetenango", code: "GT-13" },
      { name: "Izabal", code: "GT-18" },
      { name: "Jalapa", code: "GT-21" },
      { name: "Jutiapa", code: "GT-22" },
      { name: "Peten", code: "GT-17" },
      { name: "Quetzaltenango", code: "GT-09" },
      { name: "Quiche", code: "GT-14" },
      { name: "Retalhuleu", code: "GT-11" },
      { name: "Sacatepequez", code: "GT-03" },
      { name: "San Marcos", code: "GT-12" },
      { name: "Santa Rosa", code: "GT-06" },
      { name: "Solola", code: "GT-07" },
      { name: "Suchitepequez", code: "GT-10" },
      { name: "Totonicapan", code: "GT-08" },
      { name: "Zacapa", code: "GT-19" }
    ]
  },
  [countryCodes.GUAM.alphaTwo]: {
    subdivisions: [
      { name: "Agat", code: "-" },
      { name: "Barrigada", code: "-" },
      { name: "Chalan Pago-Ordot", code: "-" },
      { name: "Dededo", code: "-" },
      { name: "Hagatna", code: "-" },
      { name: "Inarajan", code: "-" },
      { name: "Mangilao", code: "-" },
      { name: "Merizo", code: "-" },
      { name: "Mongmong-Toto-Maite", code: "-" },
      { name: "Piti", code: "-" },
      { name: "Santa Rita", code: "-" },
      { name: "Talofofo", code: "-" },
      { name: "Tamuning-Tumon-Harmon", code: "-" },
      { name: "Yigo", code: "-" },
      { name: "Yona", code: "-" }
    ]
  },
  [countryCodes.GUINEA_BISSAU.alphaTwo]: {
    subdivisions: [
      { name: "Bafata", code: "GW-BA" },
      { name: "Bissau", code: "GW-BS" },
      { name: "Cacheu", code: "GW-CA" },
      { name: "Gabu", code: "GW-GA" },
      { name: "Oio", code: "GW-OI" },
      { name: "Bolama / Bijagos", code: "GW-BL" },
      { name: "Biombo", code: "GW-BM" },
      { name: "Quinara", code: "GW-QU" },
      { name: "Tombali", code: "GW-TO" }
    ]
  },
  [countryCodes.GUYANA.alphaTwo]: {
    subdivisions: [
      { name: "Barima-Waini", code: "GY-BA" },
      { name: "Cuyuni-Mazaruni", code: "GY-CU" },
      { name: "Demerara-Mahaica", code: "GY-DE" },
      { name: "East Berbice-Corentyne", code: "GY-EB" },
      { name: "Essequibo Islands-West Demerara", code: "GY-ES" },
      { name: "Mahaica-Berbice", code: "GY-MA" },
      { name: "Pomeroon-Supenaam", code: "GY-PM" },
      { name: "Potaro-Siparuni", code: "GY-PT" },
      { name: "Upper Demerara-Berbice", code: "GY-UD" },
      { name: "Upper Takutu-Upper Essequibo", code: "GY-UT" }
    ]
  },
  [countryCodes.HONG_KONG.alphaTwo]: { subdivisions: [{ name: "Hong Kong", code: "-" }] },
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Heard Island and McDonald Islands", code: "-" }]
  },
  [countryCodes.HONDURAS.alphaTwo]: {
    subdivisions: [
      { name: "Atlantida", code: "HN-AT" },
      { name: "Choluteca", code: "HN-CH" },
      { name: "Colon", code: "HN-CL" },
      { name: "Comayagua", code: "HN-CM" },
      { name: "Copan", code: "HN-CP" },
      { name: "Cortes", code: "HN-CR" },
      { name: "El Paraiso", code: "HN-EP" },
      { name: "Francisco Morazan", code: "HN-FM" },
      { name: "Gracias a Dios", code: "HN-GD" },
      { name: "Intibuca", code: "HN-IN" },
      { name: "Islas de la Bahia", code: "HN-IB" },
      { name: "La Paz", code: "HN-LP" },
      { name: "Lempira", code: "HN-LE" },
      { name: "Ocotepeque", code: "HN-OC" },
      { name: "Olancho", code: "HN-OL" },
      { name: "Santa Barbara", code: "HN-SB" },
      { name: "Valle", code: "HN-VA" },
      { name: "Yoro", code: "HN-YO" }
    ]
  },
  [countryCodes.CROATIA.alphaTwo]: {
    subdivisions: [
      { name: "Bjelovarsko-bilogorska zupanija", code: "HR-07" },
      { name: "Brodsko-posavska zupanija", code: "HR-12" },
      { name: "Dubrovacko-neretvanska zupanija", code: "HR-19" },
      { name: "Grad Zagreb", code: "HR-21" },
      { name: "Istarska zupanija", code: "HR-18" },
      { name: "Karlovacka zupanija", code: "HR-04" },
      { name: "Koprivnicko-krizevacka zupanija", code: "HR-06" },
      { name: "Krapinsko-zagorska zupanija", code: "HR-02" },
      { name: "Licko-senjska zupanija", code: "HR-09" },
      { name: "Medimurska zupanija", code: "HR-20" },
      { name: "Osjecko-baranjska zupanija", code: "HR-14" },
      { name: "Pozesko-slavonska zupanija", code: "HR-11" },
      { name: "Primorsko-goranska zupanija", code: "HR-08" },
      { name: "Sibensko-kninska zupanija", code: "HR-15" },
      { name: "Sisacko-moslavacka zupanija", code: "HR-03" },
      { name: "Splitsko-dalmatinska zupanija", code: "HR-17" },
      { name: "Varazdinska zupanija", code: "HR-05" },
      { name: "Viroviticko-podravska zupanija", code: "HR-10" },
      { name: "Vukovarsko-srijemska zupanija", code: "HR-16" },
      { name: "Zadarska zupanija", code: "HR-13" },
      { name: "Zagrebacka zupanija", code: "HR-01" }
    ]
  },
  [countryCodes.HAITI.alphaTwo]: {
    subdivisions: [
      { name: "Artibonite", code: "HT-AR" },
      { name: "Centre", code: "HT-CE" },
      { name: "Grande'Anse", code: "HT-GA" },
      { name: "Nippes", code: "HT-NI" },
      { name: "Nord", code: "HT-ND" },
      { name: "Nord-Est", code: "HT-NE" },
      { name: "Nord-Ouest", code: "HT-NO" },
      { name: "Ouest", code: "HT-OU" },
      { name: "Sud", code: "HT-SD" },
      { name: "Sud-Est", code: "HT-SE" }
    ]
  },
  [countryCodes.HUNGARY.alphaTwo]: {
    subdivisions: [
      { name: "Bacs-Kiskun", code: "HU-BK" },
      { name: "Baranya", code: "HU-BA" },
      { name: "Bekes", code: "HU-BE" },
      { name: "Borsod-Abauj-Zemplen", code: "HU-BZ" },
      { name: "Budapest", code: "HU-BU" },
      { name: "Csongrad-Csanad", code: "HU-CS" },
      { name: "Fejer", code: "HU-FE" },
      { name: "Gyor-Moson-Sopron", code: "HU-GS" },
      { name: "Hajdu-Bihar", code: "HU-HB" },
      { name: "Heves", code: "HU-HE" },
      { name: "Jasz-Nagykun-Szolnok", code: "HU-JN" },
      { name: "Komarom-Esztergom", code: "HU-KE" },
      { name: "Nograd", code: "HU-NO" },
      { name: "Pest", code: "HU-PE" },
      { name: "Somogy", code: "HU-SO" },
      { name: "Szabolcs-Szatmar-Bereg", code: "HU-SZ" },
      { name: "Tolna", code: "HU-TO" },
      { name: "Vas", code: "HU-VA" },
      { name: "Veszprem", code: "HU-VE" },
      { name: "Zala", code: "HU-ZA" },
      { name: "Bekescsaba", code: "HU-BC" },
      { name: "Debrecen", code: "HU-DE" },
      { name: "Dunaujvaros", code: "HU-DU" },
      { name: "Eger", code: "HU-EG" },
      { name: "Erd", code: "HU-ER" },
      { name: "Gyor", code: "HU-GY" },
      { name: "Hodmezovasarhely", code: "HU-HV" },
      { name: "Kecskemet", code: "HU-KM" },
      { name: "Kaposvar", code: "HU-KV" },
      { name: "Miskolc", code: "HU-MI" },
      { name: "Nagykanizsa", code: "HU-NK" },
      { name: "Nyiregyhaza", code: "HU-NY" },
      { name: "Pecs", code: "HU-PS" },
      { name: "Szeged", code: "HU-SD" },
      { name: "Szekesfehervar", code: "HU-SF" },
      { name: "Szombathely", code: "HU-SH" },
      { name: "Szolnok", code: "HU-SK" },
      { name: "Sopron", code: "HU-SN" },
      { name: "Szekszard", code: "HU-SS" },
      { name: "Salgotarjan", code: "HU-ST" },
      { name: "Tatabanya", code: "HU-TB" },
      { name: "Zalaegerszeg", code: "HU-ZE" }
    ]
  },
  [countryCodes.INDONESIA.alphaTwo]: {
    subdivisions: [
      { name: "Aceh", code: "ID-AC" },
      { name: "Bali", code: "ID-BA" },
      { name: "Banten", code: "ID-BT" },
      { name: "Bengkulu", code: "ID-BE" },
      { name: "Gorontalo", code: "ID-GO" },
      { name: "Jakarta Raya", code: "ID-JK" },
      { name: "Jambi", code: "ID-JA" },
      { name: "Jawa Barat", code: "ID-JB" },
      { name: "Jawa Tengah", code: "ID-JT" },
      { name: "Jawa Timur", code: "ID-JI" },
      { name: "Kalimantan Barat", code: "ID-KB" },
      { name: "Kalimantan Selatan", code: "ID-KS" },
      { name: "Kalimantan Tengah", code: "ID-KT" },
      { name: "Kalimantan Timur", code: "ID-KI" },
      { name: "Kalimantan Utara", code: "ID-KU" },
      { name: "Kepulauan Bangka Belitung", code: "ID-BB" },
      { name: "Kepulauan Riau", code: "ID-KR" },
      { name: "Lampung", code: "ID-LA" },
      { name: "Maluku", code: "ID-ML" },
      { name: "Maluku Utara", code: "ID-MU" },
      { name: "Nusa Tenggara Barat", code: "ID-NB" },
      { name: "Nusa Tenggara Timur", code: "ID-NT" },
      { name: "Papua", code: "ID-PP" },
      { name: "Papua Barat", code: "ID-PB" },
      { name: "Papua Barat Daya", code: "ID-PD" },
      { name: "Papua Pengunungan", code: "ID-PE" },
      { name: "Papua Selatan", code: "ID-PS" },
      { name: "Papua Tengah", code: "ID-PT" },
      { name: "Riau", code: "ID-RI" },
      { name: "Sulawesi Barat", code: "ID-SR" },
      { name: "Sulawesi Selatan", code: "ID-SN" },
      { name: "Sulawesi Tengah", code: "ID-ST" },
      { name: "Sulawesi Tenggara", code: "ID-SG" },
      { name: "Sulawesi Utara", code: "ID-SA" },
      { name: "Sumatera Barat", code: "ID-SB" },
      { name: "Sumatera Selatan", code: "ID-SS" },
      { name: "Sumatera Utara", code: "ID-SU" },
      { name: "Yogyakarta", code: "ID-YO" }
    ]
  },
  [countryCodes.IRELAND.alphaTwo]: {
    subdivisions: [
      { name: "Carlow", code: "IE-CW" },
      { name: "Cavan", code: "IE-CN" },
      { name: "Clare", code: "IE-CE" },
      { name: "Cork", code: "IE-CO" },
      { name: "Donegal", code: "IE-DL" },
      { name: "Dublin", code: "IE-D" },
      { name: "Galway", code: "IE-G" },
      { name: "Kerry", code: "IE-KY" },
      { name: "Kildare", code: "IE-KE" },
      { name: "Kilkenny", code: "IE-KK" },
      { name: "Laois", code: "IE-LS" },
      { name: "Leitrim", code: "IE-LM" },
      { name: "Limerick", code: "IE-LK" },
      { name: "Longford", code: "IE-LD" },
      { name: "Louth", code: "IE-LH" },
      { name: "Mayo", code: "IE-MO" },
      { name: "Meath", code: "IE-MH" },
      { name: "Monaghan", code: "IE-MN" },
      { name: "Offaly", code: "IE-OY" },
      { name: "Roscommon", code: "IE-RN" },
      { name: "Sligo", code: "IE-SO" },
      { name: "Tipperary", code: "IE-TA" },
      { name: "Waterford", code: "IE-WD" },
      { name: "Westmeath", code: "IE-WH" },
      { name: "Wexford", code: "IE-WX" },
      { name: "Wicklow", code: "IE-WW" }
    ]
  },
  [countryCodes.ISRAEL.alphaTwo]: {
    subdivisions: [
      { name: "Al Janubi", code: "IL-D" },
      { name: "Al Awsat", code: "IL-M" },
      { name: "HaTsafon", code: "IL-Z" },
      { name: "Hefa", code: "IL-HA" },
      { name: "Tel Aviv", code: "IL-TA" },
      { name: "Yerushalayim", code: "IL-JM" }
    ]
  },
  [countryCodes.ISLE_OF_MAN.alphaTwo]: { subdivisions: [{ name: "Isle of Man", code: "-" }] },
  [countryCodes.INDIA.alphaTwo]: {
    subdivisions: [
      { name: "Andaman and Nicobar Islands", code: "IN-AN" },
      { name: "Andhra Pradesh", code: "IN-AP" },
      { name: "Arunachal Pradesh", code: "IN-AR" },
      { name: "Assam", code: "IN-AS" },
      { name: "Bihar", code: "IN-BR" },
      { name: "Chandigarh", code: "IN-CH" },
      { name: "Chhattisgarh", code: "IN-CG" },
      { name: "Dadra and Nagar Haveli and Daman and Diu", code: "IN-DH" },
      { name: "Delhi", code: "IN-DL" },
      { name: "Goa", code: "IN-GA" },
      { name: "Gujarat", code: "IN-GJ" },
      { name: "Haryana", code: "IN-HR" },
      { name: "Himachal Pradesh", code: "IN-HP" },
      { name: "Jammu and Kashmir", code: "IN-JK" },
      { name: "Jharkhand", code: "IN-JH" },
      { name: "Karnataka", code: "IN-KA" },
      { name: "Kerala", code: "IN-KL" },
      { name: "Lakshadweep", code: "IN-LD" },
      { name: "Madhya Pradesh", code: "IN-MP" },
      { name: "Maharashtra", code: "IN-MH" },
      { name: "Manipur", code: "IN-MN" },
      { name: "Meghalaya", code: "IN-ML" },
      { name: "Mizoram", code: "IN-MZ" },
      { name: "Nagaland", code: "IN-NL" },
      { name: "Odisha", code: "IN-OD" },
      { name: "Puducherry", code: "IN-PY" },
      { name: "Punjab", code: "IN-PB" },
      { name: "Rajasthan", code: "IN-RJ" },
      { name: "Sikkim", code: "IN-SK" },
      { name: "Tamil Nadu", code: "IN-TN" },
      { name: "Telangana", code: "IN-TS" },
      { name: "Tripura", code: "IN-TR" },
      { name: "Uttar Pradesh", code: "IN-UP" },
      { name: "Uttarakhand", code: "IN-UK" },
      { name: "West Bengal", code: "IN-WB" },
      { name: "Ladakh", code: "IN-LA" }
    ]
  },
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: {
    subdivisions: [{ name: "British Indian Ocean Territory", code: "-" }]
  },
  [countryCodes.IRAQ.alphaTwo]: {
    subdivisions: [
      { name: "Al Anbar", code: "IQ-AN" },
      { name: "Al Basrah", code: "IQ-BA" },
      { name: "Al Muthanna", code: "IQ-MU" },
      { name: "Al Qadisiyah", code: "IQ-QA" },
      { name: "An Najaf", code: "IQ-NA" },
      { name: "Arbil", code: "IQ-AR" },
      { name: "As Sulaymaniyah", code: "IQ-SU" },
      { name: "Babil", code: "IQ-BB" },
      { name: "Baghdad", code: "IQ-BG" },
      { name: "Dahuk", code: "IQ-DA" },
      { name: "Dhi Qar", code: "IQ-DQ" },
      { name: "Diyala", code: "IQ-DI" },
      { name: "Karbala'", code: "IQ-KA" },
      { name: "Kirkuk", code: "IQ-KI" },
      { name: "Maysan", code: "IQ-MA" },
      { name: "Ninawa", code: "IQ-NI" },
      { name: "Salah ad Din", code: "IQ-SD" },
      { name: "Wasit", code: "IQ-WA" }
    ]
  },
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Alborz", code: "IR-30" },
      { name: "Ardabil", code: "IR-24" },
      { name: "Azarbayjan-e Gharbi", code: "IR-04" },
      { name: "Azarbayjan-e Sharqi", code: "IR-03" },
      { name: "Bushehr", code: "IR-18" },
      { name: "Chahar Mahal va Bakhtiari", code: "IR-14" },
      { name: "Esfahan", code: "IR-10" },
      { name: "Fars", code: "IR-07" },
      { name: "Gilan", code: "IR-01" },
      { name: "Golestan", code: "IR-27" },
      { name: "Hamadan", code: "IR-13" },
      { name: "Hormozgan", code: "IR-22" },
      { name: "Ilam", code: "IR-16" },
      { name: "Kerman", code: "IR-08" },
      { name: "Kermanshah", code: "IR-05" },
      { name: "Khorasan-e Jonubi", code: "IR-29" },
      { name: "Khorasan-e Razavi", code: "IR-09" },
      { name: "Khorasan-e Shomali", code: "IR-28" },
      { name: "Khuzestan", code: "IR-06" },
      { name: "Kohgiluyeh va Bowyer Ahmad", code: "IR-17" },
      { name: "Kordestan", code: "IR-12" },
      { name: "Lorestan", code: "IR-15" },
      { name: "Markazi", code: "IR-00" },
      { name: "Mazandaran", code: "IR-02" },
      { name: "Qazvin", code: "IR-26" },
      { name: "Qom", code: "IR-25" },
      { name: "Semnan", code: "IR-20" },
      { name: "Sistan va Baluchestan", code: "IR-11" },
      { name: "Tehran", code: "IR-23" },
      { name: "Yazd", code: "IR-21" },
      { name: "Zanjan", code: "IR-19" }
    ]
  },
  [countryCodes.ICELAND.alphaTwo]: {
    subdivisions: [
      { name: "Austurland", code: "IS-7" },
      { name: "Hofudborgarsvaedi", code: "IS-1" },
      { name: "Nordurland eystra", code: "IS-6" },
      { name: "Nordurland vestra", code: "IS-5" },
      { name: "Sudurland", code: "IS-8" },
      { name: "Sudurnes", code: "IS-2" },
      { name: "Vestfirdir", code: "IS-4" },
      { name: "Vesturland", code: "IS-3" }
    ]
  },
  [countryCodes.ITALY.alphaTwo]: {
    subdivisions: [
      { name: "Abruzzo", code: "IT-65" },
      { name: "Basilicata", code: "IT-77" },
      { name: "Calabria", code: "IT-78" },
      { name: "Campania", code: "IT-72" },
      { name: "Emilia-Romagna", code: "IT-45" },
      { name: "Friuli-Venezia Giulia", code: "IT-36" },
      { name: "Lazio", code: "IT-62" },
      { name: "Liguria", code: "IT-42" },
      { name: "Lombardia", code: "IT-25" },
      { name: "Marche", code: "IT-57" },
      { name: "Molise", code: "IT-67" },
      { name: "Piemonte", code: "IT-21" },
      { name: "Puglia", code: "IT-75" },
      { name: "Sardegna", code: "IT-88" },
      { name: "Sicilia", code: "IT-82" },
      { name: "Toscana", code: "IT-52" },
      { name: "Trentino-Alto Adige", code: "IT-32" },
      { name: "Umbria", code: "IT-55" },
      { name: "Valle d'Aosta", code: "IT-23" },
      { name: "Veneto", code: "IT-34" }
    ]
  },
  [countryCodes.JERSEY.alphaTwo]: { subdivisions: [{ name: "Jersey", code: "-" }] },
  [countryCodes.JAMAICA.alphaTwo]: {
    subdivisions: [
      { name: "Clarendon", code: "JM-13" },
      { name: "Hanover", code: "JM-09" },
      { name: "Kingston", code: "JM-01" },
      { name: "Manchester", code: "JM-12" },
      { name: "Portland", code: "JM-04" },
      { name: "Saint Andrew", code: "JM-02" },
      { name: "Saint Ann", code: "JM-06" },
      { name: "Saint Catherine", code: "JM-14" },
      { name: "Saint Elizabeth", code: "JM-11" },
      { name: "Saint James", code: "JM-08" },
      { name: "Saint Mary", code: "JM-05" },
      { name: "Saint Thomas", code: "JM-03" },
      { name: "Trelawny", code: "JM-07" },
      { name: "Westmoreland", code: "JM-10" }
    ]
  },
  [countryCodes.JORDAN.alphaTwo]: {
    subdivisions: [
      { name: "Ajlun", code: "JO-AJ" },
      { name: "Al 'Aqabah", code: "JO-AQ" },
      { name: "Al 'Asimah", code: "JO-AM" },
      { name: "Al Balqa'", code: "JO-BA" },
      { name: "Al Karak", code: "JO-KA" },
      { name: "Al Mafraq", code: "JO-MA" },
      { name: "At Tafilah", code: "JO-AT" },
      { name: "Az Zarqa'", code: "JO-AZ" },
      { name: "Irbid", code: "JO-IR" },
      { name: "Jarash", code: "JO-JA" },
      { name: "Ma'an", code: "JO-MN" },
      { name: "Madaba", code: "JO-MD" }
    ]
  },
  [countryCodes.JAPAN.alphaTwo]: {
    subdivisions: [
      { name: "Aichi", code: "JP-23" },
      { name: "Akita", code: "JP-05" },
      { name: "Aomori", code: "JP-02" },
      { name: "Chiba", code: "JP-12" },
      { name: "Ehime", code: "JP-38" },
      { name: "Fukui", code: "JP-18" },
      { name: "Fukuoka", code: "JP-40" },
      { name: "Fukushima", code: "JP-07" },
      { name: "Gifu", code: "JP-21" },
      { name: "Gunma", code: "JP-10" },
      { name: "Hiroshima", code: "JP-34" },
      { name: "Hokkaido", code: "JP-01" },
      { name: "Hyogo", code: "JP-28" },
      { name: "Ibaraki", code: "JP-08" },
      { name: "Ishikawa", code: "JP-17" },
      { name: "Iwate", code: "JP-03" },
      { name: "Kagawa", code: "JP-37" },
      { name: "Kagoshima", code: "JP-46" },
      { name: "Kanagawa", code: "JP-14" },
      { name: "Kochi", code: "JP-39" },
      { name: "Kumamoto", code: "JP-43" },
      { name: "Kyoto", code: "JP-26" },
      { name: "Mie", code: "JP-24" },
      { name: "Miyagi", code: "JP-04" },
      { name: "Miyazaki", code: "JP-45" },
      { name: "Nagano", code: "JP-20" },
      { name: "Nagasaki", code: "JP-42" },
      { name: "Nara", code: "JP-29" },
      { name: "Niigata", code: "JP-15" },
      { name: "Oita", code: "JP-44" },
      { name: "Okayama", code: "JP-33" },
      { name: "Okinawa", code: "JP-47" },
      { name: "Osaka", code: "JP-27" },
      { name: "Saga", code: "JP-41" },
      { name: "Saitama", code: "JP-11" },
      { name: "Shiga", code: "JP-25" },
      { name: "Shimane", code: "JP-32" },
      { name: "Shizuoka", code: "JP-22" },
      { name: "Tochigi", code: "JP-09" },
      { name: "Tokushima", code: "JP-36" },
      { name: "Tokyo", code: "JP-13" },
      { name: "Tottori", code: "JP-31" },
      { name: "Toyama", code: "JP-16" },
      { name: "Wakayama", code: "JP-30" },
      { name: "Yamagata", code: "JP-06" },
      { name: "Yamaguchi", code: "JP-35" },
      { name: "Yamanashi", code: "JP-19" }
    ]
  },
  [countryCodes.KENYA.alphaTwo]: {
    subdivisions: [
      { name: "Baringo", code: "KE-01" },
      { name: "Bomet", code: "KE-02" },
      { name: "Bungoma", code: "KE-03" },
      { name: "Busia", code: "KE-04" },
      { name: "Elgeyo/Marakwet", code: "KE-05" },
      { name: "Embu", code: "KE-06" },
      { name: "Garissa", code: "KE-07" },
      { name: "Homa Bay", code: "KE-08" },
      { name: "Isiolo", code: "KE-09" },
      { name: "Kajiado", code: "KE-10" },
      { name: "Kakamega", code: "KE-11" },
      { name: "Kericho", code: "KE-12" },
      { name: "Kiambu", code: "KE-13" },
      { name: "Kilifi", code: "KE-14" },
      { name: "Kirinyaga", code: "KE-15" },
      { name: "Kisii", code: "KE-16" },
      { name: "Kisumu", code: "KE-17" },
      { name: "Kitui", code: "KE-18" },
      { name: "Kwale", code: "KE-19" },
      { name: "Laikipia", code: "KE-20" },
      { name: "Lamu", code: "KE-21" },
      { name: "Machakos", code: "KE-22" },
      { name: "Makueni", code: "KE-23" },
      { name: "Mandera", code: "KE-24" },
      { name: "Marsabit", code: "KE-25" },
      { name: "Meru", code: "KE-26" },
      { name: "Migori", code: "KE-27" },
      { name: "Mombasa", code: "KE-28" },
      { name: "Murang'a", code: "KE-29" },
      { name: "Nairobi City", code: "KE-30" },
      { name: "Nakuru", code: "KE-31" },
      { name: "Nandi", code: "KE-32" },
      { name: "Narok", code: "KE-33" },
      { name: "Nyamira", code: "KE-34" },
      { name: "Nyandarua", code: "KE-35" },
      { name: "Nyeri", code: "KE-36" },
      { name: "Samburu", code: "KE-37" },
      { name: "Siaya", code: "KE-38" },
      { name: "Taita/Taveta", code: "KE-39" },
      { name: "Tana River", code: "KE-40" },
      { name: "Tharaka-Nithi", code: "KE-41" },
      { name: "Trans Nzoia", code: "KE-42" },
      { name: "Turkana", code: "KE-43" },
      { name: "Uasin Gishu", code: "KE-44" },
      { name: "Vihiga", code: "KE-45" },
      { name: "Wajir", code: "KE-46" },
      { name: "West Pokot", code: "KE-47" }
    ]
  },
  [countryCodes.KYRGYZSTAN.alphaTwo]: {
    subdivisions: [
      { name: "Batken", code: "KG-B" },
      { name: "Bishkek Shaary", code: "KG-GB" },
      { name: "Chuy", code: "KG-C" },
      { name: "Jalal-Abad", code: "KG-J" },
      { name: "Naryn", code: "KG-N" },
      { name: "Osh Shaary", code: "KG-GO" },
      { name: "Talas", code: "KG-T" },
      { name: "Ysyk-Kol", code: "KG-Y" },
      { name: "Osh", code: "KG-O" }
    ]
  },
  [countryCodes.CAMBODIA.alphaTwo]: {
    subdivisions: [
      { name: "Baat Dambang", code: "KH-2" },
      { name: "Banteay Mean Choay", code: "KH-1" },
      { name: "Kaeb", code: "KH-23" },
      { name: "Kampong Chaam", code: "KH-3" },
      { name: "Kampong Chhnang", code: "KH-4" },
      { name: "Kampong Spueu", code: "KH-5" },
      { name: "Kampong Thum", code: "KH-6" },
      { name: "Kampot", code: "KH-7" },
      { name: "Kandaal", code: "KH-8" },
      { name: "Kaoh Kong", code: "KH-9" },
      { name: "Kracheh", code: "KH-10" },
      { name: "Mondol Kiri", code: "KH-11" },
      { name: "Otdar Mean Chey", code: "KH-22" },
      { name: "Pailin", code: "KH-24" },
      { name: "Phnom Penh", code: "KH-12" },
      { name: "Pousaat", code: "KH-15" },
      { name: "Preah Sihanouk", code: "KH-18" },
      { name: "Preah Vihear", code: "KH-13" },
      { name: "Prey Veaeng", code: "KH-14" },
      { name: "Rotanak Kiri", code: "KH-16" },
      { name: "Siem Reab", code: "KH-17" },
      { name: "Stueng Traeng", code: "KH-19" },
      { name: "Svaay Rieng", code: "KH-20" },
      { name: "Taakaev", code: "KH-21" },
      { name: "Tbong Khmum", code: "KH-25" }
    ]
  },
  [countryCodes.KIRIBATI.alphaTwo]: {
    subdivisions: [
      { name: "Gilbert Islands", code: "KI-G" },
      { name: "Line Islands", code: "KI-L" },
      { name: "Phoenix Islands", code: "KI-P" }
    ]
  },
  [countryCodes.COMOROS.alphaTwo]: {
    subdivisions: [
      { name: "Anjouan", code: "KM-A" },
      { name: "Grande Comore", code: "KM-G" },
      { name: "Moheli", code: "KM-M" }
    ]
  },
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: {
    subdivisions: [
      { name: "Christ Church Nichola Town", code: "KN-01" },
      { name: "Saint Anne Sandy Point", code: "KN-02" },
      { name: "Saint George Basseterre", code: "KN-03" },
      { name: "Saint James Windward", code: "KN-05" },
      { name: "Saint John Capisterre", code: "KN-06" },
      { name: "Saint Mary Cayon", code: "KN-08" },
      { name: "Saint Paul Charlestown", code: "KN-10" },
      { name: "Saint Peter Basseterre", code: "KN-11" },
      { name: "Saint Thomas Lowland", code: "KN-12" },
      { name: "Trinity Palmetto Point", code: "KN-15" },
      { name: "Saint George Gingerland", code: "KN-04" },
      { name: "Saint John Figtree", code: "KN-07" },
      { name: "Saint Paul Capisterre", code: "KN-09" },
      { name: "Saint Thomas Middle Island", code: "KN-13" }
    ]
  },
  [countryCodes.NORTH_KOREA.alphaTwo]: {
    subdivisions: [
      { name: "P'yongyang", code: "KP-01" },
      { name: "P'yongan-namdo", code: "KP-02" },
      { name: "P'yongan-bukto", code: "KP-03" },
      { name: "Chagang-do", code: "KP-04" },
      { name: "Hwanghae-namdo", code: "KP-05" },
      { name: "Hwanghae-bukto", code: "KP-06" },
      { name: "Kangweonto", code: "KP-07" },
      { name: "Hamgyong-namdo", code: "KP-08" },
      { name: "Hamgyong-bukto", code: "KP-09" },
      { name: "Ryanggang-do", code: "KP-10" },
      { name: "Raseon", code: "KP-13" },
      { name: "Nampho", code: "KP-14" },
      { name: "Kaeseong", code: "KP-15" }
    ]
  },
  [countryCodes.SOUTH_KOREA.alphaTwo]: {
    subdivisions: [
      { name: "Busan-gwangyeoksi", code: "KR-26" },
      { name: "Chungcheongbuk-do", code: "KR-43" },
      { name: "Chungcheongnam-do", code: "KR-44" },
      { name: "Daegu-gwangyeoksi", code: "KR-27" },
      { name: "Daejeon-gwangyeoksi", code: "KR-30" },
      { name: "Gangwon-teukbyeoljachido", code: "KR-42" },
      { name: "Gwangju-gwangyeoksi", code: "KR-29" },
      { name: "Gyeonggi-do", code: "KR-41" },
      { name: "Gyeongsangbuk-do", code: "KR-47" },
      { name: "Gyeongsangnam-do", code: "KR-48" },
      { name: "Incheon-gwangyeoksi", code: "KR-28" },
      { name: "Jeju-teukbyeoljachido", code: "KR-49" },
      { name: "Jeollabuk-do", code: "KR-45" },
      { name: "Jeollanam-do", code: "KR-46" },
      { name: "Sejong", code: "KR-50" },
      { name: "Seoul-teukbyeolsi", code: "KR-11" },
      { name: "Ulsan-gwangyeoksi", code: "KR-31" }
    ]
  },
  [countryCodes.KUWAIT.alphaTwo]: {
    subdivisions: [
      { name: "Al 'Asimah", code: "KW-KU" },
      { name: "Al Ahmadi", code: "KW-AH" },
      { name: "Al Farwaniyah", code: "KW-FA" },
      { name: "Al Jahra'", code: "KW-JA" },
      { name: "Hawalli", code: "KW-HA" },
      { name: "Mubarak al Kabir", code: "KW-MU" }
    ]
  },
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: { subdivisions: [{ name: "Cayman Islands", code: "-" }] },
  [countryCodes.KAZAKHSTAN.alphaTwo]: {
    subdivisions: [
      { name: "Abay oblysy", code: "KZ-10" },
      { name: "Almaty", code: "KZ-75" },
      { name: "Almaty oblysy", code: "KZ-19" },
      { name: "Aqmola oblysy", code: "KZ-11" },
      { name: "Aqtobe oblysy", code: "KZ-15" },
      { name: "Astana", code: "KZ-71" },
      { name: "Atyrau oblysy", code: "KZ-23" },
      { name: "Batys Qazaqstan oblysy", code: "KZ-27" },
      { name: "Mangghystau oblysy", code: "KZ-47" },
      { name: "Pavlodar oblysy", code: "KZ-55" },
      { name: "Qaraghandy oblysy", code: "KZ-35" },
      { name: "Qostanay oblysy", code: "KZ-39" },
      { name: "Qyzylorda oblysy", code: "KZ-43" },
      { name: "Shyghys Qazaqstan oblysy", code: "KZ-63" },
      { name: "Shymkent", code: "KZ-79" },
      { name: "Soltustik Qazaqstan oblysy", code: "KZ-59" },
      { name: "Turkistan oblysy", code: "KZ-61" },
      { name: "Ulytau oblysy", code: "KZ-62" },
      { name: "Zhambyl oblysy", code: "KZ-31" },
      { name: "Zhetisu oblysy", code: "KZ-33" }
    ]
  },
  [countryCodes.LAOS.alphaTwo]: {
    subdivisions: [
      { name: "Attapu", code: "LA-AT" },
      { name: "Bokeo", code: "LA-BK" },
      { name: "Bolikhamxai", code: "LA-BL" },
      { name: "Champasak", code: "LA-CH" },
      { name: "Houaphan", code: "LA-HO" },
      { name: "Khammouan", code: "LA-KH" },
      { name: "Louangphabang", code: "LA-LP" },
      { name: "Oudomxai", code: "LA-OU" },
      { name: "Savannakhet", code: "LA-SV" },
      { name: "Viangchan", code: "LA-VI" },
      { name: "Xaignabouli", code: "LA-XA" },
      { name: "Xekong", code: "LA-XE" },
      { name: "Xiangkhouang", code: "LA-XI" },
      { name: "Louang Namtha", code: "LA-LM" },
      { name: "Phongsali", code: "LA-PH" },
      { name: "Salavan", code: "LA-SL" },
      { name: "Xaisomboun", code: "LA-XS" }
    ]
  },
  [countryCodes.LEBANON.alphaTwo]: {
    subdivisions: [
      { name: "Aakkar", code: "LB-AK" },
      { name: "Baalbek-Hermel", code: "LB-BH" },
      { name: "Al Biqa", code: "LB-BI" },
      { name: "Beyrouth", code: "LB-BA" },
      { name: "Ash Shimal", code: "LB-AS" },
      { name: "Liban-Sud", code: "LB-JA" },
      { name: "Mont-Liban", code: "LB-JL" },
      { name: "Nabatiye", code: "LB-NA" }
    ]
  },
  [countryCodes.SAINT_LUCIA.alphaTwo]: {
    subdivisions: [
      { name: "Anse la Raye", code: "LC-01" },
      { name: "Castries", code: "LC-02" },
      { name: "Choiseul", code: "LC-03" },
      { name: "Dennery", code: "LC-05" },
      { name: "Gros Islet", code: "LC-06" },
      { name: "Laborie", code: "LC-07" },
      { name: "Micoud", code: "LC-08" },
      { name: "Soufriere", code: "LC-10" },
      { name: "Vieux Fort", code: "LC-11" },
      { name: "Canaries", code: "LC-12" }
    ]
  },
  [countryCodes.LIECHTENSTEIN.alphaTwo]: {
    subdivisions: [
      { name: "Balzers", code: "LI-01" },
      { name: "Eschen", code: "LI-02" },
      { name: "Gamprin", code: "LI-03" },
      { name: "Mauren", code: "LI-04" },
      { name: "Planken", code: "LI-05" },
      { name: "Ruggell", code: "LI-06" },
      { name: "Schaan", code: "LI-07" },
      { name: "Schellenberg", code: "LI-08" },
      { name: "Triesen", code: "LI-09" },
      { name: "Triesenberg", code: "LI-10" },
      { name: "Vaduz", code: "LI-11" }
    ]
  },
  [countryCodes.SRI_LANKA.alphaTwo]: {
    subdivisions: [
      { name: "Central Province", code: "LK-2" },
      { name: "Eastern Province", code: "LK-5" },
      { name: "North Central Province", code: "LK-7" },
      { name: "North Western Province", code: "LK-6" },
      { name: "Northern Province", code: "LK-4" },
      { name: "Sabaragamuwa Province", code: "LK-9" },
      { name: "Southern Province", code: "LK-3" },
      { name: "Uva Province", code: "LK-8" },
      { name: "Western Province", code: "LK-1" },
      { name: "Colombo", code: "LK-11" },
      { name: "Gampaha", code: "LK-12" },
      { name: "Kalutara", code: "LK-13" },
      { name: "Kandy", code: "LK-21" },
      { name: "Matale", code: "LK-22" },
      { name: "Nuwara Eliya", code: "LK-23" },
      { name: "Galle", code: "LK-31" },
      { name: "Matara", code: "LK-32" },
      { name: "Hambantota", code: "LK-33" },
      { name: "Jaffna", code: "LK-41" },
      { name: "Kilinochchi", code: "LK-42" },
      { name: "Mannar", code: "LK-43" },
      { name: "Vavuniya", code: "LK-44" },
      { name: "Mullaittivu", code: "LK-45" },
      { name: "Batticaloa", code: "LK-51" },
      { name: "Ampara", code: "LK-52" },
      { name: "Trincomalee", code: "LK-53" },
      { name: "Kurunegala", code: "LK-61" },
      { name: "Puttalam", code: "LK-62" },
      { name: "Anuradhapura", code: "LK-71" },
      { name: "Polonnaruwa", code: "LK-72" },
      { name: "Badulla", code: "LK-81" },
      { name: "Monaragala", code: "LK-82" },
      { name: "Ratnapura", code: "LK-91" },
      { name: "Kegalla", code: "LK-92" }
    ]
  },
  [countryCodes.LIBERIA.alphaTwo]: {
    subdivisions: [
      { name: "Bomi", code: "LR-BM" },
      { name: "Bong", code: "LR-BG" },
      { name: "Grand Bassa", code: "LR-GB" },
      { name: "Grand Cape Mount", code: "LR-CM" },
      { name: "Grand Gedeh", code: "LR-GG" },
      { name: "Margibi", code: "LR-MG" },
      { name: "Montserrado", code: "LR-MO" },
      { name: "Nimba", code: "LR-NI" },
      { name: "River Cess", code: "LR-RI" },
      { name: "River Gee", code: "LR-RG" },
      { name: "Sinoe", code: "LR-SI" },
      { name: "Grand Kru", code: "LR-GK" },
      { name: "Gbarpolu", code: "LR-GP" },
      { name: "Lofa", code: "LR-LO" },
      { name: "Maryland", code: "LR-MY" }
    ]
  },
  [countryCodes.LESOTHO.alphaTwo]: {
    subdivisions: [
      { name: "Berea", code: "LS-D" },
      { name: "Botha-Bothe", code: "LS-B" },
      { name: "Leribe", code: "LS-C" },
      { name: "Mafeteng", code: "LS-E" },
      { name: "Maseru", code: "LS-A" },
      { name: "Mokhotlong", code: "LS-J" },
      { name: "Qacha's Nek", code: "LS-H" },
      { name: "Quthing", code: "LS-G" },
      { name: "Thaba-Tseka", code: "LS-K" },
      { name: "Mohale's Hoek", code: "LS-F" }
    ]
  },
  [countryCodes.LITHUANIA.alphaTwo]: {
    subdivisions: [
      { name: "Alytaus apskritis", code: "LT-AL" },
      { name: "Kauno apskritis", code: "LT-KU" },
      { name: "Klaipedos apskritis", code: "LT-KL" },
      { name: "Marijampoles apskritis", code: "LT-MR" },
      { name: "Panevezio apskritis", code: "LT-PN" },
      { name: "Siauliu apskritis", code: "LT-SA" },
      { name: "Taurages apskritis", code: "LT-TA" },
      { name: "Telsiu apskritis", code: "LT-TE" },
      { name: "Utenos apskritis", code: "LT-UT" },
      { name: "Vilniaus apskritis", code: "LT-VL" }
    ]
  },
  [countryCodes.LUXEMBOURG.alphaTwo]: {
    subdivisions: [
      { name: "Capellen", code: "LU-CA" },
      { name: "Clervaux", code: "LU-CL" },
      { name: "Diekirch", code: "LU-DI" },
      { name: "Echternach", code: "LU-EC" },
      { name: "Esch-sur-Alzette", code: "LU-ES" },
      { name: "Grevenmacher", code: "LU-GR" },
      { name: "Luxembourg", code: "LU-LU" },
      { name: "Mersch", code: "LU-ME" },
      { name: "Redange", code: "LU-RD" },
      { name: "Remich", code: "LU-RM" },
      { name: "Vianden", code: "LU-VD" },
      { name: "Wiltz", code: "LU-WI" }
    ]
  },
  [countryCodes.LATVIA.alphaTwo]: {
    subdivisions: [
      { name: "Adazu novads", code: "LV-011" },
      { name: "Aizkraukles novads", code: "LV-002" },
      { name: "Aluksnes novads", code: "LV-007" },
      { name: "Augsdaugavas novads", code: "LV-111" },
      { name: "Balvu novads", code: "LV-015" },
      { name: "Bauskas novads", code: "LV-016" },
      { name: "Cesu novads", code: "LV-022" },
      { name: "Daugavpils", code: "LV-DGV" },
      { name: "Dienvidkurzemes novads", code: "LV-112" },
      { name: "Dobeles novads", code: "LV-026" },
      { name: "Gulbenes novads", code: "LV-033" },
      { name: "Jekabpils novads", code: "LV-042" },
      { name: "Jelgava", code: "LV-JEL" },
      { name: "Jelgavas novads", code: "LV-041" },
      { name: "Jurmala", code: "LV-JUR" },
      { name: "Kekavas novads", code: "LV-052" },
      { name: "Kraslavas novads", code: "LV-047" },
      { name: "Kuldigas novads", code: "LV-050" },
      { name: "Liepaja", code: "LV-LPX" },
      { name: "Limbazu novads", code: "LV-054" },
      { name: "Livanu novads", code: "LV-056" },
      { name: "Ludzas novads", code: "LV-058" },
      { name: "Madonas novads", code: "LV-059" },
      { name: "Marupes novads", code: "LV-062" },
      { name: "Ogres novads", code: "LV-067" },
      { name: "Olaines novads", code: "LV-068" },
      { name: "Preilu novads", code: "LV-073" },
      { name: "Rezeknes novads", code: "LV-077" },
      { name: "Riga", code: "LV-RIX" },
      { name: "Ropazu novads", code: "LV-080" },
      { name: "Salaspils novads", code: "LV-087" },
      { name: "Saldus novads", code: "LV-088" },
      { name: "Saulkrastu novads", code: "LV-089" },
      { name: "Siguldas novads", code: "LV-091" },
      { name: "Smiltenes novads", code: "LV-094" },
      { name: "Talsu novads", code: "LV-097" },
      { name: "Tukuma novads", code: "LV-099" },
      { name: "Valkas novads", code: "LV-101" },
      { name: "Valmieras novads", code: "LV-113" },
      { name: "Varaklanu novads", code: "LV-102" },
      { name: "Ventspils novads", code: "LV-106" },
      { name: "Rezekne", code: "LV-REZ" },
      { name: "Ventspils", code: "LV-VEN" }
    ]
  },
  [countryCodes.LIBYA.alphaTwo]: {
    subdivisions: [
      { name: "Al Butnan", code: "LY-BU" },
      { name: "Al Jabal al Akhdar", code: "LY-JA" },
      { name: "Al Jabal al Gharbi", code: "LY-JG" },
      { name: "Al Jafarah", code: "LY-JI" },
      { name: "Al Jufrah", code: "LY-JU" },
      { name: "Al Marj", code: "LY-MJ" },
      { name: "Al Marqab", code: "LY-MB" },
      { name: "Al Wahat", code: "LY-WA" },
      { name: "An Nuqat al Khams", code: "LY-NQ" },
      { name: "Az Zawiyah", code: "LY-ZA" },
      { name: "Banghazi", code: "LY-BA" },
      { name: "Darnah", code: "LY-DR" },
      { name: "Misratah", code: "LY-MI" },
      { name: "Murzuq", code: "LY-MQ" },
      { name: "Nalut", code: "LY-NL" },
      { name: "Sabha", code: "LY-SB" },
      { name: "Surt", code: "LY-SR" },
      { name: "Tarabulus", code: "LY-TB" },
      { name: "Wadi al Hayat", code: "LY-WD" },
      { name: "Wadi ash Shati'", code: "LY-WS" },
      { name: "Ghat", code: "LY-GT" },
      { name: "Al Kufrah", code: "LY-KF" }
    ]
  },
  [countryCodes.MOROCCO.alphaTwo]: {
    subdivisions: [
      { name: "Beni-Mellal-Khenifra", code: "MA-05" },
      { name: "Casablanca-Settat", code: "MA-06" },
      { name: "Draa-Tafilalet", code: "MA-08" },
      { name: "Fes- Meknes", code: "MA-03" },
      { name: "Guelmim-Oued Noun (EH-partial)", code: "MA-10" },
      { name: "L'Oriental", code: "MA-02" },
      { name: "Laayoune-Sakia El Hamra (EH-partial)", code: "MA-11" },
      { name: "Marrakech-Safi", code: "MA-07" },
      { name: "Rabat-Sale-Kenitra", code: "MA-04" },
      { name: "Souss-Massa", code: "MA-09" },
      { name: "Tanger-Tetouan-Al Hoceima", code: "MA-01" },
      { name: "Dakhla-Oued Ed-Dahab (EH)", code: "MA-12" }
    ]
  },
  [countryCodes.MONACO.alphaTwo]: {
    subdivisions: [
      { name: "Fontvieille", code: "MC-FO" },
      { name: "La Condamine", code: "MC-CO" },
      { name: "Monaco-Ville", code: "MC-MO" },
      { name: "Moneghetti", code: "MC-MG" },
      { name: "Monte-Carlo", code: "MC-MC" },
      { name: "Saint-Roman", code: "MC-SR" },
      { name: "La Colle", code: "MC-CL" },
      { name: "La Gare", code: "MC-GA" },
      { name: "Jardin Exotique", code: "MC-JE" },
      { name: "Larvotto", code: "MC-LA" },
      { name: "Malbousquet", code: "MC-MA" },
      { name: "Moulins", code: "MC-MU" },
      { name: "Port-Hercule", code: "MC-PH" },
      { name: "Sainte-Devote", code: "MC-SD" },
      { name: "La Source", code: "MC-SO" },
      { name: "Spelugues", code: "MC-SP" },
      { name: "Vallon de la Rousse", code: "MC-VR" }
    ]
  },
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Anenii Noi", code: "MD-AN" },
      { name: "Balti", code: "MD-BA" },
      { name: "Basarabeasca", code: "MD-BS" },
      { name: "Bender", code: "MD-BD" },
      { name: "Briceni", code: "MD-BR" },
      { name: "Cahul", code: "MD-CA" },
      { name: "Calarasi", code: "MD-CL" },
      { name: "Cantemir", code: "MD-CT" },
      { name: "Causeni", code: "MD-CS" },
      { name: "Chisinau", code: "MD-CU" },
      { name: "Cimislia", code: "MD-CM" },
      { name: "Criuleni", code: "MD-CR" },
      { name: "Donduseni", code: "MD-DO" },
      { name: "Drochia", code: "MD-DR" },
      { name: "Dubasari", code: "MD-DU" },
      { name: "Edinet", code: "MD-ED" },
      { name: "Falesti", code: "MD-FA" },
      { name: "Floresti", code: "MD-FL" },
      { name: "Gagauzia, Unitatea teritoriala autonoma", code: "MD-GA" },
      { name: "Glodeni", code: "MD-GL" },
      { name: "Hincesti", code: "MD-HI" },
      { name: "Ialoveni", code: "MD-IA" },
      { name: "Leova", code: "MD-LE" },
      { name: "Nisporeni", code: "MD-NI" },
      { name: "Ocnita", code: "MD-OC" },
      { name: "Orhei", code: "MD-OR" },
      { name: "Rezina", code: "MD-RE" },
      { name: "Riscani", code: "MD-RI" },
      { name: "Singerei", code: "MD-SI" },
      { name: "Soldanesti", code: "MD-SD" },
      { name: "Soroca", code: "MD-SO" },
      { name: "Stefan Voda", code: "MD-SV" },
      { name: "Stinga Nistrului, unitatea teritoriala din", code: "MD-SN" },
      { name: "Straseni", code: "MD-ST" },
      { name: "Taraclia", code: "MD-TA" },
      { name: "Telenesti", code: "MD-TE" },
      { name: "Ungheni", code: "MD-UN" }
    ]
  },
  [countryCodes.MONTENEGRO.alphaTwo]: {
    subdivisions: [
      { name: "Andrijevica", code: "ME-01" },
      { name: "Bar", code: "ME-02" },
      { name: "Berane", code: "ME-03" },
      { name: "Bijelo Polje", code: "ME-04" },
      { name: "Budva", code: "ME-05" },
      { name: "Cetinje", code: "ME-06" },
      { name: "Danilovgrad", code: "ME-07" },
      { name: "Herceg-Novi", code: "ME-08" },
      { name: "Kolasin", code: "ME-09" },
      { name: "Kotor", code: "ME-10" },
      { name: "Mojkovac", code: "ME-11" },
      { name: "Niksic", code: "ME-12" },
      { name: "Plav", code: "ME-13" },
      { name: "Pljevlja", code: "ME-14" },
      { name: "Pluzine", code: "ME-15" },
      { name: "Podgorica", code: "ME-16" },
      { name: "Rozaje", code: "ME-17" },
      { name: "Savnik", code: "ME-18" },
      { name: "Tivat", code: "ME-19" },
      { name: "Tuzi", code: "ME-24" },
      { name: "Ulcinj", code: "ME-20" },
      { name: "Zabljak", code: "ME-21" },
      { name: "Zeta", code: "ME-25" },
      { name: "Gusinje", code: "ME-22" },
      { name: "Petnjica", code: "ME-23" }
    ]
  },
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: {
    subdivisions: [{ name: "Saint Martin (French Part)", code: "-" }]
  },
  [countryCodes.MADAGASCAR.alphaTwo]: {
    subdivisions: [
      { name: "Antananarivo", code: "MG-T" },
      { name: "Antsiranana", code: "MG-D" },
      { name: "Fianarantsoa", code: "MG-F" },
      { name: "Mahajanga", code: "MG-M" },
      { name: "Toamasina", code: "MG-A" },
      { name: "Toliara", code: "MG-U" }
    ]
  },
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Kwajalein", code: "MH-KWA" },
      { name: "Majuro", code: "MH-MAJ" },
      { name: "Ailuk", code: "MH-ALK" },
      { name: "Ailinglaplap", code: "MH-ALL" },
      { name: "Arno", code: "MH-ARN" },
      { name: "Aur", code: "MH-AUR" },
      { name: "Ebon", code: "MH-EBO" },
      { name: "Enewetak & Ujelang", code: "MH-ENI" },
      { name: "Jabat", code: "MH-JAB" },
      { name: "Jaluit", code: "MH-JAL" },
      { name: "Bikini & Kili", code: "MH-KIL" },
      { name: "Lae", code: "MH-LAE" },
      { name: "Lib", code: "MH-LIB" },
      { name: "Likiep", code: "MH-LIK" },
      { name: "Maloelap", code: "MH-MAL" },
      { name: "Mejit", code: "MH-MEJ" },
      { name: "Mili", code: "MH-MIL" },
      { name: "Namdrik", code: "MH-NMK" },
      { name: "Namu", code: "MH-NMU" },
      { name: "Rongelap", code: "MH-RON" },
      { name: "Ujae", code: "MH-UJA" },
      { name: "Utrik", code: "MH-UTI" },
      { name: "Wotho", code: "MH-WTH" },
      { name: "Wotje", code: "MH-WTJ" }
    ]
  },
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Aracinovo", code: "MK-802" },
      { name: "Berovo", code: "MK-201" },
      { name: "Bitola", code: "MK-501" },
      { name: "Bogdanci", code: "MK-401" },
      { name: "Bogovinje", code: "MK-601" },
      { name: "Bosilovo", code: "MK-402" },
      { name: "Brvenica", code: "MK-602" },
      { name: "Butel", code: "MK-803" },
      { name: "Caska", code: "MK-109" },
      { name: "Centar", code: "MK-814" },
      { name: "Cesinovo-Oblesevo", code: "MK-210" },
      { name: "Cucer Sandevo", code: "MK-816" },
      { name: "Debar", code: "MK-303" },
      { name: "Delcevo", code: "MK-203" },
      { name: "Demir Hisar", code: "MK-502" },
      { name: "Demir Kapija", code: "MK-103" },
      { name: "Dojran", code: "MK-406" },
      { name: "Gazi Baba", code: "MK-804" },
      { name: "Gevgelija", code: "MK-405" },
      { name: "Gostivar", code: "MK-604" },
      { name: "Gradsko", code: "MK-102" },
      { name: "Ilinden", code: "MK-807" },
      { name: "Jegunovce", code: "MK-606" },
      { name: "Kavadarci", code: "MK-104" },
      { name: "Kicevo", code: "MK-307" },
      { name: "Kisela Voda", code: "MK-809" },
      { name: "Kocani", code: "MK-206" },
      { name: "Kratovo", code: "MK-701" },
      { name: "Kriva Palanka", code: "MK-702" },
      { name: "Krivogastani", code: "MK-504" },
      { name: "Krusevo", code: "MK-505" },
      { name: "Kumanovo", code: "MK-703" },
      { name: "Lipkovo", code: "MK-704" },
      { name: "Lozovo", code: "MK-105" },
      { name: "Makedonska Kamenica", code: "MK-207" },
      { name: "Makedonski Brod", code: "MK-308" },
      { name: "Mavrovo i Rostusa", code: "MK-607" },
      { name: "Mogila", code: "MK-506" },
      { name: "Negotino", code: "MK-106" },
      { name: "Novo Selo", code: "MK-408" },
      { name: "Ohrid", code: "MK-310" },
      { name: "Pehcevo", code: "MK-208" },
      { name: "Petrovec", code: "MK-810" },
      { name: "Plasnica", code: "MK-311" },
      { name: "Prilep", code: "MK-508" },
      { name: "Probistip", code: "MK-209" },
      { name: "Radovis", code: "MK-409" },
      { name: "Rankovce", code: "MK-705" },
      { name: "Resen", code: "MK-509" },
      { name: "Saraj", code: "MK-811" },
      { name: "Sopiste", code: "MK-812" },
      { name: "Stip", code: "MK-211" },
      { name: "Struga", code: "MK-312" },
      { name: "Strumica", code: "MK-410" },
      { name: "Studenicani", code: "MK-813" },
      { name: "Sveti Nikole", code: "MK-108" },
      { name: "Tearce", code: "MK-608" },
      { name: "Tetovo", code: "MK-609" },
      { name: "Valandovo", code: "MK-403" },
      { name: "Vasilevo", code: "MK-404" },
      { name: "Veles", code: "MK-101" },
      { name: "Vevcani", code: "MK-301" },
      { name: "Vinica", code: "MK-202" },
      { name: "Vrapciste", code: "MK-603" },
      { name: "Zelenikovo", code: "MK-806" },
      { name: "Zelino", code: "MK-605" },
      { name: "Zrnovci", code: "MK-204" },
      { name: "Rosoman", code: "MK-107" },
      { name: "Karbinci", code: "MK-205" },
      { name: "Debrca", code: "MK-304" },
      { name: "Centar Zupa", code: "MK-313" },
      { name: "Konce", code: "MK-407" },
      { name: "Dolneni", code: "MK-503" },
      { name: "Novaci", code: "MK-507" },
      { name: "Staro Nagoricane", code: "MK-706" },
      { name: "Aerodrom", code: "MK-801" },
      { name: "Gjorce Petrov", code: "MK-805" },
      { name: "Karpos", code: "MK-808" },
      { name: "Cair", code: "MK-815" },
      { name: "Suto Orizari", code: "MK-817" }
    ]
  },
  [countryCodes.MALI.alphaTwo]: {
    subdivisions: [
      { name: "Bamako", code: "ML-BKO" },
      { name: "Gao", code: "ML-7" },
      { name: "Kayes", code: "ML-1" },
      { name: "Kidal", code: "ML-8" },
      { name: "Koulikoro", code: "ML-2" },
      { name: "Mopti", code: "ML-5" },
      { name: "Segou", code: "ML-4" },
      { name: "Sikasso", code: "ML-3" },
      { name: "Tombouctou", code: "ML-6" },
      { name: "Taoudenit", code: "ML-10" },
      { name: "Menaka", code: "ML-9" }
    ]
  },
  [countryCodes.MYANMAR.alphaTwo]: {
    subdivisions: [
      { name: "Ayeyarwady", code: "MM-07" },
      { name: "Bago", code: "MM-02" },
      { name: "Chin", code: "MM-14" },
      { name: "Kachin", code: "MM-11" },
      { name: "Kayah", code: "MM-12" },
      { name: "Kayin", code: "MM-13" },
      { name: "Magway", code: "MM-03" },
      { name: "Mandalay", code: "MM-04" },
      { name: "Mon", code: "MM-15" },
      { name: "Nay Pyi Taw", code: "MM-18" },
      { name: "Rakhine", code: "MM-16" },
      { name: "Sagaing", code: "MM-01" },
      { name: "Shan", code: "MM-17" },
      { name: "Tanintharyi", code: "MM-05" },
      { name: "Yangon", code: "MM-06" }
    ]
  },
  [countryCodes.MONGOLIA.alphaTwo]: {
    subdivisions: [
      { name: "Arhangay", code: "MN-073" },
      { name: "Bayan-Olgiy", code: "MN-071" },
      { name: "Bayanhongor", code: "MN-069" },
      { name: "Bulgan", code: "MN-067" },
      { name: "Darhan uul", code: "MN-037" },
      { name: "Dundgovi", code: "MN-059" },
      { name: "Dzavhan", code: "MN-057" },
      { name: "Govi-Altay", code: "MN-065" },
      { name: "Hovd", code: "MN-043" },
      { name: "Hovsgol", code: "MN-041" },
      { name: "Omnogovi", code: "MN-053" },
      { name: "Orhon", code: "MN-035" },
      { name: "Ovorhangay", code: "MN-055" },
      { name: "Selenge", code: "MN-049" },
      { name: "Tov", code: "MN-047" },
      { name: "Ulaanbaatar", code: "MN-1" },
      { name: "Uvs", code: "MN-046" },
      { name: "Hentiy", code: "MN-039" },
      { name: "Suhbaatar", code: "MN-051" },
      { name: "Dornod", code: "MN-061" },
      { name: "Dornogovi", code: "MN-063" },
      { name: "Govi-Sumber", code: "MN-064" }
    ]
  },
  [countryCodes.MACAU.alphaTwo]: { subdivisions: [{ name: "Macao", code: "-" }] },
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Northern Mariana Islands", code: "-" }]
  },
  [countryCodes.MARTINIQUE.alphaTwo]: { subdivisions: [{ name: "Martinique", code: "-" }] },
  [countryCodes.MAURITANIA.alphaTwo]: {
    subdivisions: [
      { name: "Adrar", code: "MR-07" },
      { name: "Brakna", code: "MR-05" },
      { name: "Dakhlet Nouadhibou", code: "MR-08" },
      { name: "Gorgol", code: "MR-04" },
      { name: "Guidimaka", code: "MR-10" },
      { name: "Hodh ech Chargui", code: "MR-01" },
      { name: "Hodh el Gharbi", code: "MR-02" },
      { name: "Inchiri", code: "MR-12" },
      { name: "Nouakchott Ouest", code: "MR-13" },
      { name: "Tiris Zemmour", code: "MR-11" },
      { name: "Trarza", code: "MR-06" },
      { name: "Assaba", code: "MR-03" },
      { name: "Tagant", code: "MR-09" },
      { name: "Nouakchott Nord", code: "MR-14" },
      { name: "Nouakchott Sud", code: "MR-15" }
    ]
  },
  [countryCodes.MONTSERRAT.alphaTwo]: {
    subdivisions: [
      { name: "Saint Anthony", code: "-" },
      { name: "Saint Peter", code: "-" }
    ]
  },
  [countryCodes.MALTA.alphaTwo]: {
    subdivisions: [
      { name: "Attard", code: "MT-01" },
      { name: "Balzan", code: "MT-02" },
      { name: "Birgu", code: "MT-03" },
      { name: "Birkirkara", code: "MT-04" },
      { name: "Birzebbuga", code: "MT-05" },
      { name: "Bormla", code: "MT-06" },
      { name: "Dingli", code: "MT-07" },
      { name: "Fgura", code: "MT-08" },
      { name: "Floriana", code: "MT-09" },
      { name: "Fontana", code: "MT-10" },
      { name: "Ghajnsielem", code: "MT-13" },
      { name: "Gharb", code: "MT-14" },
      { name: "Gharghur", code: "MT-15" },
      { name: "Ghasri", code: "MT-16" },
      { name: "Ghaxaq", code: "MT-17" },
      { name: "Gudja", code: "MT-11" },
      { name: "Gzira", code: "MT-12" },
      { name: "Hamrun", code: "MT-18" },
      { name: "Iklin", code: "MT-19" },
      { name: "Isla", code: "MT-20" },
      { name: "Kalkara", code: "MT-21" },
      { name: "Kercem", code: "MT-22" },
      { name: "Kirkop", code: "MT-23" },
      { name: "Lija", code: "MT-24" },
      { name: "Luqa", code: "MT-25" },
      { name: "Marsa", code: "MT-26" },
      { name: "Marsaskala", code: "MT-27" },
      { name: "Marsaxlokk", code: "MT-28" },
      { name: "Mdina", code: "MT-29" },
      { name: "Mellieha", code: "MT-30" },
      { name: "Mgarr", code: "MT-31" },
      { name: "Mosta", code: "MT-32" },
      { name: "Mqabba", code: "MT-33" },
      { name: "Msida", code: "MT-34" },
      { name: "Mtarfa", code: "MT-35" },
      { name: "Munxar", code: "MT-36" },
      { name: "Nadur", code: "MT-37" },
      { name: "Naxxar", code: "MT-38" },
      { name: "Paola", code: "MT-39" },
      { name: "Pembroke", code: "MT-40" },
      { name: "Pieta", code: "MT-41" },
      { name: "Qala", code: "MT-42" },
      { name: "Qormi", code: "MT-43" },
      { name: "Qrendi", code: "MT-44" },
      { name: "Rabat Gozo", code: "MT-45" },
      { name: "Rabat Malta", code: "MT-46" },
      { name: "Safi", code: "MT-47" },
      { name: "Saint John", code: "MT-49" },
      { name: "Saint Julian's", code: "MT-48" },
      { name: "Saint Lucia's", code: "MT-53" },
      { name: "Saint Paul's Bay", code: "MT-51" },
      { name: "Sannat", code: "MT-52" },
      { name: "Santa Venera", code: "MT-54" },
      { name: "Siggiewi", code: "MT-55" },
      { name: "Sliema", code: "MT-56" },
      { name: "Swieqi", code: "MT-57" },
      { name: "Ta' Xbiex", code: "MT-58" },
      { name: "Tarxien", code: "MT-59" },
      { name: "Valletta", code: "MT-60" },
      { name: "Xaghra", code: "MT-61" },
      { name: "Xewkija", code: "MT-62" },
      { name: "Xghajra", code: "MT-63" },
      { name: "Zabbar", code: "MT-64" },
      { name: "Zebbug Gozo", code: "MT-65" },
      { name: "Zejtun", code: "MT-67" },
      { name: "Zurrieq", code: "MT-68" },
      { name: "Saint Lawrence", code: "MT-50" },
      { name: "Zebbug Malta", code: "MT-66" }
    ]
  },
  [countryCodes.MAURITIUS.alphaTwo]: {
    subdivisions: [
      { name: "Black River", code: "MU-BL" },
      { name: "Flacq", code: "MU-FL" },
      { name: "Grand Port", code: "MU-GP" },
      { name: "Moka", code: "MU-MO" },
      { name: "Pamplemousses", code: "MU-PA" },
      { name: "Plaines Wilhems", code: "MU-PW" },
      { name: "Port Louis", code: "MU-PL" },
      { name: "Riviere du Rempart", code: "MU-RR" },
      { name: "Rodrigues Islands", code: "MU-RO" },
      { name: "Savanne", code: "MU-SA" },
      { name: "Agalega Islands", code: "MU-AG" },
      { name: "Cargados Carajos Shoals", code: "MU-CC" }
    ]
  },
  [countryCodes.MALDIVES.alphaTwo]: {
    subdivisions: [
      { name: "Addu City", code: "MV-01" },
      { name: "Faadhippolhu", code: "MV-03" },
      { name: "Felidhu Atoll", code: "MV-04" },
      { name: "Fuvammulah", code: "MV-29" },
      { name: "Hahdhunmathi", code: "MV-05" },
      { name: "Kolhumadulu", code: "MV-08" },
      { name: "Male", code: "MV-MLE" },
      { name: "Mulaku Atoll", code: "MV-12" },
      { name: "North Ari Atoll", code: "MV-02" },
      { name: "North Huvadhu Atoll", code: "MV-27" },
      { name: "North Miladhunmadulu", code: "MV-24" },
      { name: "North Nilandhe Atoll", code: "MV-14" },
      { name: "North Thiladhunmathi", code: "MV-07" },
      { name: "South Ari Atoll", code: "MV-00" },
      { name: "South Huvadhu Atoll", code: "MV-28" },
      { name: "South Maalhosmadulu", code: "MV-20" },
      { name: "South Miladhunmadulu", code: "MV-25" },
      { name: "South Nilandhe Atoll", code: "MV-17" },
      { name: "South Thiladhunmathi", code: "MV-23" },
      { name: "North Maalhosmadulu", code: "MV-13" },
      { name: "Male Atoll", code: "MV-26" }
    ]
  },
  [countryCodes.MALAWI.alphaTwo]: {
    subdivisions: [
      { name: "Balaka", code: "MW-BA" },
      { name: "Blantyre", code: "MW-BL" },
      { name: "Chikwawa", code: "MW-CK" },
      { name: "Chiradzulu", code: "MW-CR" },
      { name: "Dedza", code: "MW-DE" },
      { name: "Dowa", code: "MW-DO" },
      { name: "Karonga", code: "MW-KR" },
      { name: "Kasungu", code: "MW-KS" },
      { name: "Lilongwe", code: "MW-LI" },
      { name: "Machinga", code: "MW-MH" },
      { name: "Mangochi", code: "MW-MG" },
      { name: "Mwanza", code: "MW-MW" },
      { name: "Mzimba", code: "MW-MZ" },
      { name: "Nkhotakota", code: "MW-NK" },
      { name: "Ntcheu", code: "MW-NU" },
      { name: "Ntchisi", code: "MW-NI" },
      { name: "Salima", code: "MW-SA" },
      { name: "Zomba", code: "MW-ZO" },
      { name: "Chitipa", code: "MW-CT" },
      { name: "Likoma", code: "MW-LK" },
      { name: "Mchinji", code: "MW-MC" },
      { name: "Mulanje", code: "MW-MU" },
      { name: "Nkhata Bay", code: "MW-NB" },
      { name: "Neno", code: "MW-NE" },
      { name: "Nsanje", code: "MW-NS" },
      { name: "Phalombe", code: "MW-PH" },
      { name: "Rumphi", code: "MW-RU" },
      { name: "Thyolo", code: "MW-TH" }
    ]
  },
  [countryCodes.MEXICO.alphaTwo]: {
    subdivisions: [
      { name: "Aguascalientes", code: "MX-AGU" },
      { name: "Baja California", code: "MX-BCN" },
      { name: "Baja California Sur", code: "MX-BCS" },
      { name: "Campeche", code: "MX-CAM" },
      { name: "Chiapas", code: "MX-CHP" },
      { name: "Chihuahua", code: "MX-CHH" },
      { name: "Ciudad de Mexico", code: "MX-CMX" },
      { name: "Coahuila de Zaragoza", code: "MX-COA" },
      { name: "Colima", code: "MX-COL" },
      { name: "Durango", code: "MX-DUR" },
      { name: "Guanajuato", code: "MX-GUA" },
      { name: "Guerrero", code: "MX-GRO" },
      { name: "Hidalgo", code: "MX-HID" },
      { name: "Jalisco", code: "MX-JAL" },
      { name: "Mexico", code: "MX-MEX" },
      { name: "Michoacan de Ocampo", code: "MX-MIC" },
      { name: "Morelos", code: "MX-MOR" },
      { name: "Nayarit", code: "MX-NAY" },
      { name: "Nuevo Leon", code: "MX-NLE" },
      { name: "Oaxaca", code: "MX-OAX" },
      { name: "Puebla", code: "MX-PUE" },
      { name: "Queretaro", code: "MX-QUE" },
      { name: "Quintana Roo", code: "MX-ROO" },
      { name: "San Luis Potosi", code: "MX-SLP" },
      { name: "Sinaloa", code: "MX-SIN" },
      { name: "Sonora", code: "MX-SON" },
      { name: "Tabasco", code: "MX-TAB" },
      { name: "Tamaulipas", code: "MX-TAM" },
      { name: "Tlaxcala", code: "MX-TLA" },
      { name: "Veracruz de Ignacio de la Llave", code: "MX-VER" },
      { name: "Yucatan", code: "MX-YUC" },
      { name: "Zacatecas", code: "MX-ZAC" }
    ]
  },
  [countryCodes.MALAYSIA.alphaTwo]: {
    subdivisions: [
      { name: "Johor", code: "MY-01" },
      { name: "Kedah", code: "MY-02" },
      { name: "Kelantan", code: "MY-03" },
      { name: "Melaka", code: "MY-04" },
      { name: "Negeri Sembilan", code: "MY-05" },
      { name: "Pahang", code: "MY-06" },
      { name: "Perak", code: "MY-08" },
      { name: "Perlis", code: "MY-09" },
      { name: "Pulau Pinang", code: "MY-07" },
      { name: "Sabah", code: "MY-12" },
      { name: "Sarawak", code: "MY-13" },
      { name: "Selangor", code: "MY-10" },
      { name: "Terengganu", code: "MY-11" },
      { name: "Wilayah Persekutuan Kuala Lumpur", code: "MY-14" },
      { name: "Wilayah Persekutuan Labuan", code: "MY-15" },
      { name: "Wilayah Persekutuan Putrajaya", code: "MY-16" }
    ]
  },
  [countryCodes.MOZAMBIQUE.alphaTwo]: {
    subdivisions: [
      { name: "Cabo Delgado", code: "MZ-P" },
      { name: "Gaza", code: "MZ-G" },
      { name: "Inhambane", code: "MZ-I" },
      { name: "Manica", code: "MZ-B" },
      { name: "Maputo", code: "MZ-L" },
      { name: "Nampula", code: "MZ-N" },
      { name: "Niassa", code: "MZ-A" },
      { name: "Sofala", code: "MZ-S" },
      { name: "Tete", code: "MZ-T" },
      { name: "Zambezia", code: "MZ-Q" }
    ]
  },
  [countryCodes.NAMIBIA.alphaTwo]: {
    subdivisions: [
      { name: "Erongo", code: "NA-ER" },
      { name: "Hardap", code: "NA-HA" },
      { name: "Karas", code: "NA-KA" },
      { name: "Kavango East", code: "NA-KE" },
      { name: "Khomas", code: "NA-KH" },
      { name: "Kunene", code: "NA-KU" },
      { name: "Ohangwena", code: "NA-OW" },
      { name: "Omaheke", code: "NA-OH" },
      { name: "Omusati", code: "NA-OS" },
      { name: "Oshana", code: "NA-ON" },
      { name: "Oshikoto", code: "NA-OT" },
      { name: "Otjozondjupa", code: "NA-OD" },
      { name: "Zambezi", code: "NA-CA" }
    ]
  },
  [countryCodes.NEW_CALEDONIA.alphaTwo]: {
    subdivisions: [
      { name: "Province Nord", code: "-" },
      { name: "Province Sud", code: "-" },
      { name: "Province des iles Loyaute", code: "-" }
    ]
  },
  [countryCodes.NIGER.alphaTwo]: {
    subdivisions: [
      { name: "Agadez", code: "NE-1" },
      { name: "Diffa", code: "NE-2" },
      { name: "Dosso", code: "NE-3" },
      { name: "Maradi", code: "NE-4" },
      { name: "Niamey", code: "NE-8" },
      { name: "Tahoua", code: "NE-5" },
      { name: "Tillaberi", code: "NE-6" },
      { name: "Zinder", code: "NE-7" }
    ]
  },
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: { subdivisions: [{ name: "Norfolk Island", code: "-" }] },
  [countryCodes.NIGERIA.alphaTwo]: {
    subdivisions: [
      { name: "Abia", code: "NG-AB" },
      { name: "Abuja Federal Capital Territory", code: "NG-FC" },
      { name: "Adamawa", code: "NG-AD" },
      { name: "Akwa Ibom", code: "NG-AK" },
      { name: "Anambra", code: "NG-AN" },
      { name: "Bauchi", code: "NG-BA" },
      { name: "Bayelsa", code: "NG-BY" },
      { name: "Benue", code: "NG-BE" },
      { name: "Borno", code: "NG-BO" },
      { name: "Cross River", code: "NG-CR" },
      { name: "Delta", code: "NG-DE" },
      { name: "Ebonyi", code: "NG-EB" },
      { name: "Edo", code: "NG-ED" },
      { name: "Ekiti", code: "NG-EK" },
      { name: "Enugu", code: "NG-EN" },
      { name: "Gombe", code: "NG-GO" },
      { name: "Imo", code: "NG-IM" },
      { name: "Jigawa", code: "NG-JI" },
      { name: "Kaduna", code: "NG-KD" },
      { name: "Kano", code: "NG-KN" },
      { name: "Katsina", code: "NG-KT" },
      { name: "Kebbi", code: "NG-KE" },
      { name: "Kogi", code: "NG-KO" },
      { name: "Kwara", code: "NG-KW" },
      { name: "Lagos", code: "NG-LA" },
      { name: "Nasarawa", code: "NG-NA" },
      { name: "Niger", code: "NG-NI" },
      { name: "Ogun", code: "NG-OG" },
      { name: "Ondo", code: "NG-ON" },
      { name: "Osun", code: "NG-OS" },
      { name: "Oyo", code: "NG-OY" },
      { name: "Plateau", code: "NG-PL" },
      { name: "Rivers", code: "NG-RI" },
      { name: "Sokoto", code: "NG-SO" },
      { name: "Taraba", code: "NG-TA" },
      { name: "Yobe", code: "NG-YO" },
      { name: "Zamfara", code: "NG-ZA" }
    ]
  },
  [countryCodes.NICARAGUA.alphaTwo]: {
    subdivisions: [
      { name: "Boaco", code: "NI-BO" },
      { name: "Carazo", code: "NI-CA" },
      { name: "Chinandega", code: "NI-CI" },
      { name: "Chontales", code: "NI-CO" },
      { name: "Costa Caribe Norte", code: "NI-AN" },
      { name: "Costa Caribe Sur", code: "NI-AS" },
      { name: "Esteli", code: "NI-ES" },
      { name: "Granada", code: "NI-GR" },
      { name: "Jinotega", code: "NI-JI" },
      { name: "Leon", code: "NI-LE" },
      { name: "Madriz", code: "NI-MD" },
      { name: "Managua", code: "NI-MN" },
      { name: "Masaya", code: "NI-MS" },
      { name: "Matagalpa", code: "NI-MT" },
      { name: "Nueva Segovia", code: "NI-NS" },
      { name: "Rio San Juan", code: "NI-SJ" },
      { name: "Rivas", code: "NI-RI" }
    ]
  },
  [countryCodes.NETHERLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Drenthe", code: "NL-DR" },
      { name: "Flevoland", code: "NL-FL" },
      { name: "Fryslan", code: "NL-FR" },
      { name: "Gelderland", code: "NL-GE" },
      { name: "Groningen", code: "NL-GR" },
      { name: "Limburg", code: "NL-LI" },
      { name: "Noord-Brabant", code: "NL-NB" },
      { name: "Noord-Holland", code: "NL-NH" },
      { name: "Overijssel", code: "NL-OV" },
      { name: "Utrecht", code: "NL-UT" },
      { name: "Zeeland", code: "NL-ZE" },
      { name: "Zuid-Holland", code: "NL-ZH" }
    ]
  },
  [countryCodes.NORWAY.alphaTwo]: {
    subdivisions: [
      { name: "Agder", code: "NO-42" },
      { name: "Innlandet", code: "NO-34" },
      { name: "More og Romsdal", code: "NO-15" },
      { name: "Nordland", code: "NO-18" },
      { name: "Oslo", code: "NO-03" },
      { name: "Rogaland", code: "NO-11" },
      { name: "Troms og Finnmark", code: "NO-54" },
      { name: "Trondelag", code: "NO-50" },
      { name: "Vestfold og Telemark", code: "NO-38" },
      { name: "Vestland", code: "NO-46" },
      { name: "Viken", code: "NO-30" }
    ]
  },
  [countryCodes.NEPAL.alphaTwo]: {
    subdivisions: [
      { name: "Bagmati", code: "NP-P3" },
      { name: "Gandaki", code: "NP-P4" },
      { name: "Karnali", code: "NP-P6" },
      { name: "Koshi", code: "NP-P1" },
      { name: "Lumbini", code: "NP-P5" },
      { name: "Madhesh", code: "NP-P2" },
      { name: "Sudurpashchim", code: "NP-P7" }
    ]
  },
  [countryCodes.NAURU.alphaTwo]: {
    subdivisions: [
      { name: "Aiwo", code: "NR-01" },
      { name: "Yaren", code: "NR-14" },
      { name: "Anabar", code: "NR-02" },
      { name: "Anetan", code: "NR-03" },
      { name: "Anibare", code: "NR-04" },
      { name: "Baitsi", code: "NR-05" },
      { name: "Boe", code: "NR-06" },
      { name: "Buada", code: "NR-07" },
      { name: "Denigomodu", code: "NR-08" },
      { name: "Ewa", code: "NR-09" },
      { name: "Ijuw", code: "NR-10" },
      { name: "Meneng", code: "NR-11" },
      { name: "Nibok", code: "NR-12" },
      { name: "Uaboe", code: "NR-13" }
    ]
  },
  [countryCodes.NIUE.alphaTwo]: { subdivisions: [{ name: "Niue", code: "-" }] },
  [countryCodes.NEW_ZEALAND.alphaTwo]: {
    subdivisions: [
      { name: "Auckland", code: "NZ-AUK" },
      { name: "Bay of Plenty", code: "NZ-BOP" },
      { name: "Canterbury", code: "NZ-CAN" },
      { name: "Chatham Islands Territory", code: "NZ-CIT" },
      { name: "Gisborne", code: "NZ-GIS" },
      { name: "Greater Wellington", code: "NZ-WGN" },
      { name: "Hawke's Bay", code: "NZ-HKB" },
      { name: "Manawatu-Whanganui", code: "NZ-MWT" },
      { name: "Marlborough", code: "NZ-MBH" },
      { name: "Nelson", code: "NZ-NSN" },
      { name: "Northland", code: "NZ-NTL" },
      { name: "Otago", code: "NZ-OTA" },
      { name: "Southland", code: "NZ-STL" },
      { name: "Taranaki", code: "NZ-TKI" },
      { name: "Tasman", code: "NZ-TAS" },
      { name: "Waikato", code: "NZ-WKO" },
      { name: "West Coast", code: "NZ-WTC" }
    ]
  },
  [countryCodes.OMAN.alphaTwo]: {
    subdivisions: [
      { name: "Ad Dakhiliyah", code: "OM-DA" },
      { name: "Al Buraymi", code: "OM-BU" },
      { name: "Al Wusta", code: "OM-WU" },
      { name: "Az Zahirah", code: "OM-ZA" },
      { name: "Janub al Batinah", code: "OM-BJ" },
      { name: "Janub ash Sharqiyah", code: "OM-SJ" },
      { name: "Masqat", code: "OM-MA" },
      { name: "Musandam", code: "OM-MU" },
      { name: "Shamal al Batinah", code: "OM-BS" },
      { name: "Shamal ash Sharqiyah", code: "OM-SS" },
      { name: "Zufar", code: "OM-ZU" }
    ]
  },
  [countryCodes.PANAMA.alphaTwo]: {
    subdivisions: [
      { name: "Bocas del Toro", code: "PA-1" },
      { name: "Chiriqui", code: "PA-4" },
      { name: "Cocle", code: "PA-2" },
      { name: "Colon", code: "PA-3" },
      { name: "Darien", code: "PA-5" },
      { name: "Herrera", code: "PA-6" },
      { name: "Los Santos", code: "PA-7" },
      { name: "Ngobe-Bugle", code: "PA-NB" },
      { name: "Panama", code: "PA-8" },
      { name: "Veraguas", code: "PA-9" },
      { name: "Panama Oeste", code: "PA-10" },
      { name: "Embera", code: "PA-EM" },
      { name: "Guna Yala", code: "PA-KY" },
      { name: "Naso Tjer Di", code: "PA-NT" }
    ]
  },
  [countryCodes.PERU.alphaTwo]: {
    subdivisions: [
      { name: "Amazonas", code: "PE-AMA" },
      { name: "Ancash", code: "PE-ANC" },
      { name: "Apurimac", code: "PE-APU" },
      { name: "Arequipa", code: "PE-ARE" },
      { name: "Ayacucho", code: "PE-AYA" },
      { name: "Cajamarca", code: "PE-CAJ" },
      { name: "Cusco", code: "PE-CUS" },
      { name: "El Callao", code: "PE-CAL" },
      { name: "Huancavelica", code: "PE-HUV" },
      { name: "Huanuco", code: "PE-HUC" },
      { name: "Ica", code: "PE-ICA" },
      { name: "Junin", code: "PE-JUN" },
      { name: "La Libertad", code: "PE-LAL" },
      { name: "Lambayeque", code: "PE-LAM" },
      { name: "Lima", code: "PE-LIM" },
      { name: "Loreto", code: "PE-LOR" },
      { name: "Madre de Dios", code: "PE-MDD" },
      { name: "Moquegua", code: "PE-MOQ" },
      { name: "Pasco", code: "PE-PAS" },
      { name: "Piura", code: "PE-PIU" },
      { name: "Puno", code: "PE-PUN" },
      { name: "San Martin", code: "PE-SAM" },
      { name: "Tacna", code: "PE-TAC" },
      { name: "Tumbes", code: "PE-TUM" },
      { name: "Ucayali", code: "PE-UCA" },
      { name: "Municipalidad Metropolitana de Lima", code: "PE-LMA" }
    ]
  },
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: {
    subdivisions: [
      { name: "Iles Australes", code: "-" },
      { name: "Iles Marquises", code: "-" },
      { name: "Iles Sous-le-Vent", code: "-" },
      { name: "Iles Tuamotu-Gambier", code: "-" },
      { name: "Iles du Vent", code: "-" }
    ]
  },
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: {
    subdivisions: [
      { name: "Bougainville", code: "PG-NSB" },
      { name: "Central", code: "PG-CPM" },
      { name: "East New Britain", code: "PG-EBR" },
      { name: "Eastern Highlands", code: "PG-EHG" },
      { name: "Enga", code: "PG-EPW" },
      { name: "Madang", code: "PG-MPM" },
      { name: "Manus", code: "PG-MRL" },
      { name: "Milne Bay", code: "PG-MBA" },
      { name: "Morobe", code: "PG-MPL" },
      { name: "National Capital District (Port Moresby)", code: "PG-NCD" },
      { name: "New Ireland", code: "PG-NIK" },
      { name: "Northern", code: "PG-NPP" },
      { name: "Southern Highlands", code: "PG-SHM" },
      { name: "Western", code: "PG-WPD" },
      { name: "Western Highlands", code: "PG-WHM" },
      { name: "Chimbu", code: "PG-CPK" },
      { name: "East Sepik", code: "PG-ESW" },
      { name: "Gulf", code: "PG-GPK" },
      { name: "Hela", code: "PG-HLA" },
      { name: "Jiwaka", code: "PG-JWK" },
      { name: "West Sepik", code: "PG-SAN" },
      { name: "West New Britain", code: "PG-WBK" }
    ]
  },
  [countryCodes.PHILIPPINES.alphaTwo]: {
    subdivisions: [
      { name: "Abra", code: "PH-ABR" },
      { name: "Agusan del Norte", code: "PH-AGN" },
      { name: "Agusan del Sur", code: "PH-AGS" },
      { name: "Aklan", code: "PH-AKL" },
      { name: "Albay", code: "PH-ALB" },
      { name: "Antique", code: "PH-ANT" },
      { name: "Apayao", code: "PH-APA" },
      { name: "Aurora", code: "PH-AUR" },
      { name: "Basilan", code: "PH-BAS" },
      { name: "Bataan", code: "PH-BAN" },
      { name: "Batanes", code: "PH-BTN" },
      { name: "Batangas", code: "PH-BTG" },
      { name: "Benguet", code: "PH-BEN" },
      { name: "Biliran", code: "PH-BIL" },
      { name: "Bohol", code: "PH-BOH" },
      { name: "Bukidnon", code: "PH-BUK" },
      { name: "Bulacan", code: "PH-BUL" },
      { name: "Cagayan", code: "PH-CAG" },
      { name: "Camarines Norte", code: "PH-CAN" },
      { name: "Camarines Sur", code: "PH-CAS" },
      { name: "Camiguin", code: "PH-CAM" },
      { name: "Capiz", code: "PH-CAP" },
      { name: "Catanduanes", code: "PH-CAT" },
      { name: "Cavite", code: "PH-CAV" },
      { name: "Cebu", code: "PH-CEB" },
      { name: "Cotabato", code: "PH-NCO" },
      { name: "Davao Oriental", code: "PH-DAO" },
      { name: "Davao de Oro", code: "PH-COM" },
      { name: "Davao del Norte", code: "PH-DAV" },
      { name: "Davao del Sur", code: "PH-DAS" },
      { name: "Dinagat Islands", code: "PH-DIN" },
      { name: "Eastern Samar", code: "PH-EAS" },
      { name: "Guimaras", code: "PH-GUI" },
      { name: "Ifugao", code: "PH-IFU" },
      { name: "Ilocos Norte", code: "PH-ILN" },
      { name: "Ilocos Sur", code: "PH-ILS" },
      { name: "Iloilo", code: "PH-ILI" },
      { name: "Isabela", code: "PH-ISA" },
      { name: "Kalinga", code: "PH-KAL" },
      { name: "La Union", code: "PH-LUN" },
      { name: "Laguna", code: "PH-LAG" },
      { name: "Lanao del Norte", code: "PH-LAN" },
      { name: "Lanao del Sur", code: "PH-LAS" },
      { name: "Leyte", code: "PH-LEY" },
      { name: "Maguindanao del Norte", code: "PH-MGN" },
      { name: "Maguindanao del Sur", code: "PH-MGS" },
      { name: "Marinduque", code: "PH-MAD" },
      { name: "Masbate", code: "PH-MAS" },
      { name: "Mindoro Occidental", code: "PH-MDC" },
      { name: "Mindoro Oriental", code: "PH-MDR" },
      { name: "Misamis Occidental", code: "PH-MSC" },
      { name: "Misamis Oriental", code: "PH-MSR" },
      { name: "Mountain Province", code: "PH-MOU" },
      { name: "National Capital Region", code: "PH-00" },
      { name: "Negros Occidental", code: "PH-NEC" },
      { name: "Negros Oriental", code: "PH-NER" },
      { name: "Northern Samar", code: "PH-NSA" },
      { name: "Nueva Ecija", code: "PH-NUE" },
      { name: "Nueva Vizcaya", code: "PH-NUV" },
      { name: "Palawan", code: "PH-PLW" },
      { name: "Pampanga", code: "PH-PAM" },
      { name: "Pangasinan", code: "PH-PAN" },
      { name: "Quezon", code: "PH-QUE" },
      { name: "Quirino", code: "PH-QUI" },
      { name: "Rizal", code: "PH-RIZ" },
      { name: "Romblon", code: "PH-ROM" },
      { name: "Samar", code: "PH-WSA" },
      { name: "Sarangani", code: "PH-SAR" },
      { name: "Siquijor", code: "PH-SIG" },
      { name: "Sorsogon", code: "PH-SOR" },
      { name: "South Cotabato", code: "PH-SCO" },
      { name: "Southern Leyte", code: "PH-SLE" },
      { name: "Sultan Kudarat", code: "PH-SUK" },
      { name: "Sulu", code: "PH-SLU" },
      { name: "Surigao del Norte", code: "PH-SUN" },
      { name: "Surigao del Sur", code: "PH-SUR" },
      { name: "Tarlac", code: "PH-TAR" },
      { name: "Tawi-Tawi", code: "PH-TAW" },
      { name: "Zambales", code: "PH-ZMB" },
      { name: "Zamboanga Sibugay", code: "PH-ZSI" },
      { name: "Zamboanga del Norte", code: "PH-ZAN" },
      { name: "Zamboanga del Sur", code: "PH-ZAS" },
      { name: "Davao Occidental", code: "PH-DVO" }
    ]
  },
  [countryCodes.PAKISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Azad Jammu and Kashmir", code: "PK-JK" },
      { name: "Balochistan", code: "PK-BA" },
      { name: "Gilgit-Baltistan", code: "PK-GB" },
      { name: "Islamabad", code: "PK-IS" },
      { name: "Khyber Pakhtunkhwa", code: "PK-KP" },
      { name: "Punjab", code: "PK-PB" },
      { name: "Sindh", code: "PK-SD" }
    ]
  },
  [countryCodes.POLAND.alphaTwo]: {
    subdivisions: [
      { name: "Dolnoslaskie", code: "PL-02" },
      { name: "Kujawsko-Pomorskie", code: "PL-04" },
      { name: "Lodzkie", code: "PL-10" },
      { name: "Lubelskie", code: "PL-06" },
      { name: "Lubuskie", code: "PL-08" },
      { name: "Malopolskie", code: "PL-12" },
      { name: "Mazowieckie", code: "PL-14" },
      { name: "Opolskie", code: "PL-16" },
      { name: "Podkarpackie", code: "PL-18" },
      { name: "Podlaskie", code: "PL-20" },
      { name: "Pomorskie", code: "PL-22" },
      { name: "Slaskie", code: "PL-24" },
      { name: "Swietokrzyskie", code: "PL-26" },
      { name: "Warminsko-Mazurskie", code: "PL-28" },
      { name: "Wielkopolskie", code: "PL-30" },
      { name: "Zachodniopomorskie", code: "PL-32" }
    ]
  },
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: {
    subdivisions: [{ name: "Saint Pierre and Miquelon", code: "-" }]
  },
  [countryCodes.PITCAIRN.alphaTwo]: { subdivisions: [{ name: "Pitcairn", code: "-" }] },
  [countryCodes.PUERTO_RICO.alphaTwo]: {
    subdivisions: [
      { name: "Adjuntas", code: "-" },
      { name: "Aguada", code: "-" },
      { name: "Aguadilla", code: "-" },
      { name: "Aguas Buenas", code: "-" },
      { name: "Aibonito", code: "-" },
      { name: "Anasco", code: "-" },
      { name: "Arecibo", code: "-" },
      { name: "Arroyo", code: "-" },
      { name: "Barceloneta", code: "-" },
      { name: "Barranquitas", code: "-" },
      { name: "Bayamon", code: "-" },
      { name: "Cabo Rojo", code: "-" },
      { name: "Caguas", code: "-" },
      { name: "Camuy", code: "-" },
      { name: "Canovanas", code: "-" },
      { name: "Carolina", code: "-" },
      { name: "Catano", code: "-" },
      { name: "Cayey", code: "-" },
      { name: "Ceiba", code: "-" },
      { name: "Ciales", code: "-" },
      { name: "Cidra", code: "-" },
      { name: "Coamo", code: "-" },
      { name: "Comerio", code: "-" },
      { name: "Corozal", code: "-" },
      { name: "Culebra", code: "-" },
      { name: "Dorado", code: "-" },
      { name: "Fajardo", code: "-" },
      { name: "Florida", code: "-" },
      { name: "Guanica", code: "-" },
      { name: "Guayama", code: "-" },
      { name: "Guayanilla", code: "-" },
      { name: "Guaynabo", code: "-" },
      { name: "Gurabo", code: "-" },
      { name: "Hatillo", code: "-" },
      { name: "Hormigueros", code: "-" },
      { name: "Humacao", code: "-" },
      { name: "Isabela", code: "-" },
      { name: "Juana Diaz", code: "-" },
      { name: "Lajas", code: "-" },
      { name: "Lares", code: "-" },
      { name: "Las Marias", code: "-" },
      { name: "Las Piedras", code: "-" },
      { name: "Loiza", code: "-" },
      { name: "Luquillo", code: "-" },
      { name: "Manati", code: "-" },
      { name: "Maunabo", code: "-" },
      { name: "Mayaguez", code: "-" },
      { name: "Moca", code: "-" },
      { name: "Morovis", code: "-" },
      { name: "Municipio de Jayuya", code: "-" },
      { name: "Municipio de Juncos", code: "-" },
      { name: "Naguabo", code: "-" },
      { name: "Naranjito", code: "-" },
      { name: "Patillas", code: "-" },
      { name: "Penuelas", code: "-" },
      { name: "Ponce", code: "-" },
      { name: "Quebradillas", code: "-" },
      { name: "Rincon", code: "-" },
      { name: "Rio Grande", code: "-" },
      { name: "Sabana Grande", code: "-" },
      { name: "Salinas", code: "-" },
      { name: "San German", code: "-" },
      { name: "San Juan", code: "-" },
      { name: "San Lorenzo", code: "-" },
      { name: "San Sebastian", code: "-" },
      { name: "Santa Isabel Municipio", code: "-" },
      { name: "Toa Alta", code: "-" },
      { name: "Toa Baja", code: "-" },
      { name: "Trujillo Alto", code: "-" },
      { name: "Utuado", code: "-" },
      { name: "Vega Alta", code: "-" },
      { name: "Vega Baja", code: "-" },
      { name: "Vieques", code: "-" },
      { name: "Villalba", code: "-" },
      { name: "Yabucoa", code: "-" },
      { name: "Yauco", code: "-" }
    ]
  },
  [countryCodes.PALESTINE.alphaTwo]: {
    subdivisions: [
      { name: "Bethlehem", code: "PS-BTH" },
      { name: "Deir El Balah", code: "PS-DEB" },
      { name: "Gaza", code: "PS-GZA" },
      { name: "Hebron", code: "PS-HBN" },
      { name: "Jenin", code: "PS-JEN" },
      { name: "Jericho and Al Aghwar", code: "PS-JRH" },
      { name: "Jerusalem", code: "PS-JEM" },
      { name: "Khan Yunis", code: "PS-KYS" },
      { name: "Nablus", code: "PS-NBS" },
      { name: "Rafah", code: "PS-RFH" },
      { name: "Ramallah", code: "PS-RBH" },
      { name: "Salfit", code: "PS-SLT" },
      { name: "Tubas", code: "PS-TBS" },
      { name: "Tulkarm", code: "PS-TKM" },
      { name: "North Gaza", code: "PS-NGZ" },
      { name: "Qalqilya", code: "PS-QQA" }
    ]
  },
  [countryCodes.PORTUGAL.alphaTwo]: {
    subdivisions: [
      { name: "Aveiro", code: "PT-01" },
      { name: "Beja", code: "PT-02" },
      { name: "Braga", code: "PT-03" },
      { name: "Braganca", code: "PT-04" },
      { name: "Castelo Branco", code: "PT-05" },
      { name: "Coimbra", code: "PT-06" },
      { name: "Evora", code: "PT-07" },
      { name: "Faro", code: "PT-08" },
      { name: "Guarda", code: "PT-09" },
      { name: "Leiria", code: "PT-10" },
      { name: "Lisboa", code: "PT-11" },
      { name: "Portalegre", code: "PT-12" },
      { name: "Porto", code: "PT-13" },
      { name: "Regiao Autonoma da Madeira", code: "PT-30" },
      { name: "Regiao Autonoma dos Acores", code: "PT-20" },
      { name: "Santarem", code: "PT-14" },
      { name: "Setubal", code: "PT-15" },
      { name: "Viana do Castelo", code: "PT-16" },
      { name: "Vila Real", code: "PT-17" },
      { name: "Viseu", code: "PT-18" }
    ]
  },
  [countryCodes.PALAU.alphaTwo]: {
    subdivisions: [
      { name: "Airai", code: "PW-004" },
      { name: "Koror", code: "PW-150" },
      { name: "Melekeok", code: "PW-212" },
      { name: "Ngardmau", code: "PW-222" },
      { name: "Ngchesar", code: "PW-226" },
      { name: "Sonsorol", code: "PW-370" },
      { name: "Aimeliik", code: "PW-002" },
      { name: "Angaur", code: "PW-010" },
      { name: "Hatohobei", code: "PW-050" },
      { name: "Kayangel", code: "PW-100" },
      { name: "Ngaraard", code: "PW-214" },
      { name: "Ngarchelong", code: "PW-218" },
      { name: "Ngatpang", code: "PW-224" },
      { name: "Ngeremlengui", code: "PW-227" },
      { name: "Ngiwal", code: "PW-228" },
      { name: "Peleliu", code: "PW-350" }
    ]
  },
  [countryCodes.PARAGUAY.alphaTwo]: {
    subdivisions: [
      { name: "Alto Parana", code: "PY-10" },
      { name: "Amambay", code: "PY-13" },
      { name: "Asuncion", code: "PY-ASU" },
      { name: "Boqueron", code: "PY-19" },
      { name: "Caaguazu", code: "PY-5" },
      { name: "Caazapa", code: "PY-6" },
      { name: "Canindeyu", code: "PY-14" },
      { name: "Central", code: "PY-11" },
      { name: "Concepcion", code: "PY-1" },
      { name: "Cordillera", code: "PY-3" },
      { name: "Guaira", code: "PY-4" },
      { name: "Itapua", code: "PY-7" },
      { name: "Misiones", code: "PY-8" },
      { name: "Neembucu", code: "PY-12" },
      { name: "Paraguari", code: "PY-9" },
      { name: "Presidente Hayes", code: "PY-15" },
      { name: "San Pedro", code: "PY-2" },
      { name: "Alto Paraguay", code: "PY-16" }
    ]
  },
  [countryCodes.QATAR.alphaTwo]: {
    subdivisions: [
      { name: "Ad Dawhah", code: "QA-DA" },
      { name: "Al Khawr wa adh Dhakhirah", code: "QA-KH" },
      { name: "Al Wakrah", code: "QA-WA" },
      { name: "Ar Rayyan", code: "QA-RA" },
      { name: "Ash Shamal", code: "QA-MS" },
      { name: "Az Za'ayin", code: "QA-ZA" },
      { name: "Umm Salal", code: "QA-US" },
      { name: "Ash Shihaniyah", code: "QA-SH" }
    ]
  },
  [countryCodes.REUNION.alphaTwo]: { subdivisions: [{ name: "Reunion", code: "-" }] },
  [countryCodes.ROMANIA.alphaTwo]: {
    subdivisions: [
      { name: "Alba", code: "RO-AB" },
      { name: "Arad", code: "RO-AR" },
      { name: "Arges", code: "RO-AG" },
      { name: "Bacau", code: "RO-BC" },
      { name: "Bihor", code: "RO-BH" },
      { name: "Bistrita-Nasaud", code: "RO-BN" },
      { name: "Botosani", code: "RO-BT" },
      { name: "Braila", code: "RO-BR" },
      { name: "Brasov", code: "RO-BV" },
      { name: "Bucuresti", code: "RO-B" },
      { name: "Buzau", code: "RO-BZ" },
      { name: "Calarasi", code: "RO-CL" },
      { name: "Caras-Severin", code: "RO-CS" },
      { name: "Cluj", code: "RO-CJ" },
      { name: "Constanta", code: "RO-CT" },
      { name: "Covasna", code: "RO-CV" },
      { name: "Dambovita", code: "RO-DB" },
      { name: "Dolj", code: "RO-DJ" },
      { name: "Galati", code: "RO-GL" },
      { name: "Giurgiu", code: "RO-GR" },
      { name: "Gorj", code: "RO-GJ" },
      { name: "Harghita", code: "RO-HR" },
      { name: "Hunedoara", code: "RO-HD" },
      { name: "Ialomita", code: "RO-IL" },
      { name: "Iasi", code: "RO-IS" },
      { name: "Ilfov", code: "RO-IF" },
      { name: "Maramures", code: "RO-MM" },
      { name: "Mehedinti", code: "RO-MH" },
      { name: "Mures", code: "RO-MS" },
      { name: "Neamt", code: "RO-NT" },
      { name: "Olt", code: "RO-OT" },
      { name: "Prahova", code: "RO-PH" },
      { name: "Salaj", code: "RO-SJ" },
      { name: "Satu Mare", code: "RO-SM" },
      { name: "Sibiu", code: "RO-SB" },
      { name: "Suceava", code: "RO-SV" },
      { name: "Teleorman", code: "RO-TR" },
      { name: "Timis", code: "RO-TM" },
      { name: "Tulcea", code: "RO-TL" },
      { name: "Valcea", code: "RO-VL" },
      { name: "Vaslui", code: "RO-VS" },
      { name: "Vrancea", code: "RO-VN" }
    ]
  },
  [countryCodes.SERBIA.alphaTwo]: {
    subdivisions: [
      { name: "Beograd", code: "RS-00" },
      { name: "Borski okrug", code: "RS-14" },
      { name: "Branicevski okrug", code: "RS-11" },
      { name: "Jablanicki okrug", code: "RS-23" },
      { name: "Juznobacki okrug", code: "RS-06" },
      { name: "Juznobanatski okrug", code: "RS-04" },
      { name: "Kolubarski okrug", code: "RS-09" },
      { name: "Kosovsko-Mitrovacki okrug", code: "RS-28" },
      { name: "Macvanski okrug", code: "RS-08" },
      { name: "Moravicki okrug", code: "RS-17" },
      { name: "Nisavski okrug", code: "RS-20" },
      { name: "Pcinjski okrug", code: "RS-24" },
      { name: "Pecki okrug", code: "RS-26" },
      { name: "Pirotski okrug", code: "RS-22" },
      { name: "Podunavski okrug", code: "RS-10" },
      { name: "Pomoravski okrug", code: "RS-13" },
      { name: "Prizrenski okrug", code: "RS-27" },
      { name: "Rasinski okrug", code: "RS-19" },
      { name: "Raski okrug", code: "RS-18" },
      { name: "Severnobacki okrug", code: "RS-01" },
      { name: "Severnobanatski okrug", code: "RS-03" },
      { name: "Srednjebanatski okrug", code: "RS-02" },
      { name: "Sremski okrug", code: "RS-07" },
      { name: "Sumadijski okrug", code: "RS-12" },
      { name: "Toplicki okrug", code: "RS-21" },
      { name: "Zajecarski okrug", code: "RS-15" },
      { name: "Zapadnobacki okrug", code: "RS-05" },
      { name: "Zlatiborski okrug", code: "RS-16" }
    ]
  },
  [countryCodes.RUSSIA.alphaTwo]: {
    subdivisions: [
      { name: "Adygeya, Respublika", code: "RU-AD" },
      { name: "Altay, Respublika", code: "RU-AL" },
      { name: "Altayskiy kray", code: "RU-ALT" },
      { name: "Amurskaya oblast'", code: "RU-AMU" },
      { name: "Arkhangel'skaya oblast'", code: "RU-ARK" },
      { name: "Astrakhanskaya oblast'", code: "RU-AST" },
      { name: "Bashkortostan, Respublika", code: "RU-BA" },
      { name: "Belgorodskaya oblast'", code: "RU-BEL" },
      { name: "Bryanskaya oblast'", code: "RU-BRY" },
      { name: "Buryatiya, Respublika", code: "RU-BU" },
      { name: "Chechenskaya Respublika", code: "RU-CE" },
      { name: "Chelyabinskaya oblast'", code: "RU-CHE" },
      { name: "Chukotskiy avtonomnyy okrug", code: "RU-CHU" },
      { name: "Chuvashskaya Respublika", code: "RU-CU" },
      { name: "Dagestan, Respublika", code: "RU-DA" },
      { name: "Ingushetiya, Respublika", code: "RU-IN" },
      { name: "Irkutskaya oblast'", code: "RU-IRK" },
      { name: "Ivanovskaya oblast'", code: "RU-IVA" },
      { name: "Kabardino-Balkarskaya Respublika", code: "RU-KB" },
      { name: "Kaliningradskaya oblast'", code: "RU-KGD" },
      { name: "Kalmykiya, Respublika", code: "RU-KL" },
      { name: "Kaluzhskaya oblast'", code: "RU-KLU" },
      { name: "Kamchatskiy kray", code: "RU-KAM" },
      { name: "Karachayevo-Cherkesskaya Respublika", code: "RU-KC" },
      { name: "Kareliya, Respublika", code: "RU-KR" },
      { name: "Kemerovskaya oblast'", code: "RU-KEM" },
      { name: "Khabarovskiy kray", code: "RU-KHA" },
      { name: "Khakasiya, Respublika", code: "RU-KK" },
      { name: "Khanty-Mansiyskiy avtonomnyy okrug", code: "RU-KHM" },
      { name: "Kirovskaya oblast'", code: "RU-KIR" },
      { name: "Komi, Respublika", code: "RU-KO" },
      { name: "Kostromskaya oblast'", code: "RU-KOS" },
      { name: "Krasnodarskiy kray", code: "RU-KDA" },
      { name: "Krasnoyarskiy kray", code: "RU-KYA" },
      { name: "Kurganskaya oblast'", code: "RU-KGN" },
      { name: "Kurskaya oblast'", code: "RU-KRS" },
      { name: "Leningradskaya oblast'", code: "RU-LEN" },
      { name: "Lipetskaya oblast'", code: "RU-LIP" },
      { name: "Magadanskaya oblast'", code: "RU-MAG" },
      { name: "Mariy El, Respublika", code: "RU-ME" },
      { name: "Mordoviya, Respublika", code: "RU-MO" },
      { name: "Moskovskaya oblast'", code: "RU-MOS" },
      { name: "Moskva", code: "RU-MOW" },
      { name: "Murmanskaya oblast'", code: "RU-MUR" },
      { name: "Nenetskiy avtonomnyy okrug", code: "RU-NEN" },
      { name: "Nizhegorodskaya oblast'", code: "RU-NIZ" },
      { name: "Novgorodskaya oblast'", code: "RU-NGR" },
      { name: "Novosibirskaya oblast'", code: "RU-NVS" },
      { name: "Omskaya oblast'", code: "RU-OMS" },
      { name: "Orenburgskaya oblast'", code: "RU-ORE" },
      { name: "Orlovskaya oblast'", code: "RU-ORL" },
      { name: "Penzenskaya oblast'", code: "RU-PNZ" },
      { name: "Permskiy kray", code: "RU-PER" },
      { name: "Primorskiy kray", code: "RU-PRI" },
      { name: "Pskovskaya oblast'", code: "RU-PSK" },
      { name: "Rostovskaya oblast'", code: "RU-ROS" },
      { name: "Ryazanskaya oblast'", code: "RU-RYA" },
      { name: "Saha, Respublika", code: "RU-SA" },
      { name: "Sakhalinskaya oblast'", code: "RU-SAK" },
      { name: "Samarskaya oblast'", code: "RU-SAM" },
      { name: "Sankt-Peterburg", code: "RU-SPE" },
      { name: "Saratovskaya oblast'", code: "RU-SAR" },
      { name: "Severnaya Osetiya, Respublika", code: "RU-SE" },
      { name: "Smolenskaya oblast'", code: "RU-SMO" },
      { name: "Stavropol'skiy kray", code: "RU-STA" },
      { name: "Sverdlovskaya oblast'", code: "RU-SVE" },
      { name: "Tambovskaya oblast'", code: "RU-TAM" },
      { name: "Tatarstan, Respublika", code: "RU-TA" },
      { name: "Tomskaya oblast'", code: "RU-TOM" },
      { name: "Tul'skaya oblast'", code: "RU-TUL" },
      { name: "Tverskaya oblast'", code: "RU-TVE" },
      { name: "Tyumenskaya oblast'", code: "RU-TYU" },
      { name: "Tyva, Respublika", code: "RU-TY" },
      { name: "Udmurtskaya Respublika", code: "RU-UD" },
      { name: "Ul'yanovskaya oblast'", code: "RU-ULY" },
      { name: "Vladimirskaya oblast'", code: "RU-VLA" },
      { name: "Volgogradskaya oblast'", code: "RU-VGG" },
      { name: "Vologodskaya oblast'", code: "RU-VLG" },
      { name: "Voronezhskaya oblast'", code: "RU-VOR" },
      { name: "Yamalo-Nenetskiy avtonomnyy okrug", code: "RU-YAN" },
      { name: "Yaroslavskaya oblast'", code: "RU-YAR" },
      { name: "Yevreyskaya avtonomnaya oblast'", code: "RU-YEV" },
      { name: "Zabaykal'skiy kray", code: "RU-ZAB" }
    ]
  },
  [countryCodes.RWANDA.alphaTwo]: {
    subdivisions: [
      { name: "Est", code: "RW-02" },
      { name: "Nord", code: "RW-03" },
      { name: "Ouest", code: "RW-04" },
      { name: "Sud", code: "RW-05" },
      { name: "Ville de Kigali", code: "RW-01" }
    ]
  },
  [countryCodes.SAUDI_ARABIA.alphaTwo]: {
    subdivisions: [
      { name: "Asir", code: "SA-14" },
      { name: "Al Bahah", code: "SA-11" },
      { name: "Al Hudud ash Shamaliyah", code: "SA-08" },
      { name: "Al Jawf", code: "SA-12" },
      { name: "Al Madinah al Munawwarah", code: "SA-03" },
      { name: "Al Qasim", code: "SA-05" },
      { name: "Ar Riyad", code: "SA-01" },
      { name: "Ash Sharqiyah", code: "SA-04" },
      { name: "Ha'il", code: "SA-06" },
      { name: "Jazan", code: "SA-09" },
      { name: "Makkah al Mukarramah", code: "SA-02" },
      { name: "Najran", code: "SA-10" },
      { name: "Tabuk", code: "SA-07" }
    ]
  },
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Choiseul", code: "SB-CH" },
      { name: "Guadalcanal", code: "SB-GU" },
      { name: "Makira-Ulawa", code: "SB-MK" },
      { name: "Malaita", code: "SB-ML" },
      { name: "Western", code: "SB-WE" }
    ]
  },
  [countryCodes.SEYCHELLES.alphaTwo]: {
    subdivisions: [
      { name: "Anse Boileau", code: "SC-02" },
      { name: "Anse Royale", code: "SC-05" },
      { name: "Anse aux Pins", code: "SC-01" },
      { name: "Baie Lazare", code: "SC-06" },
      { name: "Baie Sainte Anne", code: "SC-07" },
      { name: "Beau Vallon", code: "SC-08" },
      { name: "Bel Ombre", code: "SC-10" },
      { name: "Cascade", code: "SC-11" },
      { name: "English River", code: "SC-16" },
      { name: "Grand Anse Mahe", code: "SC-13" },
      { name: "Grand Anse Praslin", code: "SC-14" },
      { name: "La Digue", code: "SC-15" },
      { name: "Pointe Larue", code: "SC-20" },
      { name: "Takamaka", code: "SC-23" }
    ]
  },
  [countryCodes.SUDAN.alphaTwo]: {
    subdivisions: [
      { name: "Blue Nile", code: "SD-NB" },
      { name: "Central Darfur", code: "SD-DC" },
      { name: "Gedaref", code: "SD-GD" },
      { name: "Gezira", code: "SD-GZ" },
      { name: "Kassala", code: "SD-KA" },
      { name: "Khartoum", code: "SD-KH" },
      { name: "North Darfur", code: "SD-DN" },
      { name: "North Kordofan", code: "SD-KN" },
      { name: "Northern", code: "SD-NO" },
      { name: "Red Sea", code: "SD-RS" },
      { name: "River Nile", code: "SD-NR" },
      { name: "Sennar", code: "SD-SI" },
      { name: "South Darfur", code: "SD-DS" },
      { name: "South Kordofan", code: "SD-KS" },
      { name: "West Darfur", code: "SD-DW" },
      { name: "West Kordofan", code: "SD-GK" },
      { name: "White Nile", code: "SD-NW" }
    ]
  },
  [countryCodes.SWEDEN.alphaTwo]: {
    subdivisions: [
      { name: "Blekinge lan", code: "SE-K" },
      { name: "Dalarnas lan", code: "SE-W" },
      { name: "Gavleborgs lan", code: "SE-X" },
      { name: "Gotlands lan", code: "SE-I" },
      { name: "Hallands lan", code: "SE-N" },
      { name: "Jamtlands lan", code: "SE-Z" },
      { name: "Jonkopings lan", code: "SE-F" },
      { name: "Kalmar lan", code: "SE-H" },
      { name: "Kronobergs lan", code: "SE-G" },
      { name: "Norrbottens lan", code: "SE-BD" },
      { name: "Orebro lan", code: "SE-T" },
      { name: "Ostergotlands lan", code: "SE-E" },
      { name: "Skane lan", code: "SE-M" },
      { name: "Sodermanlands lan", code: "SE-D" },
      { name: "Stockholms lan", code: "SE-AB" },
      { name: "Uppsala lan", code: "SE-C" },
      { name: "Varmlands lan", code: "SE-S" },
      { name: "Vasterbottens lan", code: "SE-AC" },
      { name: "Vasternorrlands lan", code: "SE-Y" },
      { name: "Vastmanlands lan", code: "SE-U" },
      { name: "Vastra Gotalands lan", code: "SE-O" }
    ]
  },
  [countryCodes.SINGAPORE.alphaTwo]: { subdivisions: [{ name: "Singapore", code: "-" }] },
  [countryCodes.SAINT_HELENA.alphaTwo]: { subdivisions: [{ name: "Saint Helena", code: "SH-HL" }] },
  [countryCodes.SLOVENIA.alphaTwo]: {
    subdivisions: [
      { name: "Ajdovscina", code: "SI-001" },
      { name: "Ankaran", code: "SI-213" },
      { name: "Apace", code: "SI-195" },
      { name: "Beltinci", code: "SI-002" },
      { name: "Benedikt", code: "SI-148" },
      { name: "Bistrica ob Sotli", code: "SI-149" },
      { name: "Bled", code: "SI-003" },
      { name: "Bloke", code: "SI-150" },
      { name: "Bohinj", code: "SI-004" },
      { name: "Borovnica", code: "SI-005" },
      { name: "Bovec", code: "SI-006" },
      { name: "Braslovce", code: "SI-151" },
      { name: "Brda", code: "SI-007" },
      { name: "Brezice", code: "SI-009" },
      { name: "Brezovica", code: "SI-008" },
      { name: "Cankova", code: "SI-152" },
      { name: "Celje", code: "SI-011" },
      { name: "Cerklje na Gorenjskem", code: "SI-012" },
      { name: "Cerknica", code: "SI-013" },
      { name: "Cerkno", code: "SI-014" },
      { name: "Cirkulane", code: "SI-196" },
      { name: "Crensovci", code: "SI-015" },
      { name: "Crnomelj", code: "SI-017" },
      { name: "Destrnik", code: "SI-018" },
      { name: "Divaca", code: "SI-019" },
      { name: "Dobje", code: "SI-154" },
      { name: "Dobrepolje", code: "SI-020" },
      { name: "Dobrna", code: "SI-155" },
      { name: "Dobrova-Polhov Gradec", code: "SI-021" },
      { name: "Dobrovnik", code: "SI-156" },
      { name: "Domzale", code: "SI-023" },
      { name: "Dornava", code: "SI-024" },
      { name: "Dravograd", code: "SI-025" },
      { name: "Duplek", code: "SI-026" },
      { name: "Gorje", code: "SI-207" },
      { name: "Gornja Radgona", code: "SI-029" },
      { name: "Gornji Petrovci", code: "SI-031" },
      { name: "Grad", code: "SI-158" },
      { name: "Grosuplje", code: "SI-032" },
      { name: "Hajdina", code: "SI-159" },
      { name: "Hoce-Slivnica", code: "SI-160" },
      { name: "Hodos", code: "SI-161" },
      { name: "Horjul", code: "SI-162" },
      { name: "Hrastnik", code: "SI-034" },
      { name: "Hrpelje-Kozina", code: "SI-035" },
      { name: "Idrija", code: "SI-036" },
      { name: "Ig", code: "SI-037" },
      { name: "Ilirska Bistrica", code: "SI-038" },
      { name: "Ivancna Gorica", code: "SI-039" },
      { name: "Izola", code: "SI-040" },
      { name: "Jesenice", code: "SI-041" },
      { name: "Jursinci", code: "SI-042" },
      { name: "Kamnik", code: "SI-043" },
      { name: "Kanal ob Soci", code: "SI-044" },
      { name: "Kidricevo", code: "SI-045" },
      { name: "Kobarid", code: "SI-046" },
      { name: "Kobilje", code: "SI-047" },
      { name: "Kocevje", code: "SI-048" },
      { name: "Komen", code: "SI-049" },
      { name: "Komenda", code: "SI-164" },
      { name: "Koper", code: "SI-050" },
      { name: "Kosanjevica na Krki", code: "SI-197" },
      { name: "Kostel", code: "SI-165" },
      { name: "Kranj", code: "SI-052" },
      { name: "Kranjska Gora", code: "SI-053" },
      { name: "Krizevci", code: "SI-166" },
      { name: "Krsko", code: "SI-054" },
      { name: "Kungota", code: "SI-055" },
      { name: "Kuzma", code: "SI-056" },
      { name: "Lasko", code: "SI-057" },
      { name: "Lenart", code: "SI-058" },
      { name: "Lendava", code: "SI-059" },
      { name: "Litija", code: "SI-060" },
      { name: "Ljubljana", code: "SI-061" },
      { name: "Ljutomer", code: "SI-063" },
      { name: "Log-Dragomer", code: "SI-208" },
      { name: "Logatec", code: "SI-064" },
      { name: "Loska dolina", code: "SI-065" },
      { name: "Loski Potok", code: "SI-066" },
      { name: "Lovrenc na Pohorju", code: "SI-167" },
      { name: "Luce", code: "SI-067" },
      { name: "Lukovica", code: "SI-068" },
      { name: "Majsperk", code: "SI-069" },
      { name: "Makole", code: "SI-198" },
      { name: "Maribor", code: "SI-070" },
      { name: "Markovci", code: "SI-168" },
      { name: "Medvode", code: "SI-071" },
      { name: "Menges", code: "SI-072" },
      { name: "Metlika", code: "SI-073" },
      { name: "Mezica", code: "SI-074" },
      { name: "Miklavz na Dravskem polju", code: "SI-169" },
      { name: "Miren-Kostanjevica", code: "SI-075" },
      { name: "Mirna", code: "SI-212" },
      { name: "Mirna Pec", code: "SI-170" },
      { name: "Mislinja", code: "SI-076" },
      { name: "Mokronog-Trebelno", code: "SI-199" },
      { name: "Moravce", code: "SI-077" },
      { name: "Mozirje", code: "SI-079" },
      { name: "Murska Sobota", code: "SI-080" },
      { name: "Muta", code: "SI-081" },
      { name: "Naklo", code: "SI-082" },
      { name: "Nazarje", code: "SI-083" },
      { name: "Nova Gorica", code: "SI-084" },
      { name: "Novo Mesto", code: "SI-085" },
      { name: "Odranci", code: "SI-086" },
      { name: "Oplotnica", code: "SI-171" },
      { name: "Ormoz", code: "SI-087" },
      { name: "Piran", code: "SI-090" },
      { name: "Pivka", code: "SI-091" },
      { name: "Podcetrtek", code: "SI-092" },
      { name: "Podlehnik", code: "SI-172" },
      { name: "Poljcane", code: "SI-200" },
      { name: "Polzela", code: "SI-173" },
      { name: "Postojna", code: "SI-094" },
      { name: "Prebold", code: "SI-174" },
      { name: "Preddvor", code: "SI-095" },
      { name: "Prevalje", code: "SI-175" },
      { name: "Ptuj", code: "SI-096" },
      { name: "Puconci", code: "SI-097" },
      { name: "Race-Fram", code: "SI-098" },
      { name: "Radece", code: "SI-099" },
      { name: "Radenci", code: "SI-100" },
      { name: "Radlje ob Dravi", code: "SI-101" },
      { name: "Radovljica", code: "SI-102" },
      { name: "Ravne na Koroskem", code: "SI-103" },
      { name: "Razkrizje", code: "SI-176" },
      { name: "Recica ob Savinji", code: "SI-209" },
      { name: "Rence-Vogrsko", code: "SI-201" },
      { name: "Ribnica", code: "SI-104" },
      { name: "Rogaska Slatina", code: "SI-106" },
      { name: "Rogasovci", code: "SI-105" },
      { name: "Ruse", code: "SI-108" },
      { name: "Salovci", code: "SI-033" },
      { name: "Semic", code: "SI-109" },
      { name: "Sempeter-Vrtojba", code: "SI-183" },
      { name: "Sencur", code: "SI-117" },
      { name: "Sentilj", code: "SI-118" },
      { name: "Sentjernej", code: "SI-119" },
      { name: "Sentjur", code: "SI-120" },
      { name: "Sentrupert", code: "SI-211" },
      { name: "Sevnica", code: "SI-110" },
      { name: "Sezana", code: "SI-111" },
      { name: "Skocjan", code: "SI-121" },
      { name: "Skofja Loka", code: "SI-122" },
      { name: "Skofljica", code: "SI-123" },
      { name: "Slovenj Gradec", code: "SI-112" },
      { name: "Slovenska Bistrica", code: "SI-113" },
      { name: "Slovenske Konjice", code: "SI-114" },
      { name: "Smarje pri Jelsah", code: "SI-124" },
      { name: "Smarjeske Toplice", code: "SI-206" },
      { name: "Smartno ob Paki", code: "SI-125" },
      { name: "Smartno pri Litiji", code: "SI-194" },
      { name: "Sodrazica", code: "SI-179" },
      { name: "Solcava", code: "SI-180" },
      { name: "Sostanj", code: "SI-126" },
      { name: "Starse", code: "SI-115" },
      { name: "Store", code: "SI-127" },
      { name: "Straza", code: "SI-203" },
      { name: "Sveta Trojica v Slovenskih goricah", code: "SI-204" },
      { name: "Sveti Andraz v Slovenskih Goricah", code: "SI-182" },
      { name: "Sveti Jurij ob Scavnici", code: "SI-116" },
      { name: "Sveti Jurij v Slovenskih goricah", code: "SI-210" },
      { name: "Sveti Tomaz", code: "SI-205" },
      { name: "Tabor", code: "SI-184" },
      { name: "Tisina", code: "SI-010" },
      { name: "Tolmin", code: "SI-128" },
      { name: "Trbovlje", code: "SI-129" },
      { name: "Trebnje", code: "SI-130" },
      { name: "Trnovska Vas", code: "SI-185" },
      { name: "Trzic", code: "SI-131" },
      { name: "Trzin", code: "SI-186" },
      { name: "Turnisce", code: "SI-132" },
      { name: "Velenje", code: "SI-133" },
      { name: "Velika Polana", code: "SI-187" },
      { name: "Velike Lasce", code: "SI-134" },
      { name: "Verzej", code: "SI-188" },
      { name: "Videm", code: "SI-135" },
      { name: "Vipava", code: "SI-136" },
      { name: "Vitanje", code: "SI-137" },
      { name: "Vodice", code: "SI-138" },
      { name: "Vojnik", code: "SI-139" },
      { name: "Vransko", code: "SI-189" },
      { name: "Vrhnika", code: "SI-140" },
      { name: "Vuzenica", code: "SI-141" },
      { name: "Zagorje ob Savi", code: "SI-142" },
      { name: "Zalec", code: "SI-190" },
      { name: "Zavrc", code: "SI-143" },
      { name: "Zelezniki", code: "SI-146" },
      { name: "Zetale", code: "SI-191" },
      { name: "Ziri", code: "SI-147" },
      { name: "Zrece", code: "SI-144" },
      { name: "Zuzemberk", code: "SI-193" }
    ]
  },
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: {
    subdivisions: [{ name: "Svalbard and Jan Mayen", code: "-" }]
  },
  [countryCodes.SLOVAKIA.alphaTwo]: {
    subdivisions: [
      { name: "Banskobystricky kraj", code: "SK-BC" },
      { name: "Bratislavsky kraj", code: "SK-BL" },
      { name: "Kosicky kraj", code: "SK-KI" },
      { name: "Nitriansky kraj", code: "SK-NI" },
      { name: "Presovsky kraj", code: "SK-PV" },
      { name: "Trenciansky kraj", code: "SK-TC" },
      { name: "Trnavsky kraj", code: "SK-TA" },
      { name: "Zilinsky kraj", code: "SK-ZI" }
    ]
  },
  [countryCodes.SIERRA_LEONE.alphaTwo]: {
    subdivisions: [
      { name: "Eastern", code: "SL-E" },
      { name: "North Western", code: "SL-NW" },
      { name: "Northern", code: "SL-N" },
      { name: "Southern", code: "SL-S" },
      { name: "Western Area", code: "SL-W" }
    ]
  },
  [countryCodes.SAN_MARINO.alphaTwo]: {
    subdivisions: [
      { name: "Borgo Maggiore", code: "SM-06" },
      { name: "Chiesanuova", code: "SM-02" },
      { name: "Citta di San Marino", code: "SM-07" },
      { name: "Faetano", code: "SM-04" },
      { name: "Serravalle", code: "SM-09" }
    ]
  },
  [countryCodes.SENEGAL.alphaTwo]: {
    subdivisions: [
      { name: "Dakar", code: "SN-DK" },
      { name: "Diourbel", code: "SN-DB" },
      { name: "Fatick", code: "SN-FK" },
      { name: "Kaffrine", code: "SN-KA" },
      { name: "Kaolack", code: "SN-KL" },
      { name: "Kedougou", code: "SN-KE" },
      { name: "Kolda", code: "SN-KD" },
      { name: "Louga", code: "SN-LG" },
      { name: "Matam", code: "SN-MT" },
      { name: "Saint-Louis", code: "SN-SL" },
      { name: "Tambacounda", code: "SN-TC" },
      { name: "Thies", code: "SN-TH" },
      { name: "Ziguinchor", code: "SN-ZG" }
    ]
  },
  [countryCodes.SOMALIA.alphaTwo]: {
    subdivisions: [
      { name: "Awdal", code: "SO-AW" },
      { name: "Banaadir", code: "SO-BN" },
      { name: "Bari", code: "SO-BR" },
      { name: "Bay", code: "SO-BY" },
      { name: "Galguduud", code: "SO-GA" },
      { name: "Hiiraan", code: "SO-HI" },
      { name: "Jubbada Hoose", code: "SO-JH" },
      { name: "Mudug", code: "SO-MU" },
      { name: "Nugaal", code: "SO-NU" },
      { name: "Sanaag", code: "SO-SA" },
      { name: "Shabeellaha Dhexe", code: "SO-SD" },
      { name: "Shabeellaha Hoose", code: "SO-SH" },
      { name: "Sool", code: "SO-SO" },
      { name: "Togdheer", code: "SO-TO" },
      { name: "Woqooyi Galbeed", code: "SO-WO" }
    ]
  },
  [countryCodes.SURINAME.alphaTwo]: {
    subdivisions: [
      { name: "Brokopondo", code: "SR-BR" },
      { name: "Commewijne", code: "SR-CM" },
      { name: "Coronie", code: "SR-CR" },
      { name: "Nickerie", code: "SR-NI" },
      { name: "Para", code: "SR-PR" },
      { name: "Paramaribo", code: "SR-PM" },
      { name: "Saramacca", code: "SR-SA" },
      { name: "Sipaliwini", code: "SR-SI" },
      { name: "Wanica", code: "SR-WA" }
    ]
  },
  [countryCodes.SOUTH_SUDAN.alphaTwo]: {
    subdivisions: [
      { name: "Central Equatoria", code: "SS-EC" },
      { name: "Eastern Equatoria", code: "SS-EE" },
      { name: "Jonglei", code: "SS-JG" },
      { name: "Lakes", code: "SS-LK" },
      { name: "Northern Bahr el Ghazal", code: "SS-BN" },
      { name: "Unity", code: "SS-UY" },
      { name: "Upper Nile", code: "SS-NU" },
      { name: "Warrap", code: "SS-WR" },
      { name: "Western Equatoria", code: "SS-EW" }
    ]
  },
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: {
    subdivisions: [
      { name: "Agua Grande", code: "ST-01" },
      { name: "Principe", code: "ST-P" }
    ]
  },
  [countryCodes.EL_SALVADOR.alphaTwo]: {
    subdivisions: [
      { name: "Ahuachapan", code: "SV-AH" },
      { name: "Cabanas", code: "SV-CA" },
      { name: "Chalatenango", code: "SV-CH" },
      { name: "Cuscatlan", code: "SV-CU" },
      { name: "La Libertad", code: "SV-LI" },
      { name: "La Paz", code: "SV-PA" },
      { name: "La Union", code: "SV-UN" },
      { name: "Morazan", code: "SV-MO" },
      { name: "San Miguel", code: "SV-SM" },
      { name: "San Salvador", code: "SV-SS" },
      { name: "San Vicente", code: "SV-SV" },
      { name: "Santa Ana", code: "SV-SA" },
      { name: "Sonsonate", code: "SV-SO" },
      { name: "Usulutan", code: "SV-US" }
    ]
  },
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: {
    subdivisions: [{ name: "Sint Maarten (Dutch Part)", code: "-" }]
  },
  [countryCodes.SYRIA.alphaTwo]: {
    subdivisions: [
      { name: "Al Hasakah", code: "SY-HA" },
      { name: "Al Ladhiqiyah", code: "SY-LA" },
      { name: "Al Qunaytirah", code: "SY-QU" },
      { name: "As Suwayda'", code: "SY-SU" },
      { name: "Dar'a", code: "SY-DR" },
      { name: "Dayr az Zawr", code: "SY-DY" },
      { name: "Dimashq", code: "SY-DI" },
      { name: "Halab", code: "SY-HL" },
      { name: "Hamah", code: "SY-HM" },
      { name: "Hims", code: "SY-HI" },
      { name: "Idlib", code: "SY-ID" },
      { name: "Rif Dimashq", code: "SY-RD" },
      { name: "Tartus", code: "SY-TA" }
    ]
  },
  [countryCodes.SWAZILAND.alphaTwo]: {
    subdivisions: [
      { name: "Hhohho", code: "SZ-HH" },
      { name: "Lubombo", code: "SZ-LU" },
      { name: "Manzini", code: "SZ-MA" },
      { name: "Shiselweni", code: "SZ-SH" }
    ]
  },
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Turks and Caicos Islands", code: "-" }]
  },
  [countryCodes.CHAD.alphaTwo]: {
    subdivisions: [
      { name: "Bahr el Ghazal", code: "TD-BG" },
      { name: "Borkou", code: "TD-BO" },
      { name: "Chari-Baguirmi", code: "TD-CB" },
      { name: "Guera", code: "TD-GR" },
      { name: "Lac", code: "TD-LC" },
      { name: "Logone-Occidental", code: "TD-LO" },
      { name: "Ouaddai", code: "TD-OD" },
      { name: "Sila", code: "TD-SI" },
      { name: "Ville de Ndjamena", code: "TD-ND" },
      { name: "Wadi Fira", code: "TD-WF" }
    ]
  },
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: {
    subdivisions: [{ name: "French Southern Territories", code: "-" }]
  },
  [countryCodes.TOGO.alphaTwo]: {
    subdivisions: [
      { name: "Centrale", code: "TG-C" },
      { name: "Kara", code: "TG-K" },
      { name: "Maritime", code: "TG-M" },
      { name: "Plateaux", code: "TG-P" },
      { name: "Savanes", code: "TG-S" }
    ]
  },
  [countryCodes.THAILAND.alphaTwo]: {
    subdivisions: [
      { name: "Amnat Charoen", code: "TH-37" },
      { name: "Ang Thong", code: "TH-15" },
      { name: "Bueng Kan", code: "TH-38" },
      { name: "Buri Ram", code: "TH-31" },
      { name: "Chachoengsao", code: "TH-24" },
      { name: "Chai Nat", code: "TH-18" },
      { name: "Chaiyaphum", code: "TH-36" },
      { name: "Chanthaburi", code: "TH-22" },
      { name: "Chiang Mai", code: "TH-50" },
      { name: "Chiang Rai", code: "TH-57" },
      { name: "Chon Buri", code: "TH-20" },
      { name: "Chumphon", code: "TH-86" },
      { name: "Kalasin", code: "TH-46" },
      { name: "Kamphaeng Phet", code: "TH-62" },
      { name: "Kanchanaburi", code: "TH-71" },
      { name: "Khon Kaen", code: "TH-40" },
      { name: "Krabi", code: "TH-81" },
      { name: "Krung Thep Maha Nakhon", code: "TH-10" },
      { name: "Lampang", code: "TH-52" },
      { name: "Lamphun", code: "TH-51" },
      { name: "Loei", code: "TH-42" },
      { name: "Lop Buri", code: "TH-16" },
      { name: "Mae Hong Son", code: "TH-58" },
      { name: "Maha Sarakham", code: "TH-44" },
      { name: "Mukdahan", code: "TH-49" },
      { name: "Nakhon Nayok", code: "TH-26" },
      { name: "Nakhon Pathom", code: "TH-73" },
      { name: "Nakhon Phanom", code: "TH-48" },
      { name: "Nakhon Ratchasima", code: "TH-30" },
      { name: "Nakhon Sawan", code: "TH-60" },
      { name: "Nakhon Si Thammarat", code: "TH-80" },
      { name: "Nan", code: "TH-55" },
      { name: "Narathiwat", code: "TH-96" },
      { name: "Nong Bua Lam Phu", code: "TH-39" },
      { name: "Nong Khai", code: "TH-43" },
      { name: "Nonthaburi", code: "TH-12" },
      { name: "Pathum Thani", code: "TH-13" },
      { name: "Pattani", code: "TH-94" },
      { name: "Phangnga", code: "TH-82" },
      { name: "Phatthalung", code: "TH-93" },
      { name: "Phayao", code: "TH-56" },
      { name: "Phetchabun", code: "TH-67" },
      { name: "Phetchaburi", code: "TH-76" },
      { name: "Phichit", code: "TH-66" },
      { name: "Phitsanulok", code: "TH-65" },
      { name: "Phra Nakhon Si Ayutthaya", code: "TH-14" },
      { name: "Phrae", code: "TH-54" },
      { name: "Phuket", code: "TH-83" },
      { name: "Prachin Buri", code: "TH-25" },
      { name: "Prachuap Khiri Khan", code: "TH-77" },
      { name: "Ranong", code: "TH-85" },
      { name: "Ratchaburi", code: "TH-70" },
      { name: "Rayong", code: "TH-21" },
      { name: "Roi Et", code: "TH-45" },
      { name: "Sa Kaeo", code: "TH-27" },
      { name: "Sakon Nakhon", code: "TH-47" },
      { name: "Samut Prakan", code: "TH-11" },
      { name: "Samut Sakhon", code: "TH-74" },
      { name: "Samut Songkhram", code: "TH-75" },
      { name: "Saraburi", code: "TH-19" },
      { name: "Satun", code: "TH-91" },
      { name: "Si Sa Ket", code: "TH-33" },
      { name: "Sing Buri", code: "TH-17" },
      { name: "Songkhla", code: "TH-90" },
      { name: "Sukhothai", code: "TH-64" },
      { name: "Suphan Buri", code: "TH-72" },
      { name: "Surat Thani", code: "TH-84" },
      { name: "Surin", code: "TH-32" },
      { name: "Tak", code: "TH-63" },
      { name: "Trang", code: "TH-92" },
      { name: "Trat", code: "TH-23" },
      { name: "Ubon Ratchathani", code: "TH-34" },
      { name: "Udon Thani", code: "TH-41" },
      { name: "Uthai Thani", code: "TH-61" },
      { name: "Uttaradit", code: "TH-53" },
      { name: "Yala", code: "TH-95" },
      { name: "Yasothon", code: "TH-35" }
    ]
  },
  [countryCodes.TAJIKISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Dushanbe", code: "TJ-DU" },
      { name: "Khatlon", code: "TJ-KT" },
      { name: "Kuhistoni Badakhshon", code: "TJ-GB" },
      { name: "Nohiyahoi Tobei Jumhuri", code: "TJ-RA" },
      { name: "Sughd", code: "TJ-SU" }
    ]
  },
  [countryCodes.TOKELAU.alphaTwo]: { subdivisions: [{ name: "Tokelau", code: "-" }] },
  [countryCodes.TIMOR_LESTE.alphaTwo]: {
    subdivisions: [
      { name: "Aileu", code: "TL-AL" },
      { name: "Ainaro", code: "TL-AN" },
      { name: "Baucau", code: "TL-BA" },
      { name: "Bobonaro", code: "TL-BO" },
      { name: "Cova Lima", code: "TL-CO" },
      { name: "Dili", code: "TL-DI" },
      { name: "Liquica", code: "TL-LI" },
      { name: "Manufahi", code: "TL-MF" },
      { name: "Oecussi", code: "TL-OE" }
    ]
  },
  [countryCodes.TURKMENISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Ahal", code: "TM-A" },
      { name: "Balkan", code: "TM-B" },
      { name: "Dasoguz", code: "TM-D" },
      { name: "Lebap", code: "TM-L" },
      { name: "Mary", code: "TM-M" }
    ]
  },
  [countryCodes.TUNISIA.alphaTwo]: {
    subdivisions: [
      { name: "Beja", code: "TN-31" },
      { name: "Ben Arous", code: "TN-13" },
      { name: "Bizerte", code: "TN-23" },
      { name: "Gabes", code: "TN-81" },
      { name: "Gafsa", code: "TN-71" },
      { name: "Jendouba", code: "TN-32" },
      { name: "Kairouan", code: "TN-41" },
      { name: "Kasserine", code: "TN-42" },
      { name: "Kebili", code: "TN-73" },
      { name: "L'Ariana", code: "TN-12" },
      { name: "La Manouba", code: "TN-14" },
      { name: "Le Kef", code: "TN-33" },
      { name: "Mahdia", code: "TN-53" },
      { name: "Medenine", code: "TN-82" },
      { name: "Monastir", code: "TN-52" },
      { name: "Nabeul", code: "TN-21" },
      { name: "Sfax", code: "TN-61" },
      { name: "Sidi Bouzid", code: "TN-43" },
      { name: "Siliana", code: "TN-34" },
      { name: "Sousse", code: "TN-51" },
      { name: "Tataouine", code: "TN-83" },
      { name: "Tozeur", code: "TN-72" },
      { name: "Tunis", code: "TN-11" },
      { name: "Zaghouan", code: "TN-22" }
    ]
  },
  [countryCodes.TONGA.alphaTwo]: {
    subdivisions: [
      { name: "Eua", code: "TO-01" },
      { name: "Ha'apai", code: "TO-02" },
      { name: "Niuas", code: "TO-03" },
      { name: "Tongatapu", code: "TO-04" },
      { name: "Vava'u", code: "TO-05" }
    ]
  },
  [countryCodes.TURKEY.alphaTwo]: {
    subdivisions: [
      { name: "Adana", code: "TR-01" },
      { name: "Adiyaman", code: "TR-02" },
      { name: "Afyonkarahisar", code: "TR-03" },
      { name: "Agri", code: "TR-04" },
      { name: "Aksaray", code: "TR-68" },
      { name: "Amasya", code: "TR-05" },
      { name: "Ankara", code: "TR-06" },
      { name: "Antalya", code: "TR-07" },
      { name: "Ardahan", code: "TR-75" },
      { name: "Artvin", code: "TR-08" },
      { name: "Aydin", code: "TR-09" },
      { name: "Balikesir", code: "TR-10" },
      { name: "Bartin", code: "TR-74" },
      { name: "Batman", code: "TR-72" },
      { name: "Bayburt", code: "TR-69" },
      { name: "Bilecik", code: "TR-11" },
      { name: "Bingol", code: "TR-12" },
      { name: "Bitlis", code: "TR-13" },
      { name: "Bolu", code: "TR-14" },
      { name: "Burdur", code: "TR-15" },
      { name: "Bursa", code: "TR-16" },
      { name: "Canakkale", code: "TR-17" },
      { name: "Cankiri", code: "TR-18" },
      { name: "Corum", code: "TR-19" },
      { name: "Denizli", code: "TR-20" },
      { name: "Diyarbakir", code: "TR-21" },
      { name: "Duzce", code: "TR-81" },
      { name: "Edirne", code: "TR-22" },
      { name: "Elazig", code: "TR-23" },
      { name: "Erzincan", code: "TR-24" },
      { name: "Erzurum", code: "TR-25" },
      { name: "Eskisehir", code: "TR-26" },
      { name: "Gaziantep", code: "TR-27" },
      { name: "Giresun", code: "TR-28" },
      { name: "Gumushane", code: "TR-29" },
      { name: "Hakkari", code: "TR-30" },
      { name: "Hatay", code: "TR-31" },
      { name: "Igdir", code: "TR-76" },
      { name: "Isparta", code: "TR-32" },
      { name: "Istanbul", code: "TR-34" },
      { name: "Izmir", code: "TR-35" },
      { name: "Kahramanmaras", code: "TR-46" },
      { name: "Karabuk", code: "TR-78" },
      { name: "Karaman", code: "TR-70" },
      { name: "Kars", code: "TR-36" },
      { name: "Kastamonu", code: "TR-37" },
      { name: "Kayseri", code: "TR-38" },
      { name: "Kilis", code: "TR-79" },
      { name: "Kirikkale", code: "TR-71" },
      { name: "Kirklareli", code: "TR-39" },
      { name: "Kirsehir", code: "TR-40" },
      { name: "Kocaeli", code: "TR-41" },
      { name: "Konya", code: "TR-42" },
      { name: "Kutahya", code: "TR-43" },
      { name: "Malatya", code: "TR-44" },
      { name: "Manisa", code: "TR-45" },
      { name: "Mardin", code: "TR-47" },
      { name: "Mersin", code: "TR-33" },
      { name: "Mugla", code: "TR-48" },
      { name: "Mus", code: "TR-49" },
      { name: "Nevsehir", code: "TR-50" },
      { name: "Nigde", code: "TR-51" },
      { name: "Ordu", code: "TR-52" },
      { name: "Osmaniye", code: "TR-80" },
      { name: "Rize", code: "TR-53" },
      { name: "Sakarya", code: "TR-54" },
      { name: "Samsun", code: "TR-55" },
      { name: "Sanliurfa", code: "TR-63" },
      { name: "Siirt", code: "TR-56" },
      { name: "Sinop", code: "TR-57" },
      { name: "Sirnak", code: "TR-73" },
      { name: "Sivas", code: "TR-58" },
      { name: "Tekirdag", code: "TR-59" },
      { name: "Tokat", code: "TR-60" },
      { name: "Trabzon", code: "TR-61" },
      { name: "Tunceli", code: "TR-62" },
      { name: "Usak", code: "TR-64" },
      { name: "Van", code: "TR-65" },
      { name: "Yalova", code: "TR-77" },
      { name: "Yozgat", code: "TR-66" },
      { name: "Zonguldak", code: "TR-67" }
    ]
  },
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: {
    subdivisions: [
      { name: "Arima", code: "TT-ARI" },
      { name: "Chaguanas", code: "TT-CHA" },
      { name: "Couva-Tabaquite-Talparo", code: "TT-CTT" },
      { name: "Diego Martin", code: "TT-DMN" },
      { name: "Mayaro-Rio Claro", code: "TT-MRC" },
      { name: "Penal-Debe", code: "TT-PED" },
      { name: "Point Fortin", code: "TT-PTF" },
      { name: "Port of Spain", code: "TT-POS" },
      { name: "Princes Town", code: "TT-PRT" },
      { name: "San Fernando", code: "TT-SFO" },
      { name: "San Juan-Laventille", code: "TT-SJL" },
      { name: "Sangre Grande", code: "TT-SGE" },
      { name: "Siparia", code: "TT-SIP" },
      { name: "Tobago", code: "TT-TOB" },
      { name: "Tunapuna-Piarco", code: "TT-TUP" }
    ]
  },
  [countryCodes.TUVALU.alphaTwo]: { subdivisions: [{ name: "Funafuti", code: "TV-FUN" }] },
  [countryCodes.TAIWAN.alphaTwo]: {
    subdivisions: [
      { name: "Changhua", code: "TW-CHA" },
      { name: "Chiayi", code: "TW-CYQ" },
      { name: "Hsinchu", code: "TW-HSQ" },
      { name: "Hualien", code: "TW-HUA" },
      { name: "Kaohsiung", code: "TW-KHH" },
      { name: "Keelung", code: "TW-KEE" },
      { name: "Kinmen", code: "TW-KIN" },
      { name: "Lienchiang", code: "TW-LIE" },
      { name: "Miaoli", code: "TW-MIA" },
      { name: "Nantou", code: "TW-NAN" },
      { name: "New Taipei", code: "TW-NWT" },
      { name: "Penghu", code: "TW-PEN" },
      { name: "Pingtung", code: "TW-PIF" },
      { name: "Taichung", code: "TW-TXG" },
      { name: "Tainan", code: "TW-TNN" },
      { name: "Taipei", code: "TW-TPE" },
      { name: "Taitung", code: "TW-TTT" },
      { name: "Taoyuan", code: "TW-TAO" },
      { name: "Yilan", code: "TW-ILA" },
      { name: "Yunlin", code: "TW-YUN" }
    ]
  },
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Arusha", code: "TZ-01" },
      { name: "Dar es Salaam", code: "TZ-02" },
      { name: "Dodoma", code: "TZ-03" },
      { name: "Geita", code: "TZ-27" },
      { name: "Iringa", code: "TZ-04" },
      { name: "Kagera", code: "TZ-05" },
      { name: "Kaskazini Unguja", code: "TZ-07" },
      { name: "Katavi", code: "TZ-28" },
      { name: "Kigoma", code: "TZ-08" },
      { name: "Kilimanjaro", code: "TZ-09" },
      { name: "Kusini Pemba", code: "TZ-10" },
      { name: "Kusini Unguja", code: "TZ-11" },
      { name: "Lindi", code: "TZ-12" },
      { name: "Manyara", code: "TZ-26" },
      { name: "Mara", code: "TZ-13" },
      { name: "Mbeya", code: "TZ-14" },
      { name: "Mjini Magharibi", code: "TZ-15" },
      { name: "Morogoro", code: "TZ-16" },
      { name: "Mtwara", code: "TZ-17" },
      { name: "Mwanza", code: "TZ-18" },
      { name: "Njombe", code: "TZ-29" },
      { name: "Pwani", code: "TZ-19" },
      { name: "Rukwa", code: "TZ-20" },
      { name: "Ruvuma", code: "TZ-21" },
      { name: "Shinyanga", code: "TZ-22" },
      { name: "Simiyu", code: "TZ-30" },
      { name: "Singida", code: "TZ-23" },
      { name: "Songwe", code: "TZ-31" },
      { name: "Tabora", code: "TZ-24" },
      { name: "Tanga", code: "TZ-25" }
    ]
  },
  [countryCodes.UKRAINE.alphaTwo]: {
    subdivisions: [
      { name: "Avtonomna Respublika Krym", code: "UA-43" },
      { name: "Cherkaska oblast", code: "UA-71" },
      { name: "Chernihivska oblast", code: "UA-74" },
      { name: "Chernivetska oblast", code: "UA-77" },
      { name: "Dnipropetrovska oblast", code: "UA-12" },
      { name: "Donetska oblast", code: "UA-14" },
      { name: "Ivano-Frankivska oblast", code: "UA-26" },
      { name: "Kharkivska oblast", code: "UA-63" },
      { name: "Khersonska oblast", code: "UA-65" },
      { name: "Khmelnytska oblast", code: "UA-68" },
      { name: "Kirovohradska oblast", code: "UA-35" },
      { name: "Kyiv", code: "UA-30" },
      { name: "Kyivska oblast", code: "UA-32" },
      { name: "Luhanska oblast", code: "UA-09" },
      { name: "Lvivska oblast", code: "UA-46" },
      { name: "Mykolaivska oblast", code: "UA-48" },
      { name: "Odeska oblast", code: "UA-51" },
      { name: "Poltavska oblast", code: "UA-53" },
      { name: "Rivnenska oblast", code: "UA-56" },
      { name: "Sevastopol", code: "UA-40" },
      { name: "Sumska oblast", code: "UA-59" },
      { name: "Ternopilska oblast", code: "UA-61" },
      { name: "Vinnytska oblast", code: "UA-05" },
      { name: "Volynska oblast", code: "UA-07" },
      { name: "Zakarpatska oblast", code: "UA-21" },
      { name: "Zaporizka oblast", code: "UA-23" },
      { name: "Zhytomyrska oblast", code: "UA-18" }
    ]
  },
  [countryCodes.UGANDA.alphaTwo]: {
    subdivisions: [
      { name: "Abim", code: "UG-314" },
      { name: "Agago", code: "UG-322" },
      { name: "Amuria", code: "UG-216" },
      { name: "Apac", code: "UG-302" },
      { name: "Arua", code: "UG-303" },
      { name: "Budaka", code: "UG-217" },
      { name: "Bududa", code: "UG-218" },
      { name: "Bugiri", code: "UG-201" },
      { name: "Buhweju", code: "UG-420" },
      { name: "Buikwe", code: "UG-117" },
      { name: "Bukedea", code: "UG-219" },
      { name: "Bukomansibi", code: "UG-118" },
      { name: "Bulambuli", code: "UG-225" },
      { name: "Buliisa", code: "UG-416" },
      { name: "Bundibugyo", code: "UG-401" },
      { name: "Bushenyi", code: "UG-402" },
      { name: "Busia", code: "UG-202" },
      { name: "Butaleja", code: "UG-221" },
      { name: "Buvuma", code: "UG-120" },
      { name: "Buyende", code: "UG-226" },
      { name: "Dokolo", code: "UG-317" },
      { name: "Gomba", code: "UG-121" },
      { name: "Gulu", code: "UG-304" },
      { name: "Hoima", code: "UG-403" },
      { name: "Ibanda", code: "UG-417" },
      { name: "Iganga", code: "UG-203" },
      { name: "Isingiro", code: "UG-418" },
      { name: "Jinja", code: "UG-204" },
      { name: "Kaabong", code: "UG-318" },
      { name: "Kabale", code: "UG-404" },
      { name: "Kabarole", code: "UG-405" },
      { name: "Kalangala", code: "UG-101" },
      { name: "Kaliro", code: "UG-222" },
      { name: "Kalungu", code: "UG-122" },
      { name: "Kampala", code: "UG-102" },
      { name: "Kamuli", code: "UG-205" },
      { name: "Kamwenge", code: "UG-413" },
      { name: "Kanungu", code: "UG-414" },
      { name: "Kapchorwa", code: "UG-206" },
      { name: "Kasese", code: "UG-406" },
      { name: "Kayunga", code: "UG-112" },
      { name: "Kibaale", code: "UG-407" },
      { name: "Kiboga", code: "UG-103" },
      { name: "Kiruhura", code: "UG-419" },
      { name: "Kiryandongo", code: "UG-421" },
      { name: "Kisoro", code: "UG-408" },
      { name: "Kitgum", code: "UG-305" },
      { name: "Koboko", code: "UG-319" },
      { name: "Kole", code: "UG-325" },
      { name: "Kumi", code: "UG-208" },
      { name: "Kween", code: "UG-228" },
      { name: "Kyankwanzi", code: "UG-123" },
      { name: "Kyegegwa", code: "UG-422" },
      { name: "Kyenjojo", code: "UG-415" },
      { name: "Lamwo", code: "UG-326" },
      { name: "Lira", code: "UG-307" },
      { name: "Luuka", code: "UG-229" },
      { name: "Luwero", code: "UG-104" },
      { name: "Lwengo", code: "UG-124" },
      { name: "Lyantonde", code: "UG-114" },
      { name: "Maracha", code: "UG-320" },
      { name: "Masaka", code: "UG-105" },
      { name: "Masindi", code: "UG-409" },
      { name: "Mayuge", code: "UG-214" },
      { name: "Mbale", code: "UG-209" },
      { name: "Mbarara", code: "UG-410" },
      { name: "Mitooma", code: "UG-423" },
      { name: "Mityana", code: "UG-115" },
      { name: "Moroto", code: "UG-308" },
      { name: "Moyo", code: "UG-309" },
      { name: "Mpigi", code: "UG-106" },
      { name: "Mubende", code: "UG-107" },
      { name: "Mukono", code: "UG-108" },
      { name: "Nakapiripirit", code: "UG-311" },
      { name: "Nakaseke", code: "UG-116" },
      { name: "Nakasongola", code: "UG-109" },
      { name: "Namutumba", code: "UG-224" },
      { name: "Napak", code: "UG-327" },
      { name: "Nebbi", code: "UG-310" },
      { name: "Ntoroko", code: "UG-424" },
      { name: "Ntungamo", code: "UG-411" },
      { name: "Nwoya", code: "UG-328" },
      { name: "Oyam", code: "UG-321" },
      { name: "Pader", code: "UG-312" },
      { name: "Pallisa", code: "UG-210" },
      { name: "Rakai", code: "UG-110" },
      { name: "Rubirizi", code: "UG-425" },
      { name: "Rukungiri", code: "UG-412" },
      { name: "Sembabule", code: "UG-111" },
      { name: "Sheema", code: "UG-426" },
      { name: "Sironko", code: "UG-215" },
      { name: "Soroti", code: "UG-211" },
      { name: "Tororo", code: "UG-212" },
      { name: "Wakiso", code: "UG-113" },
      { name: "Yumbe", code: "UG-313" },
      { name: "Zombo", code: "UG-330" }
    ]
  },
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Palmyra Atoll", code: "UM-95" }]
  },
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: {
    subdivisions: [
      { name: "Alabama", code: "US-AL" },
      { name: "Alaska", code: "US-AK" },
      { name: "Arizona", code: "US-AZ" },
      { name: "Arkansas", code: "US-AR" },
      { name: "California", code: "US-CA" },
      { name: "Colorado", code: "US-CO" },
      { name: "Connecticut", code: "US-CT" },
      { name: "Delaware", code: "US-DE" },
      { name: "District of Columbia", code: "US-DC" },
      { name: "Florida", code: "US-FL" },
      { name: "Georgia", code: "US-GA" },
      { name: "Hawaii", code: "US-HI" },
      { name: "Idaho", code: "US-ID" },
      { name: "Illinois", code: "US-IL" },
      { name: "Indiana", code: "US-IN" },
      { name: "Iowa", code: "US-IA" },
      { name: "Kansas", code: "US-KS" },
      { name: "Kentucky", code: "US-KY" },
      { name: "Louisiana", code: "US-LA" },
      { name: "Maine", code: "US-ME" },
      { name: "Maryland", code: "US-MD" },
      { name: "Massachusetts", code: "US-MA" },
      { name: "Michigan", code: "US-MI" },
      { name: "Minnesota", code: "US-MN" },
      { name: "Mississippi", code: "US-MS" },
      { name: "Missouri", code: "US-MO" },
      { name: "Montana", code: "US-MT" },
      { name: "Nebraska", code: "US-NE" },
      { name: "Nevada", code: "US-NV" },
      { name: "New Hampshire", code: "US-NH" },
      { name: "New Jersey", code: "US-NJ" },
      { name: "New Mexico", code: "US-NM" },
      { name: "New York", code: "US-NY" },
      { name: "North Carolina", code: "US-NC" },
      { name: "North Dakota", code: "US-ND" },
      { name: "Ohio", code: "US-OH" },
      { name: "Oklahoma", code: "US-OK" },
      { name: "Oregon", code: "US-OR" },
      { name: "Pennsylvania", code: "US-PA" },
      { name: "Rhode Island", code: "US-RI" },
      { name: "South Carolina", code: "US-SC" },
      { name: "South Dakota", code: "US-SD" },
      { name: "Tennessee", code: "US-TN" },
      { name: "Texas", code: "US-TX" },
      { name: "Utah", code: "US-UT" },
      { name: "Vermont", code: "US-VT" },
      { name: "Virginia", code: "US-VA" },
      { name: "Washington", code: "US-WA" },
      { name: "West Virginia", code: "US-WV" },
      { name: "Wisconsin", code: "US-WI" },
      { name: "Wyoming", code: "US-WY" }
    ]
  },
  [countryCodes.URUGUAY.alphaTwo]: {
    subdivisions: [
      { name: "Artigas", code: "UY-AR" },
      { name: "Canelones", code: "UY-CA" },
      { name: "Cerro Largo", code: "UY-CL" },
      { name: "Colonia", code: "UY-CO" },
      { name: "Durazno", code: "UY-DU" },
      { name: "Flores", code: "UY-FS" },
      { name: "Florida", code: "UY-FD" },
      { name: "Lavalleja", code: "UY-LA" },
      { name: "Maldonado", code: "UY-MA" },
      { name: "Montevideo", code: "UY-MO" },
      { name: "Paysandu", code: "UY-PA" },
      { name: "Rio Negro", code: "UY-RN" },
      { name: "Rivera", code: "UY-RV" },
      { name: "Rocha", code: "UY-RO" },
      { name: "Salto", code: "UY-SA" },
      { name: "San Jose", code: "UY-SJ" },
      { name: "Soriano", code: "UY-SO" },
      { name: "Tacuarembo", code: "UY-TA" },
      { name: "Treinta y Tres", code: "UY-TT" }
    ]
  },
  [countryCodes.UZBEKISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Andijon", code: "UZ-AN" },
      { name: "Buxoro", code: "UZ-BU" },
      { name: "Farg'ona", code: "UZ-FA" },
      { name: "Jizzax", code: "UZ-JI" },
      { name: "Namangan", code: "UZ-NG" },
      { name: "Navoiy", code: "UZ-NW" },
      { name: "Qashqadaryo", code: "UZ-QA" },
      { name: "Qoraqalpog'iston Respublikasi", code: "UZ-QR" },
      { name: "Samarqand", code: "UZ-SA" },
      { name: "Sirdaryo", code: "UZ-SI" },
      { name: "Surxondaryo", code: "UZ-SU" },
      { name: "Toshkent", code: "UZ-TK" },
      { name: "Xorazm", code: "UZ-XO" }
    ]
  },
  [countryCodes.VATICAN.alphaTwo]: { subdivisions: [{ name: "Vatican City", code: "-" }] },
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: {
    subdivisions: [
      { name: "Charlotte", code: "VC-01" },
      { name: "Grenadines", code: "VC-06" },
      { name: "Saint George", code: "VC-04" },
      { name: "Saint Patrick", code: "VC-05" }
    ]
  },
  [countryCodes.VENEZUELA.alphaTwo]: {
    subdivisions: [
      { name: "Amazonas", code: "VE-Z" },
      { name: "Anzoategui", code: "VE-B" },
      { name: "Apure", code: "VE-C" },
      { name: "Aragua", code: "VE-D" },
      { name: "Barinas", code: "VE-E" },
      { name: "Bolivar", code: "VE-F" },
      { name: "Carabobo", code: "VE-G" },
      { name: "Cojedes", code: "VE-H" },
      { name: "Delta Amacuro", code: "VE-Y" },
      { name: "Dependencias Federales", code: "VE-W" },
      { name: "Distrito Capital", code: "VE-A" },
      { name: "Falcon", code: "VE-I" },
      { name: "Guarico", code: "VE-J" },
      { name: "La Guaira", code: "VE-X" },
      { name: "Lara", code: "VE-K" },
      { name: "Merida", code: "VE-L" },
      { name: "Miranda", code: "VE-M" },
      { name: "Monagas", code: "VE-N" },
      { name: "Nueva Esparta", code: "VE-O" },
      { name: "Portuguesa", code: "VE-P" },
      { name: "Sucre", code: "VE-R" },
      { name: "Tachira", code: "VE-S" },
      { name: "Trujillo", code: "VE-T" },
      { name: "Yaracuy", code: "VE-U" },
      { name: "Zulia", code: "VE-V" }
    ]
  },
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: {
    subdivisions: [{ name: "Virgin Islands, British", code: "-" }]
  },
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: {
    subdivisions: [{ name: "Virgin Islands, U.S.", code: "-" }]
  },
  [countryCodes.VIETNAM.alphaTwo]: {
    subdivisions: [
      { name: "An Giang", code: "VN-44" },
      { name: "Ba Ria - Vung Tau", code: "VN-43" },
      { name: "Bac Giang", code: "VN-54" },
      { name: "Bac Kan", code: "VN-53" },
      { name: "Bac Lieu", code: "VN-55" },
      { name: "Bac Ninh", code: "VN-56" },
      { name: "Ben Tre", code: "VN-50" },
      { name: "Binh Dinh", code: "VN-31" },
      { name: "Binh Duong", code: "VN-57" },
      { name: "Binh Phuoc", code: "VN-58" },
      { name: "Binh Thuan", code: "VN-40" },
      { name: "Ca Mau", code: "VN-59" },
      { name: "Can Tho", code: "VN-CT" },
      { name: "Cao Bang", code: "VN-04" },
      { name: "Da Nang", code: "VN-DN" },
      { name: "Dak Lak", code: "VN-33" },
      { name: "Dak Nong", code: "VN-72" },
      { name: "Dien Bien", code: "VN-71" },
      { name: "Dong Nai", code: "VN-39" },
      { name: "Dong Thap", code: "VN-45" },
      { name: "Gia Lai", code: "VN-30" },
      { name: "Ha Giang", code: "VN-03" },
      { name: "Ha Nam", code: "VN-63" },
      { name: "Ha Noi", code: "VN-HN" },
      { name: "Ha Tinh", code: "VN-23" },
      { name: "Hai Duong", code: "VN-61" },
      { name: "Hai Phong", code: "VN-HP" },
      { name: "Hau Giang", code: "VN-73" },
      { name: "Ho Chi Minh", code: "VN-SG" },
      { name: "Hoa Binh", code: "VN-14" },
      { name: "Hung Yen", code: "VN-66" },
      { name: "Khanh Hoa", code: "VN-34" },
      { name: "Kien Giang", code: "VN-47" },
      { name: "Kon Tum", code: "VN-28" },
      { name: "Lai Chau", code: "VN-01" },
      { name: "Lam Dong", code: "VN-35" },
      { name: "Lang Son", code: "VN-09" },
      { name: "Lao Cai", code: "VN-02" },
      { name: "Long An", code: "VN-41" },
      { name: "Nam Dinh", code: "VN-67" },
      { name: "Nghe An", code: "VN-22" },
      { name: "Ninh Binh", code: "VN-18" },
      { name: "Ninh Thuan", code: "VN-36" },
      { name: "Phu Tho", code: "VN-68" },
      { name: "Phu Yen", code: "VN-32" },
      { name: "Quang Binh", code: "VN-24" },
      { name: "Quang Nam", code: "VN-27" },
      { name: "Quang Ngai", code: "VN-29" },
      { name: "Quang Ninh", code: "VN-13" },
      { name: "Quang Tri", code: "VN-25" },
      { name: "Soc Trang", code: "VN-52" },
      { name: "Son La", code: "VN-05" },
      { name: "Tay Ninh", code: "VN-37" },
      { name: "Thai Binh", code: "VN-20" },
      { name: "Thai Nguyen", code: "VN-69" },
      { name: "Thanh Hoa", code: "VN-21" },
      { name: "Thua Thien-Hue", code: "VN-26" },
      { name: "Tien Giang", code: "VN-46" },
      { name: "Tra Vinh", code: "VN-51" },
      { name: "Tuyen Quang", code: "VN-07" },
      { name: "Vinh Long", code: "VN-49" },
      { name: "Vinh Phuc", code: "VN-70" },
      { name: "Yen Bai", code: "VN-06" }
    ]
  },
  [countryCodes.VANUATU.alphaTwo]: {
    subdivisions: [
      { name: "Sanma", code: "VU-SAM" },
      { name: "Shefa", code: "VU-SEE" },
      { name: "Tafea", code: "VU-TAE" }
    ]
  },
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: { subdivisions: [{ name: "Uvea", code: "WF-UV" }] },
  [countryCodes.SAMOA.alphaTwo]: {
    subdivisions: [
      { name: "Atua", code: "WS-AT" },
      { name: "Fa'asaleleaga", code: "WS-FA" },
      { name: "Tuamasaga", code: "WS-TU" }
    ]
  },
  [countryCodes.YEMEN.alphaTwo]: {
    subdivisions: [
      { name: "Adan", code: "YE-AD" },
      { name: "Amran", code: "YE-AM" },
      { name: "Abyan", code: "YE-AB" },
      { name: "Ad Dali'", code: "YE-DA" },
      { name: "Al Bayda'", code: "YE-BA" },
      { name: "Al Hudaydah", code: "YE-HU" },
      { name: "Al Jawf", code: "YE-JA" },
      { name: "Al Mahwit", code: "YE-MW" },
      { name: "Amanat al 'Asimah", code: "YE-SA" },
      { name: "Dhamar", code: "YE-DH" },
      { name: "Hadramawt", code: "YE-HD" },
      { name: "Hajjah", code: "YE-HJ" },
      { name: "Ibb", code: "YE-IB" },
      { name: "Lahij", code: "YE-LA" },
      { name: "Ma'rib", code: "YE-MA" },
      { name: "Sa'dah", code: "YE-SD" },
      { name: "San'a'", code: "YE-SN" },
      { name: "Shabwah", code: "YE-SH" },
      { name: "Ta'izz", code: "YE-TA" }
    ]
  },
  [countryCodes.MAYOTTE.alphaTwo]: {
    subdivisions: [
      { name: "Bandrele", code: "-" },
      { name: "Kani-Keli", code: "-" },
      { name: "Koungou", code: "-" },
      { name: "Mamoudzou", code: "-" },
      { name: "Ouangani", code: "-" },
      { name: "Pamandzi", code: "-" },
      { name: "Sada", code: "-" },
      { name: "Tsingoni", code: "-" }
    ]
  },
  [countryCodes.SOUTH_AFRICA.alphaTwo]: {
    subdivisions: [
      { name: "Eastern Cape", code: "ZA-EC" },
      { name: "Free State", code: "ZA-FS" },
      { name: "Gauteng", code: "ZA-GP" },
      { name: "Kwazulu-Natal", code: "ZA-KZN" },
      { name: "Limpopo", code: "ZA-LP" },
      { name: "Mpumalanga", code: "ZA-MP" },
      { name: "North-West", code: "ZA-NW" },
      { name: "Northern Cape", code: "ZA-NC" },
      { name: "Western Cape", code: "ZA-WC" }
    ]
  },
  [countryCodes.ZAMBIA.alphaTwo]: {
    subdivisions: [
      { name: "Central", code: "ZM-02" },
      { name: "Copperbelt", code: "ZM-08" },
      { name: "Eastern", code: "ZM-03" },
      { name: "Luapula", code: "ZM-04" },
      { name: "Lusaka", code: "ZM-09" },
      { name: "Muchinga", code: "ZM-10" },
      { name: "North-Western", code: "ZM-06" },
      { name: "Northern", code: "ZM-05" },
      { name: "Southern", code: "ZM-07" },
      { name: "Western", code: "ZM-01" }
    ]
  },
  [countryCodes.ZIMBABWE.alphaTwo]: {
    subdivisions: [
      { name: "Bulawayo", code: "ZW-BU" },
      { name: "Harare", code: "ZW-HA" },
      { name: "Manicaland", code: "ZW-MA" },
      { name: "Mashonaland Central", code: "ZW-MC" },
      { name: "Mashonaland East", code: "ZW-ME" },
      { name: "Mashonaland West", code: "ZW-MW" },
      { name: "Masvingo", code: "ZW-MV" },
      { name: "Matabeleland North", code: "ZW-MN" },
      { name: "Matabeleland South", code: "ZW-MS" },
      { name: "Midlands", code: "ZW-MI" }
    ]
  }
};

// src/residenceDescription/index.ts
var descriptionUKResidence = deepFreeze([
  { name: "I am a UK Citizen - England" },
  { name: "I am a UK Citizen - Scotland" },
  { name: "I am a UK Citizen - Wales" },
  { name: "I am a UK Citizen - Northern Ireland" },
  { name: "I am a British Citizen - Channel Islands and Isle of Man" },
  { name: "I am a British Citizen - British Overseas Territories" },
  { name: "I am an EU National (non-UK Citizen)" },
  { name: "I am an EEA or Swiss National" },
  { name: "I am a Child of a Turkish Worker" },
  { name: "I am a Refugee" },
  { name: "I have protection status (humanitarian protection or similar)" },
  { name: "I am Settled in the UK" },
  { name: "Other" }
]);

// src/enrolmentStatus/index.ts
var defaultIEnrolmentStatus = deepFreeze({
  travelStatusSection: {},
  accommodationStatusSection: {}
});

// src/finance/restrictedCountryBanks.ts
var restrictedCountryBanks = deepFreeze({
  Cameroon: [
    {
      bank: "Afriland First Bank",
      isAccepted: true
    },
    {
      bank: "Banque Atlantique du Cameroun",
      isAccepted: true
    },
    {
      bank: "BGFI Bank Cameroun",
      isAccepted: true
    },
    {
      bank: "BICEC",
      isAccepted: true
    },
    {
      bank: "CITIBANK NA Cameroon",
      isAccepted: true
    },
    {
      bank: "Commercial Bank of Cameroon",
      isAccepted: true
    },
    {
      bank: "Credit Agricole - Societe Commerciale de Banque (CA-SCB)",
      isAccepted: true
    },
    {
      bank: "Ecobank Cameroun (EBC)",
      isAccepted: true
    },
    {
      bank: "National Financial Credit Bank",
      isAccepted: true
    },
    {
      bank: "SGBC",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank Cameroun (SCBC)",
      isAccepted: true
    },
    {
      bank: "Union Bank of Cameroon Ltd (UBC)",
      isAccepted: true
    },
    {
      bank: "United Bank For Africa Cameroun Plc (UBAC)",
      isAccepted: true
    }
  ],
  India: [
    {
      bank: "Scheduled Commercial Banks - India",
      isAccepted: true
    },
    {
      bank: "Abu Dhabi Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "American Express Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arab Bangladesh Bank Limited",
      isAccepted: true
    },
    {
      bank: "Allahabad Bank",
      isAccepted: true
    },
    {
      bank: "Andhra Bank",
      isAccepted: true
    },
    {
      bank: "Antwerp Diamond Bank NV",
      isAccepted: true
    },
    {
      bank: "Axis Bank Ltd",
      isAccepted: false
    },
    {
      bank: "Bank Internasional Indonesia",
      isAccepted: true
    },
    {
      bank: "Bank of America NA",
      isAccepted: true
    },
    {
      bank: "Bank of Bahrain & Kuwait BSC",
      isAccepted: true
    },
    {
      bank: "Barclays Bank Plc",
      isAccepted: true
    },
    {
      bank: "BNP PARIBAS",
      isAccepted: true
    },
    {
      bank: "Bank of Ceylon",
      isAccepted: true
    },
    {
      bank: "Bharat Overseas Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of Baroda",
      isAccepted: false
    },
    {
      bank: "Bank of India",
      isAccepted: true
    },
    {
      bank: "Bank of Maharashtra",
      isAccepted: true
    },
    {
      bank: "Canara Bank",
      isAccepted: false
    },
    {
      bank: "Central Bank of India",
      isAccepted: true
    },
    {
      bank: "Calyon Bank",
      isAccepted: true
    },
    {
      bank: "Citibank NA",
      isAccepted: true
    },
    {
      bank: "Cho Hung Bank",
      isAccepted: true
    },
    {
      bank: "Chinatrust Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Centurion Bank of Punjab Limited",
      isAccepted: true
    },
    {
      bank: "City Union Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coastal Local Area Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Corporation Bank",
      isAccepted: true
    },
    {
      bank: "Catholic Syrian Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "Development Credit Bank Ltd.",
      isAccepted: false
    },
    {
      bank: "Dena Bank",
      isAccepted: true
    },
    {
      bank: "Dhanlaxmi Bank",
      isAccepted: true
    },
    {
      bank: "IndusInd Bank Limited",
      isAccepted: true
    },
    {
      bank: "ICICI Bank",
      isAccepted: false
    },
    {
      bank: "IDBI Bank Limited",
      isAccepted: true
    },
    {
      bank: "IDFC Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Indian Bank",
      isAccepted: true
    },
    {
      bank: "Indian Overseas Bank",
      isAccepted: true
    },
    {
      bank: "Industrial Development Bank of India",
      isAccepted: true
    },
    {
      bank: "ING Vysya Bank",
      isAccepted: true
    },
    {
      bank: "J P Morgan Chase Bank, National Association",
      isAccepted: true
    },
    {
      bank: "Krung Thai Bank Public Company Limited",
      isAccepted: true
    },
    {
      bank: "Kotak Mahindra Bank Limited",
      isAccepted: false
    },
    {
      bank: "Karnataka Bank",
      isAccepted: true
    },
    {
      bank: "Karur Vysya Bank Limited.",
      isAccepted: true
    },
    {
      bank: "Lord Krishna Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Mashreqbank psc",
      isAccepted: true
    },
    {
      bank: "Mizuho Corporate Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Oman International Bank S A O G",
      isAccepted: true
    },
    {
      bank: "Oriental Bank of Commerce",
      isAccepted: true
    },
    {
      bank: "Punjab & Sind Bank",
      isAccepted: false
    },
    {
      bank: "Punjab National Bank",
      isAccepted: false
    },
    {
      bank: "Societe Generale",
      isAccepted: true
    },
    {
      bank: "Sonali Bank",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "State Bank of Mauritius Ltd",
      isAccepted: true
    },
    {
      bank: "SBI Commercial and International Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Bank of Bikaner and Jaipur",
      isAccepted: true
    },
    {
      bank: "State Bank of Hyderabad",
      isAccepted: true
    },
    {
      bank: "State Bank of India",
      isAccepted: true
    },
    {
      bank: "State Bank of Indore",
      isAccepted: true
    },
    {
      bank: "State Bank of Mysore",
      isAccepted: true
    },
    {
      bank: "State Bank of Patiala",
      isAccepted: true
    },
    {
      bank: "State Bank of Saurashtra",
      isAccepted: true
    },
    {
      bank: "State Bank of Travancore",
      isAccepted: true
    },
    {
      bank: "Syndicate Bank",
      isAccepted: true
    },
    {
      bank: "The Bank of Nova Scotia",
      isAccepted: true
    },
    {
      bank: "The Bank of Tokyo-Mitsubishi, Ltd",
      isAccepted: true
    },
    {
      bank: "The Development Bank of Singapore Ltd (DBS Bank Ltd.)",
      isAccepted: true
    },
    {
      bank: "The Hongkong & Shanghai Banking Corporation Ltd",
      isAccepted: true
    },
    {
      bank: "Tamilnad Mercantile Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bank of Rajasthan Limited",
      isAccepted: true
    },
    {
      bank: "The Federal Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The HDFC Bank Ltd",
      isAccepted: false
    },
    {
      bank: "The Jammu & Kashmir Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nainital Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sangli Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The South Indian Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Ratnakar Bank Ltd",
      isAccepted: false
    },
    {
      bank: "The Royal Bank of Scotland NV",
      isAccepted: true
    },
    {
      bank: "The Lakshmi Vilas Bank Ltd",
      isAccepted: true
    },
    {
      bank: "UCO Bank",
      isAccepted: true
    },
    {
      bank: "Union Bank of India",
      isAccepted: true
    },
    {
      bank: "United Bank Of India",
      isAccepted: true
    },
    {
      bank: "Vijaya Bank",
      isAccepted: true
    },
    {
      bank: "Yes Bank",
      isAccepted: false
    },
    {
      bank: "AP Mahajans Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "AP Janata Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "AP RajaRajeswari Mahila Co-Operative",
      isAccepted: true
    },
    {
      bank: "Abhinandan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Abhinav Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Abhivriddhi Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Abhyudaya Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Abiramam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Accountant General's Office Employees Co-opera",
      isAccepted: true
    },
    {
      bank: "ACE Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarniya PD Patil Saheb Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Mahila Mercantile Co-operative Bankltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsha Pattana Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Adhyapaka Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adoor Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agartala Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agra Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agrasen Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agroha Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahilyadevi Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmedabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar Shahar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar Zilla Prathamik Shikshak Saha Bank",
      isAccepted: true
    },
    {
      bank: "Ajantha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajinkyatara Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajinkyatara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajmer Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajmer Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akhand Anand Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akkamahadevi Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Akki-Alur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akola District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akola Merchant Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alappuzha District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alavi Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alibag Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aligarh Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Allahabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Allahabad UP Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Alleppey Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Almel Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Almora Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Almora Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alnavar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alwar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alwar Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alwaye Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amalapuram Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amalner Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aman Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amanath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amarnath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambajogai Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambala Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambarnath Jai-Hind Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambasamudram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambica Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ameer Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ammapet Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amod Nagric Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amravati District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amreli Jilla Madhyasth Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Amreli Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amritsar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anand Mercantile Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ananda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anandeshwari Nagrik Sahakarti banAnanthasayanam Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anantnag Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anantpur co-op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andersul Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andhra Bank Employees Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andhra Pradesh Grameena Vikas Bank",
      isAccepted: true
    },
    {
      bank: "Andhra Pradesh Mahesh Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andhra Pragathi Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Angul United Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ankaleshwar Udyognagar Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ankola Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anna Sahaeb Magar Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Anuradha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Apani Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Apna Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Appasaheb Birnale Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arantangi Co-Op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arcot Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arihant Urban Co-Operative Bank",
      isAccepted: true
    },
    {
      bank: "Ariyalur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arjun Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arkonam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Army Base Work-Shop Credit Co-operative",
      isAccepted: true
    },
    {
      bank: "Arni Co-Operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aroodhjyoti Pattan Sahakara Bank Niyamith",
      isAccepted: true
    },
    {
      bank: "Arrah-Buxer District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arsikere Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aruna Sahakara Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Arunachal Pradesh Rural Bank",
      isAccepted: true
    },
    {
      bank: "Arvind Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arya Vaishya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aryapuram Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aryavart Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Ashok Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ashok Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ashoknagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ashta People's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aska Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Assam Gramin Vikash Bank",
      isAccepted: true
    },
    {
      bank: "Astha Mahila Nagrik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Attur Town Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aurangabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aurangabad District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "AVB Employees' Co-operative Credit Society & Bank",
      isAccepted: true
    },
    {
      bank: "Azad Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Azamgarh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "B Komarapalayam Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bagalkot Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bagalkot Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baghat Urban Coop Bank Limited Solan.",
      isAccepted: true
    },
    {
      bank: "Bahraich District central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bailhongal Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bailhongal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baitarani Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Bajirao Appa Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balangir District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balasore Coop.Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balasore District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balgeria Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balitikuri Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ballia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ballia -Etawah Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Bally Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Balotra Urban Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balsinor Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balusseri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banaras Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banaskantha District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banaskantha Mercantile co-op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Banda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banda Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bangalore City Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bangalore District and Bangalore Rural",
      isAccepted: true
    },
    {
      bank: "Bangiya Gramin Vikash Bank",
      isAccepted: true
    },
    {
      bank: "Bank Jogindra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banki District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bankura District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banswara Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bapatla Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bapuji Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bapunagar Maahilaa Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Barabanki District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baramati Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baramulla Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baran Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Baranagar Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bardoli Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bareilly Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baripada Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Barmer Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baroda City co-op bank Limited",
      isAccepted: true
    },
    {
      bank: "Baroda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baroda Gujarat Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Baroda Rajasthan Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Baroda Trader's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baroda Uttar Pradesh Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Basaveshwar Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Basoda Nagrik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bassein Catholic Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Basti District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Batlagundu Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bavla Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bayad Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Beawar Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bechraji Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bedkihal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Beed District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Begusarai District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Begusarai District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Behrampore District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belgaum District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belgaum District Revenue Employees' Co-operative",
      isAccepted: true
    },
    {
      bank: "Belgaum Industrial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belgaum Zilla Rani Channamma Mahila Sahakari",
      isAccepted: true
    },
    {
      bank: "Bellad Bagewadi Urban Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bellary District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bellary Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Berhampur Co-Operative Urban Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Betul Nagarik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bhabhar Vibhag Nagarik sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhadgaon Peoples Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Bhadohi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhadradri Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhadran People's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhagalpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhagini Nivedita Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhagyodaya co-op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhagyodaya Friends Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhandara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhandari Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bharat Co-operative Bank (Mumbai) Ltd",
      isAccepted: true
    },
    {
      bank: "Bharat Heavy Electricals Employees Co op Bank",
      isAccepted: true
    },
    {
      bank: "Bharat Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bharath Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bharathiya Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Bharati Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bharatpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bharatpur Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhatinda Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhatkal Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhatpara Naihati Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhausaheb Birajdar Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavana Rishi Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavanagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavani Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhavani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavanikudal Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhavasar Kshatriya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavnagar Mahila Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhawanipatna Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhilai Nagarik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bhilwara Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhilwara Mahila Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhilwara Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhimashankar Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhimavaram Co-op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhind Nagarik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bhinger Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhiwani Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhopal District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhopal Nagarik SahakariBank Limited",
      isAccepted: true
    },
    {
      bank: "Bhuj Commercial Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhuj Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhupathiraju Co op Credit Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhusawal People's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bicholim Urban Co- operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bidar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bidar Mahila Urban Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Big Kancheepuram Co op Town Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bihar Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Bijapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijapur District Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijapur Mahalaxmi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijapur Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bijapur Zilla Sarkari Naukarara Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bijnor Jilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijnor Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bikaner Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bilagi Pattan Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Birbhum District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Birdeo Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bodeli Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bombay Mercantile Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Borsad Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Botad Peoples Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Boudh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Brahmadeodada Mane Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Brahmawart Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bramhapuri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Broach District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Budaun Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Budge-Budge Nangi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Buldhana District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bundi Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bundi Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Burdwan Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Business Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Calicut Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cannanore Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cardamom Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Catholic Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cauvery Kalpatharu Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Chaitanya Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chaitanya Godavari Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Chaitanya Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chamba Urban Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chamoli Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chanasma Commercial Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chanasma Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandgad Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandrapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandraseniya Kayastha Prabhu Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandwad Merchant's Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Changanacherry Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Charda Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Charminar Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chartered Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Chatrapur Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chembur Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chengalpattu Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chennai Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chennai Port Trust Employees Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chennimalai Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cherpalcheri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chhapi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chhattisgarh Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Chhopda Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Chidambaram Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chidambaranar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chikmagalur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chikmagalur Jilla Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Chikmagalur Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Chikmagalur-Kodagu Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Chiplun Urban Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chitradurg District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittoor Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittoor District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittorgarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittorgarh Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chopda People's Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Choudeshwari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Churu Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Churu Zilla Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Citizen Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Credit Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Urban Co opBank Limited",
      isAccepted: true
    },
    {
      bank: "Citizens' Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "City Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Coastal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coimbatore City Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coimbatore District Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Col RD Nikam Sainik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Colour Merchants'Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Commercial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Comptroller's Office Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Contai Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coonoor Cooperative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coop Bank of Baroda Ltd",
      isAccepted: true
    },
    {
      bank: "Coop Bank of Rajkot Ltd",
      isAccepted: true
    },
    {
      bank: "Co-operative bank of Mehsana Ltd",
      isAccepted: true
    },
    {
      bank: "Cooperative City Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cooperative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cordite Factory Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cosmos Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cuddalore & Villipuram DCCB Employees Co-Op",
      isAccepted: true
    },
    {
      bank: "Cuddalore District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cuddapah District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cumbum CoopTown Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cuttack United Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "DY Patil Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dadasaheb Gajmal Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dadasaheb Ramrao Patil Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dahanu Road Janata Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dahod Mercantile Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dahod Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Daivadnya Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Dakor Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dakshin Dinajpur (Balurghat) District Central Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dakshina Kannada Jilla Mahila Co-operative Ban",
      isAccepted: true
    },
    {
      bank: "Dalmiapuram Empl.s'Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dapoli Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Darjeeling District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Darus Salam Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dattatraya Maharaj Kalambi Jaoli Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Daund Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dausa Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dausa Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Davangere Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Davangere Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Davangere-Harihar Urban Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Dayalbagh Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deccan Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deccan Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Deccan Merchants Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deendayal Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deepak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Defence Accounts Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dehradun District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Delhi Nagrik Sehkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dena Gujarat Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Deoghar Jamtara District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deogiri Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deola Merchants'Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deoria Kasia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Desaiganj Nagari Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Development Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Devgad Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Devi Gayatri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Devyani Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhakuria Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhanashree Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhanbad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhanera Mercantile Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharampuri District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharamvir Sambhaji Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharapuram Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Dharmaj Peoples' Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharmapuri Co-op. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharmavaram Co-op. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhinoj Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dholpur Urban Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhrangadhra Peoples'Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhule and Nandurbar Jilha Sarkari Nokaranchi",
      isAccepted: true
    },
    {
      bank: "Dhule Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhulia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dilip Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dindigul Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dindigul Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "District Central Co-operative Bank Ltd, Bulandshahar",
      isAccepted: true
    },
    {
      bank: "District Co-operative Bank Ltd, Sitapur",
      isAccepted: true
    },
    {
      bank: "Dombivli Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dr Annasahab Chaugule Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dr Babasaheb Ambedkar Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Dr Babasaheb Ambedkar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dr Babasaheb Ambedkar Urban Co-operativeBank",
      isAccepted: true
    },
    {
      bank: "Dr Jaiprakash Mundada Urban Co-oprative Bank",
      isAccepted: true
    },
    {
      bank: "Dr Shivajirao Patil Nilangekar Urban Co-operativ",
      isAccepted: true
    },
    {
      bank: "Dumka District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dungarpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Durga Co-op. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Durgapur Mahila Co-Operative Bank LtdDurgapur Steel Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Durg-Rajnandgaon Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Dwarakadas Mantri Nagari Sahakari Bk. Ltd",
      isAccepted: true
    },
    {
      bank: "Eastern & North East Frontier Railway Co-operative",
      isAccepted: true
    },
    {
      bank: "Eenadu Co-Operative Urban bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ellaquai Dehati Bank",
      isAccepted: true
    },
    {
      bank: "Eluri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Eluru Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Eluru District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ernakulam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Erode Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Erode District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etah District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etah Urban Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etawah Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etawah Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Excellent Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faiz Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faizabad co-operative District Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faridabad Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faridcot Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Farrukhabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Fatehabad Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Fatehgarh Sahib Central Co-operative Bank Ltd, Sirhind",
      isAccepted: true
    },
    {
      bank: "Fathehpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Fazilka Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Feroke Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ferozepur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Financial Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gadchiroli District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gadhinglaj Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandevi People's Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandhi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhi Gunj Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhibag Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhidham Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandhidham Mercantile Co-op.Bk.Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhinagar Nagarik Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandhinagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganesh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganga Mercantile Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganganagar Kendriya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganraj Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gauhati Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gautam Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gayatri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "George Town Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ghaziabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghaziabad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghazipur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghazipur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghoghamba Vibhag Nagarik Sahakari Bank Limite",
      isAccepted: true
    },
    {
      bank: "Ghoti Marchants Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Giridh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Goa Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gobichettipalyam Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Godavari Laxmi Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Godavari Urban Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Godhra City Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Godhra Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gokak Urban Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gokul Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gomthi Nagariya Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gondal Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gondia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gooty Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gopalganj District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gopinath Patil Parsik Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gorakhpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Government Employees Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Gozaria Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Graduates' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Grain Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Greater Bombay Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Guardian Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Gudiwada Co-op. Urban bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gudiyattam Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gujarat Ambuja Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gujarat Mercantile Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gulbarga District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gulshan Mercantile Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gumla Simdga District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guna District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guntur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guntur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guntur Women Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gurdaspur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gurgaon Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gurgaon Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Guruvayur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hadgali Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hadoti Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Halol Mercantile Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Halol Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hamirpur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hanamasagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hangal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hansot Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hanumanthanagar Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Hardoi District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hardoi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Harihareshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Harij Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Haryana Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Hassan District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hasti Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Haveli Sahakari Bank Maryadit.",
      isAccepted: true
    },
    {
      bank: "Haveri Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hazaribagh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Himachal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Himatnagar Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hindu Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hindustan Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hindustan Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hindustan Shipyard Staff Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hira Sugar Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hiriyur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hissar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hissar Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Honavar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hoogly District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hoshiarpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hospet Co-operative City Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hotel Industrialists Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Howrah District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hubli Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hukeri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hutatma Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hyderabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ichalkaranji Merchants Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Idar Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Idukki District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ilayangudi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ilkal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Imperial Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Imperial Urban cooprative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Imphal Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Income Tax Department Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Independence Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indian Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indira Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indira Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indore Premier Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indraprastha Sehkari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Indrayani Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Industrial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Innespeta Coop urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Innovative Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Integral Urban co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Irinjalakuda Town Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Islampur Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "J&K Grameen Bank",
      isAccepted: true
    },
    {
      bank: "Jagruti Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jagruti Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jai Bhawani Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jai Hind Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jai Kalimata Mahila Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jain Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jain Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaipur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaipur Thar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Jaisalmer Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalana District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalaun District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon Merchants' Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalna Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalore Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalore Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalpaiguri Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamkhandi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamkhed Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jammu Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamnagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamnagar mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamnagar People's Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jampeta Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janakalyan Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janakalyan Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janalaxmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janaseva Sahakari (Borivli) Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janaseva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Coop Bank Ltd Godhra.",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janatha Seva Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jankalyan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janseva Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janseva Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Jansewa Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jath Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaunpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jawahar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jawahar Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jay Tuljabhavani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jayprakash Narayan Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaysingpur Udgaon Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jeypore coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhabua Dhar Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Jhajjar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhalawar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhalawar Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhalod Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jharkhand Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Jhunjhunu Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jijamata Mahila Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jijamata Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jijau Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jilla Sahakari Kendriya Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Jind Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jivan Commercial Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jivhaji Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jodhpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jodhpur Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jolarpet Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jowai Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jubilee Hills Mercantile Co-Operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Jugalkishor Tapdia - Shri Mahesh Urban Co-opera",
      isAccepted: true
    },
    {
      bank: "Jullunder Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Junagadh Commercial Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Junagadh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kachchh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaduthuruthy Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kagal Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaira District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaithal Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kakatiya Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kakinada Co-op. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kakinada Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalghatgi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalinga Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Kallappanna Awade Ichalkaranji Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kallidaikurichi Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Kalol Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalol Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalpavruksha Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalupur Commercial Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalwan Marchants' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalyan Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalyan Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalyansagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kamala Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kamaraj coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kamuthi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanaka Mahalakshmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanaka Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Kanara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kancheepuram Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kangra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kankaria Maninagar Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kannur (Cannanore) District Cooperative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanyakumari District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kapadwanj Peoples' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kapurthala Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karad Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karaikudi Coop. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karamana Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karan Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karimnagar Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karimnagar District co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karjan Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karmala Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnal Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnala Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnataka Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnataka Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnataka Rajya Kaigarika Vanijya Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Karnataka Vikas Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Karnavathi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karunagapalli Taluk Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karuntattankudi Dravidian Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karur Town Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karwar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kasaragod District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kasargod Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kashi Gomti Samyut Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Kashipur Urban Co-opeerative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kasundia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Katihar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kattappana Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaujalgi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaveripatnam Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kavita Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kedarnath Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kempegowda Pattana Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Kendrapara Urban Coop Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Keonjhar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kerala Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khagaria District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khalilabad Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khambhat Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khammam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khanapur Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khardah Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kheda Peoples' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khedbrahma Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kheralu Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khurda Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kisan Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kittur Channamma Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kodagu District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodagu Zilla Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Kodaikanal Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodinar Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodinar Taluka Co-operative Banking Union Ltd",
      isAccepted: true
    },
    {
      bank: "Kodoli Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodungallur Town Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kohinoor Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koilkuntla Co-Operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kokan Mercantile Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kokan Prant Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolar District Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolhapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolhapur Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolhapur Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolikata Mahila Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolkata Police Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kollam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Konark Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Konnagar Samabaya Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Konoklota Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kopargaon Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koraput Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kosamba Mercantile Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kota Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kota Mahila Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kota Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koteshwara Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kottakal Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kottayam Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kottayam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kovilpatti Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kovvur Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koyana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kozhikode District co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kranti Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishna District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishna Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Krishna Pattana Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Krishna Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishna Valley Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishnagiri Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krushiseva Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kshetriya Kisan Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Kukarwada Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kulitalai Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Kumbakonam Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kumbakonam Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kumbhi Kasari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kumta Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kunbi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kuppam Coop.Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurla Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurmanchal Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurnool District Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurukshetra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurukshetra Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kushtagi Pattana Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kutch Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kutch Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kuttiady Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "LIC of India Staff Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "LIC Employees' Coop Bank LtdLakhimpur-Kheri District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lakhvad Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lala Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lalbaug Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lalgudi Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lalitpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Langpi Dehangi Rural Bank",
      isAccepted: true
    },
    {
      bank: "Lasalgaon Merchant's Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Latur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Laxmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Laxmi Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Laxmi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Laxmi Vishnu Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Liberal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Liluah Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Limbasi Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Limdi Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Little Kancheepuram Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lokapavani Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Lokmangal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lokneta Dattaji Patil Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lokseva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lokvikas Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lonavla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lucknow University Adm Staff Primary Co-operative",
      isAccepted: true
    },
    {
      bank: "Lucknow Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ludhiana Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lunawada Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lunawada People's Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "MD Pawar Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "MS Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madanapalle Co-Op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madgaum Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madhavpura Mercantile Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madheshwari Urban Development Co-operative",
      isAccepted: true
    },
    {
      bank: "Madhya Bharat Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Madhya Bihar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Madikeri Town Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madura Sourashtra Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madurai District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madurantakam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Magadh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maha Mantralaya & Allied Offices Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahabaleshwar Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahabhairab Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahabubanagar District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahakaushal Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Mahalakshmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahalaxmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahalingpur Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahamedha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahanagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahanagar Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maharaja Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maharana Pratap Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maharashtra Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Maharashtra Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Mahatma Fule District Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Mahatma Fule Urban Co-oprative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahaveer Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahaveer Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahendragarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahesh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahesh Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahila Co-Operative Nagrik Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahoba Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahudha Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mainpuri District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Makarpura Industrial Estate Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malad Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malappuram District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malegaon Merchants Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mallapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malleswaram Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malpur Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malviya Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malwa Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Manapparai Town Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandal Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandapeta Co-Operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandi Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandvi Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandvi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandya City Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandya District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangal Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangaldai Nagar Samabai Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangalore Catholic Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangalore Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maninagar Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manipal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manipur Rural Bank",
      isAccepted: true
    },
    {
      bank: "Manipur Women's Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manjeri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manjra Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manmad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manmandhir Co-Op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mannargudi Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manndeshi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manorama Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansa Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansa Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansarovar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansingh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mantha Urban Co-operative Bank LtdManvi Pattana Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Manwath Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mapusa Urban Co-operative Bank of Goa Ltd",
      isAccepted: true
    },
    {
      bank: "Maratha Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maratha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Markandey Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Marketyard Commercial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Marwar Ganganagar Bikaner Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Masulipatanam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mathura Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Matoshri Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mattancherry Mahajanik Co-operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Mattancherry Sarvajanik Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mayani Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mayuram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mayurbhanj Central Co-operative Bank LtdMechanical Department Primary Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Medak District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Meenachil East Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Meerut District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Meghalaya Rural Bank",
      isAccepted: true
    },
    {
      bank: "Megharaj Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehmadabad Urban People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana District central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana Jilla Panchayat Karmachari Co op Bank",
      isAccepted: true
    },
    {
      bank: "Mehsana Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Melur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Memon Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mercantile Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mercantile Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchants' Liberal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchants' Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Merchants' Urban Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Mettupalayam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mewar Anchalik Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Millath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mirzapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mirzapur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mizoram Rural Bank",
      isAccepted: true
    },
    {
      bank: "Mizoram Urban Co-Op Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Modasa Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Model Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Model Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Modern Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moga Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mogaveera Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mohol Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moirang Primary Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Monghyr-Jamui District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moradabad Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moti Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Motihari District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mudalgi Co operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Mudgal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mudhol Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mugberia District Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mukkuperi Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muktai Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muktsar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mula Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mulgund Urban Souharda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mumbai District Central Co-operative Bank Lt",
      isAccepted: true
    },
    {
      bank: "Mumbai Mahanager Palika Shikshan VibhagSaha",
      isAccepted: true
    },
    {
      bank: "Municipal Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Municipal Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Murshidabad District Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Musiri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muslim Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muvattupuzha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muzaffarnagar District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muzaffarrur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore District central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore Merchant's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore Silk Cloth Merchants' Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Mysore Zilla Mahila Sahakara Bank Niyamitha.",
      isAccepted: true
    },
    {
      bank: "NE Rly Emp.Multi State Pri.Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Nabagram People's Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nadapuram Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nadia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nadiad People's Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagaland Rural Bank",
      isAccepted: true
    },
    {
      bank: "Nagar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagar Vikas Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagarik Samabay Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagaur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagaur Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagina Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagnath Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagpur Mahanagarpalika Karmachari Sahahakari",
      isAccepted: true
    },
    {
      bank: "Nagpur Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagrik Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nainital Almora Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Nainital District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nakodar Hindu Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nalanda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nalbari Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nalgaonda District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Namakkal Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nandani Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nanded District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nandgaon Urban Co-operative Ltd",
      isAccepted: true
    },
    {
      bank: "Nandurbar Merchants' Co-op Ltd",
      isAccepted: true
    },
    {
      bank: "Narayanaguru Urban Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Narmada Malwa Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Naroda Nagrik Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik District Industrial & Mercantile Co-op Bank",
      isAccepted: true
    },
    {
      bank: "Nasik Jilha Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Merchant's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Road Deolali Vyapari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Zilla Girna Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Zilla Mahila Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Zilla Sar & Par Karmachari Sah Bank",
      isAccepted: true
    },
    {
      bank: "National Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Insurance Emp Co-operative Cr & Bank",
      isAccepted: true
    },
    {
      bank: "National Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nav Jeevan Coop Bank",
      isAccepted: true
    },
    {
      bank: "Navabharat Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navakalyan Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Naval Dockyard Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navanagara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navanirman Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navapur Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navi Mumbai Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navnirman Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navsarjan Industrial Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nawadh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nawanagar Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nawanshahr Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nayagarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nazareth Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nedumangad Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Needs of Life Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Neela Krishna co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Neelachal Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Nehru Nagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nellai Nagar Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nellore Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nellore District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nemmara Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nesargi Urban Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "New Agra Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "New India Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "New Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Neyyattinkara Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nicholson Coop. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nidhi Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nilambur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nileshwar Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nilgiries Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nilkanth Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nipani Urban Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Niphad Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nirmal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nishigandha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nizamabad District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "NKGSB Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Noble Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Noida Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "North Arcot Ambedkar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "North Malabar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Northern Railway Primary Co-operative Bank.Ltd",
      isAccepted: true
    },
    {
      bank: "Nutan Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nutan Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nyayamitra Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Ode Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ojhar Merchants Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Omalur Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Om-Datta Chaitanya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Omerga Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Omkar Nagriya Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ordinance Equip Factory Prarambhik Sahkari Bk",
      isAccepted: true
    },
    {
      bank: "Osmanabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Osmanabad Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ottapalam Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pachhapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pachora People's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Padmaavati Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Padmashri Dr.Vithalrao Vikhe Patil Co-operative",
      isAccepted: true
    },
    {
      bank: "Padra Nagar Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Padukkottai Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pala Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palakkad District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palamoor Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palani Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palanpur People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palayamkottai Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palghat Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pali Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pali Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pallavan Grama Bank",
      isAccepted: true
    },
    {
      bank: "Pallikonda Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palus Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchkula Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchkula Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchmahals District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchsheel Mercantile Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pandharpur Marchant's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pandharpur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pandyan Grama Bank",
      isAccepted: true
    },
    {
      bank: "Panipat Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panipat Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panvel Co-op. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Papanasam Coop. Urban Bank LtdParamakudi Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parbhani District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parner Taluka Sainik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parshwanath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parvatiya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Parwanoo Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Paschim Banga Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Patan Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patan Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patdi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pathanamthitta District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patiala Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patliputra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pattukottai Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pavana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Payangadi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Payyanur Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Payyoli Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pen Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "People's Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Periyakulam Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pij People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pilibhit District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pimpalgaon Merchants'Co-op. BAnk Ltd d",
      isAccepted: true
    },
    {
      bank: "Pimpri Chinchwad Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Pioneer Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pioneer Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pithorgarh Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pochampally Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pollachi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ponani Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pondicherry Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ponnampet Town Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Poona Marchant's Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Poornawadi Nagrik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Porbandar Commercial Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Porbandar Vibhagiya Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Postal & .MS Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragathi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragathi Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Pragathi Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Pragati Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragati Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragati Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prakasam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prakasapuram Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pratap Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pratapgarh Jilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prathama Bank",
      isAccepted: true
    },
    {
      bank: "Prathamik Shikshak Sahakari bank ltd",
      isAccepted: true
    },
    {
      bank: "Prathamik Shikshak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pravara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Premier Automobile Employees' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prerna Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prime Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pritisangam Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshani Mahila Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshani Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Mahila Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Mahila Urban Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Proddatur Co-Op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Progressive Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Progressive Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Progressive Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pudukottai Coop.Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Puduvai Bharathiar Grama Bank",
      isAccepted: true
    },
    {
      bank: "Pune Cantonment Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pune District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pune Municipal Corporation Servants Co-operative",
      isAccepted: true
    },
    {
      bank: "Pune Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pune Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Punjab & Maharashtra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Punjab Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Purasawalkam Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Puri Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Purnea District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Purulia Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Purvanchal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Pusad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Puttur Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Quilon Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "RBI Employees' Co-op Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "RS Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raddi Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Radhasoami Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rae Bareli District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rahimatpur Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raichur City Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raichur District Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raigad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raigad Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raiganj Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Employees'Coop Banking Soc Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Shramik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raj Laxmi Mahila Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajadhani Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajajinagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajapalayam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajapur Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajapur Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajarambapu Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajarshi Shahu Government Servants' Co-op.Bank",
      isAccepted: true
    },
    {
      bank: "Rajarshi Shahu Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Rajasthan Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Rajasthan Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajdhani Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajgurunagar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajiv Gandhi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajkot Commercial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajkot Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajkot Peoples Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajlaxmi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajmata Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajpipla Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajputana Mahila Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajsamand Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajula Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramakrishna Mutually Aided Co-operative",
      isAccepted: true
    },
    {
      bank: "Ramanagaram Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramanathapuram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramanathapuram District Central Co-operative Bank Lt",
      isAccepted: true
    },
    {
      bank: "Rameshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramgarhia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rampur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramrajya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranaghat People's Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranchi-Khunti Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rander People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Randheja Commercial Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranga Reddy Co-operative Urban Bank LtdRaniganj Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranilaxmibai Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranipet Town Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranuj Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rasipuram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ratanchand Shaha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ratnagiri District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ratnagiri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raver People's Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ravi Commercial Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rayat Sevak Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rendal Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Repalle Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Reserve Bank Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Reserve Bank Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Revdanda Co-op Urban bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rewari Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rewa-Sidhi Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Rohika Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rohtak Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ron Taluka Primary Teachers' Co-operative",
      isAccepted: true
    },
    {
      bank: "Ropar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rukhmini Nagari Sahakati Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rupee Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rushikulya Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Sabarkantha District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sachin Industrial Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sadalga Urban Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sadguru Gahininath Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sadhana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sadhana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saharanpur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahasrarjun Seva Kalyan Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahebrao Deshmukh Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahyadri Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahyadri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sai Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Saibaba Janata Sahakari Bank LtdSaibaba Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Saidapet Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salal Sarvodaya Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salem District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salem Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salur Cooperative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samarth Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samarth Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samastipur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samastipur Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Samata Co-operative Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samatha Mahila Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sambalpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sampada Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samruddhi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sandur Pattana Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sangamner Merchant's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanghamitra Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli District Primary Teacher's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangola Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangrur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sankari Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sankheda Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanmathi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanmitra Mahila Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sanmitra Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sanmitra Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanmitra Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sant Motiram Maharaj Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sant Sopankaka Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Santrampur Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saptagiri Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Sarangpur Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Saraspur Nagarik Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Saraswat Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saraswathi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sardar Bhiladwala Pardi Peoples Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sardar Vallabhbhai Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sardarganj Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sardargunj Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarjerao-Dada Naik Shirala Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarsa People's Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sarva UP Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Commercial Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sasaram Bhabua Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satana Merchants' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sathamba People's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satpura Narmada Kshetriya",
      isAccepted: true
    },
    {
      bank: "Satyamangalam Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satyashodhak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saurashtra Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saurashtra Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Savanur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sawai Madhopur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sawai Madhopur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sawantwadi Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Secunderabad Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Secunderabad Mercantile Co-operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Seva Vikas Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sevalia Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Seven Hills Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shahada People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shahjahanpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shalini Sahakari Bank LtdShamrao Vithal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shankar Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shankarrao Chavan Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shankerrao Mohite-Patil Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sharad Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sharad Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sharda Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Shatabdi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shedbal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shevapet Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shiggaon Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shihori Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shikshak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shillong Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shimla Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shimoga Arecanut Mandy Merchants Co-operativ",
      isAccepted: true
    },
    {
      bank: "Shimoga District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shimsha Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Shirpur Merchants Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shirpur Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shiva Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shivaji Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivajirao Bhosale Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivalik Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivam Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivdaulat Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivneri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivparvati Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivshakti Urban Co-op BnkLtd",
      isAccepted: true
    },
    {
      bank: "Sholapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sholavandan Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sholinghur Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shoranur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Agrasen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Baria Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Basaveshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Basaveshwar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Bhadran Mercantile Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Bharat Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Bhavnagar Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shree Botad Mercantile Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Dhandhuka Janta Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Dharati Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Gajanan Lokseva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Gajanan Maharaj Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Shree Gajanan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Govardhansingji Raghuvashi Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shree Kadi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Lathi Vibhagiya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Laxmi Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Laxmi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Laxmi Mahila Sahakari Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Shree Lodhra Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahabaleshwar Co operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahalaxmi Mercantile Coop Bk Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahalaxmi Urban Co-operative Credit Bank",
      isAccepted: true
    },
    {
      bank: "Shree Mahavir Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shree Mahayogi Lakshmamma Co-Operative Ban",
      isAccepted: true
    },
    {
      bank: "Shree Mahesh Co-operative Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahuva Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Murugharajendra Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Shree Panchaganga Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Parswanth Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Savarkundla Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Savli Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Sidhhi Vinayak Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Talaja Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shree Tukaram Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Vardhaman Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Virpur Urban Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Vyas Dhanvarsha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Warana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Yugprabhav Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shreeji Bhatia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shreenath Coop Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Shreeram Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shreyas Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Shri Adinath Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Anand Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Anand Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Arihant Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Babasaheb Deshmukh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Balaji Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Balbhim Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Basaveshwar Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Bhagasara Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Bhailalbhai Contractor Smarak Co-operative",
      isAccepted: true
    },
    {
      bank: "Shri Bharat Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Bhausaheb Thorat Amrutvahini Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Chatrapati Shivaji Maharaj Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Chhani Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Chhatrapati Rajarshi Shahu Urban Co-operat",
      isAccepted: true
    },
    {
      bank: "Shri Chhatrapati Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Gajanan Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Ganesh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Gurudev Brahmanand Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Shri Gurusiddheshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Kadasiddeshwar Pattan Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Kanyaka Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Lakshmi Krupa Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Laxmi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahalaxmi Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahalaxmi Pattan Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Shri Mahant Shivayogi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahaveer Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahila Sewa Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Morbi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Nrusingh Saraswati sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Patneshwar Urban cooprative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Rajkot District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Rukmini Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Sai Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Satyavijay Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Shadakshari Shivayogi Siddharameshwar",
      isAccepted: true
    },
    {
      bank: "Shri Shantappanna Mirji Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Shri Sharada Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Sharan Veereshwar Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Shiddheshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Shivaji Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Shivayogi Murughendra Swami Urban Co-op",
      isAccepted: true
    },
    {
      bank: "Shri Shiveshwar Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Siddeshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Swami Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Swami Samarth Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Veer Pulikeshi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Veershaiv Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Vijay Mahantesh Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Vinayak Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Vyankatesh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Yashwant Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shrikrishna Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shrimant Malojiraje Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shripatrao Dada Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shriram Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shushruti Souharda Sahakara Bank Niyamita",
      isAccepted: true
    },
    {
      bank: "Siddaganga Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siddarthnagar District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siddharth Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Siddheshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siddheshwar Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Siddhi Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sihor Mercantile Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sihor Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sikar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sikar Urban Co Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sind Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sindgi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sindhudurg District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sindhudurg Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Singhbhum District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sinor Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sir M Vishweshwaraiah Sahakar Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sir M.Visvesvaraya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sircilla Co op Urban bank Limited",
      isAccepted: true
    },
    {
      bank: "Sirkali Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sirohi Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sirsa Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sirsi Urban Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sitamarhi Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sivagangai (Pasumpon) District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sivakasi Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siwan Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Smriti Nagrik Sahakari Bank Maryadit., Mandsau",
      isAccepted: true
    },
    {
      bank: "Sojitra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Solapur Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Solapur Nagri Audhyogik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Solapur Siddheshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Solapur Social Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sonbhadra Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sonepat Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sonpeth Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Soubhagya Mahila Souharda Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "South Canara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "South Kanara Government Officers' Co-operative",
      isAccepted: true
    },
    {
      bank: "South Malabar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Sree Anjaneya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Bhyraveshwara Sahakara Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sree Chaitanya Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Charan Souharda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Harihareshwara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Narayana Guru Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Subramanyeswara Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Thyagaraja Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sreenidhi Souharda Sahakari Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sreenivasa Padmavatthi Co-Operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Sri Amba Bhavani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Balaji Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Banashankari Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Basaveshwar Pattana Sahakari Bank Niyamit",
      isAccepted: true
    },
    {
      bank: "Sri Basaveshwar Sahakar Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sri Basaveshwara Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Basaveswar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Bhagavathi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Bharathi Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Channabasavaswamy Souharda Pattana Saha",
      isAccepted: true
    },
    {
      bank: "Sri Durgadevi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Ganapathi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Ganesh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Gavisiddeshwar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Gayatri Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Gokarnanath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Guru Raghavendra Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Kalahasti Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Kalidasa Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Kamalambika Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Kannikaparameshwari Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Kanyakaparameswari Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Krishnarajendra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Lakshmi Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Lakshminarayana Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Laxminarayana Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Mahatma Basaveshwar Co-Operative Bank",
      isAccepted: true
    },
    {
      bank: "Sri Mallikarjuna Pattana Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sri Parshwanatha Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Rama Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Revana Siddeshwar Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Seetharaghava Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Sharada Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Sharadamba Mahila Cooperative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Sri Sharanabasaveshwar Pattana Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Sri Siddarameshwara Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Sudha Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Vasavamba Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Veerabhadreshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srikakulam Co-op.Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srikakulam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srimatha Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sriramnagar Pattana Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Srirangam Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srivilliputtur Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Stambhadri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Transport Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Transport Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sterling Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Subramanianagar Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "SUCO Souharda Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sudha Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Suleimani Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sultanpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sultan's Battery Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sumerpur Mercantile Urban Co-operative Bank Lt",
      isAccepted: true
    },
    {
      bank: "Sundargarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sundarlal Sawji Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat National Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat Peoples Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surendranagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surguja Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Sutlej Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Suvarna Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Suvarnayug Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Suvikas Peoples Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Swami Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Swami Vivekanand Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Swarna Bharathi Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Swarna Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Swasakthi Mercantile Co-Operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Swatantrya Senani",
      isAccepted: true
    },
    {
      bank: "Tadpatri Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Talikoti Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Taliparamba Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Talod Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tambaram Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tamilnadu Circle Postal Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tamilnadu Industrial Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Tamluk-Ghatal Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tandur Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tanur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tarapur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tasgaon Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tavaragera Pattana Souharda Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Teachers' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tehri Garhwal District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tellicherry Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tenali Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Terna Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Textile Co-op.Bank of Surat Ltd",
      isAccepted: true
    },
    {
      bank: "Textile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Textile Manufacturers' Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Textile Traders' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thane Bharat Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thane District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thane Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thanjavur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thanjavur Public Servants'Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thasra Peoples'Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Adilabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Adinath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Agrasen Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Akola Janata Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Akola Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati Zilla Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati Zilla-Parishad Shikshak Sahakari",
      isAccepted: true
    },
    {
      bank: "The Anantapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Andaman and Nicobar State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Andhra Pradesh State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Anjangaon Surji Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Annasaheb Savant Co-Op. Urban Bank",
      isAccepted: true
    },
    {
      bank: "The Arunachal Pradesh State co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Assam Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Associate Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Aurangabad District Industrial & Urban Co-op",
      isAccepted: true
    },
    {
      bank: "The Badagara Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Baidyabati Sheoraphuli Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Bank Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bankura Town Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Bantra Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Bhagyalakshmi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bhandara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bihar Awami Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bihar State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bishnupur Town Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Boral Union Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Chandigarh State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Chhattisgarh RajyaSahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "The Chikhli Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Chitnavispura Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Citizen Co operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Citizen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Citizens' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Delhi State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Devika Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Dr. Panjabrao Deshmukh Urban Co-operative",
      isAccepted: true
    },
    {
      bank: "The Eastern Railway Employees'Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Ghadchiroli Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "The Ghatal Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Goa State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Gujarat Industrial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Gujarat Rajya Karmachari Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "The Gujarat State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Haryana State Co-opertive Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Himachal Pradesh State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Hooghly Co-operative Credit Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Jalna People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jambusar People's Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jammu and Kashmir State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jamshedpur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Janata Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jaynagar Mozilpur Peoples' Co-operative BanK",
      isAccepted: true
    },
    {
      bank: "The Kalna Town Credit Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Kangra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Kapol Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Karnataka State Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Kashmir Mercantile Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "The Kerala State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Keshav Sehkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Khamgaon Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Khatra Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Khattri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Koylanchal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Krishnagar City Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Latur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Madhya Pradesh Rajya Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "The Maharashtra State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mahila Vikas Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Malkapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Manipur State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Meghalaya Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mehkar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Midnapore People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mizoram Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Muzzaffarpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nabadwip Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nabapalli Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nagaland State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nagarik Shakari Bank Maryadit, Jhabua",
      isAccepted: true
    },
    {
      bank: "The Nanded Merchant's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nandura Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Navodaya Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Orissa State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Panihati Co-operative Bank LtdThe Pondichery State Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Prerna Nagari Sahakari Bank LtdThe Punjab State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Raipur Urban Mercantile Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Rajasthan State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sahyog Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Santragachi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Shibpur Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sikkim State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Social Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sonepat Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Suri Friends' Union Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sutex Co operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Tamil Nadu State Apex Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Tapindu Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Tripura State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Udgir Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Union Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Uttar Pradesh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Uttaranchal Rajya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Uttarpara Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The V.S.V.Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaidyanath Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaijapur Merchants Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Vaish Co-operative Adarsh Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaish Co-operative Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaish Co-operative New Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vardhman Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Washim Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The West Bengal State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Yavatmal Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Yavatmal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvaikuntam Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvalluvar Town Co-Op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvananthapuram District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvannamali Sambuvarayar District Central",
      isAccepted: true
    },
    {
      bank: "Thodupuzha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thrissur District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thyagarayanagar Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tindivanam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchendoor Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchengode Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchirapalli City Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchirapalli District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchirapalli Hirudayapuram Co-Op Credit Bank",
      isAccepted: true
    },
    {
      bank: "Tirukoilur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirumala Co-op. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirumangalam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirunelveli Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirunelveli Junction Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirupati Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirupati Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirupattur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruppur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruturaipundi Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvalla East Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvalla Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvallur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvannamalai Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvathipuram Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tonk Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Town Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Town Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Transport Coop Bank Ltd, Indore",
      isAccepted: true
    },
    {
      bank: "Trichur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tripura Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Trivandrum Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tumkur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tumkur Grain Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tumkur Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Tumkur Veerashaiva Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tura Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tuticorin Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tuticorin Melur Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Twin Cities Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "UP Civil Secretriat Primary Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "UP Postal Primary Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Mahila Samridhhi Urban Coop Bk Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Mahila Urban Co-op.Bk.Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udamalpet Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udhagmandlam Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udhana Citizen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udupi Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udyam Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ujjain Audhyogik Vikas Nagrik Sahkari Bank",
      isAccepted: true
    },
    {
      bank: "Ujjain Nagarik Sahakari Bank Maryadit, Ujjain",
      isAccepted: true
    },
    {
      bank: "Ujjain Paraspar Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Uma Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Umiya Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Umreth Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Una Peoples' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Unava Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Union Co op Bank Limited Naroda.",
      isAccepted: true
    },
    {
      bank: "United Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "United India Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Puri Nimpara Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Universal Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Unjha Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Uravakonda Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Urban Co op Bank Limited Cuttack",
      isAccepted: true
    },
    {
      bank: "Usilampatti Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Uthamapalayam Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Utkal Coop Banking Soc Ltd",
      isAccepted: true
    },
    {
      bank: "Utkal Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Uttar Banga Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Uttar Bihar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Uttarakhand co-op. Bank LTD",
      isAccepted: true
    },
    {
      bank: "Uttaranchal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Uttarkashi Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Uttarsanda Peoples Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "VISL Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vadali Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vadnagar Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vaijanath Appa Saraf Marathwada Nagari Sahaka",
      isAccepted: true
    },
    {
      bank: "Vaikom Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vaishali District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaishali Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaishya Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaishya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vallabh Vidhyanagar Commercial Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valmiki Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valparai Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valsad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valsad Mahila Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vananchal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Vani Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vani Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaniyambadi Town Coop bank Ltd",
      isAccepted: true
    },
    {
      bank: "Varachha Co-operative bank Ltd",
      isAccepted: true
    },
    {
      bank: "Varaganeri Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Varanashi District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vardhaman (Mahila) Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasai Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasai Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasantdada Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasavi Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vasundhara Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Veershaiva Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Veershaiva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vejalpur Nagarik Sahakari bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vellala Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vellore Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Velur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vepar Udhyog Vikas Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Veraval Mercantile Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Veraval Peoples Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vidharbha Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Vidharbha Merchants Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Vidisha Bhopal Kshetriya",
      isAccepted: true
    },
    {
      bank: "Vidya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vidyanand Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vidyasagar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vijapur Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vijay Commercial Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vijay Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vikas Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vikas Souharda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vikas Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Vikramaditya Nagarik Sahakari Bank Maryadit,",
      isAccepted: true
    },
    {
      bank: "Villupuram Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Villupuram District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vima Kamgar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Virajpet Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Viramgam Mercantile Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Viravanallur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Virudhunagar Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Virudhunagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Visakhapatnam Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishakapatnam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishwakalyan Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Vishwakarma Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishwakarma Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Vishwanathrao Patil Murgud Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishwas Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishweshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Visveshvaraya Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Vita Merchants Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vita Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vitthal Nagari Sahari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vivekanada Nagarik Sahakari Bank Maryad.,Shuj",
      isAccepted: true
    },
    {
      bank: "Vriddhachalam Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vyankateshwara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vyapari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vyaparik Audhyogik Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Vyavasayik Evam Audhyogik Sah.Bk.Maryadit.",
      isAccepted: true
    },
    {
      bank: "Vyavsaik Sahakari Bank Maryadit, Raipur",
      isAccepted: true
    },
    {
      bank: "Vysya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Waghodia Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wai Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wainganga Krishna Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Walchandnagar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wana Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wani Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Warangal Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wardha District Ashirwad Mahila Nagari Sahakari",
      isAccepted: true
    },
    {
      bank: "Wardha District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wardha Nagari Sahakari Adhikosh (Bank)",
      isAccepted: true
    },
    {
      bank: "Wardha Zilla Parishad Employees (Urban) Co-op",
      isAccepted: true
    },
    {
      bank: "Wardhaman Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Warud Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Women's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wynad District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yadagiri Lakshmi Narasimha Swamy Co-op.Urban",
      isAccepted: true
    },
    {
      bank: "Yadrav Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yamuna Nagar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yaragatti Urban Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yashwant Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yashwant Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yavatmal District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yawal Peoples Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yemmiganur Co-op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yeola Merchants Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yeshwant Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Youth Development Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Garhwal",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Haridwar",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Jhansi",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Lucknow",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Mau",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Unnao",
      isAccepted: true
    },
    {
      bank: "Zoroastrian Co-operative Bank Ltd",
      isAccepted: true
    }
  ],
  Ghana: [
    {
      bank: "Absa Bank Ghana Limited",
      isAccepted: false
    },
    {
      bank: "Access Bank (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "Agricultural Development Bank Ltd",
      isAccepted: false
    },
    {
      bank: "ARB Apex Bank",
      isAccepted: true
    },
    {
      bank: "Bank of Africa (Gh) Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of Baroda (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "Barclays Bank of Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "BSIC Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "CAL Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citibank NA Ghana",
      isAccepted: true
    },
    {
      bank: "Ecobank Ghana Ltd",
      isAccepted: false
    },
    {
      bank: "Energy Bank (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "Fidelity Bank Ghana Ltd",
      isAccepted: false
    },
    {
      bank: "First Atlantic Bank Ltd",
      isAccepted: true
    },
    {
      bank: "First Capital Plus Bank Limited",
      isAccepted: true
    },
    {
      bank: "GCB Bank Plc",
      isAccepted: false
    },
    {
      bank: "Ghana Commercial Bank Limited",
      isAccepted: false
    },
    {
      bank: "Ghana International Bank Plc",
      isAccepted: true
    },
    {
      bank: "Guaranty Trust bank (Ghana) Ltd",
      isAccepted: false
    },
    {
      bank: "HFC Bank Ltd",
      isAccepted: true
    },
    {
      bank: "International Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchant Bank (Ghana) Ltd",
      isAccepted: false
    },
    {
      bank: "National Investment Bank Ltd",
      isAccepted: true
    },
    {
      bank: "OmniBSIC Bank Ghana Limited",
      isAccepted: false
    },
    {
      bank: "Prudential Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Royal Bank Ltd",
      isAccepted: true
    },
    {
      bank: "SG-SSB Ltd",
      isAccepted: true
    },
    {
      bank: "Stanbic Bank Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank Ghana Limited",
      isAccepted: true
    },
    {
      bank: "uniBank Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "United bank for Africa (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "UT Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Zenith Bank (Ghana) Ltd",
      isAccepted: false
    }
  ],
  Pakistan: [
    {
      bank: "Al-Baraka Islamic Banking BSC (EC)",
      isAccepted: true
    },
    {
      bank: "Allied Bank Limited",
      isAccepted: true
    },
    {
      bank: "American Express Bank Limited",
      isAccepted: true
    },
    {
      bank: "Askari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bank Al-Falah",
      isAccepted: true
    },
    {
      bank: "Bank Al-Habib",
      isAccepted: true
    },
    {
      bank: "Bank of Ceylon",
      isAccepted: true
    },
    {
      bank: "Bank of KhyberBank of Tokyo Mitsubishi Limited",
      isAccepted: true
    },
    {
      bank: "Barclays",
      isAccepted: true
    },
    {
      bank: "Burj Bank",
      isAccepted: true
    },
    {
      bank: "Citibank",
      isAccepted: true
    },
    {
      bank: "Credit Agricole Indosuez (The Global French Bank)",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "Doha Bank",
      isAccepted: true
    },
    {
      bank: "Dubai Islamic Bank",
      isAccepted: true
    },
    {
      bank: "Faysal Bank",
      isAccepted: true
    },
    {
      bank: "First Women Bank",
      isAccepted: true
    },
    {
      bank: "GPO Abbottabad",
      isAccepted: true
    },
    {
      bank: "GPO Charsadda",
      isAccepted: true
    },
    {
      bank: "GPO Gujar Khan",
      isAccepted: true
    },
    {
      bank: "GPO Haripur",
      isAccepted: true
    },
    {
      bank: "GPO Jhelum",
      isAccepted: true
    },
    {
      bank: "GPO Kotli",
      isAccepted: true
    },
    {
      bank: "GPO Mardan",
      isAccepted: true
    },
    {
      bank: "GPO Mirpur",
      isAccepted: true
    },
    {
      bank: "GPO Multan",
      isAccepted: true
    },
    {
      bank: "GPO Nowshera",
      isAccepted: true
    },
    {
      bank: "GPO Peshawar",
      isAccepted: true
    },
    {
      bank: "GPO Swabi",
      isAccepted: true
    },
    {
      bank: "GPO Swat",
      isAccepted: true
    },
    {
      bank: "Habib bank AG Zurich",
      isAccepted: true
    },
    {
      bank: "Habib Bank Limited",
      isAccepted: true
    },
    {
      bank: "Habib Metropolitan Bank",
      isAccepted: true
    },
    {
      bank: "Industrial Development Bank of Pakistan (IDBP)",
      isAccepted: true
    },
    {
      bank: "International Finance Investment & Commerce Bank Limited",
      isAccepted: true
    },
    {
      bank: "JS bank",
      isAccepted: true
    },
    {
      bank: "KASB Bank",
      isAccepted: true
    },
    {
      bank: "Khushhali Bank",
      isAccepted: true
    },
    {
      bank: "Mashreq Bank PSC",
      isAccepted: true
    },
    {
      bank: "Meezan Bank",
      isAccepted: true
    },
    {
      bank: "Muslim Commercial Bank (MCB)",
      isAccepted: true
    },
    {
      bank: "National Bank of Pakistan",
      isAccepted: true
    },
    {
      bank: "National Investment Bank (NIB)",
      isAccepted: true
    },
    {
      bank: "National Investment Trust Limited (NIT)",
      isAccepted: true
    },
    {
      bank: "National Savings Abbottabad",
      isAccepted: true
    },
    {
      bank: "National Savings Bahawalpur",
      isAccepted: true
    },
    {
      bank: "National Savings Faisalabad",
      isAccepted: true
    },
    {
      bank: "National Savings Gujranwala",
      isAccepted: true
    },
    {
      bank: "National Savings Hyderabad",
      isAccepted: true
    },
    {
      bank: "National Savings Islamabad",
      isAccepted: true
    },
    {
      bank: "National Savings Karachi",
      isAccepted: true
    },
    {
      bank: "National Savings Lahore",
      isAccepted: true
    },
    {
      bank: "National Savings Multan",
      isAccepted: true
    },
    {
      bank: "National Savings Peshawar",
      isAccepted: true
    },
    {
      bank: "National Savings Quetta",
      isAccepted: true
    },
    {
      bank: "National Savings Sukkur",
      isAccepted: true
    },
    {
      bank: "Oman International Bank SOAG",
      isAccepted: true
    },
    {
      bank: "Pak Kuwait Investment Company (Pvt) Limited",
      isAccepted: true
    },
    {
      bank: "Pak Libya Holding Company (Pvt) Limited",
      isAccepted: true
    },
    {
      bank: "Pak Oman Investment Company (PVT) Limited",
      isAccepted: true
    },
    {
      bank: "Pakistan Industrial Credit & Investment Corporation Limited",
      isAccepted: true
    },
    {
      bank: "Punjab Provincial Corporative Bank (PPCB)",
      isAccepted: true
    },
    {
      bank: "Rupali Bank Limited",
      isAccepted: true
    },
    {
      bank: "Samba Bank Limited",
      isAccepted: true
    },
    {
      bank: "Saudi Pak Industrial & Agricultural Investment Company (Pvt) Limited",
      isAccepted: true
    },
    {
      bank: "Silk Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sindh Bank",
      isAccepted: true
    },
    {
      bank: "SME BANK",
      isAccepted: true
    },
    {
      bank: "Soneri Bank",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "Summit Bank",
      isAccepted: true
    },
    {
      bank: "The Bank of Azad Jammu & Kashmir (Bank of AJK)",
      isAccepted: true
    },
    {
      bank: "The Bank of Punjab",
      isAccepted: true
    },
    {
      bank: "The First Micro Finance Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Trust Bank",
      isAccepted: true
    },
    {
      bank: "United Bank Limited",
      isAccepted: true
    },
    {
      bank: "Zarai Taraqiati Bank Limited (ZTBL)",
      isAccepted: true
    },
    {
      bank: "Government Post Office Region Islamabad",
      isAccepted: true
    },
    {
      bank: "Government Post Office Region Karachi",
      isAccepted: true
    },
    {
      bank: "Government Post Office Region Lahore",
      isAccepted: true
    }
  ],
  "Iran, Islamic Republic of": [
    {
      bank: "Pasargad Bank",
      isAccepted: true
    },
    {
      bank: "Parsian Bank",
      isAccepted: true
    },
    {
      bank: "en Bank",
      isAccepted: true
    },
    {
      bank: "Mellat Bank",
      isAccepted: true
    },
    {
      bank: "Melli Bank",
      isAccepted: true
    },
    {
      bank: "Tejarat Bank",
      isAccepted: true
    },
    {
      bank: "Ghavvamin Bank",
      isAccepted: true
    },
    {
      bank: "Bank Keshavarzi (Agri Bank)",
      isAccepted: true
    },
    {
      bank: "Bank Sedarat: Bank Saderat Iran",
      isAccepted: true
    },
    {
      bank: "Saman Bank",
      isAccepted: true
    },
    {
      bank: "Fereshtegan",
      isAccepted: true
    },
    {
      bank: "Samenolaemeh",
      isAccepted: true
    },
    {
      bank: "Samenolhojaj Bank",
      isAccepted: true
    },
    {
      bank: "Bank Maskan",
      isAccepted: true
    }
  ],
  Philippines: [
    {
      bank: "ABN Amro Bank",
      isAccepted: true
    },
    {
      bank: "Al-Amanah Islamic Bank",
      isAccepted: true
    },
    {
      bank: "Allied Banking Corporation",
      isAccepted: true
    },
    {
      bank: "Allied Savings Bank",
      isAccepted: true
    },
    {
      bank: "Asia United Bank",
      isAccepted: true
    },
    {
      bank: "Australia & New Zealand Banking Group (ANZ)",
      isAccepted: true
    },
    {
      bank: "Banco de Oro Unibank, Inc",
      isAccepted: true
    },
    {
      bank: "Bangkok Bank Public Co Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of America",
      isAccepted: true
    },
    {
      bank: "Bank of China (Limited - Manila Branch)",
      isAccepted: true
    },
    {
      bank: "Bank of Commerce",
      isAccepted: true
    },
    {
      bank: "Bank of the Philippine Islands",
      isAccepted: true
    },
    {
      bank: "Bank of Tokyo-Mitsubishi",
      isAccepted: true
    },
    {
      bank: "BDO Elite Savings Bank",
      isAccepted: true
    },
    {
      bank: "BDO Private Bank",
      isAccepted: true
    },
    {
      bank: "BPI Capital Corporation",
      isAccepted: true
    },
    {
      bank: "BPI Card Finance Corporation",
      isAccepted: true
    },
    {
      bank: "BPI Direct Savings Bank",
      isAccepted: true
    },
    {
      bank: "BPI Family Savings Bank",
      isAccepted: true
    },
    {
      bank: "BPI Globe BanKo, Inc.",
      isAccepted: true
    },
    {
      bank: "BPI Leasing Corporation",
      isAccepted: true
    },
    {
      bank: "China Banking Corporation",
      isAccepted: true
    },
    {
      bank: "China Bank Savings, Inc",
      isAccepted: true
    },
    {
      bank: "China Trust (Phils) Commercial Bank",
      isAccepted: true
    },
    {
      bank: "Citibank",
      isAccepted: true
    },
    {
      bank: "Citibank Savings, Inc.",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "Development Bank of the Philippines",
      isAccepted: true
    },
    {
      bank: "East West Bank",
      isAccepted: true
    },
    {
      bank: "Export and Industry Bank",
      isAccepted: true
    },
    {
      bank: "First Consolidated Bank",
      isAccepted: true
    },
    {
      bank: "HSBC - Hongkong and Shanghai Banking Corporation",
      isAccepted: true
    },
    {
      bank: "HSBC Savings Bank (Phils)",
      isAccepted: true
    },
    {
      bank: "ING Bank (Internationale Nederlanden Groep Bank N.V. - Manila Branch)",
      isAccepted: true
    },
    {
      bank: "ISLA Bank (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "JP Morgan Chase Bank",
      isAccepted: true
    },
    {
      bank: "Korea Exchange Bank",
      isAccepted: true
    },
    {
      bank: "Land Bank of the Philippines",
      isAccepted: true
    },
    {
      bank: "Malayan Bank Savings and Mortgage Bank",
      isAccepted: true
    },
    {
      bank: "Maybank Philippines",
      isAccepted: true
    },
    {
      bank: "Mega International Commercial Bank",
      isAccepted: true
    },
    {
      bank: "Metropolitan Bank and Trust Company",
      isAccepted: true
    },
    {
      bank: "Mizuho Corporate Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Philippine Bank of Communications",
      isAccepted: true
    },
    {
      bank: "Philippine Business Bank",
      isAccepted: true
    },
    {
      bank: "Philippine National Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Savings Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Veterans Bank",
      isAccepted: true
    },
    {
      bank: "Planters Development Bank",
      isAccepted: true
    },
    {
      bank: "Queen City Development Bank",
      isAccepted: true
    },
    {
      bank: "RCBC Capital Corporation",
      isAccepted: true
    },
    {
      bank: "RCBC Savings Bank",
      isAccepted: true
    },
    {
      bank: "Rizal Commercial Banking Corporation",
      isAccepted: true
    },
    {
      bank: "Robinsons Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Security Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "The Real Bank",
      isAccepted: true
    },
    {
      bank: "UCPB Leasing and Finance Corporation (ULFC)",
      isAccepted: true
    },
    {
      bank: "UCPB Savings Bank",
      isAccepted: true
    },
    {
      bank: "Unionbank of the Philippines",
      isAccepted: true
    },
    {
      bank: "United Coconut Planters Bank",
      isAccepted: true
    },
    {
      bank: "World Partner's Bank (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "1st Macro Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "1st Macro Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "1st Valley Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "5 Speed Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "A B Capital and Investment Corporation",
      isAccepted: true
    },
    {
      bank: "Advantage Bank Corp. (A Microfinance-Oriented Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Agri-Business Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Agricom Rural Bank (Sta. Maria,Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "Agusan Norte - Butuan City Coop RB",
      isAccepted: true
    },
    {
      bank: "Air Materiel Wing Savings & Loan Association, Inc. (AMWSLAI)",
      isAccepted: true
    },
    {
      bank: "Aliaga Farmers Rural Bank (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "AMA Bank (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Anilao Bank (Rural Bank of Anilao (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Armed Forces of the Phils. Savings & Loan Association, Inc. (AFPSLAI)",
      isAccepted: true
    },
    {
      bank: "Arsenal Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Asian Consumers Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Asiatrust Development Bank",
      isAccepted: true
    },
    {
      bank: "ASLA Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Aspac Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Aurorabank (A Microfinance-Oriented Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Baclaran Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bagong Bangko Rural ng Malabang, Inc.",
      isAccepted: true
    },
    {
      bank: "Baguio Vendors Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Balanga Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Baliuag Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Alabang, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Bakun, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Batangan, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Carmona, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Banco de Arevalo, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco de Mindoro, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Dingras (Comm. RB Dingras, Inc.)",
      isAccepted: true
    },
    {
      bank: "Banco Dipolog, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Banco Makiling, A Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Maximo, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco ng Masa, Inc. (A Microfinance-Oriented Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Rural de General Tinio (BRGT), Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Rural de Isla Cordova, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco San Juan, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Sual (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Buena Consolidated, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Bangko Carrascal, Inc. (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Kabayan (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Mabuhay (RB of Tanza, Inc.)",
      isAccepted: true
    },
    {
      bank: "Bangko Magsaysay (Isabela), Inc. - A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Bangko Pangasinan - A Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Pasig (Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Rural ng Magarao (Camarines Sur), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Rural ng Pasacao, Inc.",
      isAccepted: true
    },
    {
      bank: "BANGKO RURAL NG SAN TEODORO",
      isAccepted: true
    },
    {
      bank: "Bangko Rural ng Tagoloan, Inc.",
      isAccepted: true
    },
    {
      bank: "Bank of Florida, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Bank of Makati (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bank One Savings and Trust Corporation",
      isAccepted: true
    },
    {
      bank: "Banko Nuestra Sra. del Pilar, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Bannawag Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Basa Air Base Savings & Loan Associatiom, Inc.",
      isAccepted: true
    },
    {
      bank: "Bataan Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Bataan Development Bank",
      isAccepted: true
    },
    {
      bank: "Bataan Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Batanes Government Employees Savings & Loan, Inc.",
      isAccepted: true
    },
    {
      bank: "Batangas Rural Bank for Coop., Inc.",
      isAccepted: true
    },
    {
      bank: "Baybank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Benguet Centre Bank, Inc. A Rural Bank",
      isAccepted: true
    },
    {
      bank: "BHF Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bicol Teachers Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Bi\xF1an Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Binangonan Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "BIR Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Bolbok Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bottlers Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Bridgeway Rural Banking Corp.",
      isAccepted: true
    },
    {
      bank: "Builders Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bukidnon Bank, INC (RB of Kalilangan)",
      isAccepted: true
    },
    {
      bank: "Business and Consumers Bank (A Dev't. Bank)",
      isAccepted: true
    },
    {
      bank: "Butuan City Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Cabanatuan City Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Cagsawa Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Camiling Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Cantilan Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Capitol City Bank, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Capiz Settlers Cooperative Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Card Bank, Inc. (A Microfinance Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Card SME Bank, Inc. A Thrift Bank",
      isAccepted: true
    },
    {
      bank: "Cavite Naval Base Savings and Loan Association,Inc. (CNBSLAI)",
      isAccepted: true
    },
    {
      bank: "Cavite Rural Banking Corporation",
      isAccepted: true
    },
    {
      bank: "CDCP Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Cebu International Finance Corporation",
      isAccepted: true
    },
    {
      bank: "Cebuana Lhuillier Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Central Equity Rural Bank",
      isAccepted: true
    },
    {
      bank: "Central Visayas Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Century Rural Bank Inc.(RB of Babak Inc.)",
      isAccepted: true
    },
    {
      bank: "Century Savings Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Certified Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Citizen's Rural Bank (Cabiao), Inc.",
      isAccepted: true
    },
    {
      bank: "City Savings Bank",
      isAccepted: true
    },
    {
      bank: "Citystate Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Classic Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Bank (RB of Alfonso, Inc.)",
      isAccepted: true
    },
    {
      bank: "Community RB of Naawan, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Catmon, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Clarin, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Dapitan City, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Magallon, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Magsaysay, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Medellin, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Romblon, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of San Felipe, Inc",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of San Gabriel, Inc.",
      isAccepted: true
    },
    {
      bank: "Composite Wing Savings and Loan Association, Inc. (CWSLAI)",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Agusan del Sur",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Aurora",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Benguet",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cagayan",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Camarines Norte",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cavite",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cebu",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cotabato",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Ilocos Norte",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Iloilo",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of La Union",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Leyte-Leyte Coop RB",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Misamis",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Mt. Province",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Negros Oriental",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Nueva Vizcaya",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Palawan",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Pampanga, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Quezon Province",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Surigao del Sur",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Tarlac, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Zambales",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Bohol, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Bukidnon, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Bulacan, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Davao del Sur, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Zamboanga del Norte",
      isAccepted: true
    },
    {
      bank: "Cordillera Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Cordillera Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Country Rural Bank of Taguig, Inc.",
      isAccepted: true
    },
    {
      bank: "Countryside Coop Rural Bank of Batangas",
      isAccepted: true
    },
    {
      bank: "Countryside Rural Bank of Palauig (Zambales), Inc.",
      isAccepted: true
    },
    {
      bank: "Crown Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "CSFirst Bank, INC. - A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Cuyapo Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "D' Asian Hills Bank (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "De La O Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Delmont Bank, Inc. (RB of San Jose del Monte)",
      isAccepted: true
    },
    {
      bank: "DEPW Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "DER Savings & Loan Association, Inc. (DERSALA)",
      isAccepted: true
    },
    {
      bank: "Diamond Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Dumaguete City Development Bank",
      isAccepted: true
    },
    {
      bank: "Dumaguete Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Dungganon Bank, Inc. (A Microfinance Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "Earist Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "East Coast Rural Bank, Inc.(RB Hagonoy)",
      isAccepted: true
    },
    {
      bank: "Eastern Rizal Rural Bank Inc.(Jala-Jala Rural Bank)",
      isAccepted: true
    },
    {
      bank: "EIB Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Emerald Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Empire Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Enterprise Bank, Inc. A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Enterprise Capital Bank (Rural Bank of Taguig)",
      isAccepted: true
    },
    {
      bank: "Entrepreneur Rural Bank",
      isAccepted: true
    },
    {
      bank: "Equicom Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Faculty Savings & Loan Association of Adamson University, Inc.",
      isAccepted: true
    },
    {
      bank: "Far Eastern Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Farm Bank (A Rural Bank) - Farmer's Bank of Capiz, Inc.",
      isAccepted: true
    },
    {
      bank: "Farmers Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Farmers Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Fernando Air Base Savings & Loan Association, Inc. (FABSLAI)",
      isAccepted: true
    },
    {
      bank: "Fil-Agro Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Filidian Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Filipino Savers Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Finman Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Agro-Industrial Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Community Bank, Inc.(A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "First Integrity Bank, Inc. (Rural Bank of Bailen)",
      isAccepted: true
    },
    {
      bank: "First Isabela Cooperative Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Malayan Leasing & Finance Corporation",
      isAccepted: true
    },
    {
      bank: "First Metro Investment Corporation",
      isAccepted: true
    },
    {
      bank: "First Midland Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Mindoro Microfinance Rural Bank, INC.",
      isAccepted: true
    },
    {
      bank: "First Naga Bank ( A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "First Provincial Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "First State Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Tagum Rural Bank , Inc.",
      isAccepted: true
    },
    {
      bank: "First United Farmers Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Forestry Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Frontier Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Gateway Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "GM BANK OF LUZON, INC. (A RURAL BANK)",
      isAccepted: true
    },
    {
      bank: "Golden Rural Bank of the Philippines, Inc.",
      isAccepted: true
    },
    {
      bank: "Grand-Agri Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Green Bank (Rural Green Bank of Caraga)",
      isAccepted: true
    },
    {
      bank: "GSIS Bayanihan Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "GSIS Family Bank, A Thrift Bank",
      isAccepted: true
    },
    {
      bank: "Guagua Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Guagua Savers Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Gulf Bank, Inc. (RB of Lingayen, Inc.)",
      isAccepted: true
    },
    {
      bank: "Highland Rural Bank, Inc. (RB Kapangan, Inc.)",
      isAccepted: true
    },
    {
      bank: "Hiyas Banking Corporation (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "Iligan City Public School Teachers Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Ilocandia Community Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Ilocos Sur Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Iloilo City Development Bank",
      isAccepted: true
    },
    {
      bank: "Imus Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Innovative Rural Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Insular Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Inter-Asia Development Bank",
      isAccepted: true
    },
    {
      bank: "Isla Lipana & Co-Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Janiuay Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Jemba Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Judiciary Savings & Loan Association, Inc. (JUSLAI)",
      isAccepted: true
    },
    {
      bank: "Kaluyagan Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Kap. Kawani ng Quezon City Hall",
      isAccepted: true
    },
    {
      bank: "Katipunan Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Key Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Koronadal Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "La Consolacion Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lagawe Highlands Rural Bank",
      isAccepted: true
    },
    {
      bank: "Laguna Prestige Banking Corporation, (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Lapu-Lapu Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "LBC Development Bank",
      isAccepted: true
    },
    {
      bank: "Legazpi Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lemery Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lepanto Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Liberty Savings Bank Inc.",
      isAccepted: true
    },
    {
      bank: "Life Bank - Rural Bank of Maasin (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Life Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Limcoma Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lipa Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "LUDB Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Luzon Development Bank",
      isAccepted: true
    },
    {
      bank: "Mactan Air Base Savings & Loan Association, Inc. (MABSLAI)",
      isAccepted: true
    },
    {
      bank: "Mactan Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Maharlika Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Malaca\xF1ang Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Malarayat Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Malasiqui Progressive Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Malaybalay Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Mallig Plains Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Manila Teacher's Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Mantrasco Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Maritime Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Mariwasa Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Masagana Rural Bank (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "Masantol Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Masuwerte Rural Bank of Bacoor, Inc.",
      isAccepted: true
    },
    {
      bank: "Mead Johnson Nutrition Employees Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Mega Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Meralco Savings & Loan Association (MESALA)",
      isAccepted: true
    },
    {
      bank: "Merchants Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Metro South Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Metrobank Card Corporation (A Finance Co.)",
      isAccepted: true
    },
    {
      bank: "Metro-Cebu Public Savings Bank",
      isAccepted: true
    },
    {
      bank: "Microfinance Maximum Savings Bank (Maxbank)",
      isAccepted: true
    },
    {
      bank: "Millenium Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Misamis Occidental Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Money Mall Rural Bank, Inc. (Com. RB Cuambog, Inc.)",
      isAccepted: true
    },
    {
      bank: "Mt. Carmel Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Multinational Investment Bancorporation",
      isAccepted: true
    },
    {
      bank: "Multi-Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Municipal Rural Bank of Libmanan, Inc.",
      isAccepted: true
    },
    {
      bank: "Municipal Rural Bank of Nabua, Inc.",
      isAccepted: true
    },
    {
      bank: "Muntinlupa Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "MVSM Bank (A Rural Bank Since 1953) INC.",
      isAccepted: true
    },
    {
      bank: "N2/NISF Military Personnel & Civilian Employees Savings & Loan Association, Inc. (N2/NISF MPCESLAI)",
      isAccepted: true
    },
    {
      bank: "National Teachers & Employees Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "NBI Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Negros Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "New Covenant Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Agoncillo, Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Binalbagan, Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of San Leonardo (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Tagkawayan, Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Victorias, Inc.",
      isAccepted: true
    },
    {
      bank: "NIA Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "North Pacific Banking Corp. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Northpoint Development Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "NPC Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Occidental Mindoro Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Occidental Mindoro Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "One Network Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Opportunity Kauswagan Bank, Inc. (A Microfinance TB)",
      isAccepted: true
    },
    {
      bank: "Optimum Development Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Oriental Tamaraw Rural Bank of Naujan, Inc.",
      isAccepted: true
    },
    {
      bank: "Orix Metro Leasing and Finance Corporation",
      isAccepted: true
    },
    {
      bank: "Ormon Bank (RB of Mulanay, Inc.)",
      isAccepted: true
    },
    {
      bank: "Own Bank, The Rural Bank of Cavite City, Inc.",
      isAccepted: true
    },
    {
      bank: "Pacific Ace Savings Bank",
      isAccepted: true
    },
    {
      bank: "PAL Employees Savings & Loan Association (PESALA)",
      isAccepted: true
    },
    {
      bank: "Pampanga Development Bank",
      isAccepted: true
    },
    {
      bank: "Pangasinan Bank (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Panguil Bay Rural Bank",
      isAccepted: true
    },
    {
      bank: "Partner Rural Bank (Cotabato), Inc.",
      isAccepted: true
    },
    {
      bank: "Pe\xF1afrancia Rural Bank of Calabanga, Inc.",
      isAccepted: true
    },
    {
      bank: "Penbank, Inc. (A Private Development Bank) (Formerly: Peninsula Rural Bank, Inc.)",
      isAccepted: true
    },
    {
      bank: "People's Bank of Caraga, Inc.",
      isAccepted: true
    },
    {
      bank: "People's Rural Bank (Gen. Santos City), Inc.",
      isAccepted: true
    },
    {
      bank: "Philippine Coast Guard Savings & Loan Association, Inc. (PCGSLAI)",
      isAccepted: true
    },
    {
      bank: "Philippine Depository and Trust Corp",
      isAccepted: true
    },
    {
      bank: "Philippine Navy Savings & Loan Association, Inc. (PNSLAI)",
      isAccepted: true
    },
    {
      bank: "Philippine Postal Savings Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Rural Banking Corp. (PR Bank)",
      isAccepted: true
    },
    {
      bank: "Philippine Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Philippine SME Bank, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Trust Company",
      isAccepted: true
    },
    {
      bank: "Philnabank Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Philtrust Company Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Phimco Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "PlanBank-Rural Bank of Canlubang Planters, Inc.",
      isAccepted: true
    },
    {
      bank: "Port Community Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Premiere Development Bank",
      isAccepted: true
    },
    {
      bank: "Pres. Jose P. Laurel Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Pride Star Development Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Producers Savings Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Professional Regulation Commission Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Progress Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Progressive Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Progressive Bank, Inc. (Progressive-A Rural Bank Inc.)",
      isAccepted: true
    },
    {
      bank: "Providence Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Provident Rural Bank of Sta. Cruz, Inc.",
      isAccepted: true
    },
    {
      bank: "Public Safety Savings & Loan Association, Inc. (PSSLAI)",
      isAccepted: true
    },
    {
      bank: "Quezon Capital Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Quezon Coconut Producers Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Quezon Traders Rural Bank of Candelaria, Inc.",
      isAccepted: true
    },
    {
      bank: "Racso's Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Rang-ay Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "RB of Do\xF1a Remedios Trinidad, Inc.",
      isAccepted: true
    },
    {
      bank: "RB of Pres. Manuel A. Roxas, Inc.",
      isAccepted: true
    },
    {
      bank: "RBG Imperial Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "RBT Bank, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "RGC Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Rizal Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "RNG Coastal Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Rodriguez Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "RPP Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Abucay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Agoo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alabat, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alabel, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alaminos (Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alaminos (Pangasinan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alicia, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alimodian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alitagtag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Altavas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Amadeo (Cavite), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Amlan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Anda, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angadanan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angat, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angeles, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angono, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Antipolo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Apalit, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Aritao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Atimonan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bacnotan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Baco, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bacolod City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bacong (Negros Oriental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Badiangan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bagabag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bagac, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Baguio, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Balete, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Balingasag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Balungao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bambang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Banayoyo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Banga, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bangar, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bansud, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Barili, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Barotac Nuevo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Barotac Viejo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Basay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Basey, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Batac, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bato, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bauang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bayambang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bayawan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bayombong, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Benito Soliven, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bogo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bolinao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bonifacio, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bontoc, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Borongan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Brookes Point, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bucay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Buenavista, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bugasong, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Buguias, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Burauen, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bustos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Caba (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabadbaran, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabangan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabatuan (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabugao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cadiz, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cainta, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calaca, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calamba, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calasiao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calauan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calbayog City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calinog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Caloocan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calubian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Camalig, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Candelaria (Quezon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Candelaria (Zambales), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Capalonga, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cardona, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Casiguran, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Catubig, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cauayan (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cavinti, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cebu South, Inc. (Sibonga RB)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Central Pangasinan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Claveria, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Compostela (Comval), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cotabato, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cuartero, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cuenca, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cuyo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dasmari\xF1as, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Datu Paglas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Digos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dolores (Quezon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Donsol, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dulag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dumangas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dupax , Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of El Salvador, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Escalante, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gainza, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Galimuyod, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gandara, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gattaran, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of General Luna, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of General Trias, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gigaquit, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gingoog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gitagum, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gloria, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Goa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Guihulngan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Guinobatan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Guiuan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hagonoy, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hermosa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hilongos,Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hindang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hinundayan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ibajay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Iligan City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ilog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Iloilo City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Infanta, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Initao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Irosin, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Itogon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jaen, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jamindan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Javier, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jimenez, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jordan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jose Panganiban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kabasalan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kapalong, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Karomatan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kawit, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kiamba, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kibawe, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kinogitan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kolambugan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of La Paz (Tarlac), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of La Trinidad, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Labason, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Labrador, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lanuza, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Larena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lebak, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Leganes, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lemery (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Liloy, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Limay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lipa City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lobo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Loboc, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Loon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lopez Jaena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Loreto, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lubao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lucban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luisiana, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lumban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luna (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luna (Kalinga-Apayao), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luna (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lupao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ma-ao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maasin (So. Leyte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mabalacat, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mabini (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mabitac, Inc. (Fortune Bank)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maddela, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Madridejos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Magdalena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Magsingal, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mahaplag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maigo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Majayjay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Makato, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Malinao (Aklan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Malitbog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Malolos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mambusao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Manapla, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mandaue, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mangaldan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Manolo Fortich, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Manukan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maragondon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Marayo (Negros Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maria Aurora, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Marilag (Sta. Maria,Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Matag-ob, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mati, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mauban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mawab, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Medina, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mendez, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mexico, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Miagao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Midsayap, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of M'lang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Montalban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Montevista, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Nabunturan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Nagcarlan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Naguilian (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Naic, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Nasugbu, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Naval, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of New Corella, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of New Washington, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Norala, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ocampo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Odiongan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ormoc City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Oroquieta, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Oslob, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Oton, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Padre Burgos (Southern Leyte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Padre Garcia, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Paete, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pagadian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pagbilao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pagsanjan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pamplona (Camarines Sur), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pamplona (Negros Oriental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pana-on, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Panay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pandi, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pangil, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Paracale, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pavia, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pilar (Bataan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pilar (Sorsogon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pinamalayan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Placer (Surigao del Norte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Plaridel (Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Plaridel (Misamis Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pola, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Polomolok, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Porac, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pototan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pozorrubio, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pres. Quirino, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Puerto Galera, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pura, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Quezon (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ragay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ramon, Inc,",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Reina Mercedes, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rizal (Kalinga), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rizal (Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rizal (Z.N.), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rosario (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Roxas (Oriental Mindoro), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sagada, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sagay (Negros Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Salcedo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Salinas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Salug, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sampaloc, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Agustin, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Antonio (Quezon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Enrique, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Fabian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Fernando (Camarines Sur), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Fernando (Cebu), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Jacinto, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Jose (Camarines), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Juan (Southern Leyte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Lorenzo Ruiz (Siniloan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Luis (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Luis (Pampanga), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Manuel (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Marcelino, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Mateo (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Miguel (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Narciso (Zambales), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Nicolas (Pangasinan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Pascual, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Quintin, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Rafael (Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Vicente, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sanchez Mira, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Santa Catalina, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Santiago de Libon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sapian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sasmuan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Seven Lakes, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Siaton, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sibalom, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sibulan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Silay City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Siocon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sipocot, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Socorro, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Solano, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Barbara (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Elena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Fe (Romblon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Ignacia, Inc. (Signa Bank)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Magdalena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Maria (Ilocos Sur) Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Rosa (Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Rosa de Lima, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sto. Domingo (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sto. Tomas (Davao), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sudipen, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Taal, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tabuk, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Taft, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tagaytay City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talisay (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talisay (Cebu), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talisay (Negros Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talugtog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tandag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tangub, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tanjay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tayabas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Taysan, Inc. (Banco Batangas)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Teresa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tibiao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tigaon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tigbauan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tudela, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tumauini, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Valencia (Bukidnon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Valencia (Negros Or.), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Victoria (Oriental Mindoro), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Victoria, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Villaverde, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Villaviciosa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Zarraga, Inc.",
      isAccepted: true
    },
    {
      bank: "Sadiri Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Salug Valley Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sampaguita Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "San Bartolome Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "San Fernando Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "San Francisco Del Monte Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sarangani Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings & Loan Association of Government Auditors, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings & Loan Association of Mataas na Kahoy, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings & Loan Association of Power Employees, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings &n Loan Association of P & G Phil. Employees, Inc.",
      isAccepted: true
    },
    {
      bank: "Saviour Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Science Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Second Rural Bank of Meycauayan, Inc.",
      isAccepted: true
    },
    {
      bank: "Second Rural Bank of San Luis (Pampanga), Inc.",
      isAccepted: true
    },
    {
      bank: "Second Rural Bank of Valenzuela, Inc.",
      isAccepted: true
    },
    {
      bank: "Secured Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Shell Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Shell Refinery Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Shoe Mart Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Siam Bank (CRB of Lugait Inc.)",
      isAccepted: true
    },
    {
      bank: "Siargao Bank, Inc. (A Rural Bank) RB of Dapa, Inc.",
      isAccepted: true
    },
    {
      bank: "Silahis Bank Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Silangan Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Smart Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Sorsogon Provincial Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "South Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Southeast Country Bank, Inc. - RB of Camaligan, Inc.",
      isAccepted: true
    },
    {
      bank: "Southern Leyte Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Southern Luzon Teachers Savings & Loan Association, Inc. (SLTSLAI)",
      isAccepted: true
    },
    {
      bank: "Southernside Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "St. Michael Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sta. Maria Rural Bank (Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "State Investment Trust, Inc.",
      isAccepted: true
    },
    {
      bank: "Sterling Bank of Asia, Inc. (A Savings Bank)",
      isAccepted: true
    },
    {
      bank: "Sto. Ni\xF1o Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sto. Rosario Rural Bank (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Sugbuanon Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Summit Bank (Rural Bank of Tublay, Inc.)",
      isAccepted: true
    },
    {
      bank: "Summit Rural Bank of Lipa City, Inc.",
      isAccepted: true
    },
    {
      bank: "Sunrise Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Supreme Court Savings & Loan Association, Inc. (SCSLAI)",
      isAccepted: true
    },
    {
      bank: "Surigao City Evergreen Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Surigao Officials & Employees Savings & Loan Association",
      isAccepted: true
    },
    {
      bank: "Surigaonon Rural Banking Corporation",
      isAccepted: true
    },
    {
      bank: "Synergy Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tamaraw Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tanay Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Telecommunications Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "The Country Bank, Inc. (RB Bongabong, Inc.)",
      isAccepted: true
    },
    {
      bank: "The Palawan Bank (Palawan Development Bank, Inc.)",
      isAccepted: true
    },
    {
      bank: "Tiaong Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tong Yang Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tower Development Bank",
      isAccepted: true
    },
    {
      bank: "Towncall Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Toyota Financial Services Philippines Corporation (TFSPH)",
      isAccepted: true
    },
    {
      bank: "Toyota Motor Philippines Savings & Loan Association, Inc. (TMPSLAI)",
      isAccepted: true
    },
    {
      bank: "Turumba Rural Bank of Pakil, Inc.",
      isAccepted: true
    },
    {
      bank: "Unilink Bank Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "United Consumers Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "United Overseas Bank Philippines",
      isAccepted: true
    },
    {
      bank: "United People's Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Unity Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Universal Rural Bank of Lopez, Inc.",
      isAccepted: true
    },
    {
      bank: "University of Luzon Savings & Loan Association",
      isAccepted: true
    },
    {
      bank: "University Savings Bank",
      isAccepted: true
    },
    {
      bank: "Unlad Rural Bank of Noveleta, Inc.",
      isAccepted: true
    },
    {
      bank: "Upland Rural Bank of Dalaguete (Cebu), Inc.",
      isAccepted: true
    },
    {
      bank: "Utility Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Valiant Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Vigan Banco Rural, Incorporada",
      isAccepted: true
    },
    {
      bank: "Village Bank, Inc. (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "Vision Bank, Inc.- A Rural Bank (Microfinance)",
      isAccepted: true
    },
    {
      bank: "Vizcaya Bank, A Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Water and Sewerage Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Wealth Bank - A Development Bank",
      isAccepted: true
    },
    {
      bank: "Women's Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Wyeth Suaco Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Xavier-Punla Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Xavier-Tibod Bank, Inc. (Microfinance Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Zambales Rural Bank (Zambank)-RB Castillejos",
      isAccepted: true
    }
  ],
  Bangladesh: [
    {
      bank: "AB Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bank Alfalah Limited",
      isAccepted: true
    },
    {
      bank: "The City Bank Limited",
      isAccepted: true
    },
    {
      bank: "Eastern Bank Limited",
      isAccepted: true
    },
    {
      bank: "International Finance Investment and Commerce Bank Limited",
      isAccepted: true
    },
    {
      bank: "National Credit and Commerce Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Southeast Bank Ltd",
      isAccepted: true
    },
    {
      bank: "One Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mutual trust Bank Ltd",
      isAccepted: true
    },
    {
      bank: "BRAC Bank Ltd",
      isAccepted: true
    },
    {
      bank: "First Security Islami Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shahjalal Islami Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "State Bank of India",
      isAccepted: false
    },
    {
      bank: "Citi Bank",
      isAccepted: true
    },
    {
      bank: "Commercial Bank of Ceylon Ltd",
      isAccepted: true
    },
    {
      bank: "The Hong Kong and Shanghai Banking Corporation Ltd",
      isAccepted: true
    },
    {
      bank: "Dhaka Bank Limited",
      isAccepted: true
    },
    {
      bank: "Premier Bank Limited",
      isAccepted: true
    },
    {
      bank: "Prime Bank Limited",
      isAccepted: true
    },
    {
      bank: "Pubali Bank Limited",
      isAccepted: true
    },
    {
      bank: "Standard Bank Limited",
      isAccepted: true
    },
    {
      bank: "Trust Bank Limited",
      isAccepted: true
    },
    {
      bank: "Woori Bank Limited",
      isAccepted: true
    },
    {
      bank: "Agrani Bank Limited",
      isAccepted: true
    },
    {
      bank: "Al-Arafah Islami Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ansar-Vidipi Bank",
      isAccepted: true
    },
    {
      bank: "Bangladesh Commerce Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bangladesh Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bangladesh Krishi Bank",
      isAccepted: true
    },
    {
      bank: "Bangladesh Small Industries and Commerce (BASIC) Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bank Asia Limited",
      isAccepted: true
    },
    {
      bank: "Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Dutch Bangla Bank Limited",
      isAccepted: true
    },
    {
      bank: "Export Import Bank of Bangladesh Limited",
      isAccepted: true
    },
    {
      bank: "Grameen Bank",
      isAccepted: true
    },
    {
      bank: "Habib Bank Limited",
      isAccepted: true
    },
    {
      bank: "Islami Bank Bangladesh Limited",
      isAccepted: true
    },
    {
      bank: "Jamuna Bank Limited Janata Bank Limited",
      isAccepted: true
    },
    {
      bank: "Karmashangstan Bank",
      isAccepted: true
    },
    {
      bank: "Mercantile Bank Limited",
      isAccepted: true
    },
    {
      bank: "National Bank Limited",
      isAccepted: true
    },
    {
      bank: "National Bank of Pakistan",
      isAccepted: true
    },
    {
      bank: "Rupali Bank Limited",
      isAccepted: true
    },
    {
      bank: "Social Islami Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sonali Bank Limited",
      isAccepted: true
    },
    {
      bank: "ICB Islamic Bank Limited",
      isAccepted: true
    },
    {
      bank: "United Commercial Bank Limited",
      isAccepted: true
    },
    {
      bank: "Uttara Bank Limited",
      isAccepted: true
    }
  ],
  "Sri Lanka": [
    {
      bank: "Amana Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Axis Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of Ceylon",
      isAccepted: true
    },
    {
      bank: "Citibank, N.A.",
      isAccepted: true
    },
    {
      bank: "Commercial Bank of Ceylon PLC",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "DFCC Vardhana Bank PLC",
      isAccepted: true
    },
    {
      bank: "Habib Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hatton National Bank PLC",
      isAccepted: true
    },
    {
      bank: "ICICI Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indian Bank",
      isAccepted: true
    },
    {
      bank: "Indian Overseas Bank",
      isAccepted: true
    },
    {
      bank: "MCB Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Development Bank PLC",
      isAccepted: true
    },
    {
      bank: "Nations Trust Bank PLC",
      isAccepted: true
    },
    {
      bank: "Pan Asia Banking Corporation PLC",
      isAccepted: true
    },
    {
      bank: "People's Bank",
      isAccepted: true
    },
    {
      bank: "Public Bank Berhad",
      isAccepted: true
    },
    {
      bank: "Sampath Bank PLC",
      isAccepted: true
    },
    {
      bank: "Seylan Bank PLC",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "State Bank of India",
      isAccepted: true
    },
    {
      bank: "The Hongkong & Shanghai Banking Corporation Ltd",
      isAccepted: true
    },
    {
      bank: "Union Bank of Colombo PLC",
      isAccepted: true
    },
    {
      bank: "DFCC Bank",
      isAccepted: true
    },
    {
      bank: "Housing Development Finance",
      isAccepted: true
    },
    {
      bank: "Lankaputra Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "MBSL Savings Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Savings Bank",
      isAccepted: true
    },
    {
      bank: "Pradeshiya Sanwardhana Bank",
      isAccepted: true
    },
    {
      bank: "Sanasa Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Lanka Sarvings Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Mortgage & Investment Bank",
      isAccepted: true
    }
  ]
});

// src/finance/currencies.ts
var currencies = deepFreeze([
  {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars"
  },
  {
    symbol: "CA$",
    name: "Canadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CAD",
    name_plural: "Canadian dollars"
  },
  {
    symbol: "\u20AC",
    name: "Euro",
    symbol_native: "\u20AC",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros"
  },
  {
    symbol: "AED",
    name: "United Arab Emirates Dirham",
    symbol_native: "\u062F.\u0625.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "AED",
    name_plural: "UAE dirhams"
  },
  {
    symbol: "Af",
    name: "Afghan Afghani",
    symbol_native: "\u060B",
    decimal_digits: 0,
    rounding: 0,
    code: "AFN",
    name_plural: "Afghan Afghanis"
  },
  {
    symbol: "ALL",
    name: "Albanian Lek",
    symbol_native: "Lek",
    decimal_digits: 0,
    rounding: 0,
    code: "ALL",
    name_plural: "Albanian lek\xEB"
  },
  {
    symbol: "AMD",
    name: "Armenian Dram",
    symbol_native: "\u0564\u0580.",
    decimal_digits: 0,
    rounding: 0,
    code: "AMD",
    name_plural: "Armenian drams"
  },
  {
    symbol: "\u0192",
    name: "Netherlands Antillean guilder",
    symbol_native: "\u0192",
    decimal_digits: 0,
    rounding: 0,
    code: "ANG",
    name_plural: "Netherlands Antillean guilder"
  },
  {
    symbol: "Kz",
    name: "Angolan Kwanza",
    symbol_native: "Kz",
    decimal_digits: 0,
    rounding: 0,
    code: "AOA",
    name_plural: "Angolan Kwanzas"
  },
  {
    symbol: "AR$",
    name: "Argentine Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "ARS",
    name_plural: "Argentine pesos"
  },
  {
    symbol: "AU$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars"
  },
  {
    symbol: "man.",
    name: "Azerbaijani Manat",
    symbol_native: "\u043C\u0430\u043D.",
    decimal_digits: 2,
    rounding: 0,
    code: "AZN",
    name_plural: "Azerbaijani manats"
  },
  {
    symbol: "KM",
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol_native: "KM",
    decimal_digits: 2,
    rounding: 0,
    code: "BAM",
    name_plural: "Bosnia-Herzegovina convertible marks"
  },
  {
    symbol: "BBD$",
    name: "Barbadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BBD",
    name_plural: "Barbadian Dollars"
  },
  {
    symbol: "Tk",
    name: "Bangladeshi Taka",
    symbol_native: "\u09F3",
    decimal_digits: 2,
    rounding: 0,
    code: "BDT",
    name_plural: "Bangladeshi takas"
  },
  {
    symbol: "BGN",
    name: "Bulgarian Lev",
    symbol_native: "\u043B\u0432.",
    decimal_digits: 2,
    rounding: 0,
    code: "BGN",
    name_plural: "Bulgarian leva"
  },
  {
    symbol: "BD",
    name: "Bahraini Dinar",
    symbol_native: "\u062F.\u0628.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "BHD",
    name_plural: "Bahraini dinars"
  },
  {
    symbol: "FBu",
    name: "Burundian Franc",
    symbol_native: "FBu",
    decimal_digits: 0,
    rounding: 0,
    code: "BIF",
    name_plural: "Burundian francs"
  },
  {
    symbol: "BN$",
    name: "Brunei Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BND",
    name_plural: "Brunei dollars"
  },
  {
    symbol: "$",
    name: "Bermudian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BMD",
    name_plural: "Bermudian Dollar"
  },
  {
    symbol: "Bs",
    name: "Bolivian Boliviano",
    symbol_native: "Bs",
    decimal_digits: 2,
    rounding: 0,
    code: "BOB",
    name_plural: "Bolivian bolivianos"
  },
  {
    symbol: "R$",
    name: "Brazilian Real",
    symbol_native: "R$",
    decimal_digits: 2,
    rounding: 0,
    code: "BRL",
    name_plural: "Brazilian reals"
  },
  {
    symbol: "Nu.",
    name: "Bhutanese Ngultrum",
    symbol_native: "Nu.",
    decimal_digits: 2,
    rounding: 0,
    code: "BTN",
    name_plural: "Bhutanese Ngultrum"
  },
  {
    symbol: "BWP",
    name: "Botswanan Pula",
    symbol_native: "P",
    decimal_digits: 2,
    rounding: 0,
    code: "BWP",
    name_plural: "Botswanan pulas"
  },
  {
    symbol: "BYR",
    name: "Belarusian Ruble",
    symbol_native: "BYR",
    decimal_digits: 0,
    rounding: 0,
    code: "BYR",
    name_plural: "Belarusian rubles"
  },
  {
    symbol: "BZ$",
    name: "Belize Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BZD",
    name_plural: "Belize dollars"
  },
  {
    symbol: "CDF",
    name: "Congolese Franc",
    symbol_native: "FrCD",
    decimal_digits: 2,
    rounding: 0,
    code: "CDF",
    name_plural: "Congolese francs"
  },
  {
    symbol: "CHF",
    name: "Swiss Franc",
    symbol_native: "CHF",
    decimal_digits: 2,
    rounding: 0.05,
    code: "CHF",
    name_plural: "Swiss francs"
  },
  {
    symbol: "CL$",
    name: "Chilean Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "CLP",
    name_plural: "Chilean pesos"
  },
  {
    symbol: "CN\xA5",
    name: "Chinese Yuan",
    symbol_native: "CN\xA5",
    decimal_digits: 2,
    rounding: 0,
    code: "CNY",
    name_plural: "Chinese yuan"
  },
  {
    symbol: "CO$",
    name: "Colombian Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "COP",
    name_plural: "Colombian pesos"
  },
  {
    symbol: "\u20A1",
    name: "Costa Rican Col\xF3n",
    symbol_native: "\u20A1",
    decimal_digits: 0,
    rounding: 0,
    code: "CRC",
    name_plural: "Costa Rican col\xF3ns"
  },
  {
    symbol: "CV$",
    name: "Cape Verdean Escudo",
    symbol_native: "CV$",
    decimal_digits: 2,
    rounding: 0,
    code: "CVE",
    name_plural: "Cape Verdean escudos"
  },
  {
    symbol: "K\u010D",
    name: "Czech Republic Koruna",
    symbol_native: "K\u010D",
    decimal_digits: 2,
    rounding: 0,
    code: "CZK",
    name_plural: "Czech Republic korunas"
  },
  {
    symbol: "Fdj",
    name: "Djiboutian Franc",
    symbol_native: "Fdj",
    decimal_digits: 0,
    rounding: 0,
    code: "DJF",
    name_plural: "Djiboutian francs"
  },
  {
    symbol: "Dkr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner"
  },
  {
    symbol: "RD$",
    name: "Dominican Peso",
    symbol_native: "RD$",
    decimal_digits: 2,
    rounding: 0,
    code: "DOP",
    name_plural: "Dominican pesos"
  },
  {
    symbol: "DA",
    name: "Algerian Dinar",
    symbol_native: "\u062F.\u062C.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "DZD",
    name_plural: "Algerian dinars"
  },
  {
    symbol: "Ekr",
    name: "Estonian Kroon",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "EEK",
    name_plural: "Estonian kroons"
  },
  {
    symbol: "EGP",
    name: "Egyptian Pound",
    symbol_native: "\u062C.\u0645.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "EGP",
    name_plural: "Egyptian pounds"
  },
  {
    symbol: "Nfk",
    name: "Eritrean Nakfa",
    symbol_native: "Nfk",
    decimal_digits: 2,
    rounding: 0,
    code: "ERN",
    name_plural: "Eritrean nakfas"
  },
  {
    symbol: "Br",
    name: "Ethiopian Birr",
    symbol_native: "Br",
    decimal_digits: 2,
    rounding: 0,
    code: "ETB",
    name_plural: "Ethiopian birrs"
  },
  {
    symbol: "\xA3",
    name: "Falkland Island Pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "FKP",
    name_plural: "Falkland Island Pounds"
  },
  {
    symbol: "\xA3",
    name: "British Pound Sterling",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "British pounds sterling"
  },
  {
    symbol: "GEL",
    name: "Georgian Lari",
    symbol_native: "GEL",
    decimal_digits: 2,
    rounding: 0,
    code: "GEL",
    name_plural: "Georgian laris"
  },
  {
    symbol: "GH\u20B5",
    name: "Ghanaian Cedi",
    symbol_native: "GH\u20B5",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Ghanaian cedis"
  },
  {
    symbol: "\xA3",
    name: "Gibraltar Pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Gibraltar pound"
  },
  {
    symbol: "FG",
    name: "Guinean Franc",
    symbol_native: "FG",
    decimal_digits: 0,
    rounding: 0,
    code: "GNF",
    name_plural: "Guinean francs"
  },
  {
    symbol: "GTQ",
    name: "Guatemalan Quetzal",
    symbol_native: "Q",
    decimal_digits: 2,
    rounding: 0,
    code: "GTQ",
    name_plural: "Guatemalan quetzals"
  },
  {
    symbol: "HK$",
    name: "Hong Kong Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "HKD",
    name_plural: "Hong Kong dollars"
  },
  {
    symbol: "HNL",
    name: "Honduran Lempira",
    symbol_native: "L",
    decimal_digits: 2,
    rounding: 0,
    code: "HNL",
    name_plural: "Honduran lempiras"
  },
  {
    symbol: "kn",
    name: "Croatian Kuna",
    symbol_native: "kn",
    decimal_digits: 2,
    rounding: 0,
    code: "HRK",
    name_plural: "Croatian kunas"
  },
  {
    symbol: "Ft",
    name: "Hungarian Forint",
    symbol_native: "Ft",
    decimal_digits: 0,
    rounding: 0,
    code: "HUF",
    name_plural: "Hungarian forints"
  },
  {
    symbol: "FJ$",
    name: "Fijian Dollar",
    symbol_native: "FJ$",
    decimal_digits: 2,
    rounding: 0,
    code: "FJD",
    name_plural: "Fijian dollars"
  },
  {
    symbol: "Rp",
    name: "Indonesian Rupiah",
    symbol_native: "Rp",
    decimal_digits: 0,
    rounding: 0,
    code: "IDR",
    name_plural: "Indonesian rupiahs"
  },
  {
    symbol: "\u20AA",
    name: "Israeli New Sheqel",
    symbol_native: "\u20AA",
    decimal_digits: 2,
    rounding: 0,
    code: "ILS",
    name_plural: "Israeli new sheqels"
  },
  {
    symbol: "Rs",
    name: "Indian Rupee",
    symbol_native: "\u099F\u0995\u09BE",
    decimal_digits: 2,
    rounding: 0,
    code: "INR",
    name_plural: "Indian rupees"
  },
  {
    symbol: "IQD",
    name: "Iraqi Dinar",
    symbol_native: "\u062F.\u0639.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "IQD",
    name_plural: "Iraqi dinars"
  },
  {
    symbol: "IRR",
    name: "Iranian Rial",
    symbol_native: "\uFDFC",
    decimal_digits: 0,
    rounding: 0,
    code: "IRR",
    name_plural: "Iranian rials"
  },
  {
    symbol: "Ikr",
    name: "Icelandic Kr\xF3na",
    symbol_native: "kr",
    decimal_digits: 0,
    rounding: 0,
    code: "ISK",
    name_plural: "Icelandic kr\xF3nur"
  },
  {
    symbol: "J$",
    name: "Jamaican Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "JMD",
    name_plural: "Jamaican dollars"
  },
  {
    symbol: "JD",
    name: "Jordanian Dinar",
    symbol_native: "\u062F.\u0623.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "JOD",
    name_plural: "Jordanian dinars"
  },
  {
    symbol: "\xA5",
    name: "Japanese Yen",
    symbol_native: "\uFFE5",
    decimal_digits: 0,
    rounding: 0,
    code: "JPY",
    name_plural: "Japanese yen"
  },
  {
    symbol: "\u0441",
    name: "Kyrgyzstani som",
    symbol_native: "\u0441",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kyrgyzstani som"
  },
  {
    symbol: "Ksh",
    name: "Kyrgyzstani Som",
    symbol_native: "Ksh",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kenyan shillings"
  },
  {
    symbol: "KHR",
    name: "Cambodian Riel",
    symbol_native: "\u17DB",
    decimal_digits: 2,
    rounding: 0,
    code: "KHR",
    name_plural: "Cambodian riels"
  },
  {
    symbol: "CF",
    name: "Comorian Franc",
    symbol_native: "FC",
    decimal_digits: 0,
    rounding: 0,
    code: "KMF",
    name_plural: "Comorian francs"
  },
  {
    symbol: "\u20A9",
    name: "South Korean Won",
    symbol_native: "\u20A9",
    decimal_digits: 0,
    rounding: 0,
    code: "KRW",
    name_plural: "South Korean won"
  },
  {
    symbol: "KD",
    name: "Kuwaiti Dinar",
    symbol_native: "\u062F.\u0643.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "KWD",
    name_plural: "Kuwaiti dinars"
  },
  {
    symbol: "$",
    name: "Cayman Islands dollar",
    symbol_native: "$\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "KYD",
    name_plural: "Cayman Islands dollarS"
  },
  {
    symbol: "KZT",
    name: "Kazakhstani Tenge",
    symbol_native: "\u0442\u04A3\u0433.",
    decimal_digits: 2,
    rounding: 0,
    code: "KZT",
    name_plural: "Kazakhstani tenges"
  },
  {
    symbol: "\u20AD",
    name: "Lao kip",
    symbol_native: "\u20AD\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "LAK",
    name_plural: "Lao kip"
  },
  {
    symbol: "LB\xA3",
    name: "Lebanese Pound",
    symbol_native: "\u0644.\u0644.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "LBP",
    name_plural: "Lebanese pounds"
  },
  {
    symbol: "SLRs",
    name: "Sri Lankan Rupee",
    symbol_native: "SL Re",
    decimal_digits: 2,
    rounding: 0,
    code: "LKR",
    name_plural: "Sri Lankan rupees"
  },
  {
    symbol: "$",
    name: "Liberian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "LRD",
    name_plural: "Liberian Dollars"
  },
  {
    symbol: "Lt",
    name: "Lithuanian Litas",
    symbol_native: "Lt",
    decimal_digits: 2,
    rounding: 0,
    code: "LTL",
    name_plural: "Lithuanian litai"
  },
  {
    symbol: "Ls",
    name: "Latvian Lats",
    symbol_native: "Ls",
    decimal_digits: 2,
    rounding: 0,
    code: "LVL",
    name_plural: "Latvian lati"
  },
  {
    symbol: "LD",
    name: "Libyan Dinar",
    symbol_native: "\u062F.\u0644.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "LYD",
    name_plural: "Libyan dinars"
  },
  {
    symbol: "MAD",
    name: "Moroccan Dirham",
    symbol_native: "\u062F.\u0645.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "MAD",
    name_plural: "Moroccan dirhams"
  },
  {
    symbol: "MDL",
    name: "Moldovan Leu",
    symbol_native: "MDL",
    decimal_digits: 2,
    rounding: 0,
    code: "MDL",
    name_plural: "Moldovan lei"
  },
  {
    symbol: "MGA",
    name: "Malagasy Ariary",
    symbol_native: "MGA",
    decimal_digits: 0,
    rounding: 0,
    code: "MGA",
    name_plural: "Malagasy Ariaries"
  },
  {
    symbol: "MKD",
    name: "Macedonian Denar",
    symbol_native: "MKD",
    decimal_digits: 2,
    rounding: 0,
    code: "MKD",
    name_plural: "Macedonian denari"
  },
  {
    symbol: "MMK",
    name: "Myanma Kyat",
    symbol_native: "K",
    decimal_digits: 0,
    rounding: 0,
    code: "MMK",
    name_plural: "Myanma kyats"
  },
  {
    symbol: "MOP$",
    name: "Macanese Pataca",
    symbol_native: "MOP$",
    decimal_digits: 2,
    rounding: 0,
    code: "MOP",
    name_plural: "Macanese patacas"
  },
  {
    symbol: "MURs",
    name: "Mauritian Rupee",
    symbol_native: "MURs",
    decimal_digits: 0,
    rounding: 0,
    code: "MUR",
    name_plural: "Mauritian rupees"
  },
  {
    symbol: "MK",
    name: "Malawian Kwacha",
    symbol_native: "MK",
    decimal_digits: 2,
    rounding: 0,
    code: "MWK",
    name_plural: "Malawian Kwacha"
  },
  {
    symbol: "MX$",
    name: "Mexican Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "MXN",
    name_plural: "Mexican pesos"
  },
  {
    symbol: "RM",
    name: "Malaysian Ringgit",
    symbol_native: "RM",
    decimal_digits: 2,
    rounding: 0,
    code: "MYR",
    name_plural: "Malaysian ringgits"
  },
  {
    symbol: "MTn",
    name: "Mozambican Metical",
    symbol_native: "MTn",
    decimal_digits: 2,
    rounding: 0,
    code: "MZN",
    name_plural: "Mozambican meticals"
  },
  {
    symbol: "N$",
    name: "Namibian Dollar",
    symbol_native: "N$",
    decimal_digits: 2,
    rounding: 0,
    code: "NAD",
    name_plural: "Namibian dollars"
  },
  {
    symbol: "\u20A6",
    name: "Nigerian Naira",
    symbol_native: "\u20A6",
    decimal_digits: 2,
    rounding: 0,
    code: "NGN",
    name_plural: "Nigerian nairas"
  },
  {
    symbol: "C$",
    name: "Nicaraguan C\xF3rdoba",
    symbol_native: "C$",
    decimal_digits: 2,
    rounding: 0,
    code: "NIO",
    name_plural: "Nicaraguan c\xF3rdobas"
  },
  {
    symbol: "Nkr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner"
  },
  {
    symbol: "NPRs",
    name: "Nepalese Rupee",
    symbol_native: "\u0928\u0947\u0930\u0942",
    decimal_digits: 2,
    rounding: 0,
    code: "NPR",
    name_plural: "Nepalese rupees"
  },
  {
    symbol: "NZ$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars"
  },
  {
    symbol: "OMR",
    name: "Omani Rial",
    symbol_native: "\u0631.\u0639.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "OMR",
    name_plural: "Omani rials"
  },
  {
    symbol: "B/.",
    name: "Panamanian Balboa",
    symbol_native: "B/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PAB",
    name_plural: "Panamanian balboas"
  },
  {
    symbol: "S/.",
    name: "Peruvian Sol",
    symbol_native: "S/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PEN",
    name_plural: "Peruvian soles"
  },
  {
    symbol: "\u20B1",
    name: "Philippine Peso",
    symbol_native: "\u20B1",
    decimal_digits: 2,
    rounding: 0,
    code: "PHP",
    name_plural: "Philippine pesos"
  },
  {
    symbol: "PKRs",
    name: "Pakistani Rupee",
    symbol_native: "\u20A8",
    decimal_digits: 0,
    rounding: 0,
    code: "PKR",
    name_plural: "Pakistani rupees"
  },
  {
    symbol: "z\u0142",
    name: "Polish Zloty",
    symbol_native: "z\u0142",
    decimal_digits: 2,
    rounding: 0,
    code: "PLN",
    name_plural: "Polish zlotys"
  },
  {
    symbol: "\u20B2",
    name: "Paraguayan Guarani",
    symbol_native: "\u20B2",
    decimal_digits: 0,
    rounding: 0,
    code: "PYG",
    name_plural: "Paraguayan guaranis"
  },
  {
    symbol: "QR",
    name: "Qatari Rial",
    symbol_native: "\u0631.\u0642.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "QAR",
    name_plural: "Qatari rials"
  },
  {
    symbol: "RON",
    name: "Romanian Leu",
    symbol_native: "RON",
    decimal_digits: 2,
    rounding: 0,
    code: "RON",
    name_plural: "Romanian lei"
  },
  {
    symbol: "din.",
    name: "Serbian Dinar",
    symbol_native: "\u0434\u0438\u043D.",
    decimal_digits: 0,
    rounding: 0,
    code: "RSD",
    name_plural: "Serbian dinars"
  },
  {
    symbol: "RUB",
    name: "Russian Ruble",
    symbol_native: "\u0440\u0443\u0431.",
    decimal_digits: 2,
    rounding: 0,
    code: "RUB",
    name_plural: "Russian rubles"
  },
  {
    symbol: "RWF",
    name: "Rwandan Franc",
    symbol_native: "FR",
    decimal_digits: 0,
    rounding: 0,
    code: "RWF",
    name_plural: "Rwandan francs"
  },
  {
    symbol: "SR",
    name: "Saudi Riyal",
    symbol_native: "\u0631.\u0633.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "SAR",
    name_plural: "Saudi riyals"
  },
  {
    symbol: "$",
    name: "Solomon Islander Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SBD",
    name_plural: "Solomon Islander Dollars"
  },
  {
    symbol: "SDG",
    name: "Sudanese Pound",
    symbol_native: "SDG",
    decimal_digits: 2,
    rounding: 0,
    code: "SDG",
    name_plural: "Sudanese pounds"
  },
  {
    symbol: "Skr",
    name: "Swedish Krona",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "SEK",
    name_plural: "Swedish kronor"
  },
  {
    symbol: "S$",
    name: "Singapore Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SGD",
    name_plural: "Singapore dollars"
  },
  {
    symbol: "Le",
    name: "Sierra Leonean Leone",
    symbol_native: "Le",
    decimal_digits: 2,
    rounding: 0,
    code: "SLL",
    name_plural: "Sierra Leonean Leone"
  },
  {
    symbol: "Ssh",
    name: "Somali Shilling",
    symbol_native: "Ssh",
    decimal_digits: 0,
    rounding: 0,
    code: "SOS",
    name_plural: "Somali shillings"
  },
  {
    symbol: "\xA3",
    name: "South Sudanese pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "SSP",
    name_plural: "South Sudanese pound"
  },
  {
    symbol: "Db",
    name: "Sao Tomean Dobra",
    symbol_native: "Db",
    decimal_digits: 0,
    rounding: 0,
    code: "STD",
    name_plural: "Sao Tomean Dobra"
  },
  {
    symbol: "Db",
    name: "Sao Tomean Dobra",
    symbol_native: "Db",
    decimal_digits: 0,
    rounding: 0,
    code: "STN",
    name_plural: "Sao Tomean Dobra"
  },
  {
    symbol: "SY\xA3",
    name: "Syrian Pound",
    symbol_native: "\u0644.\u0633.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "SYP",
    name_plural: "Syrian pounds"
  },
  {
    symbol: "L",
    name: "Swazi Lilangeni",
    symbol_native: "L\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "SZL",
    name_plural: "Swazi Lilangeni"
  },
  {
    symbol: "\u0E3F",
    name: "Thai Baht",
    symbol_native: "\u0E3F",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Thai baht"
  },
  {
    symbol: "\u0405\u041C",
    name: "Tajikistani Somoni",
    symbol_native: "\u0405\u041C",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Tajikistani Somoni"
  },
  {
    symbol: "DT",
    name: "Tunisian Dinar",
    symbol_native: "\u062F.\u062A.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "TND",
    name_plural: "Tunisian dinars"
  },
  {
    symbol: "T$",
    name: "Tongan Pa\u02BBanga",
    symbol_native: "T$",
    decimal_digits: 2,
    rounding: 0,
    code: "TOP",
    name_plural: "Tongan pa\u02BBanga"
  },
  {
    symbol: "TL",
    name: "Turkish Lira",
    symbol_native: "TL",
    decimal_digits: 2,
    rounding: 0,
    code: "TRY",
    name_plural: "Turkish Lira"
  },
  {
    symbol: "TT$",
    name: "Trinidad and Tobago Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "TTD",
    name_plural: "Trinidad and Tobago dollars"
  },
  {
    symbol: "NT$",
    name: "New Taiwan Dollar",
    symbol_native: "NT$",
    decimal_digits: 2,
    rounding: 0,
    code: "TWD",
    name_plural: "New Taiwan dollars"
  },
  {
    symbol: "TSh",
    name: "Tanzanian Shilling",
    symbol_native: "TSh",
    decimal_digits: 0,
    rounding: 0,
    code: "TZS",
    name_plural: "Tanzanian shillings"
  },
  {
    symbol: "\u20B4",
    name: "Ukrainian Hryvnia",
    symbol_native: "\u20B4",
    decimal_digits: 2,
    rounding: 0,
    code: "UAH",
    name_plural: "Ukrainian hryvnias"
  },
  {
    symbol: "USh",
    name: "Ugandan Shilling",
    symbol_native: "USh",
    decimal_digits: 0,
    rounding: 0,
    code: "UGX",
    name_plural: "Ugandan shillings"
  },
  {
    symbol: "$U",
    name: "Uruguayan Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "UYU",
    name_plural: "Uruguayan pesos"
  },
  {
    symbol: "UZS",
    name: "Uzbekistan Som",
    symbol_native: "UZS",
    decimal_digits: 0,
    rounding: 0,
    code: "UZS",
    name_plural: "Uzbekistan som"
  },
  {
    symbol: "Bs.F.",
    name: "Venezuelan Bol\xEDvar",
    symbol_native: "Bs.F.",
    decimal_digits: 2,
    rounding: 0,
    code: "VEF",
    name_plural: "Venezuelan bol\xEDvars"
  },
  {
    symbol: "\u20AB",
    name: "Vietnamese Dong",
    symbol_native: "\u20AB",
    decimal_digits: 0,
    rounding: 0,
    code: "VND",
    name_plural: "Vietnamese dong"
  },
  {
    symbol: "Vt",
    name: "Ni-Vanuatu Vatu",
    symbol_native: "Vt",
    decimal_digits: 0,
    rounding: 0,
    code: "VUV",
    name_plural: "Ni-Vanuatu Vatu"
  },
  {
    symbol: "FCFA",
    name: "CFA Franc BEAC",
    symbol_native: "FCFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC"
  },
  {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean Dollars"
  },
  {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO"
  },
  {
    symbol: "Fr",
    name: "CFP franc",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "XPF",
    name_plural: "CFP franc"
  },
  {
    symbol: "YR",
    name: "Yemeni Rial",
    symbol_native: "\u0631.\u064A.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "YER",
    name_plural: "Yemeni rials"
  },
  {
    symbol: "R",
    name: "South African Rand",
    symbol_native: "R",
    decimal_digits: 2,
    rounding: 0,
    code: "ZAR",
    name_plural: "South African rand"
  },
  {
    symbol: "ZK",
    name: "Zambian Kwacha",
    symbol_native: "ZK",
    decimal_digits: 0,
    rounding: 0,
    code: "ZMK",
    name_plural: "Zambian kwachas"
  },
  {
    symbol: "Rf",
    name: "Maldivian rufiyaa",
    symbol_native: "\u0783",
    decimal_digits: 2,
    rounding: 0,
    code: "MVR",
    name_plural: "Maldivian rufiyaas"
  },
  {
    symbol: "\u0192",
    name: "Aruban Florin",
    symbol_native: "Afl",
    decimal_digits: 2,
    rounding: 0,
    code: "AWG",
    name_plural: "Aruban florin"
  },
  {
    symbol: "$",
    name: "Bahamian Dollar",
    symbol_native: "$, B$",
    decimal_digits: 2,
    rounding: 0,
    code: "BSD",
    name_plural: "Bahamian dollars"
  },
  {
    symbol: "L, M (pl.)",
    name: "Lesotho Loti",
    symbol_native: "L, M (pl.)",
    decimal_digits: 2,
    rounding: 0,
    code: "LSL",
    name_plural: "Lesotho maloti"
  },
  {
    symbol: "\u20B1",
    name: "Cuban Peso",
    symbol_native: "$, $MN, \u20B1",
    decimal_digits: 2,
    rounding: 0,
    code: "CUP",
    name_plural: "Cuban pesos"
  },
  {
    symbol: "\u0192",
    name: "Netherlands Antillean Guilder",
    symbol_native: "NA\u0192, NAf, \u0192, f",
    decimal_digits: 2,
    rounding: 0,
    code: "ANG",
    name_plural: "Netherlands antillean guilders"
  },
  {
    symbol: "D",
    name: "Gambian Dalasi",
    symbol_native: "D",
    decimal_digits: 2,
    rounding: 0,
    code: "GMD",
    name_plural: "Gambian dalasis"
  },
  {
    symbol: "$",
    name: "Guyanaese Dollar",
    symbol_native: "$, G$, GY$",
    decimal_digits: 2,
    rounding: 0,
    code: "GYD",
    name_plural: "Guyanaese dollars"
  },
  {
    symbol: "G",
    name: "Haitian Gourde",
    symbol_native: "G",
    decimal_digits: 2,
    rounding: 0,
    code: "HTG",
    name_plural: "Haitian gourdes"
  },
  {
    symbol: "UM",
    name: "Mauritanian Ouguiya",
    symbol_native: "UM",
    decimal_digits: 2,
    rounding: 0,
    code: "MRU",
    name_plural: "Mauritanian ouguiya"
  },
  {
    symbol: "\u20AE",
    name: "Mongolian Tughrik",
    symbol_native: "\u20AE",
    decimal_digits: 2,
    rounding: 0,
    code: "MNT",
    name_plural: "Mongolian tughrik"
  },
  {
    symbol: "\u20A9",
    name: "North Korean Won",
    symbol_native: "\u20A9",
    decimal_digits: 2,
    rounding: 0,
    code: "KPW",
    name_plural: "North Korean won"
  },
  {
    symbol: "K",
    name: "Papua New Guinean Kina",
    symbol_native: "K",
    decimal_digits: 2,
    rounding: 0,
    code: "PGK",
    name_plural: "Papua New Guinean kina"
  },
  {
    symbol: "\xA3",
    name: "Saint Helenian Pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "SHP",
    name_plural: "Saint Helenian pounds"
  },
  {
    symbol: "SAT$",
    name: "Samoan Tala",
    symbol_native: "$, SAT$, SAT, ST, T",
    decimal_digits: 2,
    rounding: 0,
    code: "WST",
    name_plural: "Samoan talas"
  },
  {
    symbol: "SRs",
    name: "Seychellois Rupee",
    symbol_native: "SRe, SR, Re, Rs",
    decimal_digits: 2,
    rounding: 0,
    code: "SCR",
    name_plural: "Seychellois rupees"
  },
  {
    symbol: "$",
    name: "Surinamese Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SRD",
    name_plural: "Surinamese dollars"
  },
  {
    symbol: "M",
    name: "Turkmenistani Manat",
    symbol_native: "M",
    decimal_digits: 2,
    rounding: 0,
    code: "TMT",
    name_plural: "Turkmenistani manats"
  }
]);

// src/finance/index.ts
var defaultFinance = deepFreeze({
  courseFeeDepositReqd: "",
  courseFeeDeposit: void 0,
  courseFeeDepositDate: "",
  courseFeeDepositNotReqdReason: "",
  accomDepositReqd: "",
  accomDeposit: 0,
  accomDepositDate: "",
  organisationSponsorship: {},
  scholarshipSponsorship: {},
  educationSponsorship: {},
  familySponsorship: {},
  otherSponsorship: {},
  fundingSummary: {
    courseFees: [],
    studentLivingCost: {
      label: "",
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    spouseLivingCost: {
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    childrenLivingCost: {
      number: 0,
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    totalToBeShown: 0,
    totalRemaining: 0,
    totalInvalid: 0
  },
  isSectionStarted: false,
  isSectionComplete: false
});
var fundingSources = deepFreeze([
  {
    id: "organisationSponsorship",
    label: "Company or Government Sponsorship",
    button: "Add Sponsorship",
    buttonAlt: "Add another Sponsorship",
    saveButtonText: "Save Sponsorship Details"
  },
  {
    id: "scholarshipSponsorship",
    label: "University Scholarship or Discount",
    button: "Add Scholarship",
    buttonAlt: "Add another scholarship",
    saveButtonText: "Save Scholarship Details"
  },
  {
    id: "educationSponsorship",
    label: "Education Loan",
    button: "Add Loan",
    buttonAlt: "Add another loan",
    saveButtonText: "Save Loan Details"
  },
  {
    id: "familySponsorship",
    label: "Myself or My Family",
    button: "Add Bank Account",
    buttonAlt: "Add another bank account",
    saveButtonText: "Save Funding Details"
  },
  {
    id: "otherSponsorship",
    label: "Other",
    button: "Add Other",
    buttonAlt: "Add another Other",
    saveButtonText: "Save Other Details"
  }
]);
var INNER_LONDON_LIVING_COST = 1529;
var OUTER_LONDON_LIVING_COST = 1171;
var MAX_ACCOMMODATION_DEPOSIT = 1529;
var AU_LIVING_COST_ANNUAL = 29710;
var AU_SPOUSE_DEPENDENT_ANNUAL = 10394;
var AU_CHILD_DEPENDENT_ANNUAL = 4449;
var AU_SCHOOL_AGE_CHILD_ANNUAL = 13502;
var AU_TRAVEL_COST_DEFAULT = 2e3;
var AU_TRAVEL_COST_EAST_S_AFRICA = 2500;
var AU_TRAVEL_COST_WEST_AFRICA = 3e3;
var AU_FUNDS_DURATION_MONTHS_CAP = 12;

// src/globalCustomDocuments/index.ts
var defaultCustomDocuments = deepFreeze({
  documents: {},
  followUpDocuments: {
    beforeArrivalDocuments: {},
    afterArrivalDocuments: {}
  },
  financeDocuments: {}
});

// src/history/index.ts
var CompletedCourses = /* @__PURE__ */ ((CompletedCourses2) => {
  CompletedCourses2["HIGH_SCHOOL"] = "High School";
  CompletedCourses2["A_LEVEL"] = "A Level";
  CompletedCourses2["BACCALAUREATE"] = "Baccalaureate";
  CompletedCourses2["FOUNDATION"] = "Foundation";
  CompletedCourses2["COHE"] = "CoHE";
  CompletedCourses2["DIPHE"] = "DipHE";
  CompletedCourses2["HND"] = "HND";
  CompletedCourses2["UG"] = "UG";
  CompletedCourses2["PG"] = "PG";
  CompletedCourses2["GC"] = "GC";
  CompletedCourses2["PGC"] = "PGC";
  CompletedCourses2["RESEARCH"] = "Research";
  return CompletedCourses2;
})(CompletedCourses || {});
var successfullyCompletedCourses = deepFreeze([
  { label: "High School", value: "High School" /* HIGH_SCHOOL */ },
  { label: "A Level", value: "A Level" /* A_LEVEL */ },
  {
    label: "International Baccalaureate diploma",
    value: "Baccalaureate" /* BACCALAUREATE */
  },
  { label: "University Foundation", value: "Foundation" /* FOUNDATION */ },
  { label: "Certificate of Higher Education", value: "CoHE" /* COHE */ },
  {
    label: "Diploma of Higher Education (DipHE)",
    value: "DipHE" /* DIPHE */
  },
  { label: "Higher National Diploma (HND)", value: "HND" /* HND */ },
  { label: "Bachelor Degree (UG)", value: "UG" /* UG */ },
  { label: `Master's Degree (PG)`, value: "PG" /* PG */ },
  { label: "Graduate Certificate or Diploma", value: "GC" /* GC */ },
  {
    label: "Post Graduate Certificate or Diploma",
    value: "PGC" /* PGC */
  },
  { label: "Research Degree", value: "Research" /* RESEARCH */ }
]);
var getSuccessfullyCompletedCourseLabelFromValue = (value) => {
  const course = successfullyCompletedCourses.find((currentCourse) => currentCourse.value === value);
  return course ? course.label : value;
};
var getSuccessfullyCompletedCourseValueFromLabel = (label) => {
  const course = successfullyCompletedCourses.find((currentCourse) => currentCourse.label === label);
  return course ? course.value : label;
};
var PreviouslyCompletedStudyLevel = /* @__PURE__ */ ((PreviouslyCompletedStudyLevel2) => {
  PreviouslyCompletedStudyLevel2["HIGH_SCHOOL"] = "High School";
  PreviouslyCompletedStudyLevel2["FOUNDATION"] = "Foundation";
  PreviouslyCompletedStudyLevel2["BACHELOR"] = "Bachelor (UG)";
  PreviouslyCompletedStudyLevel2["MASTERS"] = "Masters (PG)";
  PreviouslyCompletedStudyLevel2["RESEARCH"] = "Research (PhD etc.)";
  PreviouslyCompletedStudyLevel2["SHORT_COURSE"] = "Short Course";
  PreviouslyCompletedStudyLevel2["ENGLISH_LANGUAGE_COURSE"] = "English Language Course";
  return PreviouslyCompletedStudyLevel2;
})(PreviouslyCompletedStudyLevel || {});
var previouslyCompletedStudyLevels = deepFreeze([
  { label: "High School", value: "High School" /* HIGH_SCHOOL */ },
  { label: "Foundation", value: "Foundation" /* FOUNDATION */ },
  { label: "Bachelor (UG)", value: "Bachelor (UG)" /* BACHELOR */ },
  { label: "Masters (PG)", value: "Masters (PG)" /* MASTERS */ },
  { label: "Research (PhD etc.)", value: "Research (PhD etc.)" /* RESEARCH */ },
  { label: "Short Course", value: "Short Course" /* SHORT_COURSE */ },
  {
    label: "English Language Course",
    value: "English Language Course" /* ENGLISH_LANGUAGE_COURSE */
  }
]);
function getPreviouslyCompletedStudyLevelLabelFromValue(value) {
  const level = previouslyCompletedStudyLevels.find((currentLevel) => currentLevel.value === value);
  return level ? level.label : value;
}
function getPreviouslyCompletedStudyLevelValueFromLabel(label) {
  const level = previouslyCompletedStudyLevels.find((currentLevel) => currentLevel.label === label);
  return level ? level.value : label;
}
var PreviousStudyVisaType = /* @__PURE__ */ ((PreviousStudyVisaType2) => {
  PreviousStudyVisaType2["SHORT_TERM_STUDY"] = "Short-term study / student visa";
  PreviousStudyVisaType2["STUDENT_VISA_TIER_4_GENERAL"] = "Student visa (Tier 4 General/Student Route)";
  PreviousStudyVisaType2["STUDENT_VISA_TIER_4_CHILD"] = "Child Student visa (Tier 4 Child/Child Student Route)";
  PreviousStudyVisaType2["OTHER"] = "Other (my visa is not listed here)";
  return PreviousStudyVisaType2;
})(PreviousStudyVisaType || {});
var PreviousStudyVisas = [
  { label: "Short-term study / student visa", value: "Short-term study / student visa" /* SHORT_TERM_STUDY */ },
  {
    label: "Student visa (Tier 4 General/Student Route)",
    value: "Student visa (Tier 4 General/Student Route)" /* STUDENT_VISA_TIER_4_GENERAL */
  },
  {
    label: "Child Student visa (Tier 4 Child/Child Student Route)",
    value: "Child Student visa (Tier 4 Child/Child Student Route)" /* STUDENT_VISA_TIER_4_CHILD */
  },
  {
    label: "Other (my visa is not listed here)",
    value: "Other (my visa is not listed here)" /* OTHER */
  }
];
var getPreviousStudyVisaLabelFromValue = (value) => {
  const visa = PreviousStudyVisas.find((currentVisa) => currentVisa.value === value);
  return visa ? visa.label : value;
};
var getPreviousStudyVisaValueFromLabel = (label) => {
  const visa = PreviousStudyVisas.find((currentVisa) => currentVisa.label === label);
  return visa ? visa.value : label;
};
var VisaType = /* @__PURE__ */ ((VisaType2) => {
  VisaType2["TOURIST_VISITOR_VISA"] = "Tourist / visitor visa";
  VisaType2["INNOVATOR"] = "Innovator";
  VisaType2["START_UP"] = "Start-up";
  VisaType2["INVESTOR_ENTREPRENEUR_VISA_TIER_1"] = "Investor / entrepreneur visa (Tier 1)";
  VisaType2["EXCEPTIONAL_TALENT_VISA_TIER_1"] = "Exceptional talent visa (Tier 1)";
  VisaType2["GRADUATE_ENTREPRENEUR"] = "Graduate Entrepreneur";
  VisaType2["LONG_TERM_WORK_VISA_TIER_2"] = "Long-term work visa (Tier 2)";
  VisaType2["SHORT_TERM_WORK_VISA_TIER_5"] = "Short-term work visa (Tier 5)";
  VisaType2["INTRA_COMPANY_TRANSFER"] = "Intra-company Transfer";
  VisaType2["MINISTER_OF_RELIGION"] = "Minister of Religion";
  VisaType2["SPORTSPERSON"] = "Sportsperson";
  VisaType2["LOW_SKILLED_WORKER"] = "Low Skilled Worker";
  VisaType2["STANDARD_VISITOR"] = "Standard Visitor";
  VisaType2["MARRIAGE_VISITOR"] = "Marriage Visitor";
  VisaType2["PERMITTED_PAID_ENGAGEMENT"] = "Permitted Paid Engagement";
  VisaType2["PARENT_OF_A_TIER_4_CHILD"] = "Parent of a Tier 4 child";
  VisaType2["CHINESE_TOUR"] = "Chinese Tour";
  VisaType2["PASS_THROUGH"] = "Pass Through";
  VisaType2["SHORT_TERM"] = "Short Term";
  VisaType2["STUDENT_VISA_TIER_4"] = "Student visa (Tier 4 General/Student Route)";
  VisaType2["CHILD_STUDENT_VISA_TIER_4"] = "Child Student visa (Tier 4 Child/Child Student Route)";
  VisaType2["TW_CHARITY"] = "TW - Charity";
  VisaType2["TW_CREATIVE_AND_SPORTING"] = "TW - Creative & Sporting";
  VisaType2["TW_GOV_AUTH_EXCHANGE"] = "TW - Gov Auth Exchange";
  VisaType2["TW_INT_AGREEMENT"] = "TW - Int. Agreement";
  VisaType2["TW_RELIGIOUS_WORKER"] = "TW - Religious Worker";
  VisaType2["TW_SEASONAL_WORKER"] = "TW - Seasonal Worker";
  VisaType2["YOUTH_MOBILITY_SCHEME_VISA_TIER_5"] = "Youth mobility scheme visa (Tier 5)";
  VisaType2["FAMILY_VISAS"] = "Family Visas";
  VisaType2["EU_EEA_FAMILY"] = "EU/EEA Family";
  VisaType2["DEPENDANT"] = "Dependant";
  VisaType2["ADR"] = "ADR";
  VisaType2["ACRS"] = "ACRS";
  VisaType2["ARAP"] = "ARAP";
  VisaType2["ASYLUM"] = "Asylum";
  VisaType2["BN_O"] = "BN(O)";
  VisaType2["CHARITY_WORKER"] = "Charity Worker";
  VisaType2["CHILD_DEPENDANT"] = "Child Dependant";
  VisaType2["CHILD_STUDENT"] = "Child Student";
  VisaType2["CIVIL_PARTNER"] = "Civil Partner";
  VisaType2["CREATIVE_WORKER"] = "Creative Worker";
  VisaType2["DIRECT_AIRSIDE_TRANSIT"] = "Direct Airside Transit";
  VisaType2["FAMILY_DEPENDANT"] = "Family Dependant";
  VisaType2["FIANCE"] = "Fiance";
  VisaType2["FRONTIER_WORKER"] = "Frontier Worker";
  VisaType2["GLOBAL_TALENT"] = "Global Talent";
  VisaType2["GLOBAL_TALENT_DEPENDANT"] = "Global Talent Dependant";
  VisaType2["GAE"] = "GAE";
  VisaType2["GRADUATE"] = "Graduate";
  VisaType2["GRADUATE_DEPENDANT"] = "Graduate Dependant";
  VisaType2["GRADUATE_TRAINEE"] = "Graduate Trainee";
  VisaType2["HEALTH_AND_CARE_WORKER"] = "Health and Care Worker";
  VisaType2["HPI"] = "HPI";
  VisaType2["HUMANITARIAN_PROTECTION"] = "Humanitarian Protection";
  VisaType2["ILR"] = "ILR";
  VisaType2["INDIA_PROFESSIONAL"] = "India Professional";
  VisaType2["INDIA_YPS"] = "India YPS";
  VisaType2["INNOVATOR_FOUNDER"] = "Innovator Founder";
  VisaType2["INNOVATOR_FOUNDER_DEPENDANT"] = "Innovator Founder Dependant";
  VisaType2["INTERNATIONAL_AGREEMENT"] = "International Agreement";
  VisaType2["INTERNATIONAL_SPORTSPERSON"] = "International Sportsperson";
  VisaType2["MINISTER_OF_RELIGION_T2"] = "Minister of Religion (T2)";
  VisaType2["ODW"] = "ODW";
  VisaType2["PARENT_OF_A_CHILD"] = "Parent of a Child";
  VisaType2["PARENT_OF_A_CHILD_STUDENT"] = "Parent of a Child Student";
  VisaType2["PPE"] = "PPE";
  VisaType2["REFUGEE_FAMILY_REUNION"] = "Refugee Family Reunion";
  VisaType2["RELIGIOUS_WORKER"] = "Religious Worker";
  VisaType2["OVERSEAS_BUSINESS_REP"] = "Overseas Business Rep";
  VisaType2["RETURNING_RESIDENT"] = "Returning Resident";
  VisaType2["SCALE_UP_WORKER"] = "Scale-up Worker";
  VisaType2["SEASONAL_WORKER"] = "Seasonal Worker";
  VisaType2["SECONDMENT_WORKER"] = "Secondment Worker";
  VisaType2["SENIOR_SPECIALIST_WORKER"] = "Senior/Specialist Worker";
  VisaType2["SERVICE_PROVIDERS_SWITZERLAND"] = "Service Providers (Switzerland)";
  VisaType2["SERVICE_SUPPLIER"] = "Service Supplier";
  VisaType2["SKILLED_WORKER"] = "Skilled Worker";
  VisaType2["SKILLED_WORKER_DEPENDANT"] = "Skilled Worker Dependant";
  VisaType2["SPOUSE"] = "Spouse";
  VisaType2["STATELESS_PERSON"] = "Stateless Person";
  VisaType2["STUDENT_DEPENDANT"] = "Student Dependant";
  VisaType2["TRANSIT_AIRSIDE"] = "Transit (Airside)";
  VisaType2["TRANSIT_LANDSIDE"] = "Transit (Landside)";
  VisaType2["UK_ANCESTRY"] = "UK Ancestry";
  VisaType2["UK_EXPANSION_WORKER"] = "UK Expansion Worker";
  VisaType2["UKRAINE_EXTENSION"] = "Ukraine Extension";
  VisaType2["UKRAINE_FAMILY"] = "Ukraine Family";
  VisaType2["UKRAINE_SPONSORSHIP"] = "Ukraine Sponsorship";
  VisaType2["UNMARRIED_PARTNER"] = "Unmarried Partner";
  VisaType2["YOUTH_MOBILITY_SCHEME"] = "Youth Mobility Scheme";
  VisaType2["OTHER"] = "Other";
  return VisaType2;
})(VisaType || {});
var getVisaLabelFromValue = (value) => {
  const visa = visas.find((currentVisa) => currentVisa.value === value);
  return visa ? visa.label : value;
};
var getVisaValueFromLabel = (label) => {
  const visa = visas.find((currentVisa) => currentVisa.label === label);
  return visa ? visa.value : label;
};
var visas = deepFreeze(
  [
    { label: "Tourist/visitor", value: "Tourist / visitor visa" /* TOURIST_VISITOR_VISA */ },
    { label: "Innovator", value: "Innovator" /* INNOVATOR */ },
    { label: "Start-up (legacy/switching only)", value: "Start-up" /* START_UP */ },
    { label: "Investor Entrepreneur (Tier 1)", value: "Investor / entrepreneur visa (Tier 1)" /* INVESTOR_ENTREPRENEUR_VISA_TIER_1 */ },
    { label: "Exceptional Talent (Tier 1)", value: "Exceptional talent visa (Tier 1)" /* EXCEPTIONAL_TALENT_VISA_TIER_1 */ },
    { label: "Graduate Entrepreneur (Tier 1)", value: "Graduate Entrepreneur" /* GRADUATE_ENTREPRENEUR */ },
    { label: "Long-term Work (Tier 2)", value: "Long-term work visa (Tier 2)" /* LONG_TERM_WORK_VISA_TIER_2 */ },
    { label: "Short-term Work (Tier 5)", value: "Short-term work visa (Tier 5)" /* SHORT_TERM_WORK_VISA_TIER_5 */ },
    { label: "Intra-company Transfer (Tier 2)", value: "Intra-company Transfer" /* INTRA_COMPANY_TRANSFER */ },
    { label: "Minister of Religion (Tier 2)", value: "Minister of Religion" /* MINISTER_OF_RELIGION */ },
    { label: "Sportsperson (Tier 2)", value: "Sportsperson" /* SPORTSPERSON */ },
    { label: "Low Skilled Worker (Tier 3)", value: "Low Skilled Worker" /* LOW_SKILLED_WORKER */ },
    { label: "Standard Visitor", value: "Standard Visitor" /* STANDARD_VISITOR */ },
    { label: "Marriage Visitor", value: "Marriage Visitor" /* MARRIAGE_VISITOR */ },
    { label: "Permitted Paid Engagement Visitor", value: "Permitted Paid Engagement" /* PERMITTED_PAID_ENGAGEMENT */ },
    { label: "Parent of a Tier 4 Child", value: "Parent of a Tier 4 child" /* PARENT_OF_A_TIER_4_CHILD */ },
    { label: "ADS Visitor (visiting as a part of a Chinese tour group)", value: "Chinese Tour" /* CHINESE_TOUR */ },
    { label: "Visitor in Transit", value: "Pass Through" /* PASS_THROUGH */ },
    { label: "Short-term Study", value: "Short Term" /* SHORT_TERM */ },
    { label: "Student (Tier 4 General/Student Route)", value: "Student visa (Tier 4 General/Student Route)" /* STUDENT_VISA_TIER_4 */ },
    {
      label: "Child Student (Tier 4 Child/Child Student Route)",
      value: "Child Student visa (Tier 4 Child/Child Student Route)" /* CHILD_STUDENT_VISA_TIER_4 */
    },
    { label: "Temporary Worker - Charity Worker (Tier 5)", value: "TW - Charity" /* TW_CHARITY */ },
    { label: "Temporary Worker - Creative and Sporting (Tier 5)", value: "TW - Creative & Sporting" /* TW_CREATIVE_AND_SPORTING */ },
    { label: "Temporary Worker - Government Authorised Exchange (Tier 5)", value: "TW - Gov Auth Exchange" /* TW_GOV_AUTH_EXCHANGE */ },
    { label: "Temporary Worker - International Agreement (Tier 5)", value: "TW - Int. Agreement" /* TW_INT_AGREEMENT */ },
    { label: "Temporary Worker - Religious Worker (Tier 5)", value: "TW - Religious Worker" /* TW_RELIGIOUS_WORKER */ },
    { label: "Temporary Worker - Seasonal Worker (Tier 5)", value: "TW - Seasonal Worker" /* TW_SEASONAL_WORKER */ },
    { label: "Youth Mobility Scheme (Tier 5)", value: "Youth mobility scheme visa (Tier 5)" /* YOUTH_MOBILITY_SCHEME_VISA_TIER_5 */ },
    { label: "Appendix FM (spouse, child or ADR)", value: "Family Visas" /* FAMILY_VISAS */ },
    { label: "EU Settlement Scheme", value: "EU/EEA Family" /* EU_EEA_FAMILY */ },
    { label: "Dependant (PBS)", value: "Dependant" /* DEPENDANT */ },
    { label: "Adult Dependent Relative (ADR)", value: "ADR" /* ADR */ },
    { label: "Afghan Citizens Resettlement Scheme (ACRS)", value: "ACRS" /* ACRS */ },
    { label: "Afghan Relocation and Assistance Policy (ARAP)", value: "ARAP" /* ARAP */ },
    { label: "Asylum", value: "Asylum" /* ASYLUM */ },
    { label: "British National (Overseas) (BN(O))", value: "BN(O)" /* BN_O */ },
    { label: "Charity Worker (Temporary Work)", value: "Charity Worker" /* CHARITY_WORKER */ },
    { label: "Child Dependant", value: "Child Dependant" /* CHILD_DEPENDANT */ },
    { label: "Child Student", value: "Child Student" /* CHILD_STUDENT */ },
    { label: "Civil Partner", value: "Civil Partner" /* CIVIL_PARTNER */ },
    { label: "Creative Worker (Temporary Work)", value: "Creative Worker" /* CREATIVE_WORKER */ },
    { label: "Direct Airside Transit", value: "Direct Airside Transit" /* DIRECT_AIRSIDE_TRANSIT */ },
    { label: "Family Dependant Routes", value: "Family Dependant" /* FAMILY_DEPENDANT */ },
    { label: "Fianc\xE9(e)", value: "Fiance" /* FIANCE */ },
    { label: "Frontier Worker", value: "Frontier Worker" /* FRONTIER_WORKER */ },
    { label: "Global Talent", value: "Global Talent" /* GLOBAL_TALENT */ },
    { label: "Global Talent Dependant", value: "Global Talent Dependant" /* GLOBAL_TALENT_DEPENDANT */ },
    { label: "Government Authorised Exchange (Temporary Work)", value: "GAE" /* GAE */ },
    { label: "Graduate", value: "Graduate" /* GRADUATE */ },
    { label: "Graduate Dependant", value: "Graduate Dependant" /* GRADUATE_DEPENDANT */ },
    { label: "Graduate Trainee (Global Business Mobility)", value: "Graduate Trainee" /* GRADUATE_TRAINEE */ },
    { label: "Health and Care Worker", value: "Health and Care Worker" /* HEALTH_AND_CARE_WORKER */ },
    { label: "High Potential Individual (HPI)", value: "HPI" /* HPI */ },
    { label: "Humanitarian Protection", value: "Humanitarian Protection" /* HUMANITARIAN_PROTECTION */ },
    { label: "Indefinite Leave to Remain (ILR)", value: "ILR" /* ILR */ },
    { label: "India Professional", value: "India Professional" /* INDIA_PROFESSIONAL */ },
    { label: "India Young Professionals Scheme", value: "India YPS" /* INDIA_YPS */ },
    { label: "Innovator Founder", value: "Innovator Founder" /* INNOVATOR_FOUNDER */ },
    { label: "Innovator Founder Dependant", value: "Innovator Founder Dependant" /* INNOVATOR_FOUNDER_DEPENDANT */ },
    { label: "International Agreement (Temporary Work)", value: "International Agreement" /* INTERNATIONAL_AGREEMENT */ },
    { label: "International Sportsperson", value: "International Sportsperson" /* INTERNATIONAL_SPORTSPERSON */ },
    { label: "Minister of Religion (T2)", value: "Minister of Religion (T2)" /* MINISTER_OF_RELIGION_T2 */ },
    { label: "Overseas Domestic Worker (Global Business Mobility)", value: "ODW" /* ODW */ },
    { label: "Parent of a Child", value: "Parent of a Child" /* PARENT_OF_A_CHILD */ },
    { label: "Parent of a Child Student", value: "Parent of a Child Student" /* PARENT_OF_A_CHILD_STUDENT */ },
    { label: "Permitted Paid Engagement", value: "PPE" /* PPE */ },
    { label: "Refugee Family Reunion", value: "Refugee Family Reunion" /* REFUGEE_FAMILY_REUNION */ },
    { label: "Religious Worker (Temporary Work)", value: "Religious Worker" /* RELIGIOUS_WORKER */ },
    { label: "Representative of an Overseas Business", value: "Overseas Business Rep" /* OVERSEAS_BUSINESS_REP */ },
    { label: "Returning Resident", value: "Returning Resident" /* RETURNING_RESIDENT */ },
    { label: "Scale-up Worker", value: "Scale-up Worker" /* SCALE_UP_WORKER */ },
    { label: "Seasonal Worker (Temporary Work)", value: "Seasonal Worker" /* SEASONAL_WORKER */ },
    { label: "Secondment Worker (Global Business Mobility)", value: "Secondment Worker" /* SECONDMENT_WORKER */ },
    { label: "Senior or Specialist Worker (Global Business Mobility)", value: "Senior/Specialist Worker" /* SENIOR_SPECIALIST_WORKER */ },
    { label: "Service Providers from Switzerland", value: "Service Providers (Switzerland)" /* SERVICE_PROVIDERS_SWITZERLAND */ },
    { label: "Service Supplier (Global Business Mobility)", value: "Service Supplier" /* SERVICE_SUPPLIER */ },
    { label: "Skilled Worker", value: "Skilled Worker" /* SKILLED_WORKER */ },
    { label: "Skilled Worker Dependant", value: "Skilled Worker Dependant" /* SKILLED_WORKER_DEPENDANT */ },
    { label: "Spouse", value: "Spouse" /* SPOUSE */ },
    { label: "Stateless Person Leave", value: "Stateless Person" /* STATELESS_PERSON */ },
    { label: "Student Dependant", value: "Student Dependant" /* STUDENT_DEPENDANT */ },
    { label: "Transit (Airside)", value: "Transit (Airside)" /* TRANSIT_AIRSIDE */ },
    { label: "Transit (Landside)", value: "Transit (Landside)" /* TRANSIT_LANDSIDE */ },
    { label: "UK Ancestry", value: "UK Ancestry" /* UK_ANCESTRY */ },
    { label: "UK Expansion Worker (Global Business Mobility)", value: "UK Expansion Worker" /* UK_EXPANSION_WORKER */ },
    { label: "Ukraine Extension Scheme", value: "Ukraine Extension" /* UKRAINE_EXTENSION */ },
    { label: "Ukraine Family Scheme", value: "Ukraine Family" /* UKRAINE_FAMILY */ },
    { label: "Ukraine Sponsorship Scheme", value: "Ukraine Sponsorship" /* UKRAINE_SPONSORSHIP */ },
    { label: "Unmarried Partner", value: "Unmarried Partner" /* UNMARRIED_PARTNER */ },
    { label: "Youth Mobility Scheme", value: "Youth Mobility Scheme" /* YOUTH_MOBILITY_SCHEME */ },
    { label: "Other (My visa is not listed here)", value: "Other" /* OTHER */ }
  ].sort((a, b) => a.label.localeCompare(b.label))
);

// src/importData/index.ts
var defaultImportData = deepFreeze({
  studentNo: "",
  email: "",
  familyName: "",
  givenName: "",
  offers: []
});

// src/offer/index.ts
import { IntakeStatus } from "types";
var defaultOffer = deepFreeze({
  intakeId: "",
  offerId: "",
  intakeStatus: IntakeStatus.ACTIVE
});

// src/regionConfig/index.ts
import {
  DocStatusType,
  FollowUpDocStatusType,
  OptionStatusType,
  RegionConfigType,
  SectionStatusType
} from "types";
var defaultRegionConfig = deepFreeze({
  id: "string",
  configName: "defaultConf",
  configDesc: "static low risk fallback",
  customParentalConsentFormLink: "",
  depositInstructionLink: "",
  studentAutomatedChatReply: "",
  otherGenderEnabled: true,
  universityAccommodationEnabled: true,
  agentDetailsEnabled: true,
  agentCompanyNameForStudentEnabled: false,
  type: RegionConfigType.DEFAULT,
  docSectionStatus: SectionStatusType.ACTIVE,
  finDocSectionStatus: SectionStatusType.ACTIVE,
  interviewSectionStatus: SectionStatusType.ACTIVE,
  historySectionStatus: SectionStatusType.ACTIVE,
  financeSectionStatus: SectionStatusType.ACTIVE,
  followUpDocSectionStatus: SectionStatusType.ACTIVE,
  scheduledInterviewsSectionStatus: SectionStatusType.ACTIVE,
  scheduledInterviews: { calendlyEventType: { id: "" } },
  recordedInterviewSectionStatus: SectionStatusType.ACTIVE,
  beforeArrivalDocAreaStatus: SectionStatusType.ACTIVE,
  afterArrivalDocAreaStatus: SectionStatusType.ACTIVE,
  preDepartureDocSectionStatus: SectionStatusType.ACTIVE,
  afterTravelDocSectionStatus: SectionStatusType.ACTIVE,
  beforeArrivalDocuments: {
    customDocuments: {},
    studentRefusalLetter: FollowUpDocStatusType.REQUIRED,
    immigrationStatusShareCode: FollowUpDocStatusType.NOT_REQUIRED,
    immigrationStatusPdf: FollowUpDocStatusType.NOT_REQUIRED,
    visaApplicationPdfCopy: FollowUpDocStatusType.REQUIRED,
    travelTicket: FollowUpDocStatusType.REQUIRED,
    visaVignette: FollowUpDocStatusType.REQUIRED
  },
  afterArrivalDocuments: {
    customDocuments: {},
    biometricResidencePermit: FollowUpDocStatusType.REQUIRED,
    stampedVisaVignette: FollowUpDocStatusType.REQUIRED
  },
  documents: {
    customDocuments: {},
    studentVisas: {
      studentVisa: DocStatusType.REQUIRED,
      cas: DocStatusType.REQUIRED,
      biometric: DocStatusType.REQUIRED
    },
    cas: DocStatusType.REQUIRED,
    passport: DocStatusType.REQUIRED,
    academicTranscript: DocStatusType.REQUIRED,
    academicCertificate: DocStatusType.REQUIRED,
    visaRefusals: DocStatusType.REQUIRED,
    nonUkVisaRefusals: DocStatusType.REQUIRED,
    otherVisas: {
      visas: DocStatusType.REQUIRED,
      biometric: DocStatusType.REQUIRED
    },
    parentalConsent: DocStatusType.REQUIRED,
    birthCertificate: DocStatusType.REQUIRED,
    tbTest: DocStatusType.REQUIRED,
    atas: DocStatusType.REQUIRED,
    englishTest: DocStatusType.REQUIRED,
    englishQualification: DocStatusType.REQUIRED,
    customRequest: DocStatusType.REQUIRED,
    postStudyLetter: DocStatusType.REQUIRED
  },
  financeDocuments: {
    deposit: DocStatusType.REQUIRED,
    birthCertificate: DocStatusType.REQUIRED,
    evidenceOfIncome: {
      curriculumVitae: DocStatusType.REQUIRED,
      employmentReference: DocStatusType.REQUIRED,
      recentEmploymentContract: DocStatusType.REQUIRED,
      recentPayslip: DocStatusType.REQUIRED
    },
    familySponsorship: {
      bankStatement: DocStatusType.REQUIRED,
      parentLetter: DocStatusType.REQUIRED,
      termDeposit: DocStatusType.REQUIRED,
      verificationBankLetter: DocStatusType.REQUIRED,
      secondaryBankStatement: DocStatusType.REQUIRED
    },
    governmentSponsorship: DocStatusType.REQUIRED,
    companySponsorship: DocStatusType.REQUIRED,
    scholarshipSponsorship: DocStatusType.REQUIRED,
    educationSponsorship: DocStatusType.REQUIRED,
    customRequest: DocStatusType.REQUIRED,
    other: DocStatusType.REQUIRED,
    customDocuments: {}
  },
  otherOptions: {
    visaSupport: OptionStatusType.ACTIVE
  },
  Checklist: {
    Consents: {
      Page1: {
        blurb: "Please ensure the information you have provided is correct and be sure to fill in any missing information.\n            <br />\n            <br />\n              The University will use this information to obtain your CAS number from the UKVI which, when received by the University, will be sent to the email address you have provided.\n            <br />\n            <br />\n              If a visa application is made with a CAS which has incorrect information, this could lead to the application being refused, immigration permission of the wrong length or with the wrong conditions being granted.\n              <br />\n              <br />\n              I confirm that the information provided in the form is correct.\n        ",
        heading: "Accuracy of information provided by you",
        hidden: false,
        title: "Consent 1"
      },
      Page2: {
        hidden: false,
        title: "Consent 2"
      },
      Page3: {
        hidden: false,
        title: "Consent 3"
      },
      Page4: {},
      SectionStart: {
        warning: "In this section you will acknowledge your responsibilities as a student and confirm relevant consents for your CAS application"
      },
      shortTitle: "Your Responsibilities",
      title: "Section 3 - Your Responsibilities"
    },
    defaultOverrides: {
      core: {},
      personalInfo: {}
    },
    Finances: {
      Page1: {
        AccommodationDepositAmount: {
          defaultValue: 0,
          label: "Accommodation Deposit Amount",
          mandatory: true,
          visible: true
        },
        AccommodationDepositDate: {
          label: "Approximately when do you plan on paying your accommodation deposit?",
          mandatory: true,
          visible: true
        },
        AccommodationDepositPaid: {
          label: "Have you paid a deposit to the university for university accommodation?",
          mandatory: true,
          visible: true
        },
        AmountCovered: {
          helpText: "The amount in pounds that will be used from this account"
        },
        AmountCoveredBankSponsor: {
          helpText: ""
        },
        AmountToProve: {
          helpText: "To obtain your visa you will need to have access to the funds above"
        },
        CanWithdrawImmediately: {
          label: "Can the funds from the account be withdrawn immediately?"
        },
        CompanyPresence: {
          helpText: "e.g. Does it operate outside of its home country"
        },
        CoverType: {
          label: "How much is your sponsor (or scholarship) providing for your tuition fees?",
          mandatory: true,
          visible: true
        },
        DepositAmount: {
          defaultValue: 0,
          helpText: "Enter the total deposit you have transferred to the university in GBP (british pounds). Please note if you have deposited less than the minimum deposit of \xA33000 you will need to make another transfer to make up the difference before your CAS can be issued.",
          label: "Deposit Amount",
          mandatory: true,
          visible: true
        },
        DepositDate: {
          helpText: "Tell us the approximate date you plan to make your deposit payment",
          label: "When do you expect to pay your deposit?",
          mandatory: true,
          visible: true
        },
        DepositPaid: {
          helpText: "<span>Answer 'yes' if you have paid a contribution towards your course fees.<br /><br />A minimum deposit of \xA33000 must be made before the university can process your CAS.</span>",
          label: "Have you paid a course fee deposit?",
          mandatory: true,
          visible: true
        },
        DepositReason: {
          label: "Please provide more information on why a deposit isn't required",
          mandatory: true,
          visible: true
        },
        EducationLoanName: {
          helpText: "Select the person whose name is on the loan. If your name is on the loan select \u201Cmy name\u201D."
        },
        FundingSources: {},
        FundsMatured: {
          helpText: "Has the full amount of required funds been in this account for 28 days?"
        },
        FundsMatureDate: {
          helpText: "What date will the funds have been in this account for 28 days?"
        },
        HasSeparateLivingCost: {
          label: "Are your living costs listed separately from your tuition in your sponsorship documentation?",
          mandatory: true,
          visible: true
        },
        MonthlyLivingCost: {
          label: "What is the monthly amount for living costs?",
          mandatory: true,
          visible: true
        },
        MonthlyOrUpfrontLivingCost: {
          label: "Will your living costs be provided to you as a monthly stipend / payment or provided to you as an upfront payment?",
          mandatory: true,
          visible: true
        },
        OtherFundingDesc: {
          helpText: "Explain in your own words, maximum 2 sentences"
        },
        RelationshipToPerson: {
          helpText: ""
        },
        RemainingAmountToProve: {
          helpText: "You cannot proceed until you have proven how you will fund your studies and maintenance costs"
        },
        ScholarshipName: {
          helpText: "Enter the name / type of scholarship you received "
        },
        ScholarshipNature: {
          helpText: "How much of your course fee and/or living expenses does your scholarship cover?"
        },
        title: "Source of Funds and Calculator",
        TotalAmountInAccount: {
          helpText: 'If your account is not in GBP, use the latest exchange rate value to convert your currency to GBP. UKVI use <a class="studentAppLinks" href="https://www.oanda.com/currency-converter/en/?from=EUR&to=GBP&amount=1" target="_blank">Oanda</a> exchange rate.',
          subLabel: "Enter the amount currently in your account to the nearest pound sterling (GBP)."
        },
        TotalLivingCost: {
          label: "What is the total amount for living costs?",
          mandatory: true,
          visible: true
        }
      },
      shortTitle: "Finance",
      title: "Section 4 - Your Financial Plan"
    },
    History: {
      Page1: {
        HasOverseasTravel: {
          helpText: "Includes any country outside the border of the country you currently live in"
        },
        HasPreviousUkStudy: {
          visible: true
        },
        HasPreviousUkStudyVisa: {
          visible: true
        },
        HasUKTravel: {},
        LastCourse: {
          helpText: "Please choose the option that accurately represents the course you have either completed most recently or are expected to complete by the time you apply for your visa."
        },
        LastCourseOther: {},
        LastCourseYear: {
          helpText: "Please enter the year you graduated from, or will graduate from, the course you just declared in the previous question."
        },
        OverseasTravelTimes: {},
        PreviousUkStudyCourseComplete: {},
        PreviousUkStudyIncopleteRecorded: {},
        PreviousUkStudyLevel: {},
        PreviousUkStudyReasonNotCompleteCourse: {},
        PreviousUkStudyVisaShortened: {},
        PreviousUkStudyVisaShortenedDate: {},
        PreviousUkStudyVisaType: {},
        PreviousUkStudyYearOfReceived: {},
        LastCourseLevel: {
          helpText: "Relates only to the last academic course you have studied in the UK on a TIER 4 visa"
        },
        LowerOrSameLevelReason: {},
        title: "Prior Study and Travel",
        UKTravelTimes: {}
      },
      Page2: {
        PrevNonUKVisaRefusal: {
          helpText: "\n            <span>\n              This question relates to any visa refusals from countries other than the\n              UK.\n              <br />\n              <br />A visa refusal is a letter or email issued by a government after a\n              visa application. A refusal denies your request to enter the country.\n            </span>\n          "
        },
        PrevNonUKVisaRefusalCountry: {},
        PrevNonUKVisaRefusalStudent: {},
        PrevNonUKVisaRefusalYear: {},
        PrevRejectionReason: {},
        PrevRejections: {
          helpText: "For example at a UK airport or seaport"
        },
        PrevUKOtherVisa: {
          helpText: "This question relates to any non-student UK visas, which are typically represented as stickers or vignettes in your passport, granting you permission to enter the country. Standard entry stamps should not be included in your response."
        },
        PrevUKOtherVisaType: {
          helpText: "Select 'Other' if you can't find your visa type"
        },
        PrevUKOtherVisaYear: {},
        PrevVisaRefusal: {
          helpText: "\n            <span>\n              This question relates to UK visa refusals only.\n              <br />\n              <br />A visa refusal is a letter or email issued by a government after a\n              visa application. A refusal denies your request to enter the country.\n            </span>\n          "
        },
        PrevVisaRefusalType: {
          helpText: "Select other if you can't find your visa type"
        },
        PrevVisaRefusalYear: {},
        title: "Prior Travel and Refusals",
        UKLeaveToRemain: {
          helpText: "Have you ever applied to live permanently in the UK"
        }
      },
      Page3: {
        ChildrenTravelling: {},
        ChildrenTravellingNumber: {},
        FamilyMembersTravelling: {
          helpText: 'This question refers to whether you will be coming to the UK alone or plan to bring any dependants or family members with you. <br><br> For the latest rules and regulations regarding students bringing dependants, please refer to the latest government guidance on the <a class="studentAppLinks" href="https://www.gov.uk/student-visa/family-members" target="_blank">gov.uk website</a>.'
        },
        HomeCountryApplication: {
          helpText: "Please confirm whether you intend to submit your student visa application in the country you have declared as your nationality above. This question refers to the location of your visa application"
        },
        HomeCountryApplicationReason: {},
        SpouseTravelling: {},
        PartnerVisaStatus: {},
        title: "Travellers and Dependants"
      },
      shortTitle: "Your History",
      title: "Section 2 - Your History"
    },
    InfoProcessing: {
      blurb: "I understand that the CAS preparation process will require the collection of personal and sensitive information that belongs to me. This data will be processed by the university and approved representatives for the purpose of my CAS application and enrolment.",
      title: "Processing of Information"
    },
    Landing: {
      blurb: "In this process you will be asked a series of questions and given a recommended set of documents to be uploaded in advance of your CAS application review by the university.\n        <br />\n        <br />\n        If your CAS has already been issued, you will only be required to provide visa and arrival updates and upload follow-up documents on CAS Shield.\n        <br />\n        <br />\n        The list of documents and guidelines provided in this process do not constitute legal advice, the purpose is to speed up your preparation.\n        <br />\n        <br />\n        Any official visa and immigration advice will be provided as needed by our university staff and/or an assigned solicitor. If you receive advice from these parties, please ensure you follow it carefully.\n      ",
      title: "Welcome to the CAS preparation process"
    },
    PersonalInfo: {
      Page1: {
        FamilyName: {
          helpText: "If you only have one name, enter it here and type <code>-</code> as your given name.",
          label: "Family Name",
          subLabel: "Family name must match your passport exactly.",
          mandatory: true,
          visible: true
        },
        GivenName: {
          helpText: "",
          label: "Given Name",
          subLabel: "Given names must match your passport exactly, including any middle names.",
          mandatory: true,
          visible: true
        },
        HasOtherNames: {
          label: "In addition to the names already provided, are you now or have you ever been known by another name?",
          mandatory: true,
          visible: true
        },
        hidden: false,
        MiddleName: {
          helpText: "",
          label: "Other/Middle Name",
          mandatory: false,
          visible: false
        },
        OtherNameFamilyName: {
          subLabel: "Family name must match your passport exactly."
        },
        OtherNameGivenName: {},
        OtherNameReason: {
          helpText: "<span>Please provide context for this name.<br /></br />If you changed your name please include the date it was changed."
        },
        title: "Names and Aliases"
      },
      Page10: {
        hidden: false,
        title: "WhatsApp",
        WhatsApp: {},
        WhatsAppPhoneNumber: {}
      },
      Page2: {
        AppliedForEUSS: {},
        GrantedEUSSStatus: {},
        BirthCountry: {
          helpText: "The country you were born in",
          label: "Country of Birth",
          mandatory: true,
          visible: true
        },
        DOB: {
          helpText: "As per your passport.",
          label: "Date of Birth",
          mandatory: true,
          visible: true
        },
        Gender: {
          helpText: "As per your passport",
          label: "Gender",
          mandatory: true,
          visible: true
        },
        HasOtherNationality: {
          helpText: "If you have dual nationality or citizenship, select \u201Cyes\u201D",
          label: "Do you currently hold, or have you ever held, any other nationality or citizenship?",
          mandatory: true,
          visible: true
        },
        hidden: false,
        IsCountryOfNationality: {
          helpText: "Please confirm whether you intend to submit your student visa application in the country you have declared as your nationality above. This question refers to the location of your visa application",
          label: "Are you applying from the country of your nationality?",
          mandatory: true,
          visible: true
        },
        CountryOfVisaApplication: {
          label: "In which country will you make your visa application?",
          mandatory: true,
          visible: true
        },
        LivedInUKLast12Months: {
          helpText: 'Select "Yes" if on the date of your visa application, you have lived in the UK for 12 months or more without any gaps. Otherwise, select "No"',
          label: "Have you lived in the UK continuously for over 12 months?",
          subLabel: "",
          mandatory: true,
          visible: true
        },
        Nationality: {
          helpText: "Enter your nationality/citizenship as per the passport or travel document you will use for your visa application. <br> You will be asked about additional or previous nationalities at the end of this section.",
          label: "Nationality",
          mandatory: true,
          visible: true
        },
        OtherNationality: {
          label: "Other Nationality",
          mandatory: true,
          visible: true
        },
        OtherNationalityCurrent: {
          helpText: "Select \u201Ccurrent\u201D if you hold this nationality now, or \u201Cformer\u201D if you held this nationality in the past",
          label: "Is this a current or former nationality?",
          mandatory: true,
          visible: true
        },
        OtherNationalityNumber: {
          helpText: "Including current and former nationalities/citizenships",
          label: "How many other nationalities?",
          mandatory: true,
          visible: true
        },
        ReasonWhyNotCountryOfNationality: {
          label: "Please tell us why you are applying from a country other than the country of your nationality?"
        },
        title: "Gender, Birth and Nationality"
      },
      Page3: {
        City: {
          label: "City",
          mandatory: true,
          visible: true
        },
        Country: {
          label: "Country",
          mandatory: true,
          visible: true
        },
        hidden: false,
        HomeAddress: {
          helpText: "Your current home / residential address e.g. Where you live",
          label: "Permanent Residential Address",
          mandatory: true,
          subLabel: "Address (e.g. unit 33, 17 Example Street)",
          visible: true
        },
        PhoneNumber: {
          helpText: "",
          label: "Phone Number",
          mandatory: true,
          visible: true
        },
        Postcode: {
          label: "Postcode (if applicable)",
          mandatory: false,
          visible: true
        },
        title: "Contact and Address"
      },
      Page4: {
        CriminalConvictionsReason: {
          label: "Please provide more information on the date and nature of the offence(s)",
          mandatory: true,
          visible: true
        },
        HasCriminalConvictions: {
          helpText: "Please respond 'yes' if you currently have any of the following: a criminal conviction, a penalty for a driving offense (e.g. speeding or driving without insurance), an ongoing arrest or charge awaiting trial, a caution, warning, reprimand, or another out-of-court penalty, a civil court judgment (e.g. for non-payment of debt, bankruptcy, or antisocial behavior), or a civil penalty.",
          label: "Have you ever had any criminal convictions, charges, or penalties in the UK or any other country?",
          mandatory: true,
          visible: true
        },
        hidden: false,
        title: "Criminal Convictions"
      },
      Page5: {
        AutoCourseName: {
          helpText: "Please select the same course name as listed on your offer letter",
          label: "Course Name",
          mandatory: true,
          visible: true
        },
        CAH3: {
          helpText: "If present on your offer letter (e.g. CAH10-01-02)",
          label: "CAH3 Code",
          mandatory: false,
          visible: true
        },
        Campus: {
          helpText: "As per your offer letter",
          label: "Select your campus",
          mandatory: false,
          visible: false
        },
        CASReceived: {
          label: "Have you received your CAS?",
          mandatory: false,
          visible: false
        },
        CourseFee: {
          defaultValue: null,
          helpText: "",
          label: "First Year Course Fee",
          mandatory: true,
          subLabel: "",
          visible: true
        },
        CourseScholarshipAmount1: {
          subLabel: "As stated in your offer letter ",
          visible: true,
          mandatory: false,
          defaultValue: null,
          helpText: " If you have been awarded any additional scholarships or discounts that are not listed on this page, you will be able to add them later"
        },
        CourseLevel: {
          label: "What is the level of your course?",
          mandatory: true,
          visible: true
        },
        CourseLevelOther: {},
        DepositAmount: {
          helpText: "Please note if you have deposited less than the minimum deposit of 50% first year tuition fee you will need to make another transfer to make up the difference before your CAS can be issued"
        },
        DepositPaid: {
          helpText: "<span>            Answer 'yes' if you have paid a contribution towards your course fees.            <br />            <br />A minimum deposit of 50% first year tuition fee must be made            before the university can process your CAS.          </span>"
        },
        EndDate: {
          defaultValue: null,
          helpText: "",
          label: "Course End Date",
          mandatory: true,
          visible: false
        },
        hidden: false,
        IsWorkPlacement: {
          label: "Work Placement",
          helpText: 'Select "yes", if your course includes a work placement',
          mandatory: true,
          visible: true
        },
        ManualCourseName: {
          helpText: "As per your offer letter",
          label: "Course Name",
          mandatory: true,
          subLabel: "",
          visible: true
        },
        StartDate: {
          defaultValue: null,
          helpText: "",
          label: "Course Start Date",
          mandatory: true,
          visible: true
        },
        StudentNumber: {
          label: "Student Number",
          mandatory: true,
          subLabel: "All details are as per your offer letter",
          visible: true
        },
        title: "Student Number and Course"
      },
      Page5_1: {
        title: "Evidence Used to Obtain Offer",
        hidden: true,
        OfferEvidence: {
          label: "",
          subLabel: "Please make your corrections to the text or add a note at the bottom",
          visible: true,
          mandatory: true,
          helpText: ""
        }
      },
      Page6: {
        EnglishTestNotReqdReason: {
          label: "How did you meet the English language requirement?",
          visible: true,
          mandatory: true
        },
        EnglishTestNotReqdReasonOther: {
          label: "Please explain",
          visible: true,
          mandatory: true
        },
        Qualification: {
          label: "Which qualification?",
          visible: true,
          mandatory: true
        },
        QualificationOther: {
          label: "What is the name of the qualification?",
          mandatory: true,
          visible: true
        },
        qualificationOther: {
          label: "What is the name of the qualification?",
          mandatory: true,
          visible: true
        },
        EnglishTestType: {
          label: "What type of English test?",
          mandatory: true,
          visible: true
        },
        EnglishTestTypeOther: {
          label: "What is the name of the English test you completed?",
          mandatory: true,
          visible: true
        },
        HasEnglishTest: {
          label: "Were you required to submit an English test as part of your application?",
          mandatory: true,
          visible: true
        },
        title: "English Test"
      },
      Page7: {
        PassportExpectedDate: {
          helpText: "Enter the approximate date you expect to receive your new passport.",
          label: "When do you expect to receive your passport?",
          mandatory: true,
          visible: true
        },
        PassportExpiryDate: {
          helpText: "Note, if your passport expires within 6 months of your course start date, a new passport copy will be requested later. If you are unable to provide the new passport information, please contact the admissions team.",
          label: "Passport Expiry Date",
          mandatory: true,
          visible: true
        },
        PassportNumber: {
          label: "Passport Number",
          mandatory: true,
          visible: true
        },
        PassportStatus: {
          helpText: "",
          label: "Do you currently have a passport?",
          mandatory: true,
          visible: true
        },
        hidden: false,
        title: "Passport Details"
      },
      Page8: {
        AgentNameConfig: {
          label: "Who is helping you?",
          mandatory: true,
          visible: true
        },
        AutoAgentName: {
          label: "What is the name of your agency/agent?",
          mandatory: true,
          visible: true
        },
        hidden: false,
        ManualAgentName: {
          label: "Manually Enter Agent Name",
          mandatory: true,
          visible: true
        },
        title: "Enrolment Support",
        WithAgent: {
          helpText: 'An "Agent" is a local office or business that helps students choose and apply to universities',
          label: "Did anyone help you submit your application to study with us?",
          mandatory: true,
          visible: true
        }
      },
      Page9: {
        hidden: false,
        title: "Visa Support",
        VisaSupport: {
          helpText: ""
        }
      },
      SectionStart: {
        warning: "<strong>Note:</strong> The requested information may be used in official documents. Please ensure you enter accurate information."
      },
      shortTitle: "Personal Information",
      title: "Section 1 - Personal Information"
    },
    Summary: {
      Complete: {
        title: "CAS Checklist Complete!",
        warning: "Continue to your task list for document upload and a Pre-CAS Questionnaire"
      },
      Incomplete: {
        title: "You've reached the end of the CAS Checklist"
      }
    }
  },
  Interview: {
    Page1: {
      CourseReasons: {
        helpText: "You can select more than one option"
      },
      CourseReasonsOther: {
        helpText: "Maximum 2 sentences"
      },
      UniChoiceReason1: {
        helpText: "Maximum 2 sentences per reason"
      },
      UniChoiceReason2: {
        helpText: "Maximum 2 sentences per reason"
      },
      UniChoiceReason3: {
        helpText: "Maximum 2 sentences per reason"
      },
      UniReasons: {
        helpText: "You can select more than one option"
      },
      UniReasonsOther: {
        helpText: "Maximum 2 sentences"
      },
      WhyUK: {
        helpText: "Select the option that best describes your reason for studying in the UK"
      },
      WhyUKOther: {
        helpText: "Maximum 2 sentences"
      }
    },
    Page2: {
      Campus: {
        helpText: "If you are not sure please refer to your offer letter or the university website"
      },
      ConisderOtherCourseName: {
        helpText: "Please enter the title of the course you have considered"
      },
      ConsiderOtherCourseReason: {
        helpText: "Explain in your own words"
      },
      ConsiderOtherUni: {
        helpText: "Entering other universities here will not affect your application, we encourage students to be well researched"
      },
      ConsiderOtherUniReason: {
        helpText: ""
      },
      CourseAlignCareerReason: {
        helpText: "Explain in your own words, maximum 2 sentences"
      },
      UniResearchMethod: {
        helpText: "You can select more than one option"
      }
    },
    Page3: {
      CourseAndLivingWithoutWorking: {
        helpText: "It is important there is nothing hindering your ability to pay your fees or living expenses"
      },
      CourseAndLivingWithoutWorkingReason: {
        helpText: "Explain in your own words, maximum 3 sentences"
      },
      FurtherStudyCareerPlan: {
        helpText: "Explain in your own words, maximum 3 sentences"
      },
      WorkWhileStudy: {
        helpText: "This refers to working part time"
      },
      WorkWhileStudyReason: {
        helpText: "Explain in your own words, maximum 3 sentences"
      }
    },
    Page4: {},
    SectionComplete: {
      title: "Pre-CAS Questionnaire Complete!",
      warning: "Go to task list to complete the remaining items"
    },
    SectionStart: {
      title: "Pre-CAS Questionnaire"
    }
  },
  sections: {
    ScheduledInterviews: {
      label: ""
    },
    CASChecklist: {
      label: "Checklist",
      summary: "On this page you can edit the answers you have provided to the checklist, or resume the process if you are yet to complete it.",
      summaryLabel: "Checklist Summary"
    },
    FinanceDocuments: {
      description: "Please upload or review document requirements as requested",
      label: "Financial Documents",
      summary: "As part of this CAS application or your upcoming visa application you may need to provide documents that prove you have access to the required #TotalFundingToShow in expenses as outlined in the financial plan section. <p>Click \u2018How to Prove\u2019 or \u2018Please Review\u2018 as requested to see the specific requirements for each document.</p>",
      summaryLabel: "Proving your finances"
    },
    GeneralDocument: {
      description: "Please upload or review document requirements as requested",
      label: "General Documents",
      summary: "Below is a list of academic, travel and other documents associated with your CAS and visa application. This list is based on the answers you provided to the CAS Checklist questions.",
      summaryLabel: "General Documents"
    },
    PreCASInterview: {
      description: "Answer a few questions about your upcoming overseas study",
      label: "Pre-CAS Questionnaire",
      summary: "Below is a series of questions built to evaluate credibility for a CAS to be issued",
      summaryLabel: "Pre-CAS Questionnaire"
    },
    ReceiveCAS: {
      description: "Your CAS will not be issued until the above tasks are completed",
      label: "Receive CAS Document"
    },
    Registration: {
      description: "On-campus registration",
      label: "15th of January"
    },
    VisaApplication: {
      description: "Begin the visa and immigration process",
      label: "Start Visa Application"
    },
    FollowUpDocuments: {
      label: "Follow-up Documents",
      description: "Please upload or review document requirements as requested",
      summaryLabel: "Follow-up Documents",
      summary: "Please read and complete the tasks below."
    }
  }
});

// src/risk/index.ts
var defaultRisks = deepFreeze({
  personalInfoRisk: {
    namesAndAliases: [],
    birthAndNationality: [],
    criminalConvictions: [],
    englishTest: [],
    passportDetails: []
  },
  historyRisk: {
    priorStudyAndTravel: [],
    priorStudyAndRefusals: [],
    travellersAndDependants: []
  },
  fundingRisk: {
    organisationSponsorship: [],
    scholarshipSponsorship: [],
    educationSponsorship: [],
    familySponsorship: [],
    other: []
  },
  preCasInterviewRisk: {
    step1: [],
    step2: [],
    step3: [],
    step4: []
  },
  docsRisk: {
    parentalConsent: [],
    birthCertificate: []
  },
  financeDocsRisk: {
    organisationSponsorship: [],
    scholarshipSponsorship: [],
    educationSponsorship: [],
    familySponsorship: [],
    birthCertificate: [],
    evidenceOfIncome: []
  },
  countryMultiplier: 0,
  clearedRisks: {
    personalInfoRisk: {
      namesAndAliases: [],
      birthAndNationality: [],
      criminalConvictions: [],
      englishTest: [],
      passportDetails: []
    },
    historyRisk: {
      priorStudyAndTravel: [],
      priorStudyAndRefusals: [],
      travellersAndDependants: []
    },
    fundingRisk: {
      organisationSponsorship: [],
      scholarshipSponsorship: [],
      educationSponsorship: [],
      familySponsorship: [],
      other: []
    },
    preCasInterviewRisk: {
      step1: [],
      step2: [],
      step3: [],
      step4: []
    },
    docsRisk: {
      parentalConsent: [],
      birthCertificate: []
    },
    financeDocsRisk: {
      organisationSponsorship: [],
      scholarshipSponsorship: [],
      educationSponsorship: [],
      familySponsorship: [],
      birthCertificate: [],
      evidenceOfIncome: []
    }
  }
});

// src/uniConfig/index.ts
import { CoreStatus, CoreStatusExtended } from "types";

// src/uniConfig/fieldMappings.ts
var defaultFieldMappings = deepFreeze({
  intakeId: {
    uniField: "INTAKE_ID",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offerId: {
    uniField: "OFFER_ID",
    format: "MAP2",
    mappingType: "MAP_OFFER_ID_UNKNOWN",
    validationType: "STRING",
    setup: "Mandatory"
  },
  email: {
    uniField: "GOREMAL_EMAIL_ADDRESS",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  studentNo: {
    uniField: "SPRIDEN_ID",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  familyName: {
    uniField: "SPRIDEN_LAST_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  givenName: {
    uniField: "SPRIDEN_FIRST_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  otherName: {
    uniField: "SPRIDEN_MI",
    format: "TEXT",
    validationType: "STRING",
    setup: "Disabled"
  },
  phone: {
    uniField: "SPRTELE_PHONE_NUMBER",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  dob: {
    uniField: "SPBPERS_BIRTH_DATE",
    format: "DATE3",
    validationType: "DATE",
    setup: "Mandatory"
  },
  gender: {
    uniField: "SPBPERS_SEX",
    format: "GENDER",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentCompany: {
    uniField: "AGENT_COMPANY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentCompanyEmail: {
    uniField: "AGENT_COMPANY_EMAIL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentEmail: {
    uniField: "AGENT_EMAIL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentOffice: {
    uniField: "AGENT_OFFICE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchOffice: {
    uniField: "AGENT_OFFICE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  counsellorEmail: {
    uniField: "COUNSELLOR_EMAIL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  counsellorName: {
    uniField: "COUNSELLOR_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  addressLine1: {
    uniField: "SPRADDR_STREET_LINE1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  addressLine2: {
    uniField: "SPRADDR_STREET_LINE2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  addressLine3: {
    uniField: "SPRADDR_STREET_LINE3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  city: {
    uniField: "SPRADDR_CITY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentName: {
    uniField: "AGENT_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  withAgent: {
    uniField: "WITH_AGENT",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  nationality: {
    uniField: "SPRADDR_NATN_CODE",
    format: "ISO-3166-1 ALPHA-3 (Nationality)",
    validationType: "STRING",
    setup: "Secondary"
  },
  country: {
    uniField: "SPRADDR_COUNTRY",
    format: "ISO-3166-1 ALPHA-3 (Country)",
    validationType: "STRING",
    setup: "Secondary"
  },
  countryOfBirth: {
    uniField: "GOBINTL_NATN_CODE_BIRTH",
    format: "ISO-3166-1 ALPHA-3 (Country)",
    validationType: "STRING",
    setup: "Secondary"
  },
  postcode: {
    uniField: "SPRADDR_OVERSEAS_POSTCODE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  admissionsOffice: {
    uniField: "ADMISSIONS_OFFICE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Disabled"
  },
  passportNumber: {
    uniField: "GOBINTL_PASSPORT_ID",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  passportExpiry: {
    uniField: "GOBINTL_PASSPORT_EXP_DATE",
    format: "DATE3",
    validationType: "DATE",
    setup: "Secondary"
  },
  placeOfBirth: {
    uniField: "PLACE_OF_BIRTH",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  ucasId: {
    uniField: "SKRSAIN_UCASNUM",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  applicationId: {
    uniField: "SKRUCCR_APPLICANT_NO",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  englishLevelAttained: {
    uniField: "SKRICAS_SELT_LVL_ATT",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltSpeaking: {
    uniField: "SKRICAS_SELT_LVL_SPEAK",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltListening: {
    uniField: "SKRICAS_SELT_LVL_LIST",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltReading: {
    uniField: "SKRICAS_SELT_LVL_READ",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltWriting: {
    uniField: "SKRICAS_SELT_LVL_WRITE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  englishTestProvider: {
    uniField: "SKRICAS_SELT_TEST_PROV",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  prevUKStudy: {
    uniField: "SKRICAS_PREV_UK_STU",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  criminalConvictions: {
    uniField: "CRIMINAL_CONVICTIONS",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  previousCourseCompletion: {
    uniField: "PREVIOUS_COURSE",
    format: "DATE3",
    validationType: "DATE",
    setup: "Secondary"
  },
  applicationDate: {
    uniField: "APPLICATION_DATE",
    format: "TEXT",
    validationType: "DATE",
    setup: "Secondary"
  },
  confirmed: {
    uniField: "CONFIRMED",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_id: {
    uniField: "SORLCUR_PROGRAM",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_title: {
    uniField: "SMRPCMT_TEXT",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offers_courses_inner_london: {
    uniField: "CAMPUS_CODE",
    format: "NUMBER",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_cah3: {
    uniField: "COURSE_CAH3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditional: {
    uniField: "FD",
    format: "C_OR_U",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_faculty: {
    uniField: "COURSE_FACULTY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Disabled"
  },
  offers_courses_conditions_text1: {
    uniField: "COURSE_CONDITIONAL_TEXT_1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text2: {
    uniField: "COURSE_CONDITIONAL_TEXT_2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text3: {
    uniField: "COURSE_CONDITIONAL_TEXT_3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text4: {
    uniField: "COURSE_CONDITIONAL_TEXT_4",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text5: {
    uniField: "COURSE_CONDITIONAL_TEXT_5",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text6: {
    uniField: "COURSE_CONDITIONAL_TEXT_6",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text7: {
    uniField: "COURSE_CONDITIONAL_TEXT_7",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text8: {
    uniField: "COURSE_CONDITIONAL_TEXT_8",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text9: {
    uniField: "COURSE_CONDITIONAL_TEXT_9",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_declined: {
    uniField: "AD",
    format: "D_OR_F",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_level: {
    uniField: "SZRSPMY_STAGE_LEVEL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_secondaryLevel: {
    uniField: "SECONDARY_LEVEL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_start_date: {
    uniField: "SKRICAS_VISA_START_DT",
    format: "DATE3",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offers_courses_end_date: {
    uniField: "SKRICAS_EXP_CRS_END_DT",
    format: "DATE3",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offers_courses_atas: {
    uniField: "COURSE_ATAS",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_fee: {
    uniField: "SKRICAS_CRSE_FEE_FYO",
    format: "DOUBLE_COURSE_FEE",
    validationType: "STRING",
    setup: "Mandatory"
  },
  courseFeePaidToDate: {
    uniField: "SKRICAS_CRSE_FEE_PTD",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Mandatory"
  },
  offers_courses_lastAcceptanceDate: {
    uniField: "SKRICAS_LATST_ACC_DATE",
    format: "TEXT",
    validationType: "DATE",
    setup: "Secondary"
  },
  offers_courses_isFullTime: {
    uniField: "SKRUDAP_SSDT_CODE_PMOD",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_hoursPerWeek: {
    uniField: "HOURS_PER_WEEK",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  mainStudyAddressLine1: {
    uniField: "ADDR_STREET_LINE1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressLine2: {
    uniField: "ADDR_STREET_LINE2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressLine3: {
    uniField: "ADDR_STREET_LINE3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressCity: {
    uniField: "ADDR_CITY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressCountry: {
    uniField: "ADDR_COUNTRY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressPostcode: {
    uniField: "MN_SITE_STUDY_PO",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  isAccomProvided: {
    uniField: "SKRICAS_SPON_ACCOM_IND",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  isAccomIncludedCourseFee: {
    uniField: "SKRICAS_CRSE_FEE_INC_ACCOM_IND",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  accomFeePaidToDate: {
    format: "NUMBER",
    mappingType: "string",
    setup: "Secondary",
    uniField: "SKRICAS_ACCOM_FEE_PTD",
    validationType: "NUMBER"
  },
  isWorkPlacement: {
    uniField: "SKRICAS_APP_HS_WRK_PLMT",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  workPlacementPerc: {
    uniField: "SKRICAS_WRK_PLMT_PERCENT",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  workPlacementText: {
    uniField: "SKRICAS_WRK_PLMT_JUSTIF",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressLine1: {
    uniField: "WRK_PLMT_ADDR_1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressLine2: {
    uniField: "WRK_PLMT_ADDR_2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressLine3: {
    uniField: "WRK_PLMT_ADDR_3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressCity: {
    uniField: "WRK_PLMT_ADDR_L",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressCountry: {
    uniField: "WRK_PLMT_ADDR_C",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressPostcode: {
    uniField: "WRK_PLMT_ADDR_POST_CODE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  isSELTReqd: {
    uniField: "SKRICAS_SELT_REQ",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  reasonSELTNotReqd: {
    uniField: "SKRICAS_SELT_REA_NOT_REQ",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  previousCourseLevel: {
    uniField: "SKRICAS_PREV_CRS_LVL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  courseProgression: {
    uniField: "SKRICAS_PREV_CURR_LVL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  progressionText: {
    uniField: "SKRICAS_CURR_CRS_JUST",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  docsUsedToObtainOffer: {
    uniField: "SKRICAS_DOC_OFFR",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_scholarshipTitle1: {
    uniField: "SCHOLARSHIP_TITLE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_scholarshipAmount1: {
    uniField: "SCHOLARSHIP_AMOUNT",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  isPSEnglish: {
    setup: "Mandatory",
    uniField: "IS_P_S_ENGLISH",
    validationType: "BOOLEAN",
    format: "TRUE_OR_FALSE"
  },
  offers_presessional_title: {
    uniField: "Pre-sessionalTitle",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_presessional_start_date: {
    uniField: "Pre-sessionalStartDate",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_presessional_end_date: {
    uniField: "Pre-sessionalEndDate",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_presessional_fee: {
    uniField: "Pre-sessionalCourseFee",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_offerEvidence: {
    uniField: "offerEvidence",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_accepted: {
    uniField: "coursesAccepted",
    format: "TRUE_OR_FALSE",
    validationType: "BOOLEAN",
    setup: "Disabled"
  },
  externalCasStatus: {
    format: "TEXT",
    uniField: "offers_SMS_CAS_Status",
    validationType: "STRING",
    setup: "Secondary"
  },
  offersDurationMonths: {
    format: "NUMBER",
    uniField: "offers_duration_months",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_hecos1: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos1",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos2: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos2",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos3: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos3",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos4: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos4",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos5: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos5",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_proportion1: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion1",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion2: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion2",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion3: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion3",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion4: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion4",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion5: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion5",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_cat: {
    format: "TEXT",
    uniField: "offers_courses_qual_cat",
    validationType: "STRING",
    setup: "Secondary"
  },
  scholarshipAmount: {
    format: "NUMBER",
    setup: "Secondary",
    uniField: "SCHOLARSHIP_AMOUNT",
    validationType: "NUMBER"
  },
  scholarshipTitle: {
    format: "TEXT",
    setup: "Secondary",
    uniField: "SCHOLARSHIP_TITLE",
    validationType: "STRING"
  },
  offers_courses_fee_discount: {
    format: "NUMBER",
    setup: "Secondary",
    uniField: "OFFERS_COURSES_FEE_DISCOUNT",
    validationType: "NUMBER"
  },
  agentFamilyName: {
    uniField: "AGENT_FAMILY_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentGivenName: {
    uniField: "AGENT_GIVEN_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchAddressLine1: {
    uniField: "BRANCH_ADDRESS_LINE_1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchAddressLine2: {
    uniField: "BRANCH_ADDRESS_LINE_2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchAddressLine3: {
    uniField: "BRANCH_ADDRESS_LINE_3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchCity: {
    uniField: "BRANCH_CITY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchCountry: {
    uniField: "BRANCH_COUNTRY",
    format: "ISO-3166-1 ALPHA-3 (Country)",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchPostcode: {
    uniField: "BRANCH_POSTCODE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  }
});

// src/uniConfig/formatTypes.ts
var defaultFormatTypes = deepFreeze([
  {
    display: "Date (A valid moment date format)",
    shieldFormat: "YYYY-MM-DD",
    type: "MOMENT_DATE",
    uniFormat: "MOMENT_DATE"
  },
  {
    type: "DATE",
    uniFormat: "D.M.YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD.MM.YYYY"
  },
  {
    type: "DATE2",
    uniFormat: "D-M-YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD-MM-YYYY"
  },
  {
    type: "DATE3",
    uniFormat: "D-MMM-YY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD-MMM-YY"
  },
  {
    type: "DATE6",
    uniFormat: "D-MMM-YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD-MMM-YYYY"
  },
  {
    type: "DATE7",
    uniFormat: "D/M/YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD/MM/YYYY"
  },
  {
    type: "DATE8",
    uniFormat: "YYYY-MM-DDThh:mm:ss",
    shieldFormat: "YYYY-MM-DD",
    display: "YYYY-MM-DDThh:mm:ss"
  },
  {
    type: "DATE9",
    uniFormat: "MMM D, YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "MMM DD, YYYY"
  },
  {
    type: "MAP",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "BOOLEAN",
    display: "MAP (return as boolean)"
  },
  {
    type: "MAP2",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT",
    display: "MAP (return as string)"
  },
  {
    type: "MAP3",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "NUMBER",
    display: "MAP (return as number)"
  },
  {
    type: "GENDER",
    uniFormat: {
      male: "M",
      female: "F",
      other: "O"
    },
    shieldFormat: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    display: "Gender - single character (M or F or O)"
  },
  {
    type: "GENDER2",
    uniFormat: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    shieldFormat: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    display: "Gender - (Male / Female / Other)"
  },
  {
    type: "TEXT",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "Text"
  },
  {
    type: "TEXT_OR_BLANK",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT_OR_BLANK",
    display: "Text OR Blank"
  },
  {
    type: "TRUE_OR_FALSE",
    uniFormat: {
      true: "TRUE",
      false: "FALSE"
    },
    shieldFormat: {
      true: true,
      false: false
    },
    display: "TRUE or FALSE"
  },
  {
    type: "Y_OR_N",
    uniFormat: {
      true: "Y",
      false: "N"
    },
    shieldFormat: {
      true: true,
      false: false
    },
    display: "Single character (Y or N)"
  },
  {
    type: "YES_OR_NO",
    uniFormat: {
      true: "Yes",
      false: "No"
    },
    shieldFormat: {
      true: true,
      false: false
    },
    display: '"Yes" or "No"'
  },
  {
    type: "NUMBER",
    uniFormat: "TEXT",
    shieldFormat: "NUMBER",
    display: "Number"
  },
  {
    type: "ABS_NUMBER",
    uniFormat: "TEXT",
    shieldFormat: "ABS_NUMBER",
    display: "Absolute Number (Positive)"
  },
  {
    type: "ISO-3166-1 ALPHA-2 (Nationality)",
    uniFormat: "ISO-3166-1 ALPHA-2 (Nationality)",
    shieldFormat: "ISO-3166-1 ALPHA-2 (Nationality)"
  },
  {
    type: "ISO-3166-1 ALPHA-3 (Nationality)",
    uniFormat: "ISO-3166-1 ALPHA-3 (Nationality)",
    shieldFormat: "ISO-3166-1 ALPHA-3 (Nationality)"
  },
  {
    type: "ISO-3166-1 ALPHA-2 (Country)",
    uniFormat: "ISO-3166-1 ALPHA-2 (Country)",
    shieldFormat: "ISO-3166-1 ALPHA-2 (Country)"
  },
  {
    type: "ISO-3166-1 ALPHA-3 (Country)",
    uniFormat: "ISO-3166-1 ALPHA-3 (Country)",
    shieldFormat: "ISO-3166-1 ALPHA-3 (Country)"
  },
  {
    type: "REGEX",
    uniFormat: "TEXT",
    shieldFormat: "NUMBER",
    display: "Regex (return as number)"
  },
  {
    type: "REGEX2",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "Regex (return as text)"
  },
  {
    type: "REGEX3",
    uniFormat: "TEXT",
    shieldFormat: "BOOLEAN",
    display: "Regex (return as boolean)"
  },
  {
    type: "PADZERO8",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "8 Chars - Padded with 0"
  },
  {
    type: "PADZERO9",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "9 Chars - Padded with 0"
  },
  {
    type: "BLANK_IF_REGEX_CONDITION",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT_OR_BLANK",
    display: "Blank if regex condition returns a value"
  },
  {
    type: "DEFAULT_IF_REGEX_CONDITION",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT_OR_BLANK",
    display: "Default if regex condition returns a value"
  },
  {
    type: "MULTI_COLUMN",
    uniFormat: "MULTI_COLUMN",
    shieldFormat: "MULTI_COLUMN",
    display: "Multi-column selection (concatenated)"
  }
]);

// src/uniConfig/mappingTypes.ts
var defaultMappingTypes = deepFreeze({
  MAP_DEFAULT_FALSE: {
    default: false
  },
  MAP_DEFAULT_TRUE: {
    default: true
  },
  MAP_OFFER_ID_UNKNOWN: {
    default: "1"
  }
});

// src/uniConfig/reminderNotifications.ts
import { EmailTemplates, ApplicantReminderEmailTemplates } from "types";
var reminderNotificationsConfig = deepFreeze({
  emails: {
    [EmailTemplates.WELCOME]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.CAS_BYPASS_WELCOME]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.STUDENT_DETAILS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.HISTORY]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.FINANCE]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.OUTSTANDING_DOCUMENTS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.OUTSTANDING_FOLLOWUP_DOCUMENTS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.PRECAS_INTERVIEW]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.INTERVIEWS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.PASSPORT]: {},
    [EmailTemplates.DEPOSIT]: {},
    [EmailTemplates.VISA_1]: { repeat: 7, initialDelay: 2 },
    [EmailTemplates.VISA_1_LATE]: { repeat: 7, initialDelay: 2 },
    [EmailTemplates.VISA_2]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.VISA_2_LATE]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.ARRIVAL_1]: { repeat: 7, initialDelay: 1 },
    [EmailTemplates.ARRIVAL_2]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.ARRIVAL_3]: { initialDelay: 7 },
    [EmailTemplates.ARRIVAL_4]: { initialDelay: 1 },
    [EmailTemplates.NEW_INTERVIEWS]: { initialDelay: 1 },
    [EmailTemplates.READY_FOR_CAS]: { initialDelay: 1 },
    [EmailTemplates.DEFERRAL]: { initialDelay: 1 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_2]: { initialDelay: 4 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_3]: { initialDelay: 8 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_4]: { initialDelay: 13 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_4]: { initialDelay: 30 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_4]: { initialDelay: 30, repeat: 30 },
    // repeat every 1 month = every 30 days
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_4]: { initialDelay: 30, repeat: 30 },
    // repeat every 1 month = every 30 days
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_4]: { initialDelay: 30, repeat: 30 },
    // repeat every 1 month = every 30 days
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_4]: { initialDelay: 30 },
    [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_2]: { initialDelay: 7, repeat: 7 },
    [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_2]: { initialDelay: 7, repeat: 7 },
    [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_2]: { initialDelay: 7, repeat: 7 }
  }
});

// src/uniConfig/index.ts
var stages = [
  CoreStatus.PRE_DEPOSIT,
  CoreStatus.POST_DEPOSIT,
  CoreStatus.READY_FOR_CAS,
  CoreStatus.CAS_ISSUED,
  CoreStatus.VISA_ISSUED,
  CoreStatus.VISA_REFUSED,
  CoreStatus.DEFERRED,
  CoreStatus.CLOSED_LOST
];
var moveToStages = [
  { key: CoreStatus.PRE_DEPOSIT, label: CoreStatus.PRE_DEPOSIT },
  { key: CoreStatus.POST_DEPOSIT, label: CoreStatus.POST_DEPOSIT },
  { key: CoreStatus.READY_FOR_CAS, label: CoreStatus.READY_FOR_CAS },
  { key: CoreStatus.CAS_ISSUED, label: CoreStatus.CAS_ISSUED },
  { key: CoreStatus.VISA_ISSUED, label: CoreStatus.VISA_ISSUED },
  { key: CoreStatus.VISA_REFUSED, label: CoreStatus.VISA_REFUSED },
  { key: CoreStatus.DEFERRED, label: CoreStatus.DEFERRED },
  { key: CoreStatus.CLOSED_LOST, label: CoreStatus.CLOSED_LOST }
];
var uniStages = [
  CoreStatusExtended.PRE_DEPOSIT,
  CoreStatusExtended.POST_DEPOSIT,
  CoreStatusExtended.READY_FOR_CAS,
  CoreStatusExtended.CAS_ISSUED,
  CoreStatusExtended.VISA_ISSUED,
  CoreStatusExtended.VISA_REFUSED,
  CoreStatusExtended.DEFERRED,
  CoreStatusExtended.CLOSED_LOST
];
var uniMoveToStages = [
  { key: CoreStatusExtended.PRE_DEPOSIT, label: CoreStatusExtended.PRE_DEPOSIT },
  { key: CoreStatusExtended.POST_DEPOSIT, label: CoreStatusExtended.POST_DEPOSIT },
  { key: CoreStatusExtended.READY_FOR_CAS, label: CoreStatusExtended.READY_FOR_CAS },
  { key: CoreStatusExtended.CAS_ISSUED, label: CoreStatusExtended.CAS_ISSUED },
  { key: CoreStatusExtended.VISA_ISSUED, label: CoreStatusExtended.VISA_ISSUED },
  { key: CoreStatusExtended.VISA_REFUSED, label: CoreStatusExtended.VISA_REFUSED },
  { key: CoreStatusExtended.DEFERRED, label: CoreStatusExtended.DEFERRED },
  { key: CoreStatusExtended.CLOSED_LOST, label: CoreStatusExtended.CLOSED_LOST }
];
var config = {
  urls: {
    Partners: {},
    ImmigrationProviders: {}
  },
  roles: [],
  accessKey: "",
  enrolyAccess: "",
  documentDownloads: {
    enabled: false,
    errorMessage: ""
  },
  offerEnabled: false,
  intakeIds: [],
  defaultIntakeId: "all",
  universityIds: [],
  partnerIds: [],
  allPartners: [],
  allImmigrationProviders: [],
  stages: [...uniStages],
  moveToStages: [...uniMoveToStages],
  dashboardTabs: {
    "[UniAdmin]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Uni]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isArrStatusVisible: true,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[UniSecure]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[UniLite]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isArrStatusVisible: true,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Partner]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [
          CoreStatusExtended.POST_DEPOSIT,
          CoreStatusExtended.INTERVIEW,
          CoreStatusExtended.COMPLIANCE_CHECK,
          CoreStatusExtended.PATHWAY_REVIEW,
          CoreStatusExtended.AWAITING_INFO
        ],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[ImmigrationProvider]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [
          CoreStatusExtended.POST_DEPOSIT,
          CoreStatusExtended.INTERVIEW,
          CoreStatusExtended.COMPLIANCE_CHECK,
          CoreStatusExtended.PATHWAY_REVIEW,
          CoreStatusExtended.AWAITING_INFO
        ],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Agent]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Admin]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 155,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 155,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Not Triggered",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Not-Triggered"],
        isFollowUpDocsCountVisible: false,
        id: "Not-Triggered",
        isVisaStatusVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Waiting for Intake",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Waiting for Intake"],
        isFollowUpDocsCountVisible: false,
        id: "Waiting for Intake",
        isVisaStatusVisible: false
      }
    ],
    "[AgencyAdmin]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Enroly]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Not Triggered",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Not-Triggered"],
        isFollowUpDocsCountVisible: false,
        id: "Not-Triggered",
        isVisaStatusVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Waiting for Intake",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Waiting for Intake"],
        isFollowUpDocsCountVisible: false,
        id: "Waiting for Intake",
        isVisaStatusVisible: false
      }
    ]
  },
  mappingTypes: defaultMappingTypes,
  setupTypes: ["Mandatory", "Secondary", "Disabled"],
  formatTypes: defaultFormatTypes,
  importFieldMappings: defaultFieldMappings,
  sftpImportFieldMappings: defaultFieldMappings,
  sponsor: {
    licenceNumber: "",
    schoolName: "",
    address: "",
    city: "",
    postcode: ""
  },
  defaultUniversityId: "STG",
  university_name: "Staging",
  university_code: "STG",
  teamName: "CAS team",
  documentDownloadsActive: false,
  tuitionPostDiscount: false,
  campuses: [],
  faculties: [],
  departments: [],
  categories: [],
  visaStatuses: [
    "None",
    "CAS not received",
    "CAS received",
    "Visa applied",
    "Awaiting visa response",
    "UKVI request more info",
    "Visa received",
    "Visa refusal",
    "Intends to defer",
    "Intends to withdraw"
  ],
  accessToken: "",
  apiEndpointUrl: "https://public-dev-api.cas-shield.com",
  resolveConflictsModalText: "This action does not update your university system. Please ensure your central records are up to date.",
  defaultQuestions: [],
  trapQuestions: [],
  reminderNotifications: reminderNotificationsConfig,
  applyEnabled: false,
  apply: {
    studentNumberEnabled: false
  },
  partialApplyJourney: false,
  allowedAliases: []
};
var defaultUniConfig = deepFreeze({ ...config });
var defaultImmigrationProviderConfig = deepFreeze({
  ...config,
  moveToStages,
  stages
});
var defaultEmailFrom = deepFreeze({
  casShieldEmailFrom: '"CAS Shield" <contact@cas-shield.com>',
  applyEmailFrom: '"Enroly Apply" <contact@enroly.com>'
});

// src/universities/index.ts
var universities = deepFreeze([
  "Abertay University",
  "Aberystwyth University",
  "AECC University College",
  "Aga Khan University",
  "Anglia Ruskin University",
  "Arden University",
  "Aston University",
  "BPP University",
  "Bangor University",
  "Bath Spa University",
  "Bermuda College",
  "Birkbeck, University of London",
  "Birmingham City University",
  "Bishop Grosseteste University",
  "Blackpool and The Fylde College",
  "Booth School of Business",
  "Bournemouth University",
  "Brunel University London",
  "Buckinghamshire New University",
  "CU London",
  "Canterbury Christ Church University",
  "Cardiff Metropolitan University",
  "Cardiff University",
  "Centre for Medieval and Renaissance Studies",
  "City, University of London",
  "Conservatoire for Dance and Drama",
  "Cornwall College",
  "Courtauld Institute of Art",
  "Coventry University",
  "Cranfield University",
  "De Montfort University",
  "Edge Hill University",
  "Edinburgh Napier University",
  "Falmouth University",
  "Glasgow Caledonian University",
  "Goldsmiths, University of London",
  "Grimsby Institute of Further & Higher Education",
  "Guildhall School of Music and Drama",
  "Harper Adams University",
  "Hartpury University and Hartpury College",
  "Heriot-Watt University",
  "Hull College",
  "Hult International Business School",
  "Imperial College London",
  "Institute of Cancer Research",
  "Keele University",
  "Kingston University",
  "King's College London",
  "LAMDA - London Academy of Music and Dramatic Art",
  "Lancaster University",
  "Leeds Arts University",
  "Leeds Beckett University",
  "Leeds Conservatoire",
  "Leeds Trinity University",
  "Liverpool Hope University",
  "Liverpool John Moores University",
  "Liverpool School of Tropical Medicine",
  "London Business School",
  "London Institute of Banking and Finance",
  "London Metropolitan University",
  "London School of Economics and Political Science",
  "London School of Hygiene and Tropical Medicine",
  "London South Bank University",
  "Loughborough University",
  "Manchester Metropolitan University",
  "Middlesex University",
  "National Film & Television School",
  "New College, Durham",
  "Newcastle College",
  "Newcastle University",
  "Newman University, Birmingham",
  "Northumbria University",
  "Norwich University of the Arts",
  "Nottingham Trent University",
  "Oxford Brookes University",
  "Plymouth College of Art",
  "Plymouth Marjon University",
  "Queen Margaret University",
  "Queen Mary, University of London",
  "Ravensbourne University London",
  "Regent College London",
  "Regent's University London",
  "Richmond, The American International University in London",
  "Robert Gordon University",
  "Roehampton University",
  "Rose Bruford College",
  "Royal Academy of Dramatic Art",
  "Royal Academy of Music",
  "Royal Agricultural University",
  "Royal Central School of Speech and Drama",
  "Royal College of Art",
  "Royal College of Music",
  "Royal Conservatoire of Scotland",
  "Royal Holloway, University of London",
  "Royal Northern College of Music",
  "Royal Veterinary College",
  "Sheffield Hallam University",
  "Scotland's Rural College",
  "SOAS University of London",
  "Solent University",
  "St George's, University of London",
  "St Mary's University, Twickenham",
  "Staffordshire University",
  "Swansea University",
  "Teesside University",
  "The Arts University Bournemouth",
  "The Glasgow School of Art",
  "The Liverpool Institute for Performing Arts",
  "The Open University",
  "Trinity Laban Conservatoire of Music and Dance",
  "Ulster University",
  "University College Birmingham",
  "University College London",
  "University College of Estate Management",
  "University College of Osteopathy",
  "University for the Creative Arts",
  "University of Aberdeen",
  "University of Bath",
  "University of Bedfordshire",
  "University of Birmingham",
  "University of Bolton",
  "University of Bradford",
  "University of Brighton",
  "University of Bristol",
  "University of Buckingham",
  "University of Cambridge",
  "University of Central Lancashire",
  "University of Chester",
  "University of Chichester",
  "University of Cumbria",
  "University of Derby",
  "University of Dundee",
  "University of Durham",
  "University of East Anglia",
  "University of East London",
  "University of Edinburgh",
  "University of Essex",
  "University of Exeter",
  "University of Glasgow",
  "University of Gloucestershire",
  "University of Greenwich",
  "University of Hertfordshire",
  "University of Huddersfield",
  "University of Hull",
  "University of Kent",
  "University of Law",
  "University of Leeds",
  "University of Leicester",
  "University of Lincoln",
  "University of Liverpool",
  "University of London",
  "University of Manchester",
  "University of Northampton",
  "University of Notre Dame",
  "University of Nottingham",
  "University of Oxford",
  "University of Plymouth",
  "University of Portsmouth",
  "University of Reading",
  "University of Salford",
  "University of Sheffield",
  "University of South Wales",
  "University of Southampton",
  "University of St Andrews",
  "University of Stirling",
  "University of Strathclyde",
  "University of Suffolk",
  "University of Sunderland",
  "University of Surrey",
  "University of Sussex",
  "University of Wales, Trinity Saint David",
  "University of Wales",
  "University of Warwick",
  "University of West London",
  "University of Westminster",
  "University of Winchester",
  "University of Wolverhampton",
  "University of Worcester",
  "University of York",
  "University of the Arts London",
  "University of the Highlands & Islands",
  "University of the West of England, Bristol",
  "University of the West of Scotland",
  "Warwickshire College",
  "Wrexham Glynd\u0175r University",
  "Writtle University College",
  "York St John University",
  "Queen's University Belfast"
]);

// src/interviews/index.ts
import { QuestionTypeEnum } from "types";
var MYINTERVIEW_ENCRYPTION_KEY = "MyInt";
var MYINTERVIEW_ENCRYPTION_SALT = "Winner";
var defaultQuestions = deepFreeze([
  {
    question: `Please hold your passport next to your face and clearly state your full name & date of birth`,
    description: `Get your passport photo page or ID photo ready and click "Start Now" to skip the countdown.`,
    duration: 30,
    thinkingTime: 30,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What was your inspiration to choose the UK as your study destination?`,
    description: `Why are you are excited about studying in the UK?`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What is the name of the course and what are the main modules that you will be studying?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What course / degree programme have you completed most recently? How are your previous studies related to your current course?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Excluding ranking, why did you choose this university?`,
    description: `Please state, at least, 3 reasons why you chose this university`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Please share some information about the two other universities you applied to or considered applying to.`,
    description: `What are the similarities and differences between these universities and us? Please speak freely about both the positive and the negative, your answer will not affect your application.`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What accommodation types did you consider and which one did you choose? `,
    description: `Please explain why you selected the option you did and why you DID NOT select an alternative option?`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `What person or organisation is funding your tuition fees and what is the source of the funding?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Do you have any ambitions to work while studying the UK? After you have graduated, where do you plan to live and work?`,
    description: `If you have answered yes to the first question, please explain why.`,
    duration: 30,
    thinkingTime: 60,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  },
  {
    question: `Where do you see yourself in 5 years?`,
    description: `Provide a detailed summary of your future plans.`,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Standard
  }
]);
var trapQuestions = deepFreeze([
  {
    question: `Which city in the UK are you most excited to visit?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `What three things do you think the UK is most famous for?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Can you name three famous tourist attractions in the UK?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Are there any food you are looking forward to trying in the UK? Why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Which teacher has most inspired you? Why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `List 3 example grounds for visa refusals`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Do you have any hobby you'd like to pursue whilst in the UK?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Do you know the name of Queen of the United Kingdom?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `What can you tell me about the British weather?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `What was your favourite subject to study at school and why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Tell me about your proudest achievement`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `If you could choose between being invisible and flying, which would you choose and why?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  },
  {
    question: `Who is your favourite Youtuber?`,
    description: ``,
    duration: 30,
    thinkingTime: 45,
    retakes: 0,
    questionType: QuestionTypeEnum.Trap
  }
]);

// src/tag/index.ts
import { TagType } from "types";
var nonRemovableTagTypes = deepFreeze([
  TagType.OVER_12_MONTHS_UK,
  TagType.UNDER_12_MONTHS_UK,
  TagType.PATHWAY,
  TagType.EUSS_GRANTED,
  TagType.EUSS_PENDING,
  TagType.MULTI_INTAKE,
  TagType.MANUAL_CAS
]);
var systemTagTypes = deepFreeze([
  TagType.PATHWAY,
  TagType.EUSS_GRANTED,
  TagType.EUSS_PENDING,
  TagType.MULTI_INTAKE,
  TagType.MANUAL_CAS,
  TagType.TRANSFERMATE,
  TagType.OVER_12_MONTHS_UK,
  TagType.UNDER_12_MONTHS_UK,
  TagType.OVER_28_DAYS_VISA_GAP,
  TagType.UNDER_28_DAYS_VISA_GAP
]);

// src/messages/index.ts
var defaultnoRoleAssignedMsg = "You do not have CAS Shield access level configured. Please contact your administrator.";

// src/englishTestData/index.ts
import { EnglishTestNotReqdReason, EnglishTestType, GradeLevel, GradeSystem } from "types";
var ENGLISH_TEST_TYPE_VAL_LABEL_MAP = deepFreeze({
  IELTS_FOR_UKVI: "IELTS for UKVI",
  IELTS_ACADEMIC: "IELTS Academic",
  IELTS: "IELTS General",
  ESOL_SELT: "LanguageCert International ESOL SELT",
  ISE: "Trinity College London Integrated Skills in English (ISE)",
  PTE_UKVI: "PTE Academic UKVI",
  PTE: "PTE Academic",
  PSI: "PSI Services Skills for English UKVI",
  Cambridge: "Cambridge Assessment English test",
  TOEFL: "TOEFL",
  ELLT: "OI Digital Institute English Language Level Test (ELLT)",
  UNI: `University's English test`
});
var NOT_REQUIRED_REASONS = deepFreeze(
  Object.entries(EnglishTestNotReqdReason).map(([value, label]) => ({
    label,
    value
  }))
);
var ENGLISH_TEST_TYPES = deepFreeze(
  Object.entries(EnglishTestType).map(([value, label]) => ({
    label,
    value
  }))
);
var QUALIFICATIONS = deepFreeze(
  Object.entries(GradeLevel).map(([value, label]) => ({
    label,
    value
  }))
);
var QUALIFICATION_GRADE_SYSTEMS = deepFreeze(
  Object.entries(GradeSystem).map(([value, label]) => ({
    label,
    value
  }))
);
var QUALIFICATION_VAL_LABEL_MAP = deepFreeze(
  Object.entries(GradeLevel).reduce(
    (map, [key, value]) => {
      map[key] = value;
      return map;
    },
    {}
  )
);
var ENGLISH_SPEAKING_COUNTRIES = deepFreeze([
  "Antiguans",
  "Australian",
  "Bahamian",
  "Barbadian",
  "Belizean",
  "Anguillan",
  "Bermudan",
  "British (IOT)",
  "Virgin Islander (British)",
  "Caymanian",
  "Falkland Islander",
  "Gibraltarian",
  "Montserratian",
  "Pitcairn Islander",
  "Saint Helenian",
  "South Georgia and the South Sandwich Islands",
  "Turks and Caicos Islander",
  "Canadian",
  "Dominican",
  "Grenadian",
  "Guyanese",
  "Jamaican",
  "Maltese",
  "New Zealander",
  "Kittian",
  "Saint Lucian",
  "Saint Vincentian",
  "Trinidadian",
  "American"
]);

// src/apply/applicantTaskConfig.ts
import {
  SectionLabel,
  SectionRoute,
  YourInformationTaskGroupLabel,
  ApplicationTaskGroupLabel,
  YourInformationTaskLabel,
  ApplicationTaskLabel,
  YourInformationTaskRoute,
  ApplicationTaskRoute,
  OfferTaskLabel as OfferTaskLabel2,
  OfferTaskRoute,
  OfferTaskGroupLabel,
  ApplicationStatus as ApplicationStatus2
} from "types";
var applicantTasksConfig = {
  defaultTask: {
    label: SectionLabel.Home,
    route: SectionRoute.Home
  },
  sections: [
    {
      label: SectionLabel.YourInformation,
      route: SectionRoute.YourInformation,
      taskGroups: [
        {
          label: YourInformationTaskGroupLabel.AboutYou,
          tasks: [
            {
              label: YourInformationTaskLabel.ContactDetails,
              route: YourInformationTaskRoute.ContactDetails
            },
            {
              label: YourInformationTaskLabel.FeeStatus,
              route: YourInformationTaskRoute.FeeStatus
            },
            {
              label: YourInformationTaskLabel.ProgrammeChoices,
              route: YourInformationTaskRoute.ProgrammeChoices
            }
          ]
        },
        {
          label: YourInformationTaskGroupLabel.YourQualifications,
          tasks: [
            {
              label: YourInformationTaskLabel.HighestStudy,
              route: YourInformationTaskRoute.HighestStudy
            }
          ]
        }
      ]
    },
    {
      label: SectionLabel.Application,
      route: SectionRoute.Application,
      taskGroups: [
        {
          label: ApplicationTaskGroupLabel.PersonalInformation,
          tasks: [
            {
              label: ApplicationTaskLabel.Identity,
              route: ApplicationTaskRoute.Identity
            },
            {
              label: ApplicationTaskLabel.NationalityResidence,
              route: ApplicationTaskRoute.NationalityResidence
            },
            {
              label: ApplicationTaskLabel.ContactDetails,
              route: ApplicationTaskRoute.ContactDetails
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.QualificationsExperience,
          tasks: [
            {
              label: ApplicationTaskLabel.EducationHistory,
              route: ApplicationTaskRoute.EducationHistory
            },
            {
              label: ApplicationTaskLabel.EnglishLanguage,
              route: ApplicationTaskRoute.EnglishLanguage
            },
            {
              label: ApplicationTaskLabel.Employment,
              route: ApplicationTaskRoute.Employment
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.SupportingInformation,
          tasks: [
            {
              label: ApplicationTaskLabel.References,
              route: ApplicationTaskRoute.References
            },
            {
              label: ApplicationTaskLabel.PersonalStatement,
              route: ApplicationTaskRoute.PersonalStatement
            },
            {
              label: ApplicationTaskLabel.ResearchProposal,
              route: ApplicationTaskRoute.ResearchProposal
            },
            {
              label: ApplicationTaskLabel.Funding,
              route: ApplicationTaskRoute.Funding
            },
            {
              label: ApplicationTaskLabel.ImmigrationHistory,
              route: ApplicationTaskRoute.ImmigrationHistory
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.AboutYourApplication,
          tasks: [
            {
              label: ApplicationTaskLabel.DiversityInclusion,
              route: ApplicationTaskRoute.DiversityInclusion
            },
            {
              label: ApplicationTaskLabel.Representation,
              route: ApplicationTaskRoute.Representation
            },
            {
              label: ApplicationTaskLabel.Referral,
              route: ApplicationTaskRoute.Referral
            },
            {
              label: ApplicationTaskLabel.Declarations,
              route: ApplicationTaskRoute.Declarations
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.Consent,
          tasks: [
            {
              label: ApplicationTaskLabel.InformationProcessing,
              route: ApplicationTaskRoute.InformationProcessing
            },
            {
              label: ApplicationTaskLabel.PrivacyPolicy,
              route: ApplicationTaskRoute.PrivacyPolicy
            },
            {
              label: ApplicationTaskLabel.TermsConditions,
              route: ApplicationTaskRoute.TermsConditions
            },
            {
              label: ApplicationTaskLabel.AccuracyOfData,
              route: ApplicationTaskRoute.AccuracyOfData
            }
          ]
        }
      ]
    },
    {
      label: SectionLabel.Programmes,
      route: SectionRoute.Programmes,
      taskGroups: [
        {
          label: OfferTaskGroupLabel.Acceptance,
          tasks: [
            {
              label: OfferTaskLabel2.ConditionalOffer,
              route: OfferTaskRoute.ConditionalOffer
            },
            {
              label: OfferTaskLabel2.UnconditionalOffer,
              route: OfferTaskRoute.UnconditionalOffer
            }
          ]
        },
        {
          label: OfferTaskGroupLabel.Conditions,
          tasks: [
            {
              label: OfferTaskLabel2.Passport,
              route: OfferTaskRoute.Passport
            },
            {
              label: OfferTaskLabel2.PhotoID,
              route: OfferTaskRoute.PhotoID
            },
            {
              label: OfferTaskLabel2.ProofOfNameChange,
              route: OfferTaskRoute.ProofOfNameChange
            },
            {
              label: OfferTaskLabel2.NameAffidavit,
              route: OfferTaskRoute.NameAffidavit
            },
            {
              label: OfferTaskLabel2.BirthCert,
              route: OfferTaskRoute.BirthCert
            },
            {
              label: OfferTaskLabel2.AcademicResults,
              route: OfferTaskRoute.AcademicResults
            },
            {
              label: OfferTaskLabel2.FinalAcademicResults,
              route: OfferTaskRoute.FinalAcademicResults
            },
            {
              label: OfferTaskLabel2.AcademicCertificate,
              route: OfferTaskRoute.AcademicCertificate
            },
            {
              label: OfferTaskLabel2.AcademicTranscript,
              route: OfferTaskRoute.AcademicTranscript
            },
            {
              label: OfferTaskLabel2.EnglishLanguageResults,
              route: OfferTaskRoute.EnglishLanguageResults
            },
            {
              label: OfferTaskLabel2.EnglishLanguageCertificate,
              route: OfferTaskRoute.EnglishLanguageCertificate
            },
            {
              label: OfferTaskLabel2.ProofOfManagerialExperience,
              route: OfferTaskRoute.ProofOfManagerialExperience
            },
            {
              label: OfferTaskLabel2.ProofOfAddress,
              route: OfferTaskRoute.ProofOfAddress
            },
            {
              label: OfferTaskLabel2.CV,
              route: OfferTaskRoute.CV
            },
            {
              label: OfferTaskLabel2.ProofOfImmigrationStatus,
              route: OfferTaskRoute.ProofOfImmigrationStatus
            },
            {
              label: OfferTaskLabel2.LetterOfRecommendation,
              route: OfferTaskRoute.LetterOfRecommendation
            },
            {
              label: OfferTaskLabel2.PersonalStatement,
              route: OfferTaskRoute.PersonalStatement
            },
            {
              label: OfferTaskLabel2.RefereeDetails,
              route: OfferTaskRoute.RefereeDetails
            },
            {
              label: OfferTaskLabel2.Custom,
              route: OfferTaskRoute.Custom
            }
          ]
        },
        {
          label: OfferTaskGroupLabel.Finance,
          tasks: [
            {
              label: OfferTaskLabel2.Payment,
              route: OfferTaskRoute.Payment
            },
            {
              label: OfferTaskLabel2.ProofOfPayment,
              route: OfferTaskRoute.ProofOfPayment
            }
          ]
        }
      ]
    }
  ]
};
var uniViewApplicantTaskGroups = applicantTasksConfig.sections[1].taskGroups.map((taskGroup) => {
  const { label, tasks } = taskGroup;
  return {
    label,
    tasks: tasks.map((task) => {
      const { label: taskLabel, route } = task;
      return {
        label: taskLabel,
        route: route.replace("/applications/{applicationId}", "").replace("applications/{applicationId}", "")
        // more robust
      };
    })
  };
});
var ActiveApplicationStatues = [
  ApplicationStatus2.InProgress,
  ApplicationStatus2.Completed,
  ApplicationStatus2.Submitted
];

// src/apply/months.ts
var MONTHS = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" }
];

// src/apply/offers.ts
import { ApplicantOfferStatus as ApplicantOfferStatus2, ApplicantStatusReason } from "types";
var offerIssueStatuses = [ApplicantOfferStatus2.Conditional, ApplicantOfferStatus2.Unconditional];
var offerNeedsReissueStatuses = [...offerIssueStatuses, ApplicantOfferStatus2.Withdrawn];
var userGeneratedApplicantStatusReasonLabels = {
  [ApplicantStatusReason.EntryCriteriaNotMet]: "Entry criteria not met",
  [ApplicantStatusReason.FailedAcademicAssessment]: "Failed academic assessment",
  [ApplicantStatusReason.FailedCredibilityAssessment]: "Failed credibility assessment",
  [ApplicantStatusReason.FraudulentApplication]: "Fraudulent application",
  [ApplicantStatusReason.CourseClosure]: "Course closure",
  [ApplicantStatusReason.CourseFull]: "Course full",
  [ApplicantStatusReason.UnableToOfferCourse]: "Unable to offer course to applicant",
  [ApplicantStatusReason.DeadlineHasPassed]: "Deadline has passed",
  [ApplicantStatusReason.ClosedByApplicant]: "Closed by applicant",
  [ApplicantStatusReason.WrongApplicationForm]: "Wrong application form",
  [ApplicantStatusReason.FailedPreCasInterview]: "Failed Pre-CAS Interview",
  [ApplicantStatusReason.FailedComplianceInterview]: "Failed Compliance Interview",
  [ApplicantStatusReason.NegativeQualificationVerification]: "Negative Qualification Verification",
  [ApplicantStatusReason.DuplicateApplication]: "Duplicate application",
  [ApplicantStatusReason.InactiveApplication]: "Inactive application",
  [ApplicantStatusReason.RegionExclusiveToAgent]: "The region is exclusive to a specific agent",
  [ApplicantStatusReason.Other]: "Other"
};
var systemGeneratedApplicantStatusReasonLabels = {
  [ApplicantStatusReason.AcceptedByApplicant]: "Accepted by applicant",
  [ApplicantStatusReason.CompletedByApplicant]: "Completed by applicant",
  [ApplicantStatusReason.WithdrawnOnCompletion]: "Closed by applicant"
};
var statusReasonOptions = [
  { label: "Entry criteria not met", value: ApplicantStatusReason.EntryCriteriaNotMet },
  { label: "Failed academic assessment", value: ApplicantStatusReason.FailedAcademicAssessment },
  { label: "Failed credibility assessment", value: ApplicantStatusReason.FailedCredibilityAssessment },
  { label: "Fraudulent application", value: ApplicantStatusReason.FraudulentApplication },
  { label: "Course closure", value: ApplicantStatusReason.CourseClosure },
  { label: "Course full", value: ApplicantStatusReason.CourseFull },
  { label: "Unable to offer course to applicant", value: ApplicantStatusReason.UnableToOfferCourse },
  { label: "Deadline has passed", value: ApplicantStatusReason.DeadlineHasPassed },
  { label: "Closed by applicant", value: ApplicantStatusReason.ClosedByApplicant },
  { label: "Wrong application form", value: ApplicantStatusReason.WrongApplicationForm },
  { label: "Failed Pre-CAS Interview", value: ApplicantStatusReason.FailedPreCasInterview },
  { label: "Failed Compliance Interview", value: ApplicantStatusReason.FailedComplianceInterview },
  { label: "Negative Qualification Verification", value: ApplicantStatusReason.NegativeQualificationVerification },
  { label: "Duplicate application", value: ApplicantStatusReason.DuplicateApplication },
  { label: "Inactive application", value: ApplicantStatusReason.InactiveApplication },
  { label: "The region is exclusive to a specific agent", value: ApplicantStatusReason.RegionExclusiveToAgent },
  { label: "Other", value: ApplicantStatusReason.Other }
];
var OfferTooltipLabels = {
  applicantAccepted: "The applicant has accepted this offer",
  applicantDeclined: "Applicant has declined this offer",
  offerWithdrawn: "Offer withdrawn",
  pendingChanges: "Offer edited since it was last issued",
  pendingChangesByApplicant: "Applicant has provided new information",
  newDocumentsCount: (count) => {
    if (count === 1) {
      return `${count} new update from applicant`;
    }
    return `${count} new updates from applicant`;
  },
  requirementsNotSatisfied: (count) => {
    if (count === 1) {
      return `Offer cannot be issued as ${count} requirement is not satisfied`;
    }
    return `Offer cannot be issued as ${count} requirements are not satisfied`;
  }
};

// src/dates/index.ts
var months = deepFreeze([
  { name: "January", value: "01" },
  { name: "February", value: "02" },
  { name: "March", value: "03" },
  { name: "April", value: "04" },
  { name: "May", value: "05" },
  { name: "June", value: "06" },
  { name: "July", value: "07" },
  { name: "August", value: "08" },
  { name: "September", value: "09" },
  { name: "October", value: "10" },
  { name: "November", value: "11" },
  { name: "December", value: "12" }
]);

// src/highestQualification/index.ts
var HIGHEST_QUALIFICATIONS = deepFreeze([
  { value: "99999", label: "Not available" },
  { value: "C0000", label: "Certificate of Higher Education (CertHE)" },
  { value: "C0001", label: "Higher National Certificate (HNC)" },
  { value: "C0004", label: "National Vocational Qualification (NVQ) at level C" },
  { value: "C0007", label: "Other qualification at level C" },
  { value: "C0008", label: "Credits at level C" },
  { value: "C0010", label: "Higher Apprenticeship (level 4)" },
  { value: "D0000", label: "UK doctorate degree" },
  { value: "D0001", label: "Non-UK doctorate degree" },
  { value: "D0002", label: "Other qualification at level D" },
  { value: "H0000", label: "UK first degree with honours" },
  { value: "H0001", label: "Non-UK first degree" },
  {
    value: "H0002",
    label: "First degree with honours leading to Qualified Teacher Status (QTS)/registration with a General Teaching Council (GTC)"
  },
  { value: "H0013", label: "Professional Graduate Certificate in Education" },
  { value: "H0016", label: "Other qualification at level H" },
  { value: "I0000", label: "UK ordinary (non-honours) first degree" },
  { value: "J0000", label: "Foundation degree" },
  { value: "J0002", label: "Diploma of Higher Education (DipHE)" },
  { value: "J0003", label: "Higher National Diploma (HND)" },
  { value: "J0007", label: "Scottish Vocational Qualification (SVQ) 4" },
  { value: "J0008", label: "Certificate in Education (CertEd) or Diploma in Education (DipEd)" },
  { value: "J0009", label: "Foundation course at level J" },
  { value: "J0010", label: "Other qualification at level J" },
  { value: "M0000", label: "UK masters degree" },
  { value: "M0001", label: "Non-UK masters degree" },
  {
    value: "M0002",
    label: "Integrated undergraduate/postgraduate taught masters degree on the enhanced/extended pattern"
  },
  { value: "M0009", label: "Diploma at level M" },
  { value: "M0012", label: "Certificate at level M" },
  {
    value: "M0016",
    label: "Postgraduate Certificate in Education or Professional Graduate Diploma in Education"
  },
  { value: "M0021", label: "Other taught qualification at level M" },
  { value: "M0022", label: "Credits at level M" },
  { value: "P0000", label: "Diploma at level 3" },
  { value: "P0001", label: "Certificate at level 3" },
  { value: "P0002", label: "Award at level 3" },
  { value: "P0003", label: "AQA Baccalaureate (Bacc)" },
  { value: "P0004", label: "A/AS level" },
  { value: "P0005", label: "14-19 Advanced Diploma (level 3)" },
  { value: "P0006", label: "Scottish Baccalaureate" },
  { value: "P0007", label: "Scottish Highers/Advanced Highers" },
  { value: "P0008", label: "International Baccalaureate (IB) Diploma" },
  { value: "P0009", label: "International Baccalaureate (IB) Certificate" },
  { value: "P0010", label: "Cambridge Pre-U Diploma" },
  { value: "P0011", label: "Cambridge Pre-U Certificate" },
  { value: "P0012", label: "Welsh Baccalaureate Advanced Diploma (level 3)" },
  { value: "P0013", label: "Other qualification at level 3" },
  { value: "P0014", label: "UK Level 3 qualifications of which none are subject to UCAS Tariff" },
  { value: "P0015", label: "UK Level 3 qualifications of which all are subject to UCAS Tariff" },
  {
    value: "P0016",
    label: "Level 3 qualifications of which some are UK qualifications subject to UCAS Tariff"
  },
  { value: "P0017", label: "T levels" },
  { value: "Q0000", label: "14-19 Higher Diploma (level 2)" },
  { value: "Q0001", label: "Welsh Baccalaureate Intermediate Diploma (level 2)" },
  { value: "Q0002", label: "Other qualification at level 2" },
  { value: "R0000", label: "14-19 Foundation Diploma (level 1)" },
  { value: "R0001", label: "Welsh Baccalaureate Foundation Diploma (level 1)" },
  { value: "R0002", label: "Other qualification at level 1" },
  { value: "X0000", label: "Higher education (HE) access course, Quality Assurance Agency (QAA) recognised" },
  {
    value: "X0001",
    label: "Higher education (HE) access course, not Quality Assurance Agency (QAA) recognised"
  },
  { value: "X0002", label: "Mature student admitted on basis of previous experience and/or admissions test" },
  { value: "X0003", label: "Other qualification level not known" },
  { value: "X0004", label: "Student has no formal qualification" }
]);
var HIGHEST_QUALIFICATIONS_LIST = deepFreeze(
  HIGHEST_QUALIFICATIONS.map((qualification) => ({
    label: `${qualification.value} - ${qualification.label}`,
    value: qualification.value
  }))
);
var HIGHEST_QUALIFICATIONS_MAP = deepFreeze(
  HIGHEST_QUALIFICATIONS.reduce(
    (map, qualification) => {
      map[qualification.value] = qualification.label;
      return map;
    },
    {}
  )
);

// src/integration/ellucian/index.ts
var EllucianEthnicityMapping = {
  Arab: { title: "Arab" },
  "Asian - Bangladeshi": { title: "Asian\\Asian Brit - Bangladeshi" },
  "Asian - Chinese": { title: "Chinese" },
  "Asian - Indian": { title: "Asian\\Asian Brit - Indian" },
  "Asian - Pakistani": { title: "Asian\\Asian Brit - Pakistani" },
  "Asian - Other background": { title: "Other Asian background" },
  "Black - African": { title: "Black\\Black Brit - African" },
  "Black - Caribbean": { title: "Black\\Black Brit - Caribbean" },
  "Black - Other background": { title: "Other Black background" },
  "Gypsy, Traveller or Irish Traveller": { title: "Gypsy or Traveller" },
  "Mixed - White & Asian": { title: "Mixed - White & Asian" },
  "Mixed - White & Black African": { title: "Mixed - White\\Black African" },
  "Mixed - White & Black Caribbean": { title: "Mixed - White\\Black Caribbean" },
  "Mixed - Other background": { title: "Other Mixed background" },
  White: { title: "White" },
  "White - Irish": { title: "//White - Irish" },
  // closest match
  "White - Roma": { title: "//White Roma" },
  "White - Other background": { title: "Other White background" },
  "Other ethnic background": { title: "Other Ethnic background" },
  "I prefer not to say": { title: "I prefer not to say" }
};
var EllucianFpay = [
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "01",
    skvssdtSdatCodeOpt3: "01",
    skvssdtShortTitle: "Private finance.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Entire cost of tuition fees is paid by private finance.",
    enrolyEnumValue: "PrivateFinance"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "02",
    skvssdtSdatCodeOpt3: "02",
    skvssdtShortTitle: "Apply for support by LEA, SAAS etc.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Applying for student support assessment by LEA, SAAS, Northern Ireland Education and Library Board, DfES or Channel Islands or Isle of Man agency.",
    enrolyEnumValue: "StudentFinance"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "04",
    skvssdtSdatCodeOpt3: "04",
    skvssdtShortTitle: "Contrib. from Research Council.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Contribution from a Research Council.",
    enrolyEnumValue: "ResearchCouncils"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "05",
    skvssdtSdatCodeOpt3: "05",
    skvssdtShortTitle: "Contrib from Dept Health/RHA.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Contribution from the Department of Health or a Regional Health Authority.",
    enrolyEnumValue: "HealthAuthority"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "06",
    skvssdtSdatCodeOpt3: "06",
    skvssdtShortTitle: "Oseas award from UK Govt/Brit Counc",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Overseas student award from the UK government or the British Council.",
    enrolyEnumValue: "UkGovtInternational"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "07",
    skvssdtSdatCodeOpt3: "07",
    skvssdtShortTitle: "Contrib from a training agency.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Contribution from a training agency.",
    enrolyEnumValue: "TrainingAgency"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "08",
    skvssdtSdatCodeOpt3: "08",
    skvssdtShortTitle: "Other UK government award.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Other UK government award.",
    enrolyEnumValue: "UkGovtOther"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "09",
    skvssdtSdatCodeOpt3: "09",
    skvssdtShortTitle: "Contrib from an overseas agency etc",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Contribution from an overseas agency, government, university or industry.",
    enrolyEnumValue: "OverseasAgency"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "10",
    skvssdtSdatCodeOpt3: "10",
    skvssdtShortTitle: "Contrib from UK Industry/Commerce.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Contribution from UK industry or commerce.",
    enrolyEnumValue: "UkIndustry"
  },
  {
    skvssdtActivityDate: "2002-10-11T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "22",
    skvssdtSdatCodeOpt3: "22",
    skvssdtShortTitle: "Apply for support LEA and Bursary.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Applying for student support assessment by LEA in England and eligible for an Opportunity Bursary within an 'Excellence in Cities' area or an 'Education Action Zone'.",
    enrolyEnumValue: "StudentFinance"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "90",
    skvssdtSdatCodeOpt3: "90",
    skvssdtShortTitle: "Other source of finance.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Other source of finance.",
    enrolyEnumValue: "Other"
  },
  {
    skvssdtActivityDate: "1999-04-18T00:00:00.000+0100",
    skvssdtEffDate: "1999-04-18T00:00:00.000+0100",
    skvssdtSdatCodeAttr: "SKRSAIN_SSDT_CODE_FPAY",
    skvssdtSdatCodeEntity: "SKRSAIN",
    skvssdtSdatCodeOpt1: "99",
    skvssdtSdatCodeOpt3: "99",
    skvssdtShortTitle: "Not known.",
    skvssdtStatusInd: "A",
    skvssdtTitle: "Not known.",
    enrolyEnumValue: "Unknown"
  }
];

// src/idealPostcodes/countries.ts
var IdealPostcodeCountries = /* @__PURE__ */ ((IdealPostcodeCountries2) => {
  IdealPostcodeCountries2["AFGHANISTAN"] = "Afghanistan";
  IdealPostcodeCountries2["ALBANIA"] = "Albania";
  IdealPostcodeCountries2["ALGERIA"] = "Algeria";
  IdealPostcodeCountries2["AMERICAN_SAMOA"] = "American Samoa";
  IdealPostcodeCountries2["ANDORRA"] = "Andorra";
  IdealPostcodeCountries2["ANGOLA"] = "Angola";
  IdealPostcodeCountries2["ANGUILLA"] = "Anguilla";
  IdealPostcodeCountries2["ANTIGUA_AND_BARBUDA"] = "Antigua and Barbuda";
  IdealPostcodeCountries2["ARGENTINA"] = "Argentina";
  IdealPostcodeCountries2["ARMENIA"] = "Armenia";
  IdealPostcodeCountries2["ARUBA"] = "Aruba";
  IdealPostcodeCountries2["AUSTRALIA"] = "Australia";
  IdealPostcodeCountries2["AUSTRIA"] = "Austria";
  IdealPostcodeCountries2["AZERBAIJAN"] = "Azerbaijan";
  IdealPostcodeCountries2["BAHAMAS"] = "Bahamas";
  IdealPostcodeCountries2["BAHRAIN"] = "Bahrain";
  IdealPostcodeCountries2["BANGLADESH"] = "Bangladesh";
  IdealPostcodeCountries2["BARBADOS"] = "Barbados";
  IdealPostcodeCountries2["BELARUS"] = "Belarus";
  IdealPostcodeCountries2["BELGIUM"] = "Belgium";
  IdealPostcodeCountries2["BELIZE"] = "Belize";
  IdealPostcodeCountries2["BENIN"] = "Benin";
  IdealPostcodeCountries2["BERMUDA"] = "Bermuda";
  IdealPostcodeCountries2["BHUTAN"] = "Bhutan";
  IdealPostcodeCountries2["BOLIVIA"] = "Bolivia";
  IdealPostcodeCountries2["BONAIRE_SINT_EUSTATIUS_AND_SABA"] = "Bonaire, Sint Eustatius and Saba";
  IdealPostcodeCountries2["BOSNIA_AND_HERZEGOVINA"] = "Bosnia and Herzegovina";
  IdealPostcodeCountries2["BOTSWANA"] = "Botswana";
  IdealPostcodeCountries2["BRAZIL"] = "Brazil";
  IdealPostcodeCountries2["BRITISH_INDIAN_OCEAN_TERRITORY"] = "British Indian Ocean Territory";
  IdealPostcodeCountries2["BRITISH_VIRGIN_ISLANDS"] = "British Virgin Islands";
  IdealPostcodeCountries2["BRUNEI_DARUSSALAM"] = "Brunei Darussalam";
  IdealPostcodeCountries2["BULGARIA"] = "Bulgaria";
  IdealPostcodeCountries2["BURKINA_FASO"] = "Burkina Faso";
  IdealPostcodeCountries2["BURUNDI"] = "Burundi";
  IdealPostcodeCountries2["CAMBODIA"] = "Cambodia";
  IdealPostcodeCountries2["CAMEROON"] = "Cameroon";
  IdealPostcodeCountries2["CANADA"] = "Canada";
  IdealPostcodeCountries2["CAPE_VERDE"] = "Cape Verde";
  IdealPostcodeCountries2["CAYMAN_ISLANDS"] = "Cayman Islands";
  IdealPostcodeCountries2["CENTRAL_AFRICAN_REPUBLIC"] = "Central African Republic";
  IdealPostcodeCountries2["CHAD"] = "Chad";
  IdealPostcodeCountries2["CHILE"] = "Chile";
  IdealPostcodeCountries2["CHINA"] = "China";
  IdealPostcodeCountries2["CHRISTMAS_ISLAND"] = "Christmas Island";
  IdealPostcodeCountries2["COCOS_KEELING_ISLANDS"] = "Cocos (Keeling) Islands";
  IdealPostcodeCountries2["COLOMBIA"] = "Colombia";
  IdealPostcodeCountries2["COMOROS"] = "Comoros";
  IdealPostcodeCountries2["COOK_ISLANDS"] = "Cook Islands";
  IdealPostcodeCountries2["COSTA_RICA"] = "Costa Rica";
  IdealPostcodeCountries2["COTE_DIVOIRE"] = "C\xF4te d'Ivoire";
  IdealPostcodeCountries2["CROATIA"] = "Croatia";
  IdealPostcodeCountries2["CUBA"] = "Cuba";
  IdealPostcodeCountries2["CURACAO"] = "Cura\xE7ao";
  IdealPostcodeCountries2["CYPRUS"] = "Cyprus";
  IdealPostcodeCountries2["CZECH_REPUBLIC"] = "Czech Republic";
  IdealPostcodeCountries2["DEMOCRATIC_REPUBLIC_OF_THE_CONGO"] = "Democratic Republic of the Congo";
  IdealPostcodeCountries2["DENMARK"] = "Denmark";
  IdealPostcodeCountries2["DJIBOUTI"] = "Djibouti";
  IdealPostcodeCountries2["DOMINICA"] = "Dominica";
  IdealPostcodeCountries2["DOMINICAN_REPUBLIC"] = "Dominican Republic";
  IdealPostcodeCountries2["ECUADOR"] = "Ecuador";
  IdealPostcodeCountries2["EGYPT"] = "Egypt";
  IdealPostcodeCountries2["EL_SALVADOR"] = "El Salvador";
  IdealPostcodeCountries2["ENGLAND"] = "England";
  IdealPostcodeCountries2["EQUATORIAL_GUINEA"] = "Equatorial Guinea";
  IdealPostcodeCountries2["ERITREA"] = "Eritrea";
  IdealPostcodeCountries2["ESTONIA"] = "Estonia";
  IdealPostcodeCountries2["ESWATINI"] = "Eswatini";
  IdealPostcodeCountries2["ETHIOPIA"] = "Ethiopia";
  IdealPostcodeCountries2["FALKLAND_ISLANDS_MALVINAS"] = "Falkland Islands (Malvinas)";
  IdealPostcodeCountries2["FAROE_ISLANDS"] = "Faroe Islands";
  IdealPostcodeCountries2["FEDERATED_STATES_OF_MICRONESIA"] = "Federated States of Micronesia";
  IdealPostcodeCountries2["FIJI"] = "Fiji";
  IdealPostcodeCountries2["FINLAND"] = "Finland";
  IdealPostcodeCountries2["FRANCE"] = "France";
  IdealPostcodeCountries2["FRENCH_GUIANA"] = "French Guiana";
  IdealPostcodeCountries2["FRENCH_POLYNESIA"] = "French Polynesia";
  IdealPostcodeCountries2["GABON"] = "Gabon";
  IdealPostcodeCountries2["GAMBIA"] = "Gambia";
  IdealPostcodeCountries2["GEORGIA"] = "Georgia";
  IdealPostcodeCountries2["GERMANY"] = "Germany";
  IdealPostcodeCountries2["GHANA"] = "Ghana";
  IdealPostcodeCountries2["GIBRALTAR"] = "Gibraltar";
  IdealPostcodeCountries2["GREECE"] = "Greece";
  IdealPostcodeCountries2["GREENLAND"] = "Greenland";
  IdealPostcodeCountries2["GRENADA"] = "Grenada";
  IdealPostcodeCountries2["GUADELOUPE"] = "Guadeloupe";
  IdealPostcodeCountries2["GUAM"] = "Guam";
  IdealPostcodeCountries2["GUATEMALA"] = "Guatemala";
  IdealPostcodeCountries2["GUINEA"] = "Guinea";
  IdealPostcodeCountries2["GUINEA_BISSAU"] = "Guinea-Bissau";
  IdealPostcodeCountries2["GUYANA"] = "Guyana";
  IdealPostcodeCountries2["HAITI"] = "Haiti";
  IdealPostcodeCountries2["HONDURAS"] = "Honduras";
  IdealPostcodeCountries2["HONG_KONG"] = "Hong Kong";
  IdealPostcodeCountries2["HUNGARY"] = "Hungary";
  IdealPostcodeCountries2["ICELAND"] = "Iceland";
  IdealPostcodeCountries2["INDIA"] = "India";
  IdealPostcodeCountries2["INDONESIA"] = "Indonesia";
  IdealPostcodeCountries2["IRAN"] = "Iran";
  IdealPostcodeCountries2["IRAQ"] = "Iraq";
  IdealPostcodeCountries2["IRELAND"] = "Ireland";
  IdealPostcodeCountries2["ISRAEL"] = "Israel";
  IdealPostcodeCountries2["ITALY"] = "Italy";
  IdealPostcodeCountries2["JAMAICA"] = "Jamaica";
  IdealPostcodeCountries2["JAPAN"] = "Japan";
  IdealPostcodeCountries2["JORDAN"] = "Jordan";
  IdealPostcodeCountries2["KAZAKHSTAN"] = "Kazakhstan";
  IdealPostcodeCountries2["KENYA"] = "Kenya";
  IdealPostcodeCountries2["KIRIBATI"] = "Kiribati";
  IdealPostcodeCountries2["KOSOVO"] = "Kosovo";
  IdealPostcodeCountries2["KUWAIT"] = "Kuwait";
  IdealPostcodeCountries2["KYRGYZSTAN"] = "Kyrgyzstan";
  IdealPostcodeCountries2["LAOS"] = "Laos";
  IdealPostcodeCountries2["LATVIA"] = "Latvia";
  IdealPostcodeCountries2["LEBANON"] = "Lebanon";
  IdealPostcodeCountries2["LESOTHO"] = "Lesotho";
  IdealPostcodeCountries2["LIBERIA"] = "Liberia";
  IdealPostcodeCountries2["LIBYA"] = "Libya";
  IdealPostcodeCountries2["LIECHTENSTEIN"] = "Liechtenstein";
  IdealPostcodeCountries2["LITHUANIA"] = "Lithuania";
  IdealPostcodeCountries2["LUXEMBOURG"] = "Luxembourg";
  IdealPostcodeCountries2["MACAU"] = "Macau";
  IdealPostcodeCountries2["MADAGASCAR"] = "Madagascar";
  IdealPostcodeCountries2["MALAWI"] = "Malawi";
  IdealPostcodeCountries2["MALAYSIA"] = "Malaysia";
  IdealPostcodeCountries2["MALDIVES"] = "Maldives";
  IdealPostcodeCountries2["MALI"] = "Mali";
  IdealPostcodeCountries2["MALTA"] = "Malta";
  IdealPostcodeCountries2["MARSHALL_ISLANDS"] = "Marshall Islands";
  IdealPostcodeCountries2["MARTINIQUE"] = "Martinique";
  IdealPostcodeCountries2["MAURITANIA"] = "Mauritania";
  IdealPostcodeCountries2["MAURITIUS"] = "Mauritius";
  IdealPostcodeCountries2["MAYOTTE"] = "Mayotte";
  IdealPostcodeCountries2["MEXICO"] = "Mexico";
  IdealPostcodeCountries2["MOLDOVA"] = "Moldova";
  IdealPostcodeCountries2["MONACO"] = "Monaco";
  IdealPostcodeCountries2["MONGOLIA"] = "Mongolia";
  IdealPostcodeCountries2["MONTENEGRO"] = "Montenegro";
  IdealPostcodeCountries2["MONTSERRAT"] = "Montserrat";
  IdealPostcodeCountries2["MOROCCO"] = "Morocco";
  IdealPostcodeCountries2["MOZAMBIQUE"] = "Mozambique";
  IdealPostcodeCountries2["MYANMAR"] = "Myanmar";
  IdealPostcodeCountries2["NAMIBIA"] = "Namibia";
  IdealPostcodeCountries2["NAURU"] = "Nauru";
  IdealPostcodeCountries2["NEPAL"] = "Nepal";
  IdealPostcodeCountries2["NETHERLANDS"] = "Netherlands";
  IdealPostcodeCountries2["NEW_CALEDONIA"] = "New Caledonia";
  IdealPostcodeCountries2["NEW_ZEALAND"] = "New Zealand";
  IdealPostcodeCountries2["NICARAGUA"] = "Nicaragua";
  IdealPostcodeCountries2["NIGER"] = "Niger";
  IdealPostcodeCountries2["NIGERIA"] = "Nigeria";
  IdealPostcodeCountries2["NIUE"] = "Niue";
  IdealPostcodeCountries2["NORFOLK_ISLAND"] = "Norfolk Island";
  IdealPostcodeCountries2["NORTH_KOREA"] = "North Korea";
  IdealPostcodeCountries2["NORTH_MACEDONIA"] = "North Macedonia";
  IdealPostcodeCountries2["NORTHERN_IRELAND"] = "Northern Ireland";
  IdealPostcodeCountries2["NORTHERN_MARIANA_ISLANDS"] = "Northern Mariana Islands";
  IdealPostcodeCountries2["NORWAY"] = "Norway";
  IdealPostcodeCountries2["OMAN"] = "Oman";
  IdealPostcodeCountries2["PAKISTAN"] = "Pakistan";
  IdealPostcodeCountries2["PALAU"] = "Palau";
  IdealPostcodeCountries2["PANAMA"] = "Panama";
  IdealPostcodeCountries2["PAPUA_NEW_GUINEA"] = "Papua New Guinea";
  IdealPostcodeCountries2["PARAGUAY"] = "Paraguay";
  IdealPostcodeCountries2["PERU"] = "Peru";
  IdealPostcodeCountries2["PHILIPPINES"] = "Philippines";
  IdealPostcodeCountries2["PITCAIRN_ISLANDS"] = "Pitcairn Islands";
  IdealPostcodeCountries2["POLAND"] = "Poland";
  IdealPostcodeCountries2["PORTUGAL"] = "Portugal";
  IdealPostcodeCountries2["PUERTO_RICO"] = "Puerto Rico";
  IdealPostcodeCountries2["QATAR"] = "Qatar";
  IdealPostcodeCountries2["REPUBLIC_OF_THE_CONGO"] = "Republic of the Congo";
  IdealPostcodeCountries2["REUNION"] = "R\xE9union";
  IdealPostcodeCountries2["ROMANIA"] = "Romania";
  IdealPostcodeCountries2["RUSSIA"] = "Russia";
  IdealPostcodeCountries2["RWANDA"] = "Rwanda";
  IdealPostcodeCountries2["SAINT_BARTHELEMY"] = "Saint Barth\xE9lemy";
  IdealPostcodeCountries2["SAINT_HELENA"] = "Saint Helena";
  IdealPostcodeCountries2["SAINT_KITTS_AND_NEVIS"] = "Saint Kitts and Nevis";
  IdealPostcodeCountries2["SAINT_LUCIA"] = "Saint Lucia";
  IdealPostcodeCountries2["SAINT_MARTIN"] = "Saint Martin";
  IdealPostcodeCountries2["SAINT_PIERRE_AND_MIQUELON"] = "Saint Pierre and Miquelon";
  IdealPostcodeCountries2["SAINT_VINCENT_AND_THE_GRENADINES"] = "Saint Vincent and the Grenadines";
  IdealPostcodeCountries2["SAMOA"] = "Samoa";
  IdealPostcodeCountries2["SAN_MARINO"] = "San Marino";
  IdealPostcodeCountries2["SAO_TOME_AND_PRINCIPE"] = "S\xE3o Tom\xE9 and Pr\xEDncipe";
  IdealPostcodeCountries2["SAUDI_ARABIA"] = "Saudi Arabia";
  IdealPostcodeCountries2["SCOTLAND"] = "Scotland";
  IdealPostcodeCountries2["SENEGAL"] = "Senegal";
  IdealPostcodeCountries2["SERBIA"] = "Serbia";
  IdealPostcodeCountries2["SEYCHELLES"] = "Seychelles";
  IdealPostcodeCountries2["SIERRA_LEONE"] = "Sierra Leone";
  IdealPostcodeCountries2["SINGAPORE"] = "Singapore";
  IdealPostcodeCountries2["SINT_MAARTEN_DUTCH_PART"] = "Sint Maarten (Dutch part)";
  IdealPostcodeCountries2["SLOVAKIA"] = "Slovakia";
  IdealPostcodeCountries2["SLOVENIA"] = "Slovenia";
  IdealPostcodeCountries2["SOLOMON_ISLANDS"] = "Solomon Islands";
  IdealPostcodeCountries2["SOMALIA"] = "Somalia";
  IdealPostcodeCountries2["SOUTH_AFRICA"] = "South Africa";
  IdealPostcodeCountries2["SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS"] = "South Georgia and the South Sandwich Islands";
  IdealPostcodeCountries2["SOUTH_KOREA"] = "South Korea";
  IdealPostcodeCountries2["SOUTH_SUDAN"] = "South Sudan";
  IdealPostcodeCountries2["SPAIN"] = "Spain";
  IdealPostcodeCountries2["SRI_LANKA"] = "Sri Lanka";
  IdealPostcodeCountries2["SUDAN"] = "Sudan";
  IdealPostcodeCountries2["SURINAME"] = "Suriname";
  IdealPostcodeCountries2["SVALBARD_AND_JAN_MAYEN"] = "Svalbard and Jan Mayen";
  IdealPostcodeCountries2["SWEDEN"] = "Sweden";
  IdealPostcodeCountries2["SWITZERLAND"] = "Switzerland";
  IdealPostcodeCountries2["SYRIA"] = "Syria";
  IdealPostcodeCountries2["TAIWAN"] = "Taiwan";
  IdealPostcodeCountries2["TAJIKISTAN"] = "Tajikistan";
  IdealPostcodeCountries2["TANZANIA"] = "Tanzania";
  IdealPostcodeCountries2["THAILAND"] = "Thailand";
  IdealPostcodeCountries2["TIMOR_LESTE"] = "Timor-Leste";
  IdealPostcodeCountries2["TOGO"] = "Togo";
  IdealPostcodeCountries2["TOKELAU"] = "Tokelau";
  IdealPostcodeCountries2["TONGA"] = "Tonga";
  IdealPostcodeCountries2["TRINIDAD_AND_TOBAGO"] = "Trinidad and Tobago";
  IdealPostcodeCountries2["TUNISIA"] = "Tunisia";
  IdealPostcodeCountries2["TURKEY"] = "Turkey";
  IdealPostcodeCountries2["TURKMENISTAN"] = "Turkmenistan";
  IdealPostcodeCountries2["TURKS_AND_CAICOS_ISLANDS"] = "Turks and Caicos Islands";
  IdealPostcodeCountries2["TUVALU"] = "Tuvalu";
  IdealPostcodeCountries2["UGANDA"] = "Uganda";
  IdealPostcodeCountries2["UKRAINE"] = "Ukraine";
  IdealPostcodeCountries2["UNITED_ARAB_EMIRATES"] = "United Arab Emirates";
  IdealPostcodeCountries2["UNITED_STATES"] = "United States";
  IdealPostcodeCountries2["UNITED_STATES_VIRGIN_ISLANDS"] = "United States Virgin Islands";
  IdealPostcodeCountries2["URUGUAY"] = "Uruguay";
  IdealPostcodeCountries2["UZBEKISTAN"] = "Uzbekistan";
  IdealPostcodeCountries2["VANUATU"] = "Vanuatu";
  IdealPostcodeCountries2["VATICAN_CITY"] = "Vatican City";
  IdealPostcodeCountries2["VENEZUELA"] = "Venezuela";
  IdealPostcodeCountries2["VIETNAM"] = "Vietnam";
  IdealPostcodeCountries2["WALES"] = "Wales";
  IdealPostcodeCountries2["WALLIS_AND_FUTUNA"] = "Wallis and Futuna";
  IdealPostcodeCountries2["WESTERN_SAHARA"] = "Western Sahara";
  IdealPostcodeCountries2["YEMEN"] = "Yemen";
  IdealPostcodeCountries2["ZAMBIA"] = "Zambia";
  IdealPostcodeCountries2["ZIMBABWE"] = "Zimbabwe";
  return IdealPostcodeCountries2;
})(IdealPostcodeCountries || {});
var countriesToIdealPostcodeCountry = {
  "004": ["Afghanistan" /* AFGHANISTAN */],
  "008": ["Albania" /* ALBANIA */],
  "012": ["Algeria" /* ALGERIA */],
  "016": ["American Samoa" /* AMERICAN_SAMOA */],
  "020": ["Andorra" /* ANDORRA */],
  "024": ["Angola" /* ANGOLA */],
  "660": ["Anguilla" /* ANGUILLA */],
  "028": ["Antigua and Barbuda" /* ANTIGUA_AND_BARBUDA */],
  "032": ["Argentina" /* ARGENTINA */],
  "051": ["Armenia" /* ARMENIA */],
  "533": ["Aruba" /* ARUBA */],
  "036": ["Australia" /* AUSTRALIA */],
  "040": ["Austria" /* AUSTRIA */],
  "031": ["Azerbaijan" /* AZERBAIJAN */],
  "044": ["Bahamas" /* BAHAMAS */],
  "048": ["Bahrain" /* BAHRAIN */],
  "050": ["Bangladesh" /* BANGLADESH */],
  "052": ["Barbados" /* BARBADOS */],
  "112": ["Belarus" /* BELARUS */],
  "056": ["Belgium" /* BELGIUM */],
  "084": ["Belize" /* BELIZE */],
  "204": ["Benin" /* BENIN */],
  "060": ["Bermuda" /* BERMUDA */],
  "064": ["Bhutan" /* BHUTAN */],
  "068": ["Bolivia" /* BOLIVIA */],
  "535": ["Bonaire, Sint Eustatius and Saba" /* BONAIRE_SINT_EUSTATIUS_AND_SABA */],
  "070": ["Bosnia and Herzegovina" /* BOSNIA_AND_HERZEGOVINA */],
  "072": ["Botswana" /* BOTSWANA */],
  "076": ["Brazil" /* BRAZIL */],
  "086": ["British Indian Ocean Territory" /* BRITISH_INDIAN_OCEAN_TERRITORY */],
  "092": ["British Virgin Islands" /* BRITISH_VIRGIN_ISLANDS */],
  "096": ["Brunei Darussalam" /* BRUNEI_DARUSSALAM */],
  "100": ["Bulgaria" /* BULGARIA */],
  "854": ["Burkina Faso" /* BURKINA_FASO */],
  "108": ["Burundi" /* BURUNDI */],
  "116": ["Cambodia" /* CAMBODIA */],
  "120": ["Cameroon" /* CAMEROON */],
  "124": ["Canada" /* CANADA */],
  "132": ["Cape Verde" /* CAPE_VERDE */],
  "136": ["Cayman Islands" /* CAYMAN_ISLANDS */],
  "140": ["Central African Republic" /* CENTRAL_AFRICAN_REPUBLIC */],
  "148": ["Chad" /* CHAD */],
  "152": ["Chile" /* CHILE */],
  "156": ["China" /* CHINA */],
  "162": ["Christmas Island" /* CHRISTMAS_ISLAND */],
  "166": ["Cocos (Keeling) Islands" /* COCOS_KEELING_ISLANDS */],
  "170": ["Colombia" /* COLOMBIA */],
  "174": ["Comoros" /* COMOROS */],
  "184": ["Cook Islands" /* COOK_ISLANDS */],
  "188": ["Costa Rica" /* COSTA_RICA */],
  "384": ["C\xF4te d'Ivoire" /* COTE_DIVOIRE */],
  "191": ["Croatia" /* CROATIA */],
  "192": ["Cuba" /* CUBA */],
  "531": ["Cura\xE7ao" /* CURACAO */],
  "196": ["Cyprus" /* CYPRUS */],
  "203": ["Czech Republic" /* CZECH_REPUBLIC */],
  "180": ["Democratic Republic of the Congo" /* DEMOCRATIC_REPUBLIC_OF_THE_CONGO */],
  "208": ["Denmark" /* DENMARK */],
  "262": ["Djibouti" /* DJIBOUTI */],
  "212": ["Dominica" /* DOMINICA */],
  "214": ["Dominican Republic" /* DOMINICAN_REPUBLIC */],
  "218": ["Ecuador" /* ECUADOR */],
  "818": ["Egypt" /* EGYPT */],
  "222": ["El Salvador" /* EL_SALVADOR */],
  "226": ["Equatorial Guinea" /* EQUATORIAL_GUINEA */],
  "232": ["Eritrea" /* ERITREA */],
  "233": ["Estonia" /* ESTONIA */],
  "748": ["Eswatini" /* ESWATINI */],
  "231": ["Ethiopia" /* ETHIOPIA */],
  "238": ["Falkland Islands (Malvinas)" /* FALKLAND_ISLANDS_MALVINAS */],
  "234": ["Faroe Islands" /* FAROE_ISLANDS */],
  "583": ["Federated States of Micronesia" /* FEDERATED_STATES_OF_MICRONESIA */],
  "242": ["Fiji" /* FIJI */],
  "246": ["Finland" /* FINLAND */],
  "250": ["France" /* FRANCE */],
  "254": ["French Guiana" /* FRENCH_GUIANA */],
  "258": ["French Polynesia" /* FRENCH_POLYNESIA */],
  "266": ["Gabon" /* GABON */],
  "270": ["Gambia" /* GAMBIA */],
  "268": ["Georgia" /* GEORGIA */],
  "276": ["Germany" /* GERMANY */],
  "288": ["Ghana" /* GHANA */],
  "292": ["Gibraltar" /* GIBRALTAR */],
  "300": ["Greece" /* GREECE */],
  "304": ["Greenland" /* GREENLAND */],
  "308": ["Grenada" /* GRENADA */],
  "312": ["Guadeloupe" /* GUADELOUPE */],
  "316": ["Guam" /* GUAM */],
  "320": ["Guatemala" /* GUATEMALA */],
  "324": ["Guinea" /* GUINEA */],
  "624": ["Guinea-Bissau" /* GUINEA_BISSAU */],
  "328": ["Guyana" /* GUYANA */],
  "332": ["Haiti" /* HAITI */],
  "340": ["Honduras" /* HONDURAS */],
  "344": ["Hong Kong" /* HONG_KONG */],
  "348": ["Hungary" /* HUNGARY */],
  "352": ["Iceland" /* ICELAND */],
  "356": ["India" /* INDIA */],
  "360": ["Indonesia" /* INDONESIA */],
  "364": ["Iran" /* IRAN */],
  "368": ["Iraq" /* IRAQ */],
  "372": ["Ireland" /* IRELAND */],
  "376": ["Israel" /* ISRAEL */],
  "380": ["Italy" /* ITALY */],
  "388": ["Jamaica" /* JAMAICA */],
  "392": ["Japan" /* JAPAN */],
  "400": ["Jordan" /* JORDAN */],
  "398": ["Kazakhstan" /* KAZAKHSTAN */],
  "404": ["Kenya" /* KENYA */],
  "296": ["Kiribati" /* KIRIBATI */],
  "\u200B383": ["Kosovo" /* KOSOVO */],
  "414": ["Kuwait" /* KUWAIT */],
  "417": ["Kyrgyzstan" /* KYRGYZSTAN */],
  "418": ["Laos" /* LAOS */],
  "428": ["Latvia" /* LATVIA */],
  "422": ["Lebanon" /* LEBANON */],
  "426": ["Lesotho" /* LESOTHO */],
  "430": ["Liberia" /* LIBERIA */],
  "434": ["Libya" /* LIBYA */],
  "438": ["Liechtenstein" /* LIECHTENSTEIN */],
  "440": ["Lithuania" /* LITHUANIA */],
  "442": ["Luxembourg" /* LUXEMBOURG */],
  "446": ["Macau" /* MACAU */],
  "450": ["Madagascar" /* MADAGASCAR */],
  "454": ["Malawi" /* MALAWI */],
  "458": ["Malaysia" /* MALAYSIA */],
  "462": ["Maldives" /* MALDIVES */],
  "466": ["Mali" /* MALI */],
  "470": ["Malta" /* MALTA */],
  "584": ["Marshall Islands" /* MARSHALL_ISLANDS */],
  "474": ["Martinique" /* MARTINIQUE */],
  "478": ["Mauritania" /* MAURITANIA */],
  "480": ["Mauritius" /* MAURITIUS */],
  "175": ["Mayotte" /* MAYOTTE */],
  "484": ["Mexico" /* MEXICO */],
  "498": ["Moldova" /* MOLDOVA */],
  "492": ["Monaco" /* MONACO */],
  "496": ["Mongolia" /* MONGOLIA */],
  "499": ["Montenegro" /* MONTENEGRO */],
  "500": ["Montserrat" /* MONTSERRAT */],
  "504": ["Morocco" /* MOROCCO */],
  "508": ["Mozambique" /* MOZAMBIQUE */],
  "104": ["Myanmar" /* MYANMAR */],
  "516": ["Namibia" /* NAMIBIA */],
  "520": ["Nauru" /* NAURU */],
  "524": ["Nepal" /* NEPAL */],
  "528": ["Netherlands" /* NETHERLANDS */],
  "540": ["New Caledonia" /* NEW_CALEDONIA */],
  "554": ["New Zealand" /* NEW_ZEALAND */],
  "558": ["Nicaragua" /* NICARAGUA */],
  "562": ["Niger" /* NIGER */],
  "566": ["Nigeria" /* NIGERIA */],
  "570": ["Niue" /* NIUE */],
  "574": ["Norfolk Island" /* NORFOLK_ISLAND */],
  "408": ["North Korea" /* NORTH_KOREA */],
  "807": ["North Macedonia" /* NORTH_MACEDONIA */],
  "580": ["Northern Mariana Islands" /* NORTHERN_MARIANA_ISLANDS */],
  "578": ["Norway" /* NORWAY */],
  "512": ["Oman" /* OMAN */],
  "586": ["Pakistan" /* PAKISTAN */],
  "585": ["Palau" /* PALAU */],
  "591": ["Panama" /* PANAMA */],
  "598": ["Papua New Guinea" /* PAPUA_NEW_GUINEA */],
  "600": ["Paraguay" /* PARAGUAY */],
  "604": ["Peru" /* PERU */],
  "608": ["Philippines" /* PHILIPPINES */],
  "612": ["Pitcairn Islands" /* PITCAIRN_ISLANDS */],
  "616": ["Poland" /* POLAND */],
  "620": ["Portugal" /* PORTUGAL */],
  "630": ["Puerto Rico" /* PUERTO_RICO */],
  "634": ["Qatar" /* QATAR */],
  "178": ["Republic of the Congo" /* REPUBLIC_OF_THE_CONGO */],
  "638": ["R\xE9union" /* REUNION */],
  "642": ["Romania" /* ROMANIA */],
  "643": ["Russia" /* RUSSIA */],
  "646": ["Rwanda" /* RWANDA */],
  "652": ["Saint Barth\xE9lemy" /* SAINT_BARTHELEMY */],
  "654": ["Saint Helena" /* SAINT_HELENA */],
  "659": ["Saint Kitts and Nevis" /* SAINT_KITTS_AND_NEVIS */],
  "662": ["Saint Lucia" /* SAINT_LUCIA */],
  "663": ["Saint Martin" /* SAINT_MARTIN */],
  "666": ["Saint Pierre and Miquelon" /* SAINT_PIERRE_AND_MIQUELON */],
  "670": ["Saint Vincent and the Grenadines" /* SAINT_VINCENT_AND_THE_GRENADINES */],
  "882": ["Samoa" /* SAMOA */],
  "674": ["San Marino" /* SAN_MARINO */],
  "678": ["S\xE3o Tom\xE9 and Pr\xEDncipe" /* SAO_TOME_AND_PRINCIPE */],
  "682": ["Saudi Arabia" /* SAUDI_ARABIA */],
  "686": ["Senegal" /* SENEGAL */],
  "688": ["Serbia" /* SERBIA */],
  "690": ["Seychelles" /* SEYCHELLES */],
  "694": ["Sierra Leone" /* SIERRA_LEONE */],
  "702": ["Singapore" /* SINGAPORE */],
  "534": ["Sint Maarten (Dutch part)" /* SINT_MAARTEN_DUTCH_PART */],
  "703": ["Slovakia" /* SLOVAKIA */],
  "705": ["Slovenia" /* SLOVENIA */],
  "090": ["Solomon Islands" /* SOLOMON_ISLANDS */],
  "706": ["Somalia" /* SOMALIA */],
  "710": ["South Africa" /* SOUTH_AFRICA */],
  "239": ["South Georgia and the South Sandwich Islands" /* SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS */],
  "410": ["South Korea" /* SOUTH_KOREA */],
  "728": ["South Sudan" /* SOUTH_SUDAN */],
  "724": ["Spain" /* SPAIN */],
  "144": ["Sri Lanka" /* SRI_LANKA */],
  "729": ["Sudan" /* SUDAN */],
  "740": ["Suriname" /* SURINAME */],
  "744": ["Svalbard and Jan Mayen" /* SVALBARD_AND_JAN_MAYEN */],
  "752": ["Sweden" /* SWEDEN */],
  "756": ["Switzerland" /* SWITZERLAND */],
  "760": ["Syria" /* SYRIA */],
  "158": ["Taiwan" /* TAIWAN */],
  "762": ["Tajikistan" /* TAJIKISTAN */],
  "834": ["Tanzania" /* TANZANIA */],
  "764": ["Thailand" /* THAILAND */],
  "626": ["Timor-Leste" /* TIMOR_LESTE */],
  "768": ["Togo" /* TOGO */],
  "772": ["Tokelau" /* TOKELAU */],
  "776": ["Tonga" /* TONGA */],
  "780": ["Trinidad and Tobago" /* TRINIDAD_AND_TOBAGO */],
  "788": ["Tunisia" /* TUNISIA */],
  "792": ["Turkey" /* TURKEY */],
  "795": ["Turkmenistan" /* TURKMENISTAN */],
  "796": ["Turks and Caicos Islands" /* TURKS_AND_CAICOS_ISLANDS */],
  "798": ["Tuvalu" /* TUVALU */],
  "800": ["Uganda" /* UGANDA */],
  "804": ["Ukraine" /* UKRAINE */],
  "784": ["United Arab Emirates" /* UNITED_ARAB_EMIRATES */],
  "826": [
    "England" /* ENGLAND */,
    "Scotland" /* SCOTLAND */,
    "Wales" /* WALES */,
    "Northern Ireland" /* NORTHERN_IRELAND */
  ],
  "840": ["United States" /* UNITED_STATES */],
  "850": ["United States Virgin Islands" /* UNITED_STATES_VIRGIN_ISLANDS */],
  "858": ["Uruguay" /* URUGUAY */],
  "860": ["Uzbekistan" /* UZBEKISTAN */],
  "548": ["Vanuatu" /* VANUATU */],
  "336": ["Vatican City" /* VATICAN_CITY */],
  "862": ["Venezuela" /* VENEZUELA */],
  "704": ["Vietnam" /* VIETNAM */],
  "876": ["Wallis and Futuna" /* WALLIS_AND_FUTUNA */],
  "732": ["Western Sahara" /* WESTERN_SAHARA */],
  "887": ["Yemen" /* YEMEN */],
  "894": ["Zambia" /* ZAMBIA */],
  "716": ["Zimbabwe" /* ZIMBABWE */]
};

// src/agentDetails/index.ts
var AGENT_DETAILS_INTAKE_CUTOFF = "2025-12";
var ACADEMIC_YEAR_UNIS = ["LE"];
export {
  ACADEMIC_YEAR_UNIS,
  AGENT_DETAILS_INTAKE_CUTOFF,
  AU_CHILD_DEPENDENT_ANNUAL,
  AU_FUNDS_DURATION_MONTHS_CAP,
  AU_LIVING_COST_ANNUAL,
  AU_SCHOOL_AGE_CHILD_ANNUAL,
  AU_SPOUSE_DEPENDENT_ANNUAL,
  AU_TRAVEL_COST_DEFAULT,
  AU_TRAVEL_COST_EAST_S_AFRICA,
  AU_TRAVEL_COST_WEST_AFRICA,
  ActiveApplicationStatues,
  CompletedCourses,
  DefaultDashboardTabIds,
  ENGLISH_SPEAKING_COUNTRIES,
  ENGLISH_TEST_TYPES,
  ENGLISH_TEST_TYPE_VAL_LABEL_MAP,
  EllucianEthnicityMapping,
  EllucianFpay,
  HIGHEST_QUALIFICATIONS,
  HIGHEST_QUALIFICATIONS_LIST,
  HIGHEST_QUALIFICATIONS_MAP,
  INNER_LONDON_LIVING_COST,
  IdealPostcodeCountries,
  MAX_ACCOMMODATION_DEPOSIT,
  MONTHS,
  MYINTERVIEW_ENCRYPTION_KEY,
  MYINTERVIEW_ENCRYPTION_SALT,
  NOT_REQUIRED_REASONS,
  OUTER_LONDON_LIVING_COST,
  OfferTooltipLabels,
  PreviousStudyVisaType,
  PreviousStudyVisas,
  PreviouslyCompletedStudyLevel,
  QUALIFICATIONS,
  QUALIFICATION_GRADE_SYSTEMS,
  QUALIFICATION_VAL_LABEL_MAP,
  SHARE_CODE_EXPIRY_ALERT_DAYS_DEFAULT,
  SHARE_CODE_EXPIRY_DAYS_DEFAULT,
  TabIdDocumentMap,
  TabIdStageMap,
  TabIdStageMapForAgent,
  VisaType,
  applicantTasksConfig,
  countries,
  countriesToIdealPostcodeCountry,
  countryByAlpha3,
  countryByCountryName,
  countryByNationality,
  countryByNumeric,
  countryByRegionName,
  countryCodes,
  countryNames,
  countryPhoneCodes,
  currencies,
  dashboardTabs,
  defaultApplicationTaskConfig,
  defaultApplyUniConfig,
  defaultApplyUniConfigRequirement,
  defaultCore,
  defaultCustomDocuments,
  defaultEmailFrom,
  defaultFieldMappings,
  defaultFinance,
  defaultFormatTypes,
  defaultIEnrolmentStatus,
  defaultImmigrationProviderConfig,
  defaultImportData,
  defaultMappingTypes,
  defaultOffer,
  defaultQuestions,
  defaultRegionConfig,
  defaultRisks,
  defaultUniConfig,
  defaultnoRoleAssignedMsg,
  descriptionUKResidence,
  fundingSources,
  getPreviousStudyVisaLabelFromValue,
  getPreviousStudyVisaValueFromLabel,
  getPreviouslyCompletedStudyLevelLabelFromValue,
  getPreviouslyCompletedStudyLevelValueFromLabel,
  getSuccessfullyCompletedCourseLabelFromValue,
  getSuccessfullyCompletedCourseValueFromLabel,
  getVisaLabelFromValue,
  getVisaValueFromLabel,
  importStudentFields,
  months,
  nationalityCountriesMap,
  nonRemovableTagTypes,
  offerIssueStatuses,
  offerNeedsReissueStatuses,
  officeSelectionFields,
  previouslyCompletedStudyLevels,
  recognisedCountries,
  reminderNotificationsConfig,
  restrictedCountryBanks,
  statusReasonOptions,
  subdivisions,
  successfullyCompletedCourses,
  systemGeneratedApplicantStatusReasonLabels,
  systemTagTypes,
  trapQuestions,
  uniViewApplicantTaskGroups,
  universities,
  universityKeys,
  userGeneratedApplicantStatusReasonLabels,
  visas
};
